/* xeist-customizer-bundle v1 — built from src/ by scripts/build.mjs.
 * DO NOT EDIT THIS FILE DIRECTLY: edit src/, run `npm run build`.
 * 26 script blocks in original document order; order matters.
 * Server-resolved values come from window.XeistConfig (set by the
 * Liquid snippet BEFORE this script tag). */
(() => {
  // src/core/01-xeist-core.js
  (function() {
    if (window.XeistCore) return;
    var mem = {};
    var ls = null;
    try {
      ls = window.localStorage;
      var probe = "__xeist_probe__";
      ls.setItem(probe, "1");
      ls.removeItem(probe);
    } catch (e) {
      ls = null;
    }
    var store = {
      persistent: !!ls,
      get: function(k) {
        try {
          if (ls) return ls.getItem(k);
        } catch (e) {
        }
        return Object.prototype.hasOwnProperty.call(mem, k) ? mem[k] : null;
      },
      set: function(k, v) {
        v = String(v);
        try {
          if (ls) {
            ls.setItem(k, v);
            return;
          }
        } catch (e) {
        }
        mem[k] = v;
      },
      remove: function(k) {
        try {
          if (ls) ls.removeItem(k);
        } catch (e) {
        }
        delete mem[k];
      },
      getJSON: function(k, dflt) {
        try {
          var raw = store.get(k);
          return raw == null ? dflt : JSON.parse(raw);
        } catch (e) {
          return dflt;
        }
      },
      setJSON: function(k, obj) {
        try {
          store.set(k, JSON.stringify(obj));
        } catch (e) {
        }
      }
    };
    var injCache = null;
    function getInjector() {
      if (injCache) return injCache;
      try {
        var el = document.querySelector("[ng-controller]");
        injCache = el && window.angular ? angular.element(el).injector() || null : null;
      } catch (e) {
        injCache = null;
      }
      return injCache;
    }
    function getService(name) {
      try {
        var inj = getInjector();
        return inj && inj.has(name) ? inj.get(name) : null;
      } catch (e) {
        return null;
      }
    }
    function getES() {
      return getService("EditorService");
    }
    var tasks = {}, timer = null, TICK = 100;
    function pump() {
      var now = Date.now(), any = false;
      for (var name in tasks) {
        if (!Object.prototype.hasOwnProperty.call(tasks, name)) continue;
        any = true;
        var t = tasks[name];
        if (t.hiddenGate && document.hidden) continue;
        if (now - t.last >= t.ms) {
          t.last = now;
          try {
            t.fn();
          } catch (e) {
          }
        }
      }
      if (!any) {
        clearInterval(timer);
        timer = null;
      }
    }
    function every(name, ms, fn, opts) {
      tasks[name] = { ms, fn, last: 0, hiddenGate: !(opts && opts.runHidden) };
      if (!timer) timer = setInterval(pump, TICK);
      return { stop: function() {
        delete tasks[name];
      } };
    }
    function button(opts) {
      opts = opts || {};
      var b = document.createElement("button");
      b.type = "button";
      if (opts.label) b.setAttribute("aria-label", opts.label);
      if (opts.text != null) b.textContent = opts.text;
      else if (opts.html != null) b.innerHTML = opts.html;
      b.style.cssText = "min-width:44px;min-height:44px;cursor:pointer;" + (opts.css || "");
      if (opts.onClick) b.addEventListener("click", opts.onClick);
      return b;
    }
    window.XeistCore = { store, getInjector, getService, getES, every, button };
  })();

  // src/coach/02-auto-coach-engine.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    var STATIC = /114891065|114890045|210147750|211485079|117611677|117991635|209873286/;
    var PAIRS = {
      /* Essence Blue — card shows the PAIRED garment's photo */
      "210186253": { designId: "211469209", label: "Essence Joggers – Blue", image: window.XeistConfig.v["xeist_blue_pants_img"] },
      "211469209": { designId: "210186253", label: "Essence Jacket – Blue", image: window.XeistConfig.v["xeist_blue_jacket_img"] },
      /* Essence Black */
      "212281188": { designId: "122282724", label: "Essence Joggers – Black", image: window.XeistConfig.v["xeist_black_pants_img"] },
      "122282724": { designId: "212281188", label: "Essence Jacket – Black", image: window.XeistConfig.v["xeist_black_jacket_img"] },
      /* Grey tracksuit's joggers variant (elemental-joggers-grey1) → grey jacket */
      "211489086": { designId: "210147750", label: "Elemental Jacket – Grey" },
      /* Elemental Navy (2026-07-04). KB products 211475622 (jacket) /
         211475772 (joggers); no Shopify product photos exist yet, so no
         image/handle — the set prompt shows its neutral placeholder. */
      "211474835": { designId: "211469246", label: "Elemental Joggers – Navy" },
      "211469246": { designId: "211474835", label: "Elemental Jacket – Navy" }
    };
    function curId() {
      var m = (window.location.hash || "").match(/customise\/(\d+)/);
      return m ? m[1] : "";
    }
    function flagged(id2) {
      try {
        return !!id2 && window.localStorage.getItem("xeist_ts_" + id2) === "1";
      } catch (e) {
        return false;
      }
    }
    window.__xeistCoachOn = function() {
      if (STATIC.test(window.location.hash || "")) return true;
      return flagged(curId());
    };
    window.__xeistLogoHeader = function(root) {
      root = root || document;
      var headers = root.querySelectorAll(".kb-editor-heading.kb-wizard-group-header");
      if (window.angular) {
        for (var i = 0; i < headers.length; i++) {
          try {
            var s = angular.element(headers[i]).scope();
            if (s && s.placement && String(s.placement.placementKey).toLowerCase() === "add-logo") return headers[i];
          } catch (e) {
          }
        }
      }
      return headers[0] || null;
    };
    var id = curId();
    if (!id || STATIC.test(window.location.hash || "")) return;
    var hadCache = false;
    try {
      var cached = window.localStorage.getItem("xeist_cfg3_" + id);
      if (cached) {
        var c = JSON.parse(cached);
        if (c && String(c.designId) === id) {
          window.XeistOrbitCoachConfig = c;
          window.XeistCoachConfigs = window.XeistCoachConfigs || {};
          window.XeistCoachConfigs[id] = c;
          hadCache = true;
        }
      }
    } catch (e) {
    }
    function buildFromKB() {
      var root = document.querySelector("[ng-controller]");
      if (!root || !window.angular) return null;
      var cs;
      try {
        cs = angular.element(root).injector().get("CustomizeService");
      } catch (e) {
        return null;
      }
      var d = cs && cs.design || {};
      var name = String(d.productName || "");
      var hay = (name + " " + String(d.productUrlSlug || "")).toLowerCase();
      var pidM = String((document.querySelector(".kb-customise-page") || {}).className || "").match(/kb-product-id-(\d+)/);
      var pid = String(pidM && pidM[1] || d.productId || "");
      if (/^(102815476|104006063|112548745|116801147)$/.test(pid) || /xe-caliber|shooting shirt|blitz jersey/.test(hay)) return null;
      if (/^(282910203)$/.test(String(d.id || ""))) return null;
      var isJoggers = /jogger|pant|short|bottom/.test(hay);
      var isJacket = /jacket|hoodie|hoody|crew|quarter|\/4|top/.test(hay);
      if (!isJoggers && !isJacket) return null;
      var tiers = (cs.simplePriceTiers || []).slice().sort(function(a, b) {
        return a.minimumQuantity - b.minimumQuantity;
      });
      if (!tiers.length) return null;
      var baseTiers = [];
      for (var i = 0; i < tiers.length; i++) {
        baseTiers.push({ min: tiers[i].minimumQuantity, max: i + 1 < tiers.length ? tiers[i + 1].minimumQuantity - 1 : null, unitPrice: tiers[i].unitPrice });
      }
      var logo = null;
      (cs.editorPlacements || []).forEach(function(p) {
        if (String(p.placementKey || "").toLowerCase() === "add-logo") logo = { x: p.x, y: p.y };
      });
      var noun = isJoggers ? ["pair", "pairs"] : ["jacket", "jackets"];
      return {
        enabled: true,
        productSlug: String(d.productUrlSlug || "auto-" + id).toLowerCase(),
        designId: id,
        featureFlags: { coachPanelEnabled: true, debugBridge: false },
        pricing: { depositPercent: 35, baseTiers, logoUpcharge: 5, numberUpcharge: 0, logoIncludedFree: false },
        rules: { minQty: 6, maxQty: 500, requireLogoForCheckout: false },
        uiCopy: { validationMessages: {} },
        numberDefaults: { placementKey: "add-number", text: "2", fontFamily: "Arial", color: "#FFFFFF", x: 1399, y: 1773 },
        logoPlacementKeys: ["logo", "crest", "badge"],
        numberPlacementKeys: ["add-number", "number"],
        productNoun: noun[0],
        productNounPlural: noun[1],
        orderTitle: (name || "Custom") + " Order",
        decorationSpecs: logo ? { "add-logo": logo } : null,
        sizeEntry: { enabled: true, labelRules: [{ match: "^Youth", group: "youth", gender: null }, { match: "^Men's", group: "adult", gender: "Men's" }, { match: "^Women's", group: "adult", gender: "Women's" }], defaultGender: "Men's" },
        previewZoomScale: 0.75,
        crossSell: PAIRS[id] || null,
        posterImage: null
      };
    }
    var tries = 0;
    var poll = window.setInterval(function() {
      tries++;
      if (tries > 150) {
        window.clearInterval(poll);
        return;
      }
      var cfg = buildFromKB();
      if (!cfg) return;
      window.clearInterval(poll);
      window.XeistOrbitCoachConfig = cfg;
      window.XeistCoachConfigs = window.XeistCoachConfigs || {};
      window.XeistCoachConfigs[id] = cfg;
      try {
        window.localStorage.setItem("xeist_cfg3_" + id, JSON.stringify(cfg));
      } catch (e) {
      }
      try {
        window.localStorage.setItem("xeist_ts_" + id, "1");
      } catch (e) {
      }
      if (!hadCache) {
        window.location.reload();
      }
    }, 400);
  })();

  // src/enforcers/03-native-chrome-hide.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1 || !window.__xeistCoachOn()) return;
    var isPhone = function() {
      return window.innerWidth <= 767;
    };
    function hideNativeChrome() {
      if (isPhone()) {
        document.documentElement.style.removeProperty("overflow");
        document.body.style.removeProperty("overflow");
      } else {
        document.documentElement.style.setProperty("overflow", "hidden", "important");
        document.body.style.setProperty("overflow", "hidden", "important");
      }
      [".kb-wizard-breadcrumbs", ".kb-customise-edit-panel"].forEach(function(sel) {
        document.querySelectorAll(sel).forEach(function(el) {
          el.style.setProperty("display", "none", "important");
        });
      });
      var pp = document.querySelector(".kb-preview-panel");
      if (pp) {
        pp.style.setProperty("flex", "0 1 auto", "important");
        pp.style.setProperty("width", "100%", "important");
        pp.style.setProperty("max-width", "720px", "important");
        pp.style.setProperty("margin", "0 auto", "important");
        pp.style.setProperty("overflow", isPhone() ? "hidden" : "visible", "important");
      }
      var page = document.querySelector(".kb-customise-page");
      if (page) page.style.setProperty("justify-content", "center", "important");
    }
    hideNativeChrome();
    var n = 0, t = setInterval(function() {
      hideNativeChrome();
      if (++n > 250) clearInterval(t);
    }, 120);
    try {
      var mo = new MutationObserver(function() {
        hideNativeChrome();
      });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function() {
        mo.disconnect();
      }, 8e3);
    } catch (e) {
    }
    window.addEventListener("resize", hideNativeChrome);
    if (!isPhone()) window.scrollTo(0, 0);
    window.addEventListener("scroll", function() {
      if (isPhone()) return;
      if (window.scrollY || window.pageYOffset) window.scrollTo(0, 0);
    }, { passive: true });
  })();

  // src/kb-boot/04-default-zoom.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    var UNIFORM_ZOOM_OUT = {};
    var hashId = (String(window.location.hash || "").match(/\d{9,}/) || [""])[0];
    var uniformFov = UNIFORM_ZOOM_OUT[hashId] || null;
    if (!window.__xeistCoachOn() && !uniformFov) return;
    document.addEventListener("KitBuilderLoaded", function() {
      if (window.KitBuilder) {
        KitBuilder.settingsOverrides = "kb.customize_design.fov=" + (uniformFov || 55);
      }
    }, { once: true });
  })();

  // src/logo-tools/05-logo-placement-override.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1 || !/114891065|114890045/.test(window.location.hash || "")) return;
    var CANVAS_W = 4251;
    var CENTRE_X = 1965;
    var PLACEMENT_KEY = "add-logo";
    var POLL_INTERVAL = 500;
    var MAX_POLLS = 60;
    var polls = 0;
    var timer = setInterval(function() {
      polls++;
      if (polls > MAX_POLLS) {
        clearInterval(timer);
        return;
      }
      try {
        var el = document.querySelector("[ng-controller]");
        if (!el) return;
        var injector = angular.element(el).injector();
        if (!injector) return;
        var EditorService = injector.get("EditorService");
        if (!EditorService) return;
      } catch (_) {
        return;
      }
      clearInterval(timer);
      var centredIds = {};
      function centreLogos() {
        var svgStr = EditorService.getSvgString();
        if (!svgStr) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(svgStr, "image/svg+xml");
        var imgs = doc.querySelectorAll("image");
        imgs.forEach(function(img) {
          var id = img.getAttribute("id");
          if (!id) return;
          if (id.indexOf("selectorGrip") === 0) return;
          if (centredIds[id]) return;
          var w = parseFloat(img.getAttribute("width")) || 320;
          var targetX = Math.round((CANVAS_W - w) / 2);
          EditorService.selectItem(id);
          EditorService.setX(targetX);
          centredIds[id] = true;
        });
      }
      EditorService.change(function() {
        setTimeout(centreLogos, 150);
      });
      var _origSetX = EditorService.setX;
      var _origSetY = EditorService.setY;
      EditorService.setX = function(val) {
        var sel = EditorService.getSelectedItem();
        if (sel) {
          var selId = typeof sel === "string" ? sel : sel.id || sel.attr && sel.attr("id");
          if (selId && centredIds[selId]) {
            return;
          }
        }
        return _origSetX.apply(this, arguments);
      };
      EditorService.setY = function(val) {
        var sel = EditorService.getSelectedItem();
        if (sel) {
          var selId = typeof sel === "string" ? sel : sel.id || sel.attr && sel.attr("id");
          if (selId && centredIds[selId]) return;
        }
        return _origSetY.apply(this, arguments);
      };
    }, POLL_INTERVAL);
  })();

  // src/enforcers/06-container-width-fix.js
  window.__xeistErrs = window.__xeistErrs || [];
  window.addEventListener("error", function(e) {
    try {
      window.__xeistErrs.push((e.message || "err") + " @" + String(e.filename || "").split("/").pop() + ":" + e.lineno);
      if (window.__xeistErrs.length > 6) window.__xeistErrs.shift();
    } catch (x) {
    }
  });
  window.addEventListener("unhandledrejection", function(e) {
    try {
      window.__xeistErrs.push("promise: " + String(e.reason && (e.reason.message || e.reason) || "rejected").slice(0, 120));
      if (window.__xeistErrs.length > 6) window.__xeistErrs.shift();
    } catch (x) {
    }
  });
  window.addEventListener("error", function(e) {
    try {
      var t = e.target;
      if (t && t !== window && (t.src || t.href)) {
        window.__xeistErrs.push("res-fail: ..." + String(t.src || t.href).split("?")[0].slice(-70));
        if (window.__xeistErrs.length > 6) window.__xeistErrs.shift();
      }
    } catch (x) {
    }
  }, true);

  // src/kb-boot/07-misc-coach-gate.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1 || !window.__xeistCoachOn()) return;
    var container = document.querySelector(".container.max-w-narrower");
    if (container) {
      container.classList.remove("max-w-narrower");
      container.classList.add("max-w-page");
    }
    var title = document.querySelector(".main-page__title");
    if (title) {
      title.style.display = "none";
    }
  })();

  // src/enforcers/08-mobile-fix.js
  (function() {
    if (window.innerWidth > 768) return;
    var kb = document.getElementById("kitBuilder");
    if (!kb) return;
    var resizeDispatched = false;
    function setCanvasTouch() {
      var canvases = document.querySelectorAll(".kb-preview-panel canvas");
      if (!canvases.length) return;
      var logoBtn = document.getElementById("xeist-add-logo-overlay");
      var logoActive = !!(logoBtn && /remove logo/i.test(logoBtn.textContent || ""));
      var mode = logoActive ? "none" : "pan-y";
      for (var i = 0; i < canvases.length; i++) {
        canvases[i].style.setProperty("touch-action", mode, "important");
      }
    }
    setInterval(setCanvasTouch, 400);
    function fixMobile() {
      var editPanel = document.querySelector(".kb-customise-edit-panel");
      if (editPanel && editPanel.style.getPropertyValue("display") !== "none") {
        editPanel.style.setProperty("display", "none", "important");
      }
      setCanvasTouch();
      var previewPanel = document.querySelector(".kb-preview-panel");
      if (previewPanel) {
        previewPanel.style.setProperty("float", "none", "important");
        previewPanel.style.setProperty("width", "100%", "important");
      }
      if (!resizeDispatched && previewPanel) {
        resizeDispatched = true;
        window.dispatchEvent(new Event("resize"));
      }
    }
    var observer = new MutationObserver(function() {
      if (document.querySelector(".kb-customise-edit-panel")) {
        fixMobile();
        var interval = setInterval(fixMobile, 1e3);
        setTimeout(function() {
          clearInterval(interval);
        }, 15e3);
        observer.disconnect();
      }
    });
    observer.observe(kb, { childList: true, subtree: true });
    if (document.querySelector(".kb-customise-edit-panel")) {
      fixMobile();
    }
    function updateStepHighlight() {
      var items = document.querySelectorAll(".kb-customize-mobile-nav-item");
      items.forEach(function(li) {
        var a = li.querySelector("a");
        if (!a) return;
        if (li.classList.contains("kb-customize-mobile-nav-item-active")) {
          a.style.setProperty("background", "#e63946", "important");
          a.style.setProperty("opacity", "1", "important");
          a.style.setProperty("color", "#fff", "important");
        } else {
          a.style.setProperty("background", "#111", "important");
          a.style.setProperty("opacity", "0.35", "important");
        }
      });
      var nav = document.querySelector(".kb-customize-mobile-nav");
      if (nav) {
        nav.style.setProperty("position", "fixed", "important");
        nav.style.setProperty("bottom", "0", "important");
        nav.style.setProperty("left", "0", "important");
        nav.style.setProperty("right", "0", "important");
        nav.style.setProperty("z-index", "9999", "important");
        nav.style.setProperty("width", "100%", "important");
      }
    }
    var navInner = document.querySelector(".kb-customize-mobile-nav-inner");
    if (navInner) {
      new MutationObserver(updateStepHighlight).observe(navInner, { attributes: true, attributeFilter: ["class"], subtree: true });
    }
    setInterval(updateStepHighlight, 500);
    document.querySelectorAll(".kb-customize-mobile-nav-item a").forEach(function(a) {
      a.addEventListener("click", function() {
        setTimeout(function() {
          var ep = document.querySelector(".kb-customise-edit-panel");
          if (ep) ep.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 400);
      });
    });
  })();

  // src/skeleton/09-load-skeleton.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    var ORBIT = window.XeistConfig.v["xeist_poster_url"];
    var DUAL = "";
    try {
      DUAL = String((window.XeistConfig.v || {})["xeist_dual_poster_url"] || "");
    } catch (e) {
      DUAL = "";
    }
    var POSTERS = {
      "114891065": { img: ORBIT, noun: "backpack" },
      "114890045": { img: DUAL || ORBIT, noun: "backpack" },
      "211474835": { img: window.XeistConfig.assets["xeist-poster-navy-jacket.jpg"], noun: "jacket", flat: true },
      "211469246": { img: window.XeistConfig.assets["xeist-poster-navy-joggers.jpg"], noun: "joggers", flat: true },
      "212281188": { img: window.XeistConfig.assets["xeist-poster-black-jacket.jpg"], noun: "jacket", flat: true },
      "122282724": { img: window.XeistConfig.assets["xeist-poster-black-joggers.jpg"], noun: "joggers", flat: true },
      /* Elemental Grey (211489086 = the joggers variant "elemental-joggers-grey1") */
      "210147750": { img: window.XeistConfig.assets["xeist-poster-elemental-grey-jacket.jpg"], noun: "jacket", flat: true },
      "211485079": { img: window.XeistConfig.assets["xeist-poster-elemental-grey-joggers.jpg"], noun: "joggers", flat: true },
      "211489086": { img: window.XeistConfig.assets["xeist-poster-elemental-grey-joggers.jpg"], noun: "joggers", flat: true },
      /* Elemental Black */
      "117611677": { img: window.XeistConfig.assets["xeist-poster-elemental-black-jacket.jpg"], noun: "jacket", flat: true },
      "117991635": { img: window.XeistConfig.assets["xeist-poster-elemental-black-joggers.jpg"], noun: "joggers", flat: true }
    };
    var UNIFORM_POSTERS = {
      "105371583": { img: "https://www.xeist.com/cdn/shop/files/xe_caliber_front_1.jpg?v=1718642278", noun: "jersey", flat: true },
      // Vice jersey
      "105506843": { img: "https://www.xeist.com/cdn/shop/files/xe_caliber_short.jpg?v=1718643667", noun: "shorts", flat: true },
      // Vice shorts
      "107048689": { img: "https://www.xeist.com/cdn/shop/files/NEW_xe_caliber_jersey_cross_color.jpg?v=1718651421", noun: "jersey", flat: true },
      // Cross jersey
      "107045054": { img: "https://www.xeist.com/cdn/shop/files/new_new_shorts-cross_color.jpg?v=1718651423", noun: "shorts", flat: true },
      // Cross shorts
      "102815703": { img: "https://www.xeist.com/cdn/shop/products/2.jpg?v=1692085515", noun: "jersey", flat: true },
      // The X jersey
      "103981625": { img: "https://www.xeist.com/cdn/shop/products/XJersey-short.jpg?v=1692085515", noun: "shorts", flat: true },
      // The X shorts
      "108640209": { img: "https://www.xeist.com/cdn/shop/files/NEW_xe_caliber_jersey_hornet_color.jpg?v=1720025961", noun: "jersey", flat: true },
      // Hornet jersey
      "108641459": { img: "https://www.xeist.com/cdn/shop/files/new_new_shorts-hornet_color.jpg?v=1720025970", noun: "shorts", flat: true },
      // Hornet shorts
      "107447105": { img: "https://www.xeist.com/cdn/shop/files/NEW_xe_caliber_jersey_indy_color_07cf731d-cf46-4468-8f68-888037da0b55.jpg?v=1718653233", noun: "jersey", flat: true },
      // Indy jersey
      "107456931": { img: "https://www.xeist.com/cdn/shop/files/new_new_shorts-indy_color.jpg?v=1718653023", noun: "shorts", flat: true },
      // Indy shorts
      "108636728": { img: "https://www.xeist.com/cdn/shop/products/storm-back.jpg?v=1646409481", noun: "jersey", flat: true },
      // Storm jersey
      "108640210": { img: "https://www.xeist.com/cdn/shop/products/stormshorts.png?v=1646409481", noun: "shorts", flat: true },
      // Storm shorts
      "108636723": { img: "https://www.xeist.com/cdn/shop/files/NEW_xe_caliber_jersey_tiger_color_1.jpg?v=1718753517", noun: "jersey", flat: true },
      // Tiger jersey
      "108636724": { img: "https://www.xeist.com/cdn/shop/files/shorts.jpg?v=1718753528", noun: "shorts", flat: true },
      // Tiger shorts
      "108008592": { img: "https://www.xeist.com/cdn/shop/files/NEW_xe_caliber_jersey_flight_color.jpg?v=1720034710", noun: "jersey", flat: true },
      // Flight jersey
      "107983545": { img: "https://www.xeist.com/cdn/shop/files/new_new_shorts-flight_color.jpg?v=1720034806", noun: "shorts", flat: true },
      // Flight shorts
      "107904446": { img: "https://www.xeist.com/cdn/shop/files/NEW_xe_caliber_jersey_solar_color.jpg?v=1720026120", noun: "jersey", flat: true },
      // Solar jersey
      "107902891": { img: "https://www.xeist.com/cdn/shop/files/new_new_shorts-solar_color.jpg?v=1720026225", noun: "shorts", flat: true },
      // Solar shorts
      "108636726": { img: "https://www.xeist.com/cdn/shop/files/NEW_xe_caliber_jersey_rapture_color_c1237719-64bd-4d23-a16c-db44817cd892.jpg?v=1720033608", noun: "jersey", flat: true },
      // Rapture jersey
      "108636727": { img: "https://www.xeist.com/cdn/shop/files/new_new_shorts-rapture_color.jpg?v=1720034637", noun: "shorts", flat: true },
      // Rapture shorts
      "110221507": { img: "https://www.xeist.com/cdn/shop/products/Trident.jpg?v=1719441365", noun: "jersey", flat: true },
      // Trident jersey
      "110220905": { img: "https://www.xeist.com/cdn/shop/products/tridentshorts.jpg?v=1719441365", noun: "shorts", flat: true },
      // Trident shorts
      "110225240": { img: "https://www.xeist.com/cdn/shop/files/NEW_xe_caliber_jersey_buzz_color.jpg?v=1719442557", noun: "jersey", flat: true },
      // Buzz jersey
      "110221506": { img: "https://www.xeist.com/cdn/shop/files/new_new_shorts-buzz_color.jpg?v=1719442568", noun: "shorts", flat: true },
      // Buzz shorts
      "110220903": { img: "https://www.xeist.com/cdn/shop/products/XE-Caliber_-_Trench.jpg?v=1719441327", noun: "jersey", flat: true },
      // Trench jersey
      "110220904": { img: "https://www.xeist.com/cdn/shop/products/trenchshorts.jpg?v=1719441327", noun: "shorts", flat: true },
      // Trench shorts
      "110220902": { img: "https://www.xeist.com/cdn/shop/files/NEW_xe_caliber_jersey_supersonic_color_2.jpg?v=1719516960", noun: "jersey", flat: true },
      // Supersonic jersey
      "110225241": { img: "https://www.xeist.com/cdn/shop/files/new_new_shorts-supersonic_color_2.jpg?v=1719517126", noun: "shorts", flat: true },
      // Supersonic shorts
      "110220900": { img: "https://www.xeist.com/cdn/shop/products/Cameron.jpg?v=1719437730", noun: "jersey", flat: true },
      // Cameron jersey
      "110220901": { img: "https://www.xeist.com/cdn/shop/products/cameronshorts.jpg?v=1719437730", noun: "shorts", flat: true },
      // Cameron shorts
      "112544608": { img: "https://www.xeist.com/cdn/shop/files/1_9ef54add-bc98-4b2e-8663-41b896f7119b.png?v=1741196358", noun: "shooting shirt", flat: true },
      // Stripe hooded shooting shirt (product 112548745)
      "104436435": { img: "https://www.xeist.com/cdn/shop/files/strideline_vocal_white.jpg?v=1718743876", noun: "jersey", flat: true },
      // Vocal jersey (page titled Stride-Line; links to the XE-Caliber pair)
      "105092625": { img: "https://www.xeist.com/cdn/shop/files/strideline_shorts_vocal.jpg?v=1718743873", noun: "shorts", flat: true },
      // Vocal shorts
      "94282391": { img: "https://www.xeist.com/cdn/shop/products/Carolina_Blue.jpg?v=1646412762", noun: "jersey", flat: true },
      // Chapel Hill jersey (Stride-Line)
      "108968539": { img: "https://www.xeist.com/cdn/shop/products/ChapelHill-front.jpg?v=1646412762", noun: "shorts", flat: true },
      // Chapel Hill shorts (Stride-Line)
      "108969431": { img: "https://www.xeist.com/cdn/shop/files/strideline_shift_color.jpg?v=1718755244", noun: "jersey", flat: true },
      // Shift jersey (Stride-Line)
      "108968540": { img: "https://www.xeist.com/cdn/shop/files/strideline_shorts_shift_color.jpg?v=1718755253", noun: "shorts", flat: true },
      // Shift shorts (Stride-Line)
      "108968541": { img: "https://www.xeist.com/cdn/shop/products/red_stripes.jpg?v=1646412875", noun: "jersey", flat: true },
      // Uptop Boss jersey (Stride-Line)
      "108969835": { img: "https://www.xeist.com/cdn/shop/products/frontrs.jpg?v=1646412875", noun: "shorts", flat: true }
      // Uptop Boss shorts (Stride-Line)
    };
    try {
      window.XeistPosters = UNIFORM_POSTERS;
    } catch (e) {
    }
    var hashDesignId = (String(window.location.hash || "").match(/\d{9,}/) || [""])[0];
    var SPEC = POSTERS[hashDesignId] || UNIFORM_POSTERS[hashDesignId] || { img: "", noun: "gear" };
    var KEY = "xeist-customizer-skeleton";
    var POSTER = SPEC.img;
    var STATUSES = [
      "Warming up the 3D engine…",
      "Loading your " + SPEC.noun + "…",
      "Preparing fabrics & finishes…",
      "Setting up your studio…",
      "Almost ready…"
    ];
    var prog = 0, progTimer = null, statusTimer = null, statusIdx = 0, done = false;
    function setFill(p) {
      var f = document.getElementById("xeist-skel-fill");
      if (f) f.style.width = p + "%";
    }
    function build() {
      if (document.getElementById(KEY)) return;
      var sk = document.createElement("div");
      sk.id = KEY;
      var SILHOUETTE = '<svg class="xeist-skel__photo" viewBox="0 0 120 150" width="150" height="188" aria-hidden="true"><path d="M48 16 q12 -10 24 0" fill="none" stroke="rgba(0,0,0,0.18)" stroke-width="4" stroke-linecap="round"/><rect x="22" y="20" width="76" height="118" rx="26" fill="rgba(0,0,0,0.06)" stroke="rgba(0,0,0,0.10)" stroke-width="1.5"/><rect x="36" y="84" width="48" height="44" rx="12" fill="rgba(0,0,0,0.04)" stroke="rgba(0,0,0,0.10)" stroke-width="1.5"/></svg>';
      var art = POSTER ? '<img class="xeist-skel__photo' + (SPEC.flat ? " xeist-skel__photo--flat" : "") + '" src="' + POSTER + '" alt="" fetchpriority="high" decoding="async">' : SILHOUETTE;
      sk.innerHTML = '<div class="xeist-skel__stage">' + art + '<div class="xeist-skel__glow"></div></div><div class="xeist-skel__bar" role="progressbar" aria-label="Loading the 3D customizer"><div class="xeist-skel__fill" id="xeist-skel-fill"></div></div><div class="xeist-skel__status" id="xeist-skel-status" aria-live="polite">Starting up…</div>';
      var poster = sk.querySelector("img.xeist-skel__photo");
      if (poster) poster.onerror = function() {
        try {
          this.outerHTML = SILHOUETTE;
        } catch (e) {
          this.style.display = "none";
        }
      };
      document.body.appendChild(sk);
      startProgress();
    }
    function startProgress() {
      progTimer = setInterval(function() {
        if (done) return;
        prog += Math.max(0.4, (90 - prog) * 0.045);
        if (prog > 90) prog = 90;
        setFill(prog);
      }, 180);
      var st = document.getElementById("xeist-skel-status");
      if (st) st.textContent = STATUSES[0];
      statusTimer = setInterval(function() {
        if (done) return;
        statusIdx = (statusIdx + 1) % STATUSES.length;
        var s = document.getElementById("xeist-skel-status");
        if (!s) return;
        s.style.opacity = "0";
        setTimeout(function() {
          s.textContent = STATUSES[statusIdx];
          s.style.opacity = "1";
        }, 240);
      }, 1900);
    }
    function finish() {
      if (done) return;
      done = true;
      clearInterval(progTimer);
      clearInterval(statusTimer);
      setFill(100);
      var st = document.getElementById("xeist-skel-status");
      if (st) {
        st.style.opacity = "0";
        setTimeout(function() {
          st.textContent = "Ready";
          st.style.opacity = "1";
        }, 140);
      }
      setTimeout(remove, 450);
    }
    function remove() {
      var sk = document.getElementById(KEY);
      if (!sk) return;
      sk.classList.add("xeist-skel--hide");
      setTimeout(function() {
        if (sk.parentNode) sk.parentNode.removeChild(sk);
      }, 450);
    }
    if (document.body) build();
    else document.addEventListener("DOMContentLoaded", build);
    var started = Date.now();
    var poll = setInterval(function() {
      var canvas = document.querySelector(".kb-preview-panel canvas");
      var ready = canvas && canvas.width > 0 && canvas.getBoundingClientRect().height > 0;
      if (ready || Date.now() - started > 2e4) {
        clearInterval(poll);
        setTimeout(finish, ready ? 300 : 0);
      }
    }, 250);
  })();

  // src/enforcers/10-chrome-killer.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    var SELECTORS = ".kb-customize-mobile-nav, .kb-wizard-breadcrumbs, .kb-customize-mobile-nav-inner";
    function nuke() {
      var els = document.querySelectorAll(SELECTORS);
      for (var i = 0; i < els.length; i++) {
        var s = els[i].style;
        if (s.getPropertyValue("display") !== "none") {
          s.setProperty("display", "none", "important");
          s.setProperty("visibility", "hidden", "important");
          s.setProperty("height", "0", "important");
          s.setProperty("overflow", "hidden", "important");
          s.setProperty("pointer-events", "none", "important");
        }
      }
    }
    nuke();
    if (window.XeistCore) {
      XeistCore.every("kb-chrome-killer", 800, nuke, { runHidden: true });
    } else {
      setInterval(nuke, 800);
    }
  })();

  // src/kb-boot/11-default-number-strip.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    try {
      var chosenDesign = (String(window.location.hash || "").match(/customise\/(\d+)/) || [])[1] || "";
      if (chosenDesign && String(window.localStorage.getItem("xeist_coach_number_" + chosenDesign) || "") === "2") return;
    } catch (eChosen) {
    }
    document.addEventListener("click", function(e) {
      var t2 = e.target;
      if (t2 && t2.closest && t2.closest("#xeist-add-number-overlay")) {
        window.__xeistUserNumberIntent = true;
      }
    }, true);
    var tries = 0;
    var bridgeAttempts = 0;
    var cleanStreak = 0;
    var strippedOnce = false;
    var t = setInterval(function() {
      tries++;
      if (tries > 300) {
        clearInterval(t);
        return;
      }
      if (window.__xeistUserNumberIntent) {
        clearInterval(t);
        return;
      }
      try {
        var root = document.querySelector("[ng-controller]");
        if (!root || !window.angular) return;
        var inj = angular.element(root).injector();
        if (!inj) return;
        var kit = inj.get("KitService").kit;
        var items = kit && kit.editor || [];
        var numIdx = -1, numItem = null;
        for (var i = 0; i < items.length; i++) {
          if (String(items[i].placementKey || "").toLowerCase() === "add-number") {
            numIdx = i;
            numItem = items[i];
            break;
          }
        }
        if (numIdx === -1) {
          cleanStreak++;
          if (strippedOnce && cleanStreak >= 12 || tries > 75) clearInterval(t);
          return;
        }
        cleanStreak = 0;
        var numText = String(numItem.text == null ? "" : numItem.text).trim();
        if (numText !== "2") {
          clearInterval(t);
          return;
        }
        var b = window.XeistKBBridge;
        if (b && typeof b.disableDefaultNumber === "function" && bridgeAttempts < 3) {
          bridgeAttempts++;
          strippedOnce = true;
          b.disableDefaultNumber();
          return;
        }
        strippedOnce = true;
        angular.element(root).scope().$apply(function() {
          kit.editor.splice(numIdx, 1);
        });
      } catch (e2) {
      }
    }, 120);
  })();

  // src/logo-tools/12-decoration-position-lock.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    var LOCK_KEYS = { "add-number": true, "add-logo": true };
    var specs = {
      /* add-number moved from (450,1300) to (1399,1773): the old value is
         UV ~(0.106,0.306) which this product's GLB maps onto a SIDE panel
         (the "number on the side" bug, seen on real phones where KB serves
         mobile markup and the desktop canvas overlay does not run). The new
         value is UV ~(0.329,0.417) = the front middle pocket. Coordinates
         are in the design SVG space (viewBox 0 0 4251 4251). Keep in sync
         with getNumberDefaults() in assets/xeist-kb-bridge.js. */
      /* (1399,1773): FINAL top-pocket centre (2026-08-28) — matches the
         KB field template, 19-coach-config numberDefaults, and module
         17's snap fallback. */
      "add-number": { x: 1399, y: 1773 },
      "add-logo": { x: 375, y: 2400 }
    };
    try {
      var _coachCfg = window.XeistOrbitCoachConfig || {};
      if (_coachCfg.decorationSpecs) {
        for (var _dk in _coachCfg.decorationSpecs) {
          if (_coachCfg.decorationSpecs.hasOwnProperty(_dk) && _coachCfg.decorationSpecs[_dk]) {
            specs[_dk] = { x: _coachCfg.decorationSpecs[_dk].x, y: _coachCfg.decorationSpecs[_dk].y };
          }
        }
      }
    } catch (e) {
    }
    function harvestSpecs() {
      try {
        var _cc = window.XeistOrbitCoachConfig;
        if (_cc && _cc.decorationSpecs) {
          for (var _k in _cc.decorationSpecs) {
            if (_cc.decorationSpecs.hasOwnProperty(_k) && _cc.decorationSpecs[_k]) {
              specs[_k] = { x: _cc.decorationSpecs[_k].x, y: _cc.decorationSpecs[_k].y };
            }
          }
        }
      } catch (e) {
      }
      var headers = document.querySelectorAll(".kb-editor-heading.kb-wizard-group-header");
      for (var i = 0; i < headers.length; i++) {
        var s = angular.element(headers[i]).scope();
        var p = s && s.placement;
        if (!p || !p.placementKey) continue;
        var key = String(p.placementKey).toLowerCase();
        if (!LOCK_KEYS[key]) continue;
        if (key !== "add-number" && p.x != null && p.y != null && isFinite(parseFloat(p.x))) {
          specs[key] = { x: parseFloat(p.x), y: parseFloat(p.y) };
        }
        if (String(p.disableMove) !== "true") p.disableMove = "true";
      }
      try {
        var _as = window.__xeistAlignedLogoSpec;
        if (_as && isFinite(_as.x) && isFinite(_as.y)) specs["add-logo"] = { x: _as.x, y: _as.y };
      } catch (e) {
      }
    }
    var firstSeenAt = 0;
    var reprojectPass = 0;
    var REPROJECT_DELAYS = [6e3, 14e3, 3e4];
    function modelVisiblyReady() {
      if (document.getElementById("xeist-customizer-skeleton")) return false;
      var cv = document.querySelector(".kb-preview-panel canvas");
      if (!cv || !cv.width) return false;
      try {
        return cv.getBoundingClientRect().height > 0;
      } catch (e) {
        return true;
      }
    }
    function lockedByKB(key) {
      try {
        return !!document.querySelector('[placement-key="' + key + '"][disable-move="true"]');
      } catch (e) {
        return false;
      }
    }
    function numberLockedByKB() {
      return lockedByKB("add-number");
    }
    function maybeReproject(items, scope) {
      if (!items.length) return;
      if (!modelVisiblyReady()) return;
      if (!firstSeenAt) {
        firstSeenAt = Date.now();
        return;
      }
      if (reprojectPass >= REPROJECT_DELAYS.length) return;
      if (Date.now() - firstSeenAt < REPROJECT_DELAYS[reprojectPass]) return;
      reprojectPass++;
      scope.$apply(function() {
        items.forEach(function(it) {
          if (!LOCK_KEYS[String(it.placementKey || "").toLowerCase()]) return;
          var ix = parseFloat(it.x);
          if (isFinite(ix)) it.x = ix + 1;
        });
      });
    }
    function enforce() {
      if (!window.angular) return;
      if (document.hidden) return;
      var cta = document.querySelector("[data-bottom-bar-cta]");
      if (cta && cta.disabled) return;
      var root = document.querySelector("[ng-controller]");
      if (!root) return;
      var el = angular.element(root);
      var inj = el.injector();
      if (!inj) return;
      var kit = inj.get("KitService").kit;
      var items = kit && kit.editor || [];
      if (!items.length && !firstSeenAt) return;
      harvestSpecs();
      maybeReproject(items, el.scope());
      var fixes = [];
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        var itKey = String(it.placementKey || "").toLowerCase();
        if (itKey === "add-number" || itKey === "add-logo") continue;
        if (lockedByKB(itKey)) continue;
        var spec = specs[itKey];
        if (!spec) continue;
        var ix = parseFloat(it.x), iy = parseFloat(it.y);
        if (!isFinite(ix) || !isFinite(iy)) continue;
        if (Math.abs(ix - spec.x) > 0.5 || Math.abs(iy - spec.y) > 0.5) {
          fixes.push({ item: it, spec });
        }
      }
      if (!fixes.length) return;
      var scope = el.scope();
      scope.$apply(function() {
        fixes.forEach(function(f) {
          f.item.x = f.spec.x;
          f.item.y = f.spec.y;
        });
      });
    }
    setInterval(function() {
      try {
        enforce();
      } catch (e) {
      }
    }, 1500);
    if (window.location.search.indexOf("xdebug") !== -1) {
      window.__xeistBootProbe = "probing...";
      try {
        fetch("https://api.kitbuilder.co.uk/api/bootstrapper", { mode: "no-cors", cache: "reload" }).then(function() {
          window.__xeistBootProbe = "reachable";
        }).catch(function(e) {
          window.__xeistBootProbe = "NETWORK FAIL: " + e.message;
        });
      } catch (e) {
        window.__xeistBootProbe = "probe err: " + e.message;
      }
      var dbg = document.createElement("div");
      dbg.style.cssText = "position:fixed;top:70px;left:8px;right:8px;z-index:99999;background:rgba(0,0,0,.82);color:#0f0;font:10px/1.5 monospace;padding:8px;border-radius:8px;pointer-events:none;white-space:pre-wrap;";
      document.body.appendChild(dbg);
      setInterval(function() {
        try {
          var root = document.querySelector("[ng-controller]");
          var kit = window.angular && root ? angular.element(root).injector().get("KitService").kit : null;
          var rows = (kit && kit.editor || []).map(function(i) {
            return (i.placementKey || "?") + " (" + (i.type || "?") + ") x=" + i.x + " y=" + i.y + (i.text ? ' "' + i.text + '"' : "");
          });
          var layout = "";
          try {
            var pp = document.querySelector(".kb-preview-panel");
            var cv = document.querySelector(".kb-preview-panel canvas");
            var bar = document.getElementById("xeist-bottom-bar");
            var r = function(el2) {
              if (!el2) return "n/a";
              var b = el2.getBoundingClientRect();
              return Math.round(b.top) + ".." + Math.round(b.bottom) + " (h" + Math.round(b.height) + ")";
            };
            layout = "\nvh: " + window.innerHeight + "\npanel: " + r(pp) + "\ncanvas: " + r(cv) + "\nbar: " + r(bar) + "\ngap panel->bar: " + (pp && bar ? Math.round(bar.getBoundingClientRect().top - pp.getBoundingClientRect().bottom) : "n/a");
            try {
              var rx = function(el2) {
                if (!el2) return "n/a";
                var b = el2.getBoundingClientRect();
                return Math.round(b.left) + ".." + Math.round(b.right) + " (w" + Math.round(b.width) + ")";
              };
              var inn = pp ? pp.querySelector(".kb-preview-panel-inner") : null;
              layout += "\nvw: " + window.innerWidth + " dpr " + (window.devicePixelRatio || 1) + "\npanelX: " + rx(pp) + " ovf=" + (pp ? getComputedStyle(pp).overflow : "-") + "\ncanvasX: " + rx(cv) + " buf=" + (cv ? cv.width + "x" + cv.height : "-") + " css=" + (cv ? (cv.style.width || "-") + "/" + (cv.style.height || "-") : "-") + "\ncanvas tf: " + (cv && cv.style.transform ? cv.style.transform : "-") + " fit=" + (cv ? cv.style.objectFit || "-" : "-") + "\ninner tf: " + (inn && inn.style.transform ? inn.style.transform : "-") + "\nnumR: " + (window.__xeistNumDbg ? "mode=" + (window.__xeistNumDbg.mode || "-") + " draws=" + window.__xeistNumDbg.draws + " probes=" + (window.__xeistNumDbg.probes || 0) + " misses=" + (window.__xeistNumDbg.probeMisses || 0) : "n/a");
              var app0 = window.__xeistPbrApp;
              if (app0 && app0.lib && app0.lib.renderer) {
                var sz = {};
                try {
                  app0.lib.renderer.getSize({ set: function(w, h) {
                    sz.w = w;
                    sz.h = h;
                  } });
                } catch (e4) {
                }
                var cam0 = app0.lib.camera;
                layout += "\nrenderer: " + (sz.w || "?") + "x" + (sz.h || "?") + " pr=" + (app0.lib.renderer.getPixelRatio ? app0.lib.renderer.getPixelRatio() : "?") + " cam aspect=" + (cam0 && cam0.aspect ? cam0.aspect.toFixed(3) : "?") + " zoom=" + (cam0 ? cam0.zoom : "?") + " frames=" + (app0.lib.renderer.info && app0.lib.renderer.info.render ? app0.lib.renderer.info.render.frame : "?");
              }
            } catch (e5) {
              layout += "\nlayoutX err: " + e5.message;
            }
            try {
              if (pp && bar) {
                var zTop = pp.getBoundingClientRect().bottom + 5;
                var els2 = document.elementsFromPoint(window.innerWidth / 2, Math.min(zTop, window.innerHeight - 1));
                layout += "\nzone: " + els2.slice(0, 3).map(function(el2) {
                  return el2.tagName.toLowerCase() + (el2.className && typeof el2.className === "string" ? "." + el2.className.split(" ")[0] : "");
                }).join(" > ");
              }
            } catch (e3) {
            }
          } catch (e2) {
            layout = "\nlayout err: " + e2.message;
          }
          var bake = "";
          try {
            bake += "\nPBR global: " + (window.KitBuilderPBR ? "yes" : "NO") + " | pbrApp: " + (window.__xeistPbrApp ? "captured" : "NO") + " | edTex: " + (window.__xeistEditorTexture ? "captured" : "NO");
            var svgs = document.querySelectorAll("svg.kb-svgext-live, svg[kb-svgext-id]");
            bake += "\nlive svgs: " + svgs.length;
            for (var sv = 0; sv < svgs.length; sv++) {
              var el = svgs[sv];
              var uid = el.getAttribute("kb-svgext-id") || "#" + sv;
              var texts = el.querySelectorAll("text");
              var otf = el.querySelectorAll("[kb-svgext-otf-id]");
              bake += "\n " + uid + ": texts=" + texts.length + " otf=" + otf.length;
              for (var tx = 0; tx < Math.min(texts.length, 4); tx++) {
                var t = texts[tx];
                bake += "\n  t" + tx + " x=" + t.getAttribute("x") + " y=" + t.getAttribute("y") + " fill=" + (t.getAttribute("fill") || t.getAttribute("color") || "-") + " ff=" + (t.getAttribute("font-family") || "-") + " otfid=" + (t.hasAttribute("kb-svgext-otf-id") ? "Y" : "n") + ' txt="' + String(t.textContent || "").slice(0, 6) + '"';
              }
            }
          } catch (eB) {
            bake = "\nbake probe err: " + eB.message;
          }
          dbg.textContent = "items: " + rows.length + "\n" + rows.join("\n") + "\nspecs: " + JSON.stringify(specs) + "\nheaders: " + document.querySelectorAll(".kb-editor-heading.kb-wizard-group-header").length + layout + bake + "\nbootstrapper tag: " + (document.querySelector('script[src*="bootstrapper"]') ? "present" : "MISSING") + "\nbootstrapper net: " + (window.__xeistBootProbe || "n/a") + "\nerrs: " + (window.__xeistErrs && window.__xeistErrs.length ? "\n" + window.__xeistErrs.join("\n") : "none");
        } catch (e) {
          dbg.textContent = "dbg err: " + e.message;
        }
      }, 2e3);
    }
  })();

  // src/enforcers/13-sticky-preview.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1 || !window.__xeistCoachOn()) return;
    var FAST_INTERVAL = 400;
    var SLOW_INTERVAL = 2e3;
    var STABLE_THRESHOLD = 30;
    var stableTicks = 0;
    var currentInterval = FAST_INTERVAL;
    var timerId = null;
    function applyStickyPreview() {
      var kitBuilder = document.querySelector("#kitBuilder");
      var kbApp = document.querySelector("#kb-app");
      var kbPage = document.querySelector(".kb-customise-page");
      var previewPanel = document.querySelector(".kb-preview-panel");
      var editPanel = document.querySelector(".kb-customise-edit-panel");
      if (!kitBuilder || !kbApp || !kbPage || !previewPanel || !editPanel) {
        stableTicks = 0;
        return false;
      }
      if (previewPanel.style.getPropertyValue("position") === "sticky") {
        return true;
      }
      kitBuilder.style.setProperty("max-height", "none", "important");
      kitBuilder.style.setProperty("overflow", "visible", "important");
      kbApp.style.setProperty("overflow", "visible", "important");
      kbPage.style.setProperty("display", "flex", "important");
      kbPage.style.setProperty("align-items", "flex-start", "important");
      previewPanel.style.setProperty("float", "none", "important");
      previewPanel.style.setProperty("position", "sticky", "important");
      previewPanel.style.setProperty("top", "0", "important");
      previewPanel.style.setProperty("z-index", "10", "important");
      previewPanel.style.setProperty("flex", "1 1 auto", "important");
      previewPanel.style.setProperty("max-height", "75vh", "important");
      previewPanel.style.setProperty("overflow", "hidden", "important");
      var breadcrumbs = document.querySelector(".main-page__breadcrumbs");
      if (breadcrumbs) breadcrumbs.style.setProperty("margin-bottom", "12px", "important");
      editPanel.style.setProperty("float", "none", "important");
      editPanel.style.setProperty("flex", "0 0 410px", "important");
      window.dispatchEvent(new Event("resize"));
      return true;
    }
    function unapplyStickyPreview() {
      var kitBuilder = document.querySelector("#kitBuilder");
      var kbApp = document.querySelector("#kb-app");
      var kbPage = document.querySelector(".kb-customise-page");
      var previewPanel = document.querySelector(".kb-preview-panel");
      var editPanel = document.querySelector(".kb-customise-edit-panel");
      var inner = previewPanel && previewPanel.querySelector(".kb-preview-panel-inner");
      var breadcrumbs = document.querySelector(".main-page__breadcrumbs");
      if (kitBuilder) {
        kitBuilder.style.removeProperty("max-height");
        kitBuilder.style.removeProperty("overflow");
      }
      if (kbApp) kbApp.style.removeProperty("overflow");
      if (kbPage) {
        kbPage.style.removeProperty("display");
        kbPage.style.removeProperty("align-items");
      }
      if (previewPanel) {
        var props = ["float", "position", "top", "z-index", "flex", "max-height", "overflow"];
        for (var i = 0; i < props.length; i++) previewPanel.style.removeProperty(props[i]);
      }
      if (editPanel) {
        editPanel.style.removeProperty("float");
        editPanel.style.removeProperty("flex");
      }
      if (inner) inner.style.removeProperty("transform");
      if (breadcrumbs) breadcrumbs.style.removeProperty("margin-bottom");
      var canvasEl = previewPanel && previewPanel.querySelector("canvas");
      if (canvasEl) {
        canvasEl.style.removeProperty("max-height");
        canvasEl.style.removeProperty("object-fit");
        canvasEl.style.removeProperty("transform");
        canvasEl.style.removeProperty("transform-origin");
      }
      var logoOv = document.getElementById("xeist-add-logo-overlay");
      var numOv = document.getElementById("xeist-add-number-overlay");
      if (logoOv) logoOv.style.top = "";
      if (numOv) numOv.style.top = "";
      if (previewPanel) previewPanel.__xeistBandH = null;
    }
    function centerPreviewBag() {
      var previewPanel = document.querySelector(".kb-preview-panel");
      if (!previewPanel) return;
      var inner = previewPanel.querySelector(".kb-preview-panel-inner");
      var canvas = previewPanel.querySelector("canvas");
      if (!inner || !canvas) return;
      var breadcrumbs = document.querySelector(".main-page__breadcrumbs");
      var headerEl = document.querySelector("header");
      var bandTop = breadcrumbs ? breadcrumbs.getBoundingClientRect().bottom : headerEl ? headerEl.getBoundingClientRect().bottom : 0;
      var bottomBar = document.getElementById("xeist-bottom-bar");
      var barRect = bottomBar && bottomBar.getBoundingClientRect();
      var bandBottom = barRect && barRect.height ? barRect.top : window.innerHeight;
      var panelRect = previewPanel.getBoundingClientRect();
      var bandHeight = Math.max(220, Math.round(bandBottom - bandTop) - 16);
      var _coachZCfg = window.XeistOrbitCoachConfig || {};
      var _zScale = typeof _coachZCfg.previewZoomScale === "number" && isFinite(_coachZCfg.previewZoomScale) && _coachZCfg.previewZoomScale > 0 ? _coachZCfg.previewZoomScale : 1;
      var ZOOM = (window.innerWidth >= 990 ? 2 : 1.7) * _zScale;
      if (previewPanel.__xeistBandH !== bandHeight) {
        previewPanel.__xeistBandH = bandHeight;
        previewPanel.style.setProperty("max-height", Math.max(220, Math.round(bandBottom - panelRect.top) - 8) + "px", "important");
        canvas.style.setProperty("max-height", bandHeight + "px", "important");
        canvas.style.setProperty("object-fit", "contain", "important");
        canvas.style.setProperty("transform", "scale(" + ZOOM + ")", "important");
        canvas.style.setProperty("transform-origin", "center center", "important");
      }
      var overlayBase = Math.round(bandTop - panelRect.top + bandHeight * 0.5);
      var logoOverlay = document.getElementById("xeist-add-logo-overlay");
      var numberOverlay = document.getElementById("xeist-add-number-overlay");
      if (logoOverlay) logoOverlay.style.top = overlayBase + "px";
      if (numberOverlay) numberOverlay.style.top = overlayBase + 52 + "px";
      var bandCenter = (bandTop + bandBottom) / 2;
      var canvasRect = canvas.getBoundingClientRect();
      var canvasCenter = canvasRect.top + canvasRect.height / 2;
      var appliedShift = 0;
      var match = /translateY\((-?\d+(?:\.\d+)?)px\)/.exec(inner.style.transform || "");
      if (match) appliedShift = parseFloat(match[1]);
      var naturalCenter = canvasCenter - appliedShift;
      var targetShift = Math.round(bandCenter - naturalCenter);
      if (Math.abs(targetShift - appliedShift) > 1) {
        inner.style.setProperty("transform", "translateY(" + targetShift + "px)", "important");
      }
    }
    function tick() {
      if (document.documentElement.getAttribute("data-xeist-flow") === "on") {
        stableTicks = 0;
        return;
      }
      if (window.innerWidth < 990) {
        stableTicks = 0;
        unapplyStickyPreview();
        return;
      }
      var ok = applyStickyPreview();
      if (ok) {
        centerPreviewBag();
        stableTicks++;
        if (stableTicks >= STABLE_THRESHOLD && currentInterval !== SLOW_INTERVAL) {
          clearInterval(timerId);
          currentInterval = SLOW_INTERVAL;
          timerId = setInterval(tick, currentInterval);
        }
      } else {
        if (currentInterval !== FAST_INTERVAL) {
          clearInterval(timerId);
          currentInterval = FAST_INTERVAL;
          timerId = setInterval(tick, currentInterval);
        }
        stableTicks = 0;
      }
    }
    timerId = setInterval(tick, FAST_INTERVAL);
    var resizeRaf = null;
    window.addEventListener("resize", function() {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function() {
        if (document.documentElement.getAttribute("data-xeist-flow") === "on") return;
        if (window.innerWidth < 990) {
          unapplyStickyPreview();
          return;
        }
        applyStickyPreview();
        centerPreviewBag();
      });
    });
  })();

  // src/kb-boot/14-svg-white-line-fix.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1 || !/114891065|114890045/.test(window.location.hash || "")) return;
    var BG_PATH_ID = "xeist-svg-bg";
    var applied = false;
    function injectBg(viewGroup) {
      if (applied) return;
      if (viewGroup.querySelector("#" + BG_PATH_ID)) return;
      var bg = document.createElementNS("http://www.w3.org/2000/svg", "path");
      bg.setAttribute("id", BG_PATH_ID);
      bg.setAttribute("fill", "#000000");
      bg.setAttribute("d", "M0,0 H4251 V4251 H0 Z");
      viewGroup.insertBefore(bg, viewGroup.firstChild);
      applied = true;
    }
    var mo = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!node.querySelectorAll) continue;
          if (node.classList && node.classList.contains("kb-view")) {
            injectBg(node);
          }
          var views = node.querySelectorAll(".kb-view");
          for (var k = 0; k < views.length; k++) {
            injectBg(views[k]);
          }
        }
      }
      if (!applied) {
        var existing = document.querySelector(".kb-view #Base");
        if (existing && existing.parentNode) {
          injectBg(existing.parentNode);
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    var pollId = setInterval(function() {
      var base = document.querySelector(".kb-view #Base");
      if (base && base.parentNode) {
        injectBg(base.parentNode);
        clearInterval(pollId);
        mo.disconnect();
      }
    }, 50);
    setTimeout(function() {
      clearInterval(pollId);
      mo.disconnect();
    }, 3e4);
  })();

  // src/logo-tools/15-add-logo-autoprompt.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1 || !/114891065|114890045|209873286/.test(window.location.hash || "")) return;
    var design = (String(window.location.hash).match(/customise\/(\d+)/) || [])[1] || "";
    var isCompression = design === "209873286";
    var NOUN = isCompression ? "shirt" : "backpack";
    var TEAM_KEY = "xeist_team_name_" + design;
    var isDual = design === "114890045";
    var POSTER_KEY = isDual ? "xeist_dual_poster_url" : "xeist_poster_url";
    var VIDEO_GLOBAL = isDual ? "__xeistDualVideoSrc" : "__xeistOrbitVideoSrc";
    var VIDEO_ASSET = isDual ? "xeist-dual-rotation-v1.js" : "";
    (function loadBagClip() {
      if (!VIDEO_ASSET || isCompression) return;
      try {
        if (window[VIDEO_GLOBAL]) return;
        var url = String(((window.XeistConfig || {}).assets || {})[VIDEO_ASSET] || "");
        if (!url) return;
        var id = "xeist-bag-clip-" + design;
        if (document.getElementById(id)) return;
        var sc = document.createElement("script");
        sc.id = id;
        sc.src = url;
        sc.async = true;
        var head = document.head || document.getElementsByTagName && document.getElementsByTagName("head")[0];
        (head || document.body || document.documentElement).appendChild(sc);
      } catch (e) {
      }
    })();
    if (/[?&]xeist_popups=reset/.test((window.location.search || "") + (window.location.hash || ""))) {
      try {
        [
          "xeist_logo_popup_shown",
          "xeist_logo_popup_shown_209873286",
          "xeist_number_nudge_shown_114891065",
          "xeist_number_nudge_shown_114890045",
          TEAM_KEY
        ].forEach(function(k) {
          localStorage.removeItem(k);
          sessionStorage.removeItem(k);
        });
      } catch (eR) {
      }
    }
    var store = (function() {
      try {
        localStorage.getItem(TEAM_KEY);
        return localStorage;
      } catch (e) {
        return sessionStorage;
      }
    })();
    function savedTeam() {
      try {
        return String(store.getItem(TEAM_KEY) || "");
      } catch (e) {
        return "";
      }
    }
    var PULSE_CSS = [
      "@keyframes xeist-gate-ping{0%{box-shadow:0 4px 16px rgba(94,35,148,.35),0 0 0 0 rgba(94,35,148,.6)}70%{box-shadow:0 6px 20px rgba(94,35,148,.42),0 0 0 16px rgba(94,35,148,0)}100%{box-shadow:0 4px 16px rgba(94,35,148,.35),0 0 0 0 rgba(94,35,148,0)}}",
      "@keyframes xeist-gate-shimmer{0%,55%{transform:translateX(-160%) skewX(-18deg)}100%{transform:translateX(320%) skewX(-18deg)}}",
      ".xeist-gate-pulse{position:relative;overflow:hidden;}",
      ".xeist-gate-pulse:not([disabled]){animation:xeist-gate-ping 1.9s cubic-bezier(.2,.7,.3,1) infinite;}",
      '.xeist-gate-pulse::after{content:"";position:absolute;top:0;bottom:0;left:0;width:45%;pointer-events:none;background:linear-gradient(100deg,rgba(255,255,255,0) 0%,rgba(255,255,255,.32) 50%,rgba(255,255,255,0) 100%);transform:translateX(-160%) skewX(-18deg);}',
      ".xeist-gate-pulse:not([disabled])::after{animation:xeist-gate-shimmer 3.4s ease-in-out infinite;}",
      "@media (prefers-reduced-motion:reduce){.xeist-gate-pulse:not([disabled]){animation:none;box-shadow:0 4px 16px rgba(94,35,148,.35),0 0 0 5px rgba(94,35,148,.18);}.xeist-gate-pulse::after{display:none;animation:none;}}"
    ].join("\n");
    var WALL_CSS = [
      '#xeist-logo-popup-overlay{font-family:-apple-system,BlinkMacSystemFont,"SF Pro Display","SF Pro Text","Segoe UI",Roboto,Helvetica,Arial,sans-serif!important;color:#16162a!important;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.3;}',
      "#xeist-logo-popup-overlay *{box-sizing:border-box;font-family:inherit!important;}",
      "#xeist-logo-popup-overlay .xgw{position:relative;display:flex;flex-direction:column;width:100%;max-width:520px;height:100%;margin:0 auto;padding:env(safe-area-inset-top,0px) 24px 0;text-align:center;transform:translateY(12px);transition:transform .3s ease;}",
      /* top bar */
      "#xeist-logo-popup-overlay .xgw__bar{flex:none;display:flex;align-items:center;justify-content:space-between;height:56px;margin:0 -6px;}",
      "#xeist-logo-popup-overlay .xgw__back{display:flex;align-items:center;justify-content:center;width:44px;height:44px;margin:0;padding:0;border:0;border-radius:50%;background:none;color:#16162a!important;text-decoration:none!important;cursor:pointer;-webkit-tap-highlight-color:transparent;}",
      "#xeist-logo-popup-overlay .xgw__back:hover{background:#f3f3f5;}",
      "#xeist-logo-popup-overlay .xgw__back svg{display:block;width:24px;height:24px;}",
      "#xeist-logo-popup-overlay .xgw__brand{display:flex;align-items:center;justify-content:center;flex:1 1 auto;min-width:0;}",
      "#xeist-logo-popup-overlay .xgw__brand img{display:block;height:15px;width:auto;max-width:120px;}",
      "#xeist-logo-popup-overlay .xgw__brand span{font-size:15px!important;font-weight:700!important;letter-spacing:.34em!important;text-indent:.34em;color:#16162a!important;text-transform:uppercase!important;line-height:1!important;}",
      "#xeist-logo-popup-overlay .xgw__count{flex:none;min-width:44px;font-size:15px!important;font-weight:500!important;letter-spacing:.02em!important;color:#3d3d4a!important;text-align:right;font-variant-numeric:tabular-nums;padding-right:6px;}",
      /* hero: ring behind, clip on top, pill above both */
      "#xeist-logo-popup-overlay .xgw__hero{position:relative;flex:1 1 40vh;min-height:240px;max-height:440px;display:flex;align-items:center;justify-content:center;margin:0 -24px;overflow:hidden;}",
      "#xeist-logo-popup-overlay .xgw__ring{position:absolute;left:9%;right:9%;top:55%;height:0;padding-top:16.4%;transform:translateY(-50%);border:1.5px solid #dcdce1;border-radius:50%;z-index:0;}",
      "#xeist-logo-popup-overlay .xgw__dot{position:absolute;left:20%;top:90%;width:13px;height:13px;margin:-6.5px 0 0 -6.5px;border-radius:50%;background:#33333e;box-shadow:0 2px 5px rgba(0,0,0,.28);}",
      /* the clip is 4:3 with the bag in its middle 40% — it is always
         scaled by HEIGHT (height:100%, width from the intrinsic ratio),
         centred, and the hero's overflow crops whatever backdrop sticks
         out at the sides on a narrow phone. Never crop-to-fill (cover): on
         a short hero that crops the handle and the shadow instead. */
      "#xeist-logo-popup-overlay .xgw__media{position:absolute;top:0;bottom:0;left:50%;z-index:1;display:block;height:100%;width:auto;max-width:none;max-height:none;margin:0;padding:0;border:0;transform:translateX(-50%);object-fit:contain;filter:grayscale(1) brightness(1.12) contrast(1.15) brightness(1.05);mix-blend-mode:multiply;-webkit-mask-image:radial-gradient(ellipse 55% 78% at 50% 50%,#000 60%,rgba(0,0,0,0) 92%);mask-image:radial-gradient(ellipse 55% 78% at 50% 50%,#000 60%,rgba(0,0,0,0) 92%);}",
      "#xeist-logo-popup-overlay .xgw__spin{position:absolute;right:11%;top:55%;z-index:2;display:flex;flex-direction:column;align-items:center;gap:3px;margin-top:22px;padding:8px 13px 7px;border-radius:999px;background:#fff;box-shadow:0 2px 12px rgba(0,0,0,.10),0 0 0 1px rgba(0,0,0,.03);}",
      "#xeist-logo-popup-overlay .xgw__spin span{font-size:12px!important;font-weight:600!important;letter-spacing:.02em!important;line-height:1!important;color:#3d3d4a!important;}",
      "#xeist-logo-popup-overlay .xgw__spin svg{display:block;width:22px;height:9px;}",
      /* copy + form */
      "#xeist-logo-popup-overlay .xgw__body{flex:none;display:flex;flex-direction:column;align-items:center;padding:14px 0 calc(20px + env(safe-area-inset-bottom,0px));}",
      "#xeist-logo-popup-overlay .xgw__kicker{margin:0 0 10px;font-size:13px!important;font-weight:500!important;letter-spacing:.2em!important;text-transform:uppercase!important;color:#6f6f7b!important;line-height:1.2!important;}",
      "#xeist-logo-popup-overlay .xgw__title{margin:0 0 12px;font-size:clamp(30px,8.4vw,38px)!important;font-weight:600!important;line-height:1.08!important;letter-spacing:-.022em!important;text-transform:none!important;color:#16162a!important;}",
      "#xeist-logo-popup-overlay .xgw__sub{max-width:380px;margin:0 0 24px;font-size:15px!important;font-weight:400!important;line-height:1.45!important;letter-spacing:0!important;text-transform:none!important;color:#3f3f4c!important;}",
      "#xeist-logo-popup-overlay .xgw__label{display:block;width:100%;margin:0 0 8px;text-align:left;font-size:13px!important;font-weight:500!important;letter-spacing:.18em!important;text-transform:uppercase!important;color:#4a4a58!important;line-height:1.2!important;}",
      "#xeist-logo-popup-overlay #xeist-gate-team{display:block;width:100%;height:54px;margin:0 0 14px;padding:0 18px;border:1px solid #d9d9de;border-radius:12px;background:#fff!important;color:#16162a!important;font-size:16px!important;font-weight:400!important;letter-spacing:0!important;text-transform:none!important;text-align:left;outline:none;-webkit-appearance:none;appearance:none;box-shadow:none;transition:border-color .15s ease,box-shadow .15s ease;}",
      "#xeist-logo-popup-overlay #xeist-gate-team::placeholder{color:#9a9aa6;opacity:1;}",
      "#xeist-logo-popup-overlay #xeist-gate-team:focus{border-color:#5E2394;box-shadow:0 0 0 3px rgba(94,35,148,.12);}",
      "#xeist-logo-popup-overlay #xeist-gate-upload{display:inline-flex;align-items:center;justify-content:center;gap:10px;width:100%;height:58px;margin:0;padding:0 24px;border:0;border-radius:14px;background:#5E2394;color:#fff!important;font-size:18px!important;font-weight:600!important;letter-spacing:.1px!important;text-transform:none!important;line-height:1!important;cursor:pointer;-webkit-appearance:none;appearance:none;-webkit-tap-highlight-color:transparent;box-shadow:0 4px 16px rgba(94,35,148,.35);transition:background .2s,transform .15s,box-shadow .2s,opacity .2s;}",
      "#xeist-logo-popup-overlay #xeist-gate-upload:not([disabled]):hover{background:#4B1878;}",
      "#xeist-logo-popup-overlay #xeist-gate-upload:not([disabled]):active{transform:scale(.985);}",
      "#xeist-logo-popup-overlay #xeist-gate-upload svg{display:block;width:20px;height:20px;flex:none;}",
      "#xeist-logo-popup-overlay .xgw__status{min-height:18px;margin-top:12px;font-size:13px!important;line-height:1.4!important;color:#6f6f7b!important;}",
      "#xeist-logo-popup-overlay .xgw__fine{margin-top:6px;font-size:13px!important;line-height:1.4!important;color:#8b8b97!important;}",
      "@supports (height:1dvh){#xeist-logo-popup-overlay .xgw__hero{flex-basis:40dvh;}}",
      /* short viewports (phones with the browser bars showing — an
         iPhone 14 in Safari is ~664px): tighter, and the bag as big as
         it can be with the upload button still above the fold */
      "@media (max-height:700px){#xeist-logo-popup-overlay .xgw__body{padding-top:10px;}}",
      "@media (max-height:600px){#xeist-logo-popup-overlay .xgw__bar{height:48px;}#xeist-logo-popup-overlay .xgw__hero{min-height:170px;}#xeist-logo-popup-overlay .xgw__body{padding-top:8px;}#xeist-logo-popup-overlay .xgw__title{font-size:28px!important;margin-bottom:8px;}#xeist-logo-popup-overlay .xgw__kicker{margin-bottom:6px;}#xeist-logo-popup-overlay .xgw__sub{margin-bottom:16px;}}",
      "@media (min-width:768px){#xeist-logo-popup-overlay .xgw{padding-left:32px;padding-right:32px;}#xeist-logo-popup-overlay .xgw__hero{margin:0 -32px;}#xeist-logo-popup-overlay .xgw__body{padding-top:18px;}}"
    ].join("\n");
    function ensureWallCSS(host) {
      try {
        if (document.getElementById("xeist-gate-pulse")) return;
        var st = document.createElement("style");
        st.id = "xeist-gate-pulse";
        st.textContent = PULSE_CSS + "\n" + WALL_CSS;
        (host || document.head || document.documentElement).appendChild(st);
      } catch (e) {
      }
    }
    function saveTeam(v) {
      try {
        store.setItem(TEAM_KEY, v);
      } catch (e) {
      }
    }
    window.__xeistTeamName = savedTeam;
    var BACK_HREF = (function() {
      var v = {};
      try {
        v = window.XeistConfig.v || {};
      } catch (e) {
        v = {};
      }
      var slug = isCompression ? v["compression_product_slug"] || "compression-short-sleeve" : design === "114890045" ? v["dual_product_slug"] || "black-dual-strap-backpack" : v["orbit_product_slug"] || "orbit-backpack";
      return "/products/" + String(slug);
    })();
    function referrerIsStore() {
      try {
        var ref = String(document.referrer || "");
        var origin = String(window.location.origin || "");
        return !!(ref && origin && ref.indexOf(origin) === 0 && ref.indexOf("/pages/3d-customizer") === -1 && window.history && window.history.length > 1);
      } catch (e) {
        return false;
      }
    }
    function headerLogoSrc() {
      try {
        var img = document.querySelector(".site-header__logo-link:not(.logo--inverted) img.small--hide") || document.querySelector(".site-header__logo-link:not(.logo--inverted) img") || document.querySelector(".site-header__logo img");
        if (!img) return "";
        var ss = img.getAttribute("srcset") || "";
        var m = ss.match(/(\S+)\s+2x/);
        return m && m[1] || img.currentSrc || img.getAttribute("src") || "";
      } catch (e) {
        return "";
      }
    }
    function bridgeHasLogo() {
      try {
        var b = window.XeistKBBridge;
        return !!(b && typeof b.hasLogo === "function" && (b.hasLogo() || {}).hasLogo);
      } catch (e) {
        return false;
      }
    }
    function track(type, payload) {
      try {
        if (typeof window.XeistTrack !== "function") return;
        payload = payload || {};
        payload.design = design;
        window.XeistTrack(type, payload);
      } catch (e) {
      }
    }
    function publishTeam(name) {
      if (!name) return;
      var tries = 0;
      (function push() {
        var b = window.XeistKBBridge;
        if (b && typeof b.setOrderProperties === "function") {
          try {
            b.setOrderProperties({ "Team": name });
          } catch (e) {
          }
          return;
        }
        if (++tries < 60) setTimeout(push, 500);
      })();
    }
    publishTeam(savedTeam());
    function kbReadyForUpload() {
      var editPanel = document.querySelector(".kb-customise-edit-panel");
      if (!editPanel) return false;
      if (document.getElementById("xeist-add-logo-overlay")) return true;
      try {
        var header = window.__xeistLogoHeader ? window.__xeistLogoHeader(editPanel) : editPanel.querySelector(".kb-editor-heading.kb-wizard-group-header");
        return !!header;
      } catch (e) {
        return false;
      }
    }
    window.__xeistKbReadyForUpload = kbReadyForUpload;
    function mountWall() {
      if (document.body) showWall();
      else document.addEventListener("DOMContentLoaded", showWall);
    }
    setTimeout(mountWall, 0);
    function el(tag, className, html) {
      var n = document.createElement(tag);
      if (className) n.className = className;
      if (html) n.innerHTML = html;
      return n;
    }
    function showWall() {
      if (bridgeHasLogo() || document.getElementById("xeist-logo-popup-overlay")) return;
      track("gate_shown", { mobile: window.innerWidth <= 768 });
      var poster = "";
      try {
        var pv = window.XeistConfig.v || {};
        poster = isCompression ? "" : String(pv[POSTER_KEY] || pv["xeist_poster_url"] || "");
      } catch (e) {
      }
      var overlay = document.createElement("div");
      overlay.id = "xeist-logo-popup-overlay";
      overlay.style.cssText = [
        "position: fixed",
        "inset: 0",
        "z-index: 100000",
        "background: #ffffff",
        "overflow-y: auto",
        "-webkit-overflow-scrolling: touch",
        "opacity: 0",
        "transition: opacity 0.3s ease"
      ].join(";");
      ensureWallCSS(overlay);
      var modal = document.createElement("form");
      modal.id = "xeist-logo-popup-modal";
      modal.className = "xgw";
      modal.setAttribute("role", "dialog");
      modal.setAttribute("aria-modal", "true");
      modal.setAttribute("aria-labelledby", "xeist-logo-popup-title");
      modal.setAttribute("novalidate", "");
      var bar = el("div", "xgw__bar");
      var back = el("a", "xgw__back", '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>');
      back.setAttribute("href", BACK_HREF);
      back.setAttribute("aria-label", "Back");
      back.addEventListener("click", function(e) {
        track("gate_back", {});
        if (!referrerIsStore()) return;
        e.preventDefault();
        try {
          window.history.back();
        } catch (eH) {
          window.location.href = BACK_HREF;
        }
      });
      var brand = el("div", "xgw__brand");
      var logoSrc = headerLogoSrc();
      if (logoSrc) {
        var logo = document.createElement("img");
        logo.src = logoSrc;
        logo.alt = "XEIST";
        logo.decoding = "async";
        logo.addEventListener("error", function() {
          try {
            brand.innerHTML = "<span>XEIST</span>";
          } catch (eL) {
          }
        });
        brand.appendChild(logo);
      } else {
        brand.innerHTML = "<span>XEIST</span>";
      }
      var count = el("div", "xgw__count", "1 / 4");
      count.setAttribute("aria-hidden", "true");
      bar.appendChild(back);
      bar.appendChild(brand);
      bar.appendChild(count);
      modal.appendChild(bar);
      if (poster) {
        var hero = el("div", "xgw__hero");
        hero.setAttribute("aria-hidden", "true");
        var ring = el("div", "xgw__ring");
        ring.appendChild(el("div", "xgw__dot"));
        hero.appendChild(ring);
        if (!isCompression) {
          var vid = document.createElement("video");
          vid.className = "xgw__media";
          vid.muted = true;
          vid.defaultMuted = true;
          vid.autoplay = true;
          vid.loop = true;
          vid.playsInline = true;
          vid.preload = "auto";
          ["muted", "autoplay", "loop", "playsinline", "webkit-playsinline"].forEach(function(a) {
            vid.setAttribute(a, "");
          });
          vid.setAttribute("aria-hidden", "true");
          vid.poster = poster;
          var kick = function() {
            try {
              var pr = vid.play();
              if (pr && pr.catch) pr.catch(function() {
              });
            } catch (eP) {
            }
          };
          vid.addEventListener("canplay", kick);
          var applyVideoSrc = function() {
            var vs = "";
            try {
              vs = String(window[VIDEO_GLOBAL] || "");
            } catch (eS) {
              vs = "";
            }
            if (!vs || vid.src === vs) return !!vs;
            vid.src = vs;
            kick();
            return true;
          };
          if (!applyVideoSrc()) {
            var vTries = 0;
            var vPoll = setInterval(function() {
              if (applyVideoSrc() || ++vTries > 40) clearInterval(vPoll);
            }, 200);
          }
          hero.appendChild(vid);
        } else {
          var img = document.createElement("img");
          img.className = "xgw__media";
          img.src = poster;
          img.alt = "";
          img.decoding = "async";
          hero.appendChild(img);
        }
        hero.appendChild(el(
          "div",
          "xgw__spin",
          '<span>360°</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 9" fill="none" stroke="#3d3d4a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6.5C5.5 1.5 14.5 1.5 19 5.5"/><path d="M15.6 3.1L19.2 5.6 16.4 8"/></svg>'
        ));
        modal.appendChild(hero);
      }
      var body = el("div", "xgw__body");
      var kicker = el("div", "xgw__kicker");
      kicker.textContent = "Step 1 of 4";
      var heading = el("div", "xgw__title");
      heading.id = "xeist-logo-popup-title";
      heading.setAttribute("role", "heading");
      heading.setAttribute("aria-level", "1");
      heading.innerHTML = "Put your team<br>on the " + NOUN;
      var sub = el("div", "xgw__sub");
      sub.textContent = "Your team name and logo go on every " + NOUN + ". We place the logo for you — you can move or resize it after.";
      var label = el("label", "xgw__label");
      label.setAttribute("for", "xeist-gate-team");
      label.textContent = "Team name";
      var team = document.createElement("input");
      team.id = "xeist-gate-team";
      team.type = "text";
      team.name = "organization";
      team.setAttribute("autocomplete", "organization");
      team.setAttribute("autocapitalize", "words");
      team.setAttribute("enterkeyhint", "next");
      team.maxLength = 60;
      team.placeholder = "e.g. 43 Hoops U13";
      team.value = savedTeam();
      team.addEventListener("focus", function() {
        team.style.borderColor = "";
      });
      team.addEventListener("input", function() {
        team.style.borderColor = "";
      });
      var uploadBtn = document.createElement("button");
      uploadBtn.type = "submit";
      uploadBtn.id = "xeist-gate-upload";
      uploadBtn.className = "xeist-gate-pulse";
      var UPLOAD_HTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>Upload your logo';
      uploadBtn.innerHTML = UPLOAD_HTML;
      var status = el("div", "xgw__status");
      status.setAttribute("aria-live", "polite");
      var fine = el("div", "xgw__fine");
      fine.textContent = "PNG, JPG or SVG — the one from your group chat is fine.";
      body.appendChild(kicker);
      body.appendChild(heading);
      body.appendChild(sub);
      body.appendChild(label);
      body.appendChild(team);
      body.appendChild(uploadBtn);
      body.appendChild(status);
      body.appendChild(fine);
      modal.appendChild(body);
      overlay.appendChild(modal);
      document.body.appendChild(overlay);
      var prevBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      requestAnimationFrame(function() {
        overlay.style.opacity = "1";
        modal.style.transform = "translateY(0)";
        try {
          (team.value ? uploadBtn : team).focus();
        } catch (e) {
        }
      });
      var tabOrder = [back, team, uploadBtn];
      overlay.addEventListener("keydown", function(e) {
        if (e.key === "Escape") {
          e.preventDefault();
          return;
        }
        if (e.key !== "Tab") return;
        e.preventDefault();
        var i = tabOrder.indexOf(document.activeElement);
        var n = i === -1 ? 1 : (i + (e.shiftKey ? -1 : 1) + tabOrder.length) % tabOrder.length;
        try {
          tabOrder[n].focus();
        } catch (eF) {
        }
      });
      var waiting = false;
      var waitTimer = null;
      var armTimer = null;
      var nameOk = false;
      function setBusy(on, text) {
        waiting = on;
        uploadBtn.disabled = on;
        uploadBtn.style.opacity = on ? "0.7" : "1";
        uploadBtn.innerHTML = on ? "Placing your logo…" : UPLOAD_HTML;
        status.textContent = text || "";
      }
      function setArming(on, text) {
        uploadBtn.disabled = on;
        uploadBtn.style.opacity = on ? "0.7" : "1";
        uploadBtn.innerHTML = on ? "Getting your builder ready…" : UPLOAD_HTML;
        status.textContent = on ? "One moment — your logo goes on as soon as the builder is up." : text || "";
      }
      function done() {
        track("gate_passed", { team: !!savedTeam() });
        if (waitTimer) {
          clearInterval(waitTimer);
          waitTimer = null;
        }
        if (armTimer) {
          clearInterval(armTimer);
          armTimer = null;
        }
        document.body.style.overflow = prevBodyOverflow;
        overlay.style.opacity = "0";
        modal.style.transform = "translateY(20px)";
        setTimeout(function() {
          if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        }, 300);
      }
      function onFileChosen(e) {
        var t = e.target;
        if (!t || t.type !== "file" || !(t.files && t.files.length)) return;
        track("gate_file_chosen", {});
        setBusy(true, "Removing the background and placing it on the " + NOUN + "…");
        var ticks = 0;
        if (waitTimer) clearInterval(waitTimer);
        waitTimer = setInterval(function() {
          ticks++;
          if (bridgeHasLogo()) {
            clearInterval(waitTimer);
            waitTimer = null;
            done();
            return;
          }
          if (ticks >= 90) {
            clearInterval(waitTimer);
            waitTimer = null;
            track("gate_upload_timeout", {});
            setBusy(false, "That upload didn’t land. Try again — a PNG or JPG under 5 MB works best.");
          }
        }, 500);
      }
      document.addEventListener("change", onFileChosen, true);
      var anyRoute = setInterval(function() {
        if (!overlay.parentNode) {
          clearInterval(anyRoute);
          return;
        }
        if (bridgeHasLogo()) {
          clearInterval(anyRoute);
          done();
        }
      }, 1e3);
      function openPicker() {
        setTimeout(function() {
          var addLogoBtn = document.getElementById("xeist-add-logo-overlay");
          if (addLogoBtn) {
            addLogoBtn.click();
            return;
          }
          var editPanel = document.querySelector(".kb-customise-edit-panel");
          if (!editPanel) return;
          var header = window.__xeistLogoHeader ? window.__xeistLogoHeader(editPanel) : editPanel.querySelector(".kb-editor-heading.kb-wizard-group-header");
          if (header && window.angular) {
            var scope = angular.element(header).scope();
            if (scope && scope.showPlacement && scope.placement) {
              scope.$apply(function() {
                scope.showPlacement(scope.placement.placementKey);
              });
            }
          } else if (header) {
            header.click();
          }
          var fileAttempts = 0;
          var fileCheckId = setInterval(function() {
            fileAttempts++;
            if (fileAttempts > 20) {
              clearInterval(fileCheckId);
              return;
            }
            var lbl = document.querySelector(".kb-editor-placement-new-image-label");
            if (lbl && lbl.offsetParent !== null) {
              clearInterval(fileCheckId);
              var fileInput = lbl.querySelector('input[type="file"]');
              if (fileInput) fileInput.click();
              else lbl.click();
            }
          }, 150);
        }, 50);
      }
      modal.addEventListener("submit", function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (waiting) return;
        var name = (team.value || "").replace(/\s+/g, " ").trim();
        if (!name) {
          status.textContent = "Add your team name first — it goes on the " + NOUN + ".";
          team.style.borderColor = "#c0392b";
          try {
            team.focus();
          } catch (er) {
          }
          return;
        }
        if (!nameOk) {
          nameOk = true;
          track("gate_team_entered", {});
        }
        saveTeam(name);
        publishTeam(name);
        status.textContent = "";
        if (kbReadyForUpload()) {
          openPicker();
          return;
        }
        track("gate_builder_wait", { mobile: window.innerWidth <= 768 });
        setArming(true);
        var armTicks = 0;
        if (armTimer) clearInterval(armTimer);
        armTimer = setInterval(function() {
          armTicks++;
          if (!overlay.parentNode) {
            clearInterval(armTimer);
            armTimer = null;
            return;
          }
          if (kbReadyForUpload()) {
            clearInterval(armTimer);
            armTimer = null;
            setArming(false, "Ready — tap Upload your logo.");
            track("gate_builder_ready", { waitMs: armTicks * 250 });
            try {
              uploadBtn.focus();
            } catch (ef) {
            }
            return;
          }
          if (armTicks >= 240) {
            clearInterval(armTimer);
            armTimer = null;
            track("gate_builder_timeout", {});
            setArming(false, "The builder is taking longer than usual — tap again to try.");
          }
        }, 250);
      });
      overlay.addEventListener("click", function(e) {
        if (e.target === overlay) {
          e.preventDefault();
          try {
            team.focus();
          } catch (er) {
          }
        }
      });
    }
  })();

  // src/logo-tools/16-add-logo-overlay.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1 || !(window.__xeistCoachOn() || /209873286/.test(window.location.hash || ""))) return;
    var POLL_LIMIT = 30;
    var CHECK_INTERVAL = 500;
    var attempts = 0;
    var pollId = setInterval(function() {
      attempts++;
      if (attempts > POLL_LIMIT * 1e3 / CHECK_INTERVAL) {
        clearInterval(pollId);
        return;
      }
      var previewPanel = document.querySelector(".kb-preview-panel");
      var editPanel = document.querySelector(".kb-customise-edit-panel");
      if (!previewPanel || !editPanel) return;
      if (document.getElementById("xeist-add-logo-overlay")) {
        clearInterval(pollId);
        return;
      }
      clearInterval(pollId);
      var btn = document.createElement("button");
      btn.id = "xeist-add-logo-overlay";
      btn.type = "button";
      var LOGO_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:6px"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>';
      var L_COLOR_OFF = "#140b21";
      var L_COLOR_OFF_HOV = "#2c1a44";
      var L_COLOR_ON = "#6c2bd9";
      var L_COLOR_ON_HOV = "#7e3ff2";
      var L_SHADOW_OFF = "0 2px 12px rgba(20,11,33,0.35)";
      var L_SHADOW_OFF_HOV = "0 4px 16px rgba(20,11,33,0.5)";
      var L_SHADOW_ON = "0 2px 12px rgba(108,43,217,0.45)";
      var L_SHADOW_ON_HOV = "0 4px 16px rgba(108,43,217,0.6)";
      var logoActive = false;
      var tools = null;
      function setLogoState(active) {
        logoActive = active;
        btn.innerHTML = LOGO_SVG + (active ? "Remove Logo" : "Add Team Logo");
        btn.style.background = active ? L_COLOR_ON : L_COLOR_OFF;
        btn.style.boxShadow = active ? L_SHADOW_ON : L_SHADOW_OFF;
        if (tools) tools.style.display = active ? "flex" : "none";
        if (typeof window.__xeistToolsTapRouting === "function") window.__xeistToolsTapRouting(active);
        if (!active && typeof window.__xeistAlignReset === "function") window.__xeistAlignReset();
        if (active && typeof window.__xeistKbDebug === "function") {
          setTimeout(function() {
            try {
              window.__xeistKbDebug("ready | native:" + (document.querySelector(".kb-editor-scale-up") ? 1 : 0) + " svgImgs:" + document.querySelectorAll("image[id]").length + " ng:" + (window.angular ? 1 : 0) + " w:" + window.innerWidth);
            } catch (e) {
            }
          }, 1200);
        }
        try {
          window.dispatchEvent(new Event("xeist:customization-changed"));
        } catch (e) {
        }
      }
      function hasPlacedLogo() {
        if (window.XeistKBBridge && typeof window.XeistKBBridge.hasLogo === "function") {
          var state = window.XeistKBBridge.hasLogo();
          return state && state.hasLogo;
        }
        try {
          var scope = angular.element(document.getElementById("kitBuilder")).scope();
          var s = scope;
          while (s && !s.kit) s = s.$parent;
          var editor = s && s.kit && s.kit.editor ? s.kit.editor : [];
          for (var k = 0; k < editor.length; k++) {
            if (editor[k].type === "image" || editor[k].type === "placed-image") return true;
          }
        } catch (e) {
        }
        return false;
      }
      setLogoState(false);
      btn.style.cssText = [
        "position: absolute",
        "top: 100px",
        "right: 20px",
        "z-index: 1000",
        "display: flex",
        "align-items: center",
        "padding: 10px 20px",
        "background: " + L_COLOR_OFF,
        "color: #fff",
        "border: none",
        "border-radius: 8px",
        "font-family: inherit",
        "font-size: 14px",
        "font-weight: 600",
        "letter-spacing: 0.5px",
        "cursor: pointer",
        "box-shadow: " + L_SHADOW_OFF,
        "transition: background 0.2s, transform 0.15s, box-shadow 0.2s"
      ].join(";");
      btn.addEventListener("mouseenter", function() {
        btn.style.background = logoActive ? L_COLOR_ON_HOV : L_COLOR_OFF_HOV;
        btn.style.transform = "translateY(-1px)";
        btn.style.boxShadow = logoActive ? L_SHADOW_ON_HOV : L_SHADOW_OFF_HOV;
      });
      btn.addEventListener("mouseleave", function() {
        btn.style.background = logoActive ? L_COLOR_ON : L_COLOR_OFF;
        btn.style.transform = "none";
        btn.style.boxShadow = logoActive ? L_SHADOW_ON : L_SHADOW_OFF;
      });
      var computedPos = window.getComputedStyle(previewPanel).position;
      if (computedPos === "static") {
        previewPanel.style.position = "relative";
      }
      previewPanel.appendChild(btn);
      (function buildLogoTools() {
        tools = document.createElement("div");
        tools.id = "xeist-logo-tools";
        tools.style.cssText = [
          "display:none",
          "justify-content:center",
          "align-items:center",
          "gap:10px",
          "width:fit-content",
          "max-width:92%",
          "margin:6px auto 12px",
          "padding:8px 12px",
          "background:rgba(255,255,255,0.97)",
          "border-radius:14px",
          "box-shadow:0 4px 18px rgba(20,11,33,0.28)"
        ].join(";");
        function getES() {
          if (window.XeistCore) return XeistCore.getES();
          try {
            return angular.element(document.querySelector("[ng-controller]")).injector().get("EditorService");
          } catch (e) {
            return null;
          }
        }
        function findLogoItem(es) {
          if (!es || !es.getItemById) return null;
          var els = document.querySelectorAll("image[id], g[id], path[id], text[id]");
          var fallback = null;
          for (var i = 0; i < els.length; i++) {
            var it = null;
            try {
              it = es.getItemById(els[i].id);
            } catch (e) {
            }
            if (it && it.type === "image") {
              if (it.placementKey === "add-logo") return it;
              if (!fallback) fallback = it;
            }
          }
          return fallback;
        }
        function ensureSelected(es) {
          if (!es) return null;
          var item = null;
          try {
            item = es.getSelectedItem && es.getSelectedItem();
          } catch (e) {
          }
          if (item) return item;
          var logo = findLogoItem(es);
          if (!logo || !es.selectItem) return null;
          try {
            var root = angular.element(document.querySelector("[ng-controller]")).injector().get("$rootScope");
            if (root.$$phase) {
              es.selectItem(logo);
            } else {
              root.$apply(function() {
                es.selectItem(logo);
              });
            }
          } catch (e) {
            try {
              es.selectItem(logo);
            } catch (e2) {
            }
          }
          try {
            item = es.getSelectedItem();
          } catch (e) {
          }
          return item;
        }
        function safeApply(sc, fn) {
          try {
            var root = sc.$root || sc;
            if (root.$$phase || sc.$$phase) {
              fn();
            } else {
              sc.$apply(fn);
            }
          } catch (e) {
            try {
              fn();
            } catch (e2) {
            }
          }
        }
        var KB_ACTIONS = {
          ".kb-editor-scale-down": { fn: "scaleItem", sign: -1, key: "kb.editor.editor_buttons_overlay.scale_amount_multiplier", dflt: 0.1 },
          ".kb-editor-scale-up": { fn: "scaleItem", sign: 1, key: "kb.editor.editor_buttons_overlay.scale_amount_multiplier", dflt: 0.1 },
          ".kb-editor-rotate-left": { fn: "rotateItem", sign: -1, key: "kb.editor.editor_buttons_overlay.rotate_amount_degrees", dflt: 15 },
          ".kb-editor-rotate-right": { fn: "rotateItem", sign: 1, key: "kb.editor.editor_buttons_overlay.rotate_amount_degrees", dflt: 15 }
        };
        function getInjector() {
          if (window.XeistCore) return XeistCore.getInjector();
          try {
            return angular.element(document.querySelector("[ng-controller]")).injector();
          } catch (e) {
            return null;
          }
        }
        function getSetting(key, dflt) {
          try {
            var inj = getInjector();
            if (inj && inj.has("Settings")) {
              var v = inj.get("Settings")[key];
              if (v !== void 0 && v !== null) return v;
            }
          } catch (e) {
          }
          return dflt;
        }
        var kbDebugEl = null;
        function kbDebug(msg) {
          if (!/xeistdebug=1/.test(window.location.search)) return;
          if (!kbDebugEl) {
            kbDebugEl = document.createElement("div");
            kbDebugEl.id = "xeist-logo-tools-debug";
            kbDebugEl.style.cssText = "flex-basis:100%;width:100%;font:400 10px/1.4 monospace;color:#140b21;background:#fffbe6;border-radius:6px;padding:4px 6px;word-break:break-all;";
            tools.appendChild(kbDebugEl);
            tools.style.flexWrap = "wrap";
          }
          kbDebugEl.textContent = msg;
        }
        window.__xeistKbDebug = kbDebug;
        function kbAction(selector) {
          var trace = selector.replace(".kb-editor-", "");
          if (!window.angular) {
            kbDebug(trace + " | no angular");
            return false;
          }
          var es = getES();
          var item = ensureSelected(es);
          trace += " | es:" + (es ? 1 : 0) + " item:" + (item ? item.$id || 1 : 0);
          var a = document.querySelector(selector);
          if (a) {
            var sc = angular.element(a).scope();
            var expr = a.getAttribute("ng-click");
            if (sc && expr) {
              safeApply(sc, function() {
                sc.$eval(expr);
              });
              kbDebug(trace + " | native:ok" + (item ? " w:" + Math.round(item.width || 0) : ""));
              return true;
            }
          }
          var act = KB_ACTIONS[selector];
          if (!es || !item || !act || typeof es[act.fn] !== "function") {
            kbDebug(trace + " | direct:blocked fn:" + (es && act && typeof es[act.fn]));
            return false;
          }
          var amount = act.sign * getSetting(act.key, act.dflt);
          var ok = true;
          try {
            var inj = getInjector();
            var root = inj ? inj.get("$rootScope") : null;
            if (root && !root.$$phase) {
              root.$apply(function() {
                es[act.fn](item, amount);
              });
            } else {
              es[act.fn](item, amount);
            }
          } catch (e) {
            try {
              es[act.fn](item, amount);
            } catch (e2) {
              ok = false;
            }
          }
          kbDebug(trace + " | direct:" + (ok ? "ok" : "threw") + " amt:" + amount + " w:" + Math.round(item.width || 0));
          if (ok) {
            setTimeout(function() {
              try {
                kbDebug(trace + " | settled w:" + Math.round(item.width || 0) + " sel:" + (es.getSelectedItem() ? 1 : 0));
              } catch (e) {
              }
            }, 1500);
          }
          return ok;
        }
        var alignDoneId = null;
        function alignFreshLogo() {
          if (alignDoneId) {
            if (document.getElementById(alignDoneId)) {
              window.__xeistAlignLast = "done";
              return;
            }
            alignDoneId = null;
          }
          if (!document.querySelector("image[id]")) {
            window.__xeistAlignLast = "no-image-el";
            return;
          }
          window.__xeistAlignLast = "start";
          try {
            var es = getES();
            if (!es) {
              window.__xeistAlignLast = "no-es";
              return;
            }
            var placement = es.imagePlacements && es.imagePlacements[0] || null;
            if (!placement) {
              window.__xeistAlignLast = "no-placement";
              return;
            }
            var els = document.querySelectorAll("image[id], g[id], path[id], text[id]");
            var item = null, sawAny = false, itemDomY = null;
            var defY = String(placement.y);
            for (var ci = 0; ci < els.length; ci++) {
              var cand = null;
              try {
                cand = es.getItemById(els[ci].id);
              } catch (e) {
              }
              if (!cand || cand.type !== "image" || cand.placementKey !== "add-logo") continue;
              sawAny = true;
              if (cand.$$xeistAligned) continue;
              var cdy = null;
              try {
                var cel = document.getElementById(cand.$id);
                if (cel) cdy = cel.getAttribute("y");
              } catch (e) {
              }
              if (String(cand.y) === defY || cdy !== null && String(cdy) === defY) {
                item = cand;
                itemDomY = cdy;
                break;
              }
            }
            if (!item) {
              window.__xeistAlignLast = sawAny ? "no-default-item" : "no-item";
              return;
            }
            item.$$xeistAlignTries = (item.$$xeistAlignTries || 0) + 1;
            if (item.$$xeistAlignTries > 20) {
              item.$$xeistAligned = true;
              alignDoneId = String(item.$id || "");
              window.__xeistAlignLast = "gave-up";
              return;
            }
            var cfgLogo = (window.XeistOrbitCoachConfig || {}).logoDefaults;
            var cfgLX = cfgLogo ? parseFloat(cfgLogo.x) : NaN, cfgLY = cfgLogo ? parseFloat(cfgLogo.y) : NaN;
            if (isFinite(cfgLX) && isFinite(cfgLY)) {
              var tX = Math.round(cfgLX), tY = Math.round(cfgLY);
              var curX = parseFloat(item.x), curY = parseFloat(itemDomY !== null ? itemDomY : item.y);
              if (Math.abs(curX - tX) < 2 && Math.abs(curY - tY) < 2) {
                item.$$xeistAligned = true;
                alignDoneId = String(item.$id || "");
                window.__xeistAlignLast = "already-at-config";
                return;
              }
              var injC = getInjector();
              var rootC = injC ? injC.get("$rootScope") : null;
              var runC = function() {
                var wasSelC = null;
                try {
                  wasSelC = es.getSelectedItem();
                } catch (e) {
                }
                if (wasSelC !== item) es.selectItem(item);
                es.setX(tX);
                es.setY(tY);
                es.change();
                if (!wasSelC) es.clearSelection();
              };
              if (rootC && !rootC.$$phase) {
                rootC.$apply(runC);
              } else {
                runC();
              }
              item.$$xeistAligned = true;
              alignDoneId = String(item.$id || "");
              window.__xeistAlignedLogoSpec = { x: tX, y: tY };
              window.__xeistAlignLast = "config:" + curX + "," + curY + "->" + tX + "," + tY;
              kbDebug("align | config " + tX + "," + tY);
              return;
            }
            var view = document.querySelector("svg.kb-svgext-live g.kb-view");
            if (!view) {
              window.__xeistAlignLast = "no-view";
              return;
            }
            var itemH = parseFloat(item.height) || 0;
            var itemY = parseFloat(itemDomY !== null ? itemDomY : item.y) || 0;
            if (!itemH) {
              window.__xeistAlignLast = "no-height";
              return;
            }
            var itemCenter = itemY + itemH / 2;
            var targetCenter = null;
            for (var i = 0; i < view.children.length; i++) {
              var p = view.children[i];
              if (p.tagName !== "path") continue;
              var b;
              try {
                b = p.getBBox();
              } catch (e) {
                continue;
              }
              if (!b || !b.width || !b.height) continue;
              if (b.width >= 60 && b.width <= 420 && b.height >= 30 && b.height <= 220) {
                var c = b.y + b.height / 2;
                if (Math.abs(c - itemCenter) <= 200) {
                  targetCenter = c;
                  break;
                }
              }
            }
            if (targetCenter === null) {
              window.__xeistAlignLast = "no-target";
              return;
            }
            var newY = Math.round(targetCenter - itemH / 2);
            if (Math.abs(newY - itemY) < 2) {
              item.$$xeistAligned = true;
              alignDoneId = String(item.$id || "");
              window.__xeistAlignLast = "already-level";
              return;
            }
            var inj = getInjector();
            var root = inj ? inj.get("$rootScope") : null;
            var run = function() {
              var wasSel = null;
              try {
                wasSel = es.getSelectedItem();
              } catch (e) {
              }
              if (wasSel !== item) es.selectItem(item);
              es.setY(newY);
              es.change();
              if (!wasSel) es.clearSelection();
            };
            if (root && !root.$$phase) {
              root.$apply(run);
            } else {
              run();
            }
            item.$$xeistAligned = true;
            alignDoneId = String(item.$id || "");
            var alignedX = parseFloat(item.x);
            if (!isFinite(alignedX)) alignedX = parseFloat(placement.x);
            if (isFinite(alignedX)) window.__xeistAlignedLogoSpec = { x: alignedX, y: newY };
            window.__xeistAlignLast = "aligned:" + itemY + "->" + newY;
            kbDebug("align | y:" + itemY + "→" + newY);
          } catch (e) {
            window.__xeistAlignLast = "threw";
          }
        }
        window.__xeistAlignNow = alignFreshLogo;
        window.__xeistAlignReset = function() {
          alignDoneId = null;
          try {
            window.__xeistAlignedLogoSpec = null;
          } catch (e) {
          }
        };
        var toolButtons = [];
        var repeatDelay = null, repeatTimer = null;
        function stopRepeat() {
          if (repeatDelay) {
            clearTimeout(repeatDelay);
            repeatDelay = null;
          }
          if (repeatTimer) {
            clearInterval(repeatTimer);
            repeatTimer = null;
          }
        }
        function hitButton(x, y) {
          for (var i = 0; i < toolButtons.length; i++) {
            var r = toolButtons[i].el.getBoundingClientRect();
            if (!r.width || !r.height) continue;
            if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) return toolButtons[i];
          }
          return null;
        }
        function barCanClaim(ev) {
          if (!tools || tools.style.display === "none") return false;
          if (ev && ev.isTrusted === false) return false;
          return tools.getClientRects().length > 0;
        }
        function onToolsDown(ev) {
          if (!barCanClaim(ev)) return;
          var x, y;
          if (ev.touches && ev.touches[0]) {
            x = ev.touches[0].clientX;
            y = ev.touches[0].clientY;
          } else {
            x = ev.clientX;
            y = ev.clientY;
          }
          var btn2 = hitButton(x, y);
          if (!btn2) return;
          ev.preventDefault();
          ev.stopPropagation();
          if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
          stopRepeat();
          btn2.action();
          repeatDelay = setTimeout(function() {
            repeatTimer = setInterval(btn2.action, 90);
          }, 320);
        }
        function onToolsClick(ev) {
          if (!barCanClaim(ev)) return;
          if (hitButton(ev.clientX, ev.clientY)) {
            ev.preventDefault();
            ev.stopPropagation();
          }
        }
        var tapRoutingOn = false;
        var TOUCH_OPTS = { capture: true, passive: false };
        function setTapRouting(on) {
          on = !!on;
          if (on === tapRoutingOn) return;
          tapRoutingOn = on;
          if (on) {
            document.addEventListener("touchstart", onToolsDown, TOUCH_OPTS);
            document.addEventListener("mousedown", onToolsDown, true);
            ["touchend", "touchcancel", "mouseup"].forEach(function(t) {
              document.addEventListener(t, stopRepeat, true);
            });
            document.addEventListener("click", onToolsClick, true);
          } else {
            stopRepeat();
            document.removeEventListener("touchstart", onToolsDown, TOUCH_OPTS);
            document.removeEventListener("mousedown", onToolsDown, true);
            ["touchend", "touchcancel", "mouseup"].forEach(function(t) {
              document.removeEventListener(t, stopRepeat, true);
            });
            document.removeEventListener("click", onToolsClick, true);
          }
        }
        window.__xeistToolsTapRouting = setTapRouting;
        function mkBtn(label, aria, action) {
          var b = document.createElement("button");
          b.type = "button";
          b.setAttribute("aria-label", aria);
          b.innerHTML = label;
          b.style.cssText = [
            "width:44px",
            "height:44px",
            "border:none",
            "border-radius:50%",
            "background:#140b21",
            "color:#fff",
            "font-size:22px",
            "font-weight:700",
            "line-height:1",
            "display:flex",
            "align-items:center",
            "justify-content:center",
            "cursor:pointer",
            "box-shadow:0 2px 8px rgba(20,11,33,0.3)",
            "-webkit-user-select:none",
            "user-select:none",
            "touch-action:none",
            "padding:0"
          ].join(";");
          toolButtons.push({ el: b, action, aria });
          return b;
        }
        var lbl = document.createElement("span");
        lbl.textContent = "SIZE";
        lbl.style.cssText = "font:600 11px/1 inherit;letter-spacing:1px;color:#6c2bd9;margin:0 2px;";
        tools.appendChild(mkBtn("&minus;", "Make logo smaller", function() {
          kbAction(".kb-editor-scale-down");
        }));
        tools.appendChild(mkBtn("&plus;", "Make logo bigger", function() {
          kbAction(".kb-editor-scale-up");
        }));
        var rl = document.createElement("span");
        rl.style.cssText = "width:1px;height:26px;background:#e5e5ea;margin:0 2px;";
        tools.appendChild(rl);
        tools.appendChild(mkBtn("&#8634;", "Rotate left", function() {
          kbAction(".kb-editor-rotate-left");
        }));
        tools.appendChild(mkBtn("&#8635;", "Rotate right", function() {
          kbAction(".kb-editor-rotate-right");
        }));
        var cachedDeliveryCard = null;
        function deliveryCard() {
          if (cachedDeliveryCard && document.contains(cachedDeliveryCard) && cachedDeliveryCard.offsetParent !== null) return cachedDeliveryCard;
          cachedDeliveryCard = null;
          var els = document.querySelectorAll("div,section,p");
          var best = null, bestLen = 1e9;
          for (var i = 0; i < els.length; i++) {
            var tx = els[i].textContent || "";
            if (/Delivered in/i.test(tx) && !/Continue to add/i.test(tx) && tx.length < bestLen) {
              best = els[i];
              bestLen = tx.length;
            }
          }
          cachedDeliveryCard = best;
          return best;
        }
        function placeTools() {
          var card = deliveryCard();
          if (card && card.parentElement) {
            if (tools.nextElementSibling !== card || tools.parentElement !== card.parentElement) {
              card.parentElement.insertBefore(tools, card);
            }
            return true;
          }
          var parent = previewPanel.parentElement;
          if (parent) {
            if (tools.previousElementSibling !== previewPanel || tools.parentElement !== parent) {
              parent.insertBefore(tools, previewPanel.nextSibling);
            }
            return true;
          }
          return false;
        }
        placeTools();
        var placeTries = 0;
        var placeId = setInterval(function() {
          placeTries++;
          if (deliveryCard() || placeTries > 60) {
            placeTools();
            clearInterval(placeId);
          } else {
            placeTools();
          }
        }, 500);
        window.__xeistPlaceLogoTools = placeTools;
      })();
      var logoSyncSuppressUntil = 0;
      setInterval(function() {
        if (document.hidden) return;
        if (window.__xeistPlaceLogoTools) {
          try {
            window.__xeistPlaceLogoTools();
          } catch (e) {
          }
        }
        if (window.__xeistAlignNow) {
          try {
            window.__xeistAlignNow();
          } catch (e) {
          }
        }
        if (Date.now() < logoSyncSuppressUntil) return;
        var bridge = window.XeistKBBridge;
        if (!bridge || typeof bridge.hasLogo !== "function") return;
        var actual = !!(bridge.hasLogo() || {}).hasLogo;
        if (actual !== logoActive) setLogoState(actual);
      }, 800);
      btn.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        var bridge = window.XeistKBBridge;
        logoSyncSuppressUntil = Date.now() + 5e3;
        if (logoActive) {
          if (bridge && typeof bridge.hasLogo === "function" && !(bridge.hasLogo() || {}).hasLogo) {
            setLogoState(false);
            return;
          }
          if (bridge && typeof bridge.disableLogo === "function") {
            setLogoState(false);
            Promise.resolve(bridge.disableLogo()).then(function(result) {
              if (!result || !result.ok) {
                if ((bridge.hasLogo() || {}).hasLogo) setLogoState(true);
                return;
              }
              var pollCount = 0;
              var confirmId = setInterval(function() {
                pollCount++;
                if (!hasPlacedLogo()) {
                  clearInterval(confirmId);
                  try {
                    var scope2 = angular.element(document.getElementById("kitBuilder")).scope();
                    if (scope2 && scope2.$applyAsync) scope2.$applyAsync();
                  } catch (e2) {
                  }
                }
                if (pollCount > 15) {
                  clearInterval(confirmId);
                  if (hasPlacedLogo()) setLogoState(true);
                }
              }, 200);
            }).catch(function() {
              setLogoState(true);
            });
          }
          return;
        }
        var header = window.__xeistLogoHeader ? window.__xeistLogoHeader(editPanel) : editPanel.querySelector(".kb-editor-heading.kb-wizard-group-header");
        if (header && window.angular) {
          var scope = angular.element(header).scope();
          if (scope && scope.showPlacement && scope.placement) {
            var isOpen = typeof scope.isPlacementVisible === "function" && scope.isPlacementVisible(scope.placement.placementKey);
            if (!isOpen) {
              try {
                scope.$apply(function() {
                  scope.showPlacement(scope.placement.placementKey);
                });
              } catch (applyErr) {
              }
            }
          }
        } else if (header) {
          header.click();
        }
        var fileAttempts = 0;
        var fileCheckId = setInterval(function() {
          fileAttempts++;
          if (fileAttempts > 20) {
            clearInterval(fileCheckId);
            return;
          }
          var label = document.querySelector(".kb-editor-placement-new-image-label");
          if (label) {
            clearInterval(fileCheckId);
            var fileInput = label.querySelector('input[type="file"]');
            if (fileInput) {
              fileInput.click();
            } else {
              label.click();
            }
            if (fileInput) {
              fileInput.addEventListener("change", function onLogoChange() {
                fileInput.removeEventListener("change", onLogoChange);
                setTimeout(function() {
                  setLogoState(true);
                }, 500);
              });
            }
          }
        }, 150);
        if (window.innerWidth <= 768) {
          setTimeout(function() {
            editPanel.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 400);
        }
      });
    }, CHECK_INTERVAL);
  })();

  // src/logo-tools/17-add-number-overlay.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1 || !/114891065|114890045/.test(window.location.hash || "")) return;
    var POLL_LIMIT = 30;
    var CHECK_INTERVAL = 500;
    var attempts = 0;
    function isVisibleNode(node) {
      if (!node) return false;
      if (node.offsetParent) return true;
      try {
        var style = window.getComputedStyle(node);
        return style.position === "fixed" || style.position === "sticky";
      } catch (error) {
        return false;
      }
    }
    function getClickableTarget(node) {
      var current = node;
      while (current && current !== document.body) {
        if (current.matches && current.matches('button, a, [ng-click], li, [role="button"]')) {
          return current;
        }
        current = current.parentNode;
      }
      return null;
    }
    function normalizeNodeText(value) {
      return String(value || "").replace(/\s+/g, " ").trim().toLowerCase();
    }
    function findNumberTrigger(editPanel) {
      var container = editPanel || document;
      var candidates = container.querySelectorAll('button, a, div, span, [ng-click], [role="button"]');
      for (var i = 0; i < candidates.length; i++) {
        if (!isVisibleNode(candidates[i])) continue;
        var text = normalizeNodeText(candidates[i].textContent);
        if (!text) continue;
        var matchesAddNumber = text.indexOf("add number") !== -1;
        var matchesNumberOnly = text === "number" || text.indexOf("number ($") !== -1;
        if (!matchesAddNumber && !matchesNumberOnly) continue;
        var clickable = getClickableTarget(candidates[i]);
        if (clickable) return clickable;
        return candidates[i];
      }
      return null;
    }
    function findNumberHeader(editPanel) {
      if (!editPanel) return null;
      if (window.angular) {
        var headers = editPanel.querySelectorAll(".kb-editor-heading.kb-wizard-group-header");
        for (var i = 0; i < headers.length; i++) {
          var scope = angular.element(headers[i]).scope();
          if (!scope || !scope.placement) continue;
          var placementKey = String(scope.placement.placementKey || "").toLowerCase();
          var descriptor = [
            scope.placement.placementKey,
            scope.placement.name,
            scope.placement.label,
            scope.placement.orderChargeDescription
          ].filter(Boolean).join(" ").toLowerCase();
          if (placementKey === "add-number" || descriptor.indexOf("number") !== -1) {
            return headers[i];
          }
        }
      }
      return findNumberTrigger(editPanel);
    }
    function findAddTextButton(editPanel) {
      var container = editPanel || document;
      var selector = '.kb-editor-placement-new-text, .kb-editor-add-text-item, [ng-click*="addTextItem"], .kb-icon-plus';
      var direct = container.querySelectorAll(selector);
      for (var i = 0; i < direct.length; i++) {
        if (isVisibleNode(direct[i])) return direct[i];
      }
      var candidates = container.querySelectorAll('button, a, div, span, [ng-click], [role="button"]');
      for (var j = 0; j < candidates.length; j++) {
        if (!isVisibleNode(candidates[j])) continue;
        var text = String(candidates[j].textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
        if (text === "add text" || text === "add number" || text === "+") {
          var clickable = getClickableTarget(candidates[j]);
          if (clickable) return clickable;
        }
      }
      return null;
    }
    function hasRenderedNumberLayer() {
      var textNodes = document.querySelectorAll("text, .text");
      for (var i = 0; i < textNodes.length; i++) {
        var node = textNodes[i];
        var placementKey = String(node.getAttribute && (node.getAttribute("placement-key") || node.getAttribute("data-placement-key")) || "").toLowerCase();
        var text = String(node.textContent || "").trim();
        if (placementKey === "add-number") return true;
        if (/^\d{1,3}$/.test(text) && text === "2") return true;
      }
      return false;
    }
    function designHasNumberItem() {
      try {
        var b = window.XeistKBBridge;
        if (b && typeof b.hasNumber === "function") return !!(b.hasNumber() || {}).hasNumber;
      } catch (e) {
      }
      return hasRenderedNumberLayer();
    }
    function settleNumberAdd(qtyBefore) {
      var sweeps = 0;
      var sid = setInterval(function() {
        sweeps++;
        try {
          var root = document.querySelector("[ng-controller]");
          var kit = window.angular && root ? angular.element(root).injector().get("KitService").kit : null;
          var numberItems = (kit && kit.editor || []).filter(function(i) {
            return String(i.placementKey || "").toLowerCase() === "add-number";
          }).length;
          var b = window.XeistKBBridge;
          if (numberItems > 1 && b && typeof b.disableDefaultNumber === "function") {
            b.disableDefaultNumber();
          }
        } catch (e) {
        }
        var qtyInput = document.querySelector("[data-bottom-bar-qty-input]");
        if (qtyInput && qtyBefore && document.activeElement !== qtyInput && parseInt(qtyInput.value, 10) === qtyBefore + 1) {
          qtyInput.value = String(qtyBefore);
          qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
        if (sweeps >= 3) clearInterval(sid);
      }, 2500);
    }
    function snapNewNumberToSpec() {
      var tries = 0;
      var snapId = setInterval(function() {
        tries++;
        if (tries > 25) {
          clearInterval(snapId);
          return;
        }
        try {
          if (document.querySelector('[placement-key="add-number"][disable-move="true"]')) {
            clearInterval(snapId);
            return;
          }
          var sx = NaN, sy = NaN;
          try {
            var hs = document.querySelectorAll(".kb-editor-heading.kb-wizard-group-header");
            for (var h = 0; h < hs.length; h++) {
              var psc = angular.element(hs[h]).scope();
              var pl = psc && psc.placement;
              if (pl && String(pl.placementKey || "").toLowerCase() === "add-number") {
                sx = parseFloat(pl.x);
                sy = parseFloat(pl.y);
                break;
              }
            }
          } catch (eH) {
          }
          if (!isFinite(sx) && tries < 20) return;
          var cfg = (window.XeistOrbitCoachConfig || {}).numberDefaults || {};
          if (!isFinite(sx)) sx = parseFloat(cfg.x);
          if (!isFinite(sy)) sy = parseFloat(cfg.y);
          if (!isFinite(sx)) sx = 1399;
          if (!isFinite(sy)) sy = 1773;
          var root = document.querySelector("[ng-controller]");
          if (!root || !window.angular) return;
          var el = angular.element(root);
          var inj = el.injector();
          if (!inj) return;
          var kit = inj.get("KitService").kit;
          var items = kit && kit.editor || [];
          for (var i = 0; i < items.length; i++) {
            var it = items[i];
            if (String(it.placementKey || "").toLowerCase() !== "add-number") continue;
            clearInterval(snapId);
            var ix = parseFloat(it.x), iy = parseFloat(it.y);
            if (isFinite(ix) && isFinite(iy) && Math.abs(ix - sx) <= 0.5 && Math.abs(iy - sy) <= 0.5) return;
            el.scope().$apply(function() {
              it.x = sx;
              it.y = sy;
            });
            return;
          }
        } catch (e) {
        }
      }, 200);
    }
    function scopeAddNumber() {
      if (!window.angular) return false;
      if (designHasNumberItem()) return true;
      try {
        var headers = document.querySelectorAll(".kb-editor-heading.kb-wizard-group-header");
        for (var i = 0; i < headers.length; i++) {
          var scope = angular.element(headers[i]).scope();
          if (!scope || !scope.placement) continue;
          if (String(scope.placement.placementKey || "").toLowerCase() !== "add-number") continue;
          var owner = scope;
          while (owner && typeof owner.addText !== "function") owner = owner.$parent;
          if (!owner) return false;
          var placement = scope.placement;
          owner.$apply(function() {
            owner.addText(placement.placementKey, placement.newTextSource, false);
          });
          snapNewNumberToSpec();
          return true;
        }
      } catch (e) {
      }
      return false;
    }
    function fallbackAddNumber(editPanel) {
      if (scopeAddNumber()) return true;
      var numberHeader = findNumberHeader(editPanel);
      if (numberHeader) {
        var headerScope = window.angular ? angular.element(numberHeader).scope() : null;
        var parent = headerScope;
        while (parent && !parent.showPlacement) parent = parent.$parent;
        if (parent && parent.showPlacement) {
          parent.$apply(function() {
            parent.showPlacement(String(headerScope.placement && headerScope.placement.placementKey || "add-number"));
          });
        } else {
          var clickableHeader = getClickableTarget(numberHeader) || numberHeader;
          if (clickableHeader && clickableHeader.click) {
            clickableHeader.click();
          }
        }
      }
      var addTextAttempts = 0;
      var addTextId = setInterval(function() {
        addTextAttempts++;
        if (addTextAttempts > 20) {
          clearInterval(addTextId);
          return;
        }
        var addTextBtn = findAddTextButton(editPanel);
        if (addTextBtn && isVisibleNode(addTextBtn)) {
          clearInterval(addTextId);
          addTextBtn.click();
          snapNewNumberToSpec();
        }
      }, 150);
      if (window.innerWidth <= 768 && editPanel) {
        setTimeout(function() {
          editPanel.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 400);
      }
      return true;
    }
    var pollId = setInterval(function() {
      attempts++;
      if (attempts > POLL_LIMIT * 1e3 / CHECK_INTERVAL) {
        clearInterval(pollId);
        return;
      }
      var previewPanel = document.querySelector(".kb-preview-panel");
      var editPanel = document.querySelector(".kb-customise-edit-panel");
      if (!previewPanel || !editPanel) return;
      var coachConfig = window.XeistOrbitCoachConfig || {};
      var designId = String(coachConfig.designId || "").toLowerCase();
      if (designId && window.location.hash.toLowerCase().indexOf("/customise/" + designId) === -1) return;
      if (document.getElementById("xeist-add-number-overlay")) {
        clearInterval(pollId);
        return;
      }
      clearInterval(pollId);
      var btn = document.createElement("button");
      btn.id = "xeist-add-number-overlay";
      btn.type = "button";
      var SVG_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:6px"><path d="M9 7h6"/><path d="M9 12h6"/><path d="M9 17h6"/><rect x="3" y="4" width="18" height="16" rx="2"/></svg>';
      var COLOR_OFF = "#140b21";
      var COLOR_OFF_HOV = "#2c1a44";
      var COLOR_ON = "#6c2bd9";
      var COLOR_ON_HOV = "#7e3ff2";
      var SHADOW_OFF = "0 2px 12px rgba(20,11,33,0.35)";
      var SHADOW_OFF_HOV = "0 4px 16px rgba(20,11,33,0.5)";
      var SHADOW_ON = "0 2px 12px rgba(108,43,217,0.45)";
      var SHADOW_ON_HOV = "0 4px 16px rgba(108,43,217,0.6)";
      var numberActive = false;
      function setButtonState(active) {
        numberActive = active;
        btn.innerHTML = SVG_ICON + (active ? "Remove Number" : "Add Number");
        btn.style.background = active ? COLOR_ON : COLOR_OFF;
        btn.style.boxShadow = active ? SHADOW_ON : SHADOW_OFF;
        try {
          window.dispatchEvent(new Event("xeist:customization-changed"));
        } catch (e) {
        }
      }
      setButtonState(false);
      btn.style.cssText = [
        "position: absolute",
        "top: 150px",
        "right: 20px",
        "z-index: 1000",
        "display: flex",
        "align-items: center",
        "padding: 10px 20px",
        "background: " + COLOR_OFF,
        "color: #fff",
        "border: none",
        "border-radius: 8px",
        "font-family: inherit",
        "font-size: 14px",
        "font-weight: 600",
        "letter-spacing: 0.5px",
        "cursor: pointer",
        "box-shadow: " + SHADOW_OFF,
        "transition: background 0.2s, transform 0.15s, box-shadow 0.2s"
      ].join(";");
      btn.addEventListener("mouseenter", function() {
        btn.style.background = numberActive ? COLOR_ON_HOV : COLOR_OFF_HOV;
        btn.style.transform = "translateY(-1px)";
        btn.style.boxShadow = numberActive ? SHADOW_ON_HOV : SHADOW_OFF_HOV;
      });
      btn.addEventListener("mouseleave", function() {
        btn.style.background = numberActive ? COLOR_ON : COLOR_OFF;
        btn.style.transform = "none";
        btn.style.boxShadow = numberActive ? SHADOW_ON : SHADOW_OFF;
      });
      if (window.getComputedStyle(previewPanel).position === "static") {
        previewPanel.style.position = "relative";
      }
      previewPanel.appendChild(btn);
      var numberSyncSuppressUntil = 0;
      setInterval(function() {
        if (Date.now() < numberSyncSuppressUntil) return;
        var bridge = window.XeistKBBridge;
        if (!bridge || typeof bridge.hasNumber !== "function") return;
        var actual = !!(bridge.hasNumber() || {}).hasNumber;
        if (actual !== numberActive) setButtonState(actual);
      }, 800);
      if (window.location.href.indexOf("autonumber=1") !== -1) {
        setTimeout(function() {
          if (btn && btn.click) btn.click();
        }, 1400);
      }
      function performRemove() {
        var bridge = window.XeistKBBridge;
        numberSyncSuppressUntil = Date.now() + 5e3;
        if (bridge && typeof bridge.hasNumber === "function" && !(bridge.hasNumber() || {}).hasNumber) {
          setButtonState(false);
          return;
        }
        if (bridge && typeof bridge.disableDefaultNumber === "function") {
          setButtonState(false);
          Promise.resolve(bridge.disableDefaultNumber()).then(function(result) {
            if (!result || !result.ok) {
              setButtonState(true);
              return;
            }
            var pollCount = 0;
            var confirmId = setInterval(function() {
              pollCount++;
              var check = bridge.hasNumber();
              if (!check || !check.hasNumber) {
                clearInterval(confirmId);
                try {
                  var scope = angular.element(document.getElementById("kitBuilder")).scope();
                  if (scope && scope.$applyAsync) scope.$applyAsync();
                } catch (e) {
                }
              }
              if (pollCount > 15) {
                clearInterval(confirmId);
                var finalCheck = bridge.hasNumber();
                if (finalCheck && finalCheck.hasNumber) setButtonState(true);
              }
            }, 200);
          }).catch(function() {
            setButtonState(true);
          });
        }
      }
      function performAdd() {
        var bridge = window.XeistKBBridge;
        numberSyncSuppressUntil = Date.now() + 5e3;
        if (bridge && typeof bridge.hasNumber === "function" && (bridge.hasNumber() || {}).hasNumber) {
          setButtonState(true);
          return;
        }
        var qtyInputForAdd = document.querySelector("[data-bottom-bar-qty-input]");
        settleNumberAdd(qtyInputForAdd ? parseInt(qtyInputForAdd.value, 10) : null);
        if (bridge && typeof bridge.enableDefaultNumber === "function") {
          var BRIDGE_TIMEOUT_MS = 600;
          var timedOut = new Promise(function(res) {
            setTimeout(function() {
              res({ ok: false, code: "bridge_timeout" });
            }, BRIDGE_TIMEOUT_MS);
          });
          Promise.race([Promise.resolve(bridge.enableDefaultNumber()), timedOut]).then(function(result) {
            if (result && result.ok) {
              setButtonState(true);
              setTimeout(function() {
                if (!hasRenderedNumberLayer()) {
                  fallbackAddNumber(editPanel);
                }
              }, 900);
              return;
            }
            fallbackAddNumber(editPanel);
            setButtonState(true);
          }).catch(function() {
            fallbackAddNumber(editPanel);
            setButtonState(true);
          });
          return;
        }
        fallbackAddNumber(editPanel);
        setButtonState(true);
      }
      window.__xeistNumberTool = {
        add: performAdd,
        remove: performRemove,
        isActive: function() {
          return numberActive;
        },
        button: btn
      };
      btn.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        var prompt = window.__xeistNumberPrompt;
        if (prompt && typeof prompt.open === "function") {
          prompt.open();
          return;
        }
        if (numberActive) {
          performRemove();
          return;
        }
        performAdd();
      });
    }, CHECK_INTERVAL);
  })();

  // src/coach/18-save-share-button.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    var attempts = 0;
    var pollId = setInterval(function() {
      attempts++;
      if (attempts > 240) {
        clearInterval(pollId);
        return;
      }
      var previewPanel = document.querySelector(".kb-preview-panel");
      if (!previewPanel) return;
      var coachConfig = window.XeistOrbitCoachConfig || {};
      var designId = String(coachConfig.designId || "").toLowerCase();
      if (designId && window.location.hash.toLowerCase().indexOf("/customise/" + designId) === -1) return;
      if (document.getElementById("xeist-save-share-overlay")) {
        clearInterval(pollId);
        return;
      }
      clearInterval(pollId);
      var btn = document.createElement("button");
      btn.id = "xeist-save-share-overlay";
      btn.type = "button";
      btn.setAttribute("data-coach-save-share", "");
      btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:6px"><path d="M4 4v16l8-5 8 5V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2z"/></svg>Save / Share';
      btn.style.cssText = [
        "position: absolute",
        "top: 14px",
        "left: 14px",
        "z-index: 1000",
        "display: inline-flex",
        "align-items: center",
        "padding: 9px 16px",
        "background: rgba(255,255,255,0.96)",
        "color: #5b3fd6",
        "border: 1.5px solid rgba(91,63,214,0.4)",
        "border-radius: 8px",
        "font-family: inherit",
        "font-size: 13px",
        "font-weight: 700",
        "letter-spacing: 0.3px",
        "cursor: pointer",
        "box-shadow: 0 2px 10px rgba(20,11,33,0.18)",
        "transition: background 0.2s, transform 0.15s, box-shadow 0.2s, border-color 0.2s"
      ].join(";");
      btn.addEventListener("mouseenter", function() {
        btn.style.background = "#f6f3ff";
        btn.style.transform = "translateY(-1px)";
        btn.style.borderColor = "rgba(91,63,214,0.65)";
      });
      btn.addEventListener("mouseleave", function() {
        btn.style.background = "rgba(255,255,255,0.96)";
        btn.style.transform = "none";
        btn.style.borderColor = "rgba(91,63,214,0.4)";
      });
      if (window.getComputedStyle(previewPanel).position === "static") {
        previewPanel.style.position = "relative";
      }
      previewPanel.appendChild(btn);
    }, 250);
  })();

  // src/coach/19-coach-config.js
  (function() {
    if (!(window.XeistConfig && window.XeistConfig.coachEnabled)) return;
    var validationMessages = {};
    try {
      validationMessages = JSON.parse(window.XeistConfig.v["orbit_validation_messages_json"]);
    } catch (error) {
      validationMessages = {};
    }
    var numberDefaults = {
      placementKey: "add-number",
      text: "2",
      /* DELIBERATELY 'Arial' — do not "fix" this to a KitBuilder font
                     without re-testing the CART image (2026-07).
      
                     KB has two renderers that disagree about fonts:
                       - the live 3D builds its texture in-browser, so it can use KB's
                         webfonts ('jersey', 'americancaptain', 'varsity', ...);
                       - the CART/CHECKOUT image — and production — are rendered from the
                         SAVED design, and that pipeline DROPS 'jersey' text entirely.
      
                     So with 'jersey' the preview looks right but the number is missing
                     from the order (bags would ship unnumbered). With 'Arial' the number
                     survives into the saved design and production, which is the safer
                     failure. Tracked with KitBuilder; revisit once they fix it. */
      fontFamily: "Arial",
      color: "#FFFFFF",
      /* (1399,1773) = FINAL top-pocket centre (2026-08-28, decided
         after the full pipeline unravel): the orbit number renders via
         the bridge's canvas renderer at the ITEM's coords, and the KB
         field template (114905181) is also 1399,1773. Keep all three in
         sync: this default, module 12's baked spec, module 17's snap
         fallback, and the KB field. */
      x: 1399,
      y: 1773
    };
    var logoPlacementKeys = ["logo", "crest", "badge"];
    var numberPlacementKeys = ["add-number", "number"];
    function buildConfig(o) {
      return {
        enabled: true,
        productSlug: o.productSlug,
        designId: o.designId,
        featureFlags: { coachPanelEnabled: true, debugBridge: false },
        pricing: {
          /* depositPercent MUST match this product's Downpay purchase
             option; the actual charge comes from Downpay at checkout. */
          depositPercent: 35,
          baseTiers: o.baseTiers,
          logoUpcharge: o.logoUpcharge,
          numberUpcharge: o.numberUpcharge,
          /* Whether the logo is included free (Orbit's absorb scheme) or a
             real per-unit add-on. Defaults true to preserve the backpacks'
             "Logo included free" copy; the jacket sets it false so the
             volume table footer shows the real +$5/jacket logo charge. */
          logoIncludedFree: o.logoIncludedFree !== false
        },
        rules: { minQty: o.minQty, maxQty: o.maxQty, requireLogoForCheckout: false },
        uiCopy: { validationMessages },
        /* Per-design override. The bridge force-writes defaults.fontSize onto
           the rendered <text> (see xeist-kb-bridge-v8.js), so KitBuilder's own
           font-size is ignored — a design that needs a different number size
           must set it here. Falls back to the shared defaults when absent. */
        numberDefaults: o.numberDefaults || numberDefaults,
        /* Per-design LOGO default (2026-09-15): top-left of a fresh
           logo in design SVG units. Consumed by module 16's aligner
           (same "still at the placement default" guard as the
           brand-mark alignment), which moves a newly placed logo there
           through EditorService so the saved design carries it. Null =
           KitBuilder's own placement template, untouched. */
        logoDefaults: o.logoDefaults || null,
        logoPlacementKeys,
        numberPlacementKeys,
        /* Per-design copy + decoration coords (2026-06-23). All optional:
           when absent (the backpacks), the panel/JS keep their existing
           "bag" copy and harvest decoration coords live from KB, so these
           additions are fully backward-compatible. */
        productNoun: o.productNoun || null,
        productNounPlural: o.productNounPlural || null,
        orderTitle: o.orderTitle || null,
        decorationSpecs: o.decorationSpecs || null,
        /* Size-run grid (2026-06-23). When enabled (the jacket), the panel
           replaces its single quantity stepper with a per-size grid that
           writes KitBuilder's teamdetails.sizes. Absent for one-size
           designs (the backpacks), which keep the stepper. */
        sizeEntry: o.sizeEntry || null,
        /* Matching-set cross-sell (the joggers) offered at Add to cart. */
        crossSell: o.crossSell || null,
        /* Optional theme-asset image shown as a poster while the 3D model
           loads (the black products use the merchant-uploaded photos). */
        posterImage: o.posterImage || null,
        /* Optional preview-zoom multiplier (1 = default). The jackets use
           0.75 to open ~25% more zoomed-out. */
        previewZoomScale: o.previewZoomScale || null
      };
    }
    var configs = {};
    configs[window.XeistConfig.v["orbit_design_id"]] = buildConfig({
      productSlug: window.XeistConfig.v["orbit_product_slug"],
      designId: window.XeistConfig.v["orbit_design_id"],
      baseTiers: [
        { min: 1, max: 24, unitPrice: window.XeistConfig.v["orbit_tier_1_24_price"] },
        { min: 25, max: 49, unitPrice: window.XeistConfig.v["orbit_tier_25_49_price"] },
        { min: 50, max: 99, unitPrice: window.XeistConfig.v["orbit_tier_50_99_price"] },
        { min: 100, max: null, unitPrice: window.XeistConfig.v["orbit_tier_100_plus_price"] }
      ],
      logoUpcharge: window.XeistConfig.v["orbit_logo_upcharge"],
      numberUpcharge: window.XeistConfig.v["orbit_number_upcharge"],
      minQty: window.XeistConfig.v["orbit_min_qty"],
      maxQty: window.XeistConfig.v["orbit_max_qty"]
    });
    configs[window.XeistConfig.v["dual_design_id"]] = buildConfig({
      productSlug: window.XeistConfig.v["dual_product_slug"],
      designId: window.XeistConfig.v["dual_design_id"],
      baseTiers: [
        { min: 1, max: 24, unitPrice: window.XeistConfig.v["dual_tier_1_24_price"] },
        { min: 25, max: 49, unitPrice: window.XeistConfig.v["dual_tier_25_49_price"] },
        { min: 50, max: 99, unitPrice: window.XeistConfig.v["dual_tier_50_99_price"] },
        { min: 100, max: null, unitPrice: window.XeistConfig.v["dual_tier_100_plus_price"] }
      ],
      logoUpcharge: window.XeistConfig.v["dual_logo_upcharge"],
      numberUpcharge: window.XeistConfig.v["dual_number_upcharge"],
      minQty: window.XeistConfig.v["dual_min_qty"],
      maxQty: window.XeistConfig.v["dual_max_qty"],
      /* Number POSITION is owned by KitBuilder, not here (2026-07). The KB
                     add-number placement for this design is disable-move="true", so the
                     renderer takes x/y straight from the KB template and ignores any
                     coords we set — the old decorationSpecs override was inert and has
                     been removed. Placement now lives in KB product 114894172 / field
                     114898772, on the flap: x=1176, y=2485 (SVG viewBox 0 0 4251 4251;
                     LOWER y = HIGHER on the bag; flap island x 841-1490, y 2279-2550).
      
                     SIZE, however, is NOT owned by KB: the bridge force-writes
                     defaults.fontSize onto the rendered <text>, overriding KB's
                     font-size. So the number's size must be set here. The shared default
                     (250) overflows this bag's flap panel. Tuned live: 250 -> 150 -> 105.
                     fontFamily stays 'Arial' on purpose — see the shared numberDefaults
                     above: KB's cart/production render drops 'jersey' text, so a KB font
                     would give a correct preview but ship bags with no number. */
      /* fontFamily MUST be one of KitBuilder's own fonts (jersey,
         americancaptain, varsity, superstar, ...). KB renders custom-font
         text as OpenType path outlines and hides the source <text> with
         `.kb-svgext-live [kb-svgext-otf-id] { fill: none !important; }`.
         Give it a font it doesn't know (e.g. 'Arial') and it hides the text
         but can't produce the outline — the number goes invisible while
         still being present in the design. 'jersey' is this placement's
         font in KB. */
      /* x/y = THIS bag's KB placement (the flap, above), not the Orbit's
         top pocket (2026-09-15). These coords are only fallbacks — the
         live KB placement wins whenever it can be read — but every
         fallback path lands here: module 17's creation snap on real
         phones (header-less mobile markup, so the live read never
         succeeds), and the bridge's enableDefaultNumber forcePlacement.
         With the Orbit's 1399,1773 those paths put the number in a UV
         gap of the Dual Strap GLB (no island there) — a number the coach
         added but could never see. fontSize 105 is also what the bridge's
         canvas renderer draws with now (design-size mode), so preview,
         cart and production agree. */
      numberDefaults: {
        placementKey: "add-number",
        text: "2",
        fontFamily: "Arial",
        color: "#FFFFFF",
        x: 1176,
        y: 2485,
        fontSize: 105
      },
      /* Logo default (2026-09-15, "make it exactly in the middle of the
         front pocket"): KB's template puts the 185x185 logo at 418,2210,
         which is 42 units right of the pocket's centre line and 61
         above its vertical middle — measured on the GLB (mesh_4 front
         face, the two front straps' midpoint and the XEIST patch axis
         all agree; straight-on projection). Top-left 379,2271 puts the
         logo's centre on that line and mid-height. The number stays
         where it is; the Orbit sets no logoDefaults. */
      logoDefaults: { x: 379, y: 2271 }
    });
    configs[window.XeistConfig.v["jacket_design_id"]] = buildConfig({
      productSlug: window.XeistConfig.v["jacket_product_slug"],
      designId: window.XeistConfig.v["jacket_design_id"],
      baseTiers: [
        { min: 1, max: 24, unitPrice: window.XeistConfig.v["jacket_tier_1_24_price"] },
        { min: 25, max: 49, unitPrice: window.XeistConfig.v["jacket_tier_25_49_price"] },
        { min: 50, max: 99, unitPrice: window.XeistConfig.v["jacket_tier_50_99_price"] },
        { min: 100, max: 199, unitPrice: window.XeistConfig.v["jacket_tier_100_199_price"] },
        { min: 200, max: null, unitPrice: window.XeistConfig.v["jacket_tier_200_plus_price"] }
      ],
      logoUpcharge: window.XeistConfig.v["jacket_logo_upcharge"],
      numberUpcharge: window.XeistConfig.v["jacket_number_upcharge"],
      logoIncludedFree: false,
      minQty: window.XeistConfig.v["jacket_min_qty"],
      maxQty: window.XeistConfig.v["jacket_max_qty"],
      productNoun: "jacket",
      productNounPlural: "jackets",
      orderTitle: "Elemental Jacket Order",
      decorationSpecs: { "add-logo": { x: 1110, y: 2600 } },
      previewZoomScale: 0.75,
      /* Size-run grid: adult sizes (Men's/Women's via a toggle) + unisex
         youth, built live from KitBuilder's 16 sizes. labelRules tells the
         panel how to bucket each KB size label into a group/gender. */
      sizeEntry: {
        enabled: true,
        labelRules: [
          { match: "^Youth", group: "youth", gender: null },
          { match: "^Men's", group: "adult", gender: "Men's" },
          { match: "^Women's", group: "adult", gender: "Women's" }
        ],
        defaultGender: "Men's"
      },
      /* Matching set: at Add to cart the coach is offered the joggers.
         Yes carries the uploaded logo and opens this design's customizer. */
      crossSell: {
        designId: "211485079",
        handle: "xeist-mens-elemental-joggers-grey",
        label: "Elemental Joggers – Grey"
      }
    });
    configs[window.XeistConfig.v["joggers_design_id"]] = buildConfig({
      productSlug: window.XeistConfig.v["joggers_product_slug"],
      designId: window.XeistConfig.v["joggers_design_id"],
      baseTiers: [
        { min: 1, max: 24, unitPrice: window.XeistConfig.v["joggers_tier_1_24_price"] },
        { min: 25, max: 49, unitPrice: window.XeistConfig.v["joggers_tier_25_49_price"] },
        { min: 50, max: 99, unitPrice: window.XeistConfig.v["joggers_tier_50_99_price"] },
        { min: 100, max: 199, unitPrice: window.XeistConfig.v["joggers_tier_100_199_price"] },
        { min: 200, max: null, unitPrice: window.XeistConfig.v["joggers_tier_200_plus_price"] }
      ],
      logoUpcharge: window.XeistConfig.v["joggers_logo_upcharge"],
      numberUpcharge: window.XeistConfig.v["joggers_number_upcharge"],
      logoIncludedFree: false,
      minQty: window.XeistConfig.v["joggers_min_qty"],
      maxQty: window.XeistConfig.v["joggers_max_qty"],
      productNoun: "pair",
      productNounPlural: "pairs",
      orderTitle: "Elemental Joggers Order",
      decorationSpecs: { "add-logo": { x: 1330, y: 2380 } },
      previewZoomScale: 0.75,
      sizeEntry: {
        enabled: true,
        labelRules: [
          { match: "^Youth", group: "youth", gender: null },
          { match: "^Men's", group: "adult", gender: "Men's" },
          { match: "^Women's", group: "adult", gender: "Women's" }
        ],
        defaultGender: "Men's"
      },
      /* Reciprocal pair: offer the matching grey jacket. */
      crossSell: {
        designId: "210147750",
        handle: "xeist-mens-elemental-jacket-grey",
        label: "Elemental Jacket – Grey",
        image: window.XeistConfig.v["all_products_xeist_mens_elemental_jacket_grey_featured_image_image_url_width_600"]
      }
    });
    configs[window.XeistConfig.v["compression_design_id"]] = buildConfig({
      productSlug: window.XeistConfig.v["compression_product_slug"],
      designId: window.XeistConfig.v["compression_design_id"],
      baseTiers: [
        { min: 1, max: 11, unitPrice: window.XeistConfig.v["compression_tier_1_11_price"] },
        { min: 12, max: 24, unitPrice: window.XeistConfig.v["compression_tier_12_24_price"] },
        { min: 25, max: 49, unitPrice: window.XeistConfig.v["compression_tier_25_49_price"] },
        { min: 50, max: 99, unitPrice: window.XeistConfig.v["compression_tier_50_99_price"] },
        { min: 100, max: 199, unitPrice: window.XeistConfig.v["compression_tier_100_199_price"] },
        { min: 200, max: null, unitPrice: window.XeistConfig.v["compression_tier_200_plus_price"] }
      ],
      logoUpcharge: window.XeistConfig.v["compression_logo_upcharge"],
      numberUpcharge: window.XeistConfig.v["compression_number_upcharge"],
      logoIncludedFree: false,
      minQty: window.XeistConfig.v["compression_min_qty"],
      maxQty: window.XeistConfig.v["compression_max_qty"],
      productNoun: "shirt",
      productNounPlural: "shirts",
      orderTitle: "Compression Short Sleeve Order",
      decorationSpecs: { "add-logo": { x: 1589, y: 3870 } }
    });
    configs["117611677"] = buildConfig({
      productSlug: "elemental-jacket",
      designId: "117611677",
      baseTiers: [
        { min: 1, max: 24, unitPrice: 44.99 },
        { min: 25, max: 49, unitPrice: 43.99 },
        { min: 50, max: 99, unitPrice: 42.99 },
        { min: 100, max: 199, unitPrice: 41.99 },
        { min: 200, max: null, unitPrice: 40.99 }
      ],
      logoUpcharge: 5,
      numberUpcharge: 0,
      logoIncludedFree: false,
      minQty: 6,
      maxQty: window.XeistConfig.v["settings_orbit_max_qty_default_500"],
      productNoun: "jacket",
      productNounPlural: "jackets",
      orderTitle: "Elemental Jacket Order",
      decorationSpecs: { "add-logo": { x: 1110, y: 2600 } },
      previewZoomScale: 0.75,
      posterImage: window.XeistConfig.v["all_products_xeist_mens_elemental_jacket_featured_image_image_url_width_800"],
      sizeEntry: {
        enabled: true,
        labelRules: [
          { match: "^Youth", group: "youth", gender: null },
          { match: "^Men's", group: "adult", gender: "Men's" },
          { match: "^Women's", group: "adult", gender: "Women's" }
        ],
        defaultGender: "Men's"
      },
      crossSell: {
        designId: "117991635",
        handle: "xeist-elemental-jacket",
        label: "Elemental Joggers – Black",
        image: window.XeistConfig.v["all_products_xeist_elemental_jacket_featured_image_image_url_width_600"]
      }
    });
    configs["117991635"] = buildConfig({
      productSlug: "elemental-joggers-black",
      designId: "117991635",
      baseTiers: [
        { min: 1, max: 24, unitPrice: 44.99 },
        { min: 25, max: 49, unitPrice: 43.99 },
        { min: 50, max: 99, unitPrice: 42.99 },
        { min: 100, max: 199, unitPrice: 41.99 },
        { min: 200, max: null, unitPrice: 40.99 }
      ],
      logoUpcharge: 5,
      numberUpcharge: 0,
      logoIncludedFree: false,
      minQty: 6,
      maxQty: window.XeistConfig.v["settings_orbit_max_qty_default_500"],
      productNoun: "pair",
      productNounPlural: "pairs",
      orderTitle: "Elemental Joggers Order",
      decorationSpecs: { "add-logo": { x: 1330, y: 2380 } },
      previewZoomScale: 0.75,
      posterImage: window.XeistConfig.v["all_products_xeist_elemental_jacket_featured_image_image_url_width_800"],
      sizeEntry: {
        enabled: true,
        labelRules: [
          { match: "^Youth", group: "youth", gender: null },
          { match: "^Men's", group: "adult", gender: "Men's" },
          { match: "^Women's", group: "adult", gender: "Women's" }
        ],
        defaultGender: "Men's"
      },
      crossSell: {
        designId: "117611677",
        handle: "xeist-mens-elemental-jacket",
        label: "Elemental Jacket – Black",
        image: window.XeistConfig.v["all_products_xeist_mens_elemental_jacket_featured_image_image_url_width_600"]
      }
    });
    window.XeistCoachConfigs = configs;
    var hash = window.location.hash || "";
    var resolved = null;
    for (var id in configs) {
      if (configs.hasOwnProperty(id) && hash.indexOf(id) !== -1) {
        resolved = configs[id];
        break;
      }
    }
    window.XeistOrbitCoachConfig = resolved || (window.XeistOrbitCoachConfig && window.XeistOrbitCoachConfig.designId ? window.XeistOrbitCoachConfig : null) || configs[window.XeistConfig.v["orbit_design_id"]];
  })();

  // src/coach/20-save-share-locker-room.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    function findLockerVm() {
      if (!window.angular) return null;
      var nodes = document.querySelectorAll('[ng-click*="vmLr"]');
      for (var i = 0; i < nodes.length; i++) {
        var s = angular.element(nodes[i]).scope();
        if (s && s.vmLr && typeof s.vmLr.showSaveCustomDesignDialog === "function") return s;
      }
      var root = document.querySelector("[ng-controller]") || document.getElementById("kitBuilder");
      if (!root) return null;
      var sc = angular.element(root).scope(), depth = 0;
      while (sc && depth < 60) {
        if (sc.vmLr && typeof sc.vmLr.showSaveCustomDesignDialog === "function") return sc;
        sc = sc.$parent;
        depth++;
      }
      return null;
    }
    function openLockerSave(evt) {
      var scope = findLockerVm();
      if (!scope) return false;
      var vm = scope.vmLr;
      var ev = {
        preventDefault: function() {
        },
        stopPropagation: function() {
        },
        target: evt && evt.target || document.body
      };
      function run() {
        var auth = vm.authService;
        var authed = auth && typeof auth.isLoggedIn === "function" && auth.isLoggedIn();
        if (!authed) {
          window.location.hash = "/locker-room?pageNumber=1&pageSize=50";
          return;
        }
        var custom = window.__xeistSaveDesignModal;
        if (custom && typeof custom.open === "function") {
          var handled = false;
          try {
            handled = custom.open({
              scope,
              vm,
              event: evt,
              trigger: evt && evt.target && evt.target.closest ? evt.target.closest("[data-coach-save-share]") : null
            });
          } catch (eCustom) {
            handled = false;
          }
          if (handled) return;
        }
        vm.showSaveCustomDesignDialog(ev);
      }
      try {
        scope.$apply(run);
      } catch (e) {
        try {
          run();
        } catch (e2) {
          return false;
        }
      }
      return true;
    }
    document.addEventListener("click", function(e) {
      var btn = e.target && e.target.closest && e.target.closest("[data-coach-save-share]");
      if (!btn) return;
      e.preventDefault();
      btn.setAttribute("aria-busy", "true");
      if (!openLockerSave(e)) {
        var tries = 0;
        var t = setInterval(function() {
          tries++;
          if (openLockerSave(e) || tries > 24) {
            clearInterval(t);
            btn.removeAttribute("aria-busy");
          }
        }, 250);
      } else {
        btn.removeAttribute("aria-busy");
      }
    }, false);
  })();

  // src/logo-tools/21-auto-place-uploaded-logo.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1 || !window.__xeistCoachOn()) return;
    function getPlacementScope() {
      var header = window.__xeistLogoHeader ? window.__xeistLogoHeader() : document.querySelector(".kb-editor-heading.kb-wizard-group-header");
      if (!header || !window.angular) return null;
      return angular.element(header).scope();
    }
    function getImageLibThumbs() {
      var imageLib = document.querySelector("ul.kb-editor-images.kb-editor-image-library");
      if (!imageLib) return [];
      return imageLib.querySelectorAll(
        "li.kb-editor-image:not(.kb-editor-placement-new-image):not(.kb-editor-image-uploading)"
      );
    }
    var watching = false;
    var baselineCount = 0;
    var observer = null;
    var pollId = null;
    function startWatching() {
      if (watching) return;
      watching = true;
      baselineCount = getImageLibThumbs().length;
      var imageLib = document.querySelector("ul.kb-editor-images.kb-editor-image-library");
      if (!imageLib) {
        watching = false;
        return;
      }
      observer = new MutationObserver(checkForNewThumbs);
      observer.observe(imageLib, { childList: true, subtree: true });
      pollId = setInterval(checkForNewThumbs, 400);
      setTimeout(stopWatching, 9e4);
    }
    function stopWatching() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      if (pollId) {
        clearInterval(pollId);
        pollId = null;
      }
      watching = false;
    }
    function checkForNewThumbs() {
      var thumbs = getImageLibThumbs();
      if (thumbs.length <= baselineCount) return;
      var newThumb = thumbs[thumbs.length - 1];
      stopWatching();
      setTimeout(function() {
        autoPlaceImage(newThumb);
      }, 400);
    }
    function autoPlaceImage(thumbLi) {
      var scope = getPlacementScope();
      if (scope && window.angular) {
        var thumbScope = angular.element(thumbLi).scope();
        if (thumbScope && thumbScope.image && scope.addImageNew && scope.placement) {
          try {
            scope.$apply(function() {
              scope.addImageNew(
                scope.placement.placementKey,
                thumbScope.image.thumbnailImageId,
                thumbScope.image
              );
            });
            setTimeout(autoRemoveBackground, 2e3);
            return;
          } catch (e) {
          }
        }
      }
      var clickTarget = thumbLi.querySelector("[ng-click]") || thumbLi;
      clickTarget.click();
      setTimeout(autoRemoveBackground, 2e3);
    }
    function autoRemoveBackground() {
      var editPanel = document.querySelector(".kb-customise-edit-panel");
      if (!editPanel) return;
      var attempts = 0;
      var bgPollId = setInterval(function() {
        attempts++;
        if (attempts > 40) {
          clearInterval(bgPollId);
          return;
        }
        var removeBgBtn = editPanel.querySelector('[ng-click*="removeBackground"]');
        if (!removeBgBtn) {
          var candidates = editPanel.querySelectorAll("button, a, span[ng-click], div[ng-click]");
          for (var i = 0; i < candidates.length; i++) {
            var txt = (candidates[i].textContent || "").toLowerCase();
            if (txt.indexOf("remove background") > -1 || txt.indexOf("remove bg") > -1) {
              removeBgBtn = candidates[i];
              break;
            }
          }
        }
        if (removeBgBtn && removeBgBtn.offsetParent !== null) {
          clearInterval(bgPollId);
          removeBgBtn.click();
        }
      }, 500);
    }
    var hookAttempts = 0;
    var hookId = setInterval(function() {
      hookAttempts++;
      if (hookAttempts > 120) {
        clearInterval(hookId);
        return;
      }
      var addLogoBtn = document.getElementById("xeist-add-logo-overlay");
      if (!addLogoBtn || addLogoBtn.dataset.autoPlaceHooked) return;
      clearInterval(hookId);
      addLogoBtn.dataset.autoPlaceHooked = "true";
      addLogoBtn.addEventListener("click", function() {
        setTimeout(startWatching, 800);
      });
      var inputHooked = false;
      var inputPollId = setInterval(function() {
        if (inputHooked) {
          clearInterval(inputPollId);
          return;
        }
        var fileInput = document.querySelector('.kb-editor-placement-new-image-label input[type="file"]');
        if (!fileInput) return;
        inputHooked = true;
        clearInterval(inputPollId);
        fileInput.addEventListener("change", function() {
          setTimeout(startWatching, 500);
        });
      }, 1e3);
    }, 500);
  })();

  // src/gallery/22-product-gallery.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1 || !/114891065|114890045/.test(window.location.hash || "")) return;
    var GALLERY_ID = "xeist-product-gallery";
    var CHECK_INTERVAL = 500;
    var MAX_ATTEMPTS = 60;
    var attempts = 0;
    var pollId = setInterval(function() {
      attempts++;
      if (attempts > MAX_ATTEMPTS) {
        clearInterval(pollId);
        return;
      }
      if (!window.angular) return;
      var wrap = document.querySelector(".kb-partial-wrap");
      if (!wrap) return;
      var scope = angular.element(wrap).scope();
      if (!scope || !scope.design || !scope.design.productUrlSlug) return;
      if (document.getElementById(GALLERY_ID)) {
        clearInterval(pollId);
        return;
      }
      clearInterval(pollId);
      var coachCfg = window.XeistOrbitCoachConfig || {};
      var designId = String(scope.design.designId || scope.design.id || "");
      if (coachCfg.enabled && coachCfg.designId && designId === String(coachCfg.designId)) return;
      var slug = scope.design.productUrlSlug;
      var productName = scope.design.productName || scope.productName || "";
      fetch("/products/" + slug + ".json").then(function(r) {
        return r.json();
      }).then(function(data) {
        if (!data.product || !data.product.images || data.product.images.length === 0) return;
        buildGallery(data.product.images, productName);
      }).catch(function() {
      });
    }, CHECK_INTERVAL);
    function buildGallery(images, productName) {
      var kitBuilder = document.getElementById("kitBuilder");
      if (!kitBuilder) return;
      var gallery = document.createElement("div");
      gallery.id = GALLERY_ID;
      gallery.style.cssText = [
        "max-width: 1440px",
        "margin: 40px auto 60px",
        "padding: 0 36px"
      ].join(";");
      if (productName) {
        var heading = document.createElement("h3");
        heading.textContent = productName;
        heading.style.cssText = [
          "font-family: inherit",
          "font-size: 22px",
          "font-weight: 700",
          "text-transform: uppercase",
          "letter-spacing: 1px",
          "margin-bottom: 20px",
          "color: #1a1a1a"
        ].join(";");
        gallery.appendChild(heading);
      }
      var grid = document.createElement("div");
      grid.style.cssText = [
        "display: grid",
        "grid-template-columns: repeat(auto-fill, minmax(280px, 1fr))",
        "gap: 16px"
      ].join(";");
      images.forEach(function(img, idx) {
        var wrapper = document.createElement("div");
        wrapper.style.cssText = [
          "position: relative",
          "overflow: hidden",
          "border-radius: 12px",
          "background: #f5f5f5",
          "cursor: pointer",
          "aspect-ratio: 2/3",
          "transition: transform 0.2s ease, box-shadow 0.2s ease"
        ].join(";");
        wrapper.addEventListener("mouseenter", function() {
          wrapper.style.transform = "translateY(-4px)";
          wrapper.style.boxShadow = "0 8px 24px rgba(0,0,0,0.12)";
        });
        wrapper.addEventListener("mouseleave", function() {
          wrapper.style.transform = "none";
          wrapper.style.boxShadow = "none";
        });
        var thumbSrc = img.src.replace(/\.([a-z]+)\?/, "_600x900.$1?");
        var fullSrc = img.src;
        var imgEl = document.createElement("img");
        imgEl.src = thumbSrc;
        imgEl.alt = img.alt || productName + " - Image " + (idx + 1);
        imgEl.loading = "lazy";
        imgEl.style.cssText = [
          "width: 100%",
          "height: 100%",
          "object-fit: cover",
          "display: block"
        ].join(";");
        wrapper.appendChild(imgEl);
        wrapper.addEventListener("click", function() {
          openLightbox(fullSrc, img.alt || productName);
        });
        grid.appendChild(wrapper);
      });
      gallery.appendChild(grid);
      kitBuilder.parentNode.insertBefore(gallery, kitBuilder.nextSibling);
    }
    function openLightbox(src, alt) {
      var existing = document.getElementById("xeist-lightbox");
      if (existing) existing.remove();
      var overlay = document.createElement("div");
      overlay.id = "xeist-lightbox";
      overlay.style.cssText = [
        "position: fixed",
        "inset: 0",
        "z-index: 99999",
        "background: rgba(0,0,0,0.85)",
        "display: flex",
        "align-items: center",
        "justify-content: center",
        "padding: 40px",
        "cursor: zoom-out",
        "animation: xeistFadeIn 0.2s ease"
      ].join(";");
      if (!document.getElementById("xeist-lightbox-style")) {
        var style = document.createElement("style");
        style.id = "xeist-lightbox-style";
        style.textContent = "@keyframes xeistFadeIn { from { opacity: 0; } to { opacity: 1; } }";
        document.head.appendChild(style);
      }
      var img = document.createElement("img");
      img.src = src;
      img.alt = alt;
      img.style.cssText = [
        "max-width: 90vw",
        "max-height: 90vh",
        "object-fit: contain",
        "border-radius: 8px",
        "box-shadow: 0 0 60px rgba(0,0,0,0.4)",
        "cursor: default"
      ].join(";");
      img.addEventListener("click", function(e) {
        e.stopPropagation();
      });
      var closeBtn = document.createElement("button");
      closeBtn.innerHTML = "&times;";
      closeBtn.style.cssText = [
        "position: absolute",
        "top: 16px",
        "right: 24px",
        "background: none",
        "border: none",
        "color: #fff",
        "font-size: 36px",
        "cursor: pointer",
        "line-height: 1",
        "padding: 8px"
      ].join(";");
      closeBtn.addEventListener("click", function() {
        overlay.remove();
      });
      overlay.appendChild(img);
      overlay.appendChild(closeBtn);
      overlay.addEventListener("click", function() {
        overlay.remove();
      });
      var escHandler = function(e) {
        if (e.key === "Escape") {
          overlay.remove();
          document.removeEventListener("keydown", escHandler);
        }
      };
      document.addEventListener("keydown", escHandler);
      document.body.appendChild(overlay);
    }
  })();

  // src/coach/23-complete-the-set.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    var cfg = window.XeistOrbitCoachConfig || {};
    var cross = cfg.crossSell;
    if (!cross || !cross.designId) return;
    var CARD_ID = "xeist-complete-set";
    var CUSTOMIZER_PATH = "/pages/3d-customizer";
    var HIDE_SEL = ".kb-add-related-products, .kb-add-cross-sells, .kb-add-related-products-inner, .kb-add-cross-sells-inner, .kb-related-products-heading, .kb-cross-sells-heading";
    function hideKbPanels() {
      var els = document.querySelectorAll(HIDE_SEL);
      for (var i = 0; i < els.length; i++) {
        var box = els[i].closest(".kb-add-related-products, .kb-add-cross-sells") || els[i];
        if (box.style.getPropertyValue("display") !== "none") {
          box.style.setProperty("display", "none", "important");
        }
      }
    }
    var mq = window.matchMedia("(max-width: 900px)");
    function applyResponsive() {
      var c = document.getElementById(CARD_ID);
      if (c) c.style.display = mq.matches ? "none" : "block";
    }
    if (mq.addEventListener) {
      mq.addEventListener("change", applyResponsive);
    } else if (mq.addListener) {
      mq.addListener(applyResponsive);
    }
    function goToPair(e) {
      if (e) e.preventDefault();
      window.location.href = CUSTOMIZER_PATH + "?set=" + Date.now() + "#/customise/" + cross.designId;
    }
    function buildCard(imgSrc, title) {
      if (document.getElementById(CARD_ID)) return;
      var a = document.createElement("a");
      a.id = CARD_ID;
      a.href = CUSTOMIZER_PATH + "#/customise/" + cross.designId;
      a.setAttribute("aria-label", "Complete the set: " + title);
      a.style.cssText = [
        "position:fixed",
        "top:116px",
        "right:26px",
        "z-index:9000",
        "width:264px",
        "background:#fff",
        "border:1px solid rgba(20,11,33,0.12)",
        "border-radius:16px",
        "padding:14px",
        "text-decoration:none",
        "color:#140b21",
        "box-shadow:0 12px 36px rgba(20,11,33,0.16)",
        "display:block",
        'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif'
      ].join(";");
      var imgHtml = imgSrc ? '<img src="' + imgSrc + '" alt="' + title + `" onerror="this.style.display='none'" style="width:100%;height:100%;object-fit:cover;display:block;" loading="lazy">` : "";
      a.innerHTML = '<div style="font-size:11px;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;color:#6c2bd9;margin-bottom:10px;">Complete the set</div><div style="background:#f3f1f8;border-radius:12px;overflow:hidden;aspect-ratio:4/5;display:flex;align-items:center;justify-content:center;">' + imgHtml + '</div><div style="font-size:16px;font-weight:600;margin:11px 0 4px;line-height:1.3;">' + title + '</div><span style="display:inline-flex;align-items:center;gap:6px;font-size:14px;font-weight:600;color:#6c2bd9;">Customize these <span aria-hidden="true">&rarr;</span></span>';
      a.addEventListener("click", goToPair);
      document.body.appendChild(a);
      applyResponsive();
    }
    function init() {
      var title = (cross.label || "Matching set").replace(/^Xeist\s+/i, "");
      if (cross.image) {
        buildCard(cross.image, title);
        return;
      }
      if (cross.handle) {
        fetch("/products/" + cross.handle + ".json").then(function(r) {
          return r.ok ? r.json() : null;
        }).then(function(d) {
          var prod = d && d.product || {};
          var src = prod.image && prod.image.src || prod.images && prod.images[0] && prod.images[0].src || "";
          if (src) src += (src.indexOf("?") > -1 ? "&" : "?") + "width=640";
          buildCard(src, (prod.title || title).replace(/^Xeist\s+/i, ""));
        }).catch(function() {
          buildCard("", title);
        });
      } else {
        buildCard("", title);
      }
    }
    function isDesignAdded(id) {
      try {
        var m = JSON.parse(window.localStorage.getItem("xeist_set_added") || "{}") || {};
        var ts = m[String(id)];
        return !!ts && Date.now() - ts < 2 * 60 * 60 * 1e3;
      } catch (e) {
        return false;
      }
    }
    if (!isDesignAdded(cross.designId)) init();
    hideKbPanels();
    setInterval(hideKbPanels, 1e3);
  })();

  // src/skeleton/24-load-poster.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    var cfg = window.XeistOrbitCoachConfig || {};
    var src = cfg.posterImage;
    if (!src) return;
    var ID = "xeist-load-poster";
    if (document.getElementById(ID)) return;
    var wrap = document.createElement("div");
    wrap.id = ID;
    wrap.style.cssText = "position:fixed;inset:0;z-index:5000;background:#f4f4f5;display:flex;align-items:center;justify-content:center;transition:opacity .5s ease;";
    var img = document.createElement("img");
    img.alt = "";
    img.style.cssText = "max-width:min(80vw,520px);max-height:80vh;object-fit:contain;";
    img.onerror = remove;
    img.src = src;
    wrap.appendChild(img);
    function add() {
      if (document.body && !document.getElementById(ID)) document.body.appendChild(wrap);
    }
    if (document.body) add();
    else document.addEventListener("DOMContentLoaded", add);
    function remove() {
      var el = document.getElementById(ID);
      if (!el) return;
      el.style.opacity = "0";
      setTimeout(function() {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 550);
    }
    var start = Date.now();
    var poll = setInterval(function() {
      var canvas = document.querySelector(".kb-preview-panel canvas");
      var ready = canvas && canvas.width > 0 && canvas.getBoundingClientRect().height > 0;
      if (ready || Date.now() - start > 2e4) {
        clearInterval(poll);
        setTimeout(remove, ready ? 300 : 0);
      }
    }, 250);
  })();

  // src/logo-tools/25-carry-logo.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1 || !(window.__xeistCoachOn && window.__xeistCoachOn())) return;
    var KEY = "xeist_carry_logo";
    var flag;
    try {
      flag = JSON.parse(window.localStorage.getItem(KEY) || "null");
    } catch (e) {
      flag = null;
    }
    function clearFlag() {
      try {
        window.localStorage.removeItem(KEY);
      } catch (e) {
      }
    }
    if (!flag || !flag.want || Date.now() - (flag.ts || 0) > 30 * 60 * 1e3) {
      clearFlag();
      return;
    }
    function getPlacementScope() {
      var header = window.__xeistLogoHeader ? window.__xeistLogoHeader() : document.querySelector(".kb-editor-heading.kb-wizard-group-header");
      if (!header || !window.angular) return null;
      return angular.element(header).scope();
    }
    function getThumbs() {
      var lib = document.querySelector("ul.kb-editor-images.kb-editor-image-library");
      if (!lib) return [];
      return lib.querySelectorAll("li.kb-editor-image:not(.kb-editor-placement-new-image):not(.kb-editor-image-uploading)");
    }
    function alreadyPlaced() {
      try {
        var root = document.querySelector("[ng-controller]");
        var kit = root && window.angular ? angular.element(root).injector().get("KitService").kit : null;
        var items = kit && kit.editor || [];
        for (var i = 0; i < items.length; i++) {
          if (String(items[i].placementKey || "").toLowerCase().indexOf("logo") !== -1 && items[i].type === "image") return true;
        }
      } catch (e) {
      }
      return false;
    }
    var tries = 0;
    var t = setInterval(function() {
      tries++;
      if (tries > 80) {
        clearInterval(t);
        return;
      }
      if (alreadyPlaced()) {
        clearInterval(t);
        clearFlag();
        return;
      }
      var scope = getPlacementScope();
      var thumbs = getThumbs();
      if (!scope || !scope.addImageNew || !scope.placement || !thumbs.length) return;
      var thumbLi = thumbs[thumbs.length - 1];
      var thumbScope = angular.element(thumbLi).scope();
      if (!thumbScope || !thumbScope.image) return;
      clearInterval(t);
      try {
        scope.$apply(function() {
          scope.addImageNew(scope.placement.placementKey, thumbScope.image.thumbnailImageId, thumbScope.image);
        });
      } catch (e) {
        var clickTarget = thumbLi.querySelector("[ng-click]") || thumbLi;
        if (clickTarget) clickTarget.click();
      }
      clearFlag();
    }, 500);
  })();

  // src/coach/26-cost-per-player.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1 || !/114891065|114890045/.test(window.location.hash || "")) return;
    var WIDGET_ID = "xeist-cost-per-player";
    var CHECK_INTERVAL = 500;
    var POLL_LIMIT = 60;
    var attempts = 0;
    var lastRenderedHash = "";
    function formatCurrency(amount) {
      return "$" + amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    function getTierForQuantity(tiers, qty) {
      var sorted = tiers.slice().sort(function(a, b) {
        return b.minimumQuantity - a.minimumQuantity;
      });
      for (var i = 0; i < sorted.length; i++) {
        if (qty >= sorted[i].minimumQuantity) return sorted[i];
      }
      return sorted[sorted.length - 1];
    }
    function getNextTier(tiers, qty) {
      var sorted = tiers.slice().sort(function(a, b) {
        return a.minimumQuantity - b.minimumQuantity;
      });
      for (var i = 0; i < sorted.length; i++) {
        if (sorted[i].minimumQuantity > qty) return sorted[i];
      }
      return null;
    }
    function getTierLabel(tiers, tier) {
      var sorted = tiers.slice().sort(function(a, b) {
        return a.minimumQuantity - b.minimumQuantity;
      });
      var idx = -1;
      for (var i = 0; i < sorted.length; i++) {
        if (sorted[i].minimumQuantity === tier.minimumQuantity) {
          idx = i;
          break;
        }
      }
      if (idx === sorted.length - 1) return tier.minimumQuantity + "+";
      return tier.minimumQuantity + "-" + (sorted[idx + 1].minimumQuantity - 1);
    }
    function getKBData() {
      try {
        var editPanel = document.querySelector(".kb-customise-edit-panel");
        if (!editPanel) return null;
        var el = editPanel.querySelector(".kb-aggregate-size-quantity-input") || editPanel;
        var scope = angular.element(el).scope();
        if (!scope) return null;
        var s = scope;
        while (s && !s.CustomizeService) {
          s = s.$parent;
        }
        if (!s) return null;
        var cs = s.CustomizeService;
        var kitScope = scope;
        while (kitScope && !kitScope.KitService) {
          kitScope = kitScope.$parent;
        }
        var kit = kitScope ? kitScope.KitService.kit : null;
        var qty = 0;
        if (kit && kit.teamdetails && kit.teamdetails.sizes) {
          for (var sizeId in kit.teamdetails.sizes) {
            qty += parseInt(kit.teamdetails.sizes[sizeId]) || 0;
          }
        }
        var stepScope = scope;
        while (stepScope && !stepScope.StepService) {
          stepScope = stepScope.$parent;
        }
        var isOrderStep = false;
        if (stepScope && stepScope.StepService && stepScope.StepService.data) {
          isOrderStep = stepScope.StepService.data.stepIndex === stepScope.StepService.data.steps.length - 1;
        }
        var addons = [];
        if (cs.editorPlacements) {
          cs.editorPlacements.forEach(function(p) {
            if (p.unitCharge && p.unitCharge > 0) {
              addons.push({
                name: p.name,
                unitCharge: p.unitCharge,
                description: p.orderChargeDescription || p.name
              });
            }
          });
        }
        var logoCount = 0;
        if (kit && kit.editor && Array.isArray(kit.editor)) {
          kit.editor.forEach(function(item) {
            if (item.type === "image") logoCount++;
          });
        }
        return {
          quantity: qty,
          tiers: cs.simplePriceTiers || [],
          productName: cs.product ? cs.product.name : "Custom Item",
          productSlug: cs.design && cs.design.productUrlSlug ? cs.design.productUrlSlug : "",
          designName: cs.design ? cs.design.name : "",
          addons,
          logoCount,
          isOrderStep,
          currency: "USD"
        };
      } catch (e) {
        console.warn("[Xeist CPP] Data extraction error:", e);
        return null;
      }
    }
    function renderWidget(data) {
      var qty = data.quantity;
      var tier = getTierForQuantity(data.tiers, Math.max(qty, 1));
      var unitPrice = tier.unitPrice;
      var addonPerUnit = 0;
      data.addons.forEach(function(a) {
        if (data.logoCount > 0) addonPerUnit += a.unitCharge;
      });
      var costPerPlayer = unitPrice + addonPerUnit;
      var teamTotal = costPerPlayer * qty;
      var nextTier = qty > 0 ? getNextTier(data.tiers, qty) : null;
      var hash = qty + "_" + unitPrice + "_" + addonPerUnit + "_" + data.logoCount;
      if (hash === lastRenderedHash) return;
      lastRenderedHash = hash;
      var existing = document.getElementById(WIDGET_ID);
      if (existing) existing.remove();
      var style = document.getElementById("xeist-cpp-style");
      if (!style) {
        style = document.createElement("style");
        style.id = "xeist-cpp-style";
        style.textContent = [
          /* Hide the entire native checkout/pricing section */
          ".kb-single-item-checkout { display: none !important; }",
          /* Hide the Currency description field */
          ".kb-field-Currency { display: none !important; }",
          /* Tweak the size entry row */
          ".kb-group-order .kb-aggregate-size-quantity-input { font-size: 18px !important; text-align: center !important; width: 80px !important; padding: 8px !important; border: 2px solid #6B3FA0 !important; border-radius: 8px !important; }",
          ".kb-group-order .kb-aggregate-size-name { font-size: 16px !important; font-weight: 600 !important; }",
          /* Animations */
          "@keyframes xeistSlideUp { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }"
        ].join("\n");
        document.head.appendChild(style);
      }
      var widget = document.createElement("div");
      widget.id = WIDGET_ID;
      widget.style.cssText = "animation: xeistSlideUp 0.3s ease; margin-top: 16px;";
      var banner = document.createElement("div");
      banner.style.cssText = [
        "background: linear-gradient(135deg, #6B3FA0 0%, #9B59B6 50%, #6B3FA0 100%)",
        "border-radius: 16px",
        "padding: 24px 28px",
        "margin-bottom: 20px",
        "color: #fff",
        "position: relative",
        "overflow: hidden"
      ].join(";");
      var bannerLabel = document.createElement("div");
      bannerLabel.textContent = "COST PER PLAYER";
      bannerLabel.style.cssText = "font-size: 12px; font-weight: 700; letter-spacing: 2px; opacity: 0.85; margin-bottom: 4px;";
      banner.appendChild(bannerLabel);
      var bannerPrice = document.createElement("div");
      bannerPrice.textContent = qty > 0 ? formatCurrency(costPerPlayer) : "—";
      bannerPrice.style.cssText = "font-size: 42px; font-weight: 800; line-height: 1.1; letter-spacing: -1px;";
      banner.appendChild(bannerPrice);
      if (qty > 0) {
        var bannerMeta = document.createElement("div");
        var tierLabel = getTierLabel(data.tiers, tier);
        bannerMeta.textContent = qty + " players · " + tierLabel + " tier · Fully custom";
        bannerMeta.style.cssText = "font-size: 13px; opacity: 0.8; margin-top: 6px;";
        banner.appendChild(bannerMeta);
      } else {
        var bannerHint = document.createElement("div");
        bannerHint.textContent = "Enter quantity above to see pricing";
        bannerHint.style.cssText = "font-size: 13px; opacity: 0.8; margin-top: 6px;";
        banner.appendChild(bannerHint);
      }
      widget.appendChild(banner);
      if (qty > 0 && nextTier) {
        var nudge = document.createElement("div");
        var unitsNeeded = nextTier.minimumQuantity - qty;
        var savings = (unitPrice - nextTier.unitPrice).toFixed(2);
        nudge.style.cssText = [
          "background: #F3EAFB",
          "border: 1px solid #D4B8E8",
          "border-radius: 10px",
          "padding: 12px 16px",
          "margin-bottom: 20px",
          "font-size: 13px",
          "color: #5B2D8E",
          "display: flex",
          "align-items: center",
          "gap: 8px"
        ].join(";");
        nudge.innerHTML = '<span style="font-size: 18px;">💡</span> Add <strong>' + unitsNeeded + " more</strong> to save <strong>$" + savings + "/each</strong> (" + formatCurrency(nextTier.unitPrice + addonPerUnit) + "/player)";
        widget.appendChild(nudge);
        var progressWrap = document.createElement("div");
        progressWrap.style.cssText = "height: 6px; background: #E8D5F5; border-radius: 3px; margin: -12px 0 20px; overflow: hidden;";
        var progressBar = document.createElement("div");
        var pct = Math.min(qty / nextTier.minimumQuantity * 100, 100);
        progressBar.style.cssText = "height: 100%; background: linear-gradient(90deg, #6B3FA0, #9B59B6); border-radius: 3px; width: " + pct + "%; transition: width 0.4s ease;";
        progressWrap.appendChild(progressBar);
        widget.appendChild(progressWrap);
      }
      if (qty > 0) {
        var section = document.createElement("div");
        section.style.cssText = "margin-bottom: 20px;";
        var sectionLabel = document.createElement("div");
        sectionLabel.textContent = "WHAT EACH PLAYER GETS";
        sectionLabel.style.cssText = "font-size: 11px; font-weight: 700; letter-spacing: 1.5px; color: #888; margin-bottom: 12px; padding-bottom: 8px; border-bottom: 1px solid #eee;";
        section.appendChild(sectionLabel);
        var itemRow = document.createElement("div");
        itemRow.style.cssText = "display: flex; justify-content: space-between; align-items: center; padding: 10px 0; border-bottom: 1px solid #f0f0f0;";
        var itemLeft = document.createElement("div");
        itemLeft.style.cssText = "display: flex; align-items: center; gap: 10px;";
        itemLeft.innerHTML = '<span style="font-size: 20px;">🎒</span><span style="font-weight: 600; color: #333;">' + data.productName + (data.designName ? " – " + data.designName : "") + "</span>";
        var itemRight = document.createElement("div");
        itemRight.style.cssText = "font-weight: 600; color: #333;";
        itemRight.textContent = formatCurrency(unitPrice) + " each";
        itemRow.appendChild(itemLeft);
        itemRow.appendChild(itemRight);
        section.appendChild(itemRow);
        if (data.logoCount > 0 && data.addons.length > 0) {
          data.addons.forEach(function(addon) {
            var addonRow = document.createElement("div");
            addonRow.style.cssText = "display: flex; justify-content: space-between; align-items: center; padding: 10px 0; border-bottom: 1px solid #f0f0f0;";
            var addonLeft = document.createElement("div");
            addonLeft.style.cssText = "display: flex; align-items: center; gap: 10px;";
            addonLeft.innerHTML = '<span style="font-size: 20px;">🎨</span><span style="font-weight: 500; color: #555;">Custom Logo</span>';
            var addonRight = document.createElement("div");
            addonRight.style.cssText = "font-weight: 500; color: #555;";
            addonRight.textContent = "+" + formatCurrency(addon.unitCharge) + " each";
            addonRow.appendChild(addonLeft);
            addonRow.appendChild(addonRight);
            section.appendChild(addonRow);
          });
        }
        widget.appendChild(section);
        var totalRow = document.createElement("div");
        totalRow.style.cssText = [
          "display: flex",
          "justify-content: space-between",
          "align-items: baseline",
          "padding: 16px 0",
          "border-top: 2px solid #1a1a1a",
          "margin-bottom: 20px"
        ].join(";");
        var totalLeft = document.createElement("div");
        totalLeft.innerHTML = '<span style="font-size: 16px; font-weight: 700; color: #1a1a1a;">Team Total</span> <span style="font-size: 13px; color: #888;">(' + qty + " players)</span>";
        var totalRight = document.createElement("div");
        totalRight.style.cssText = "font-size: 22px; font-weight: 800; color: #1a1a1a;";
        totalRight.textContent = formatCurrency(teamTotal);
        totalRow.appendChild(totalLeft);
        totalRow.appendChild(totalRight);
        widget.appendChild(totalRow);
        var cartBtn = document.createElement("button");
        cartBtn.textContent = "ADD TO CART";
        cartBtn.type = "button";
        cartBtn.style.cssText = [
          "width: 100%",
          "padding: 16px",
          "background: #5E2394",
          "color: #fff",
          "border: none",
          "border-radius: 12px",
          "font-size: 16px",
          "font-weight: 700",
          "letter-spacing: 1.5px",
          "cursor: pointer",
          "transition: transform 0.15s, box-shadow 0.2s",
          "box-shadow: 0 4px 16px rgba(94,35,148,0.35)"
        ].join(";");
        cartBtn.addEventListener("mouseenter", function() {
          cartBtn.style.transform = "translateY(-2px)";
          cartBtn.style.boxShadow = "0 6px 24px rgba(94,35,148,0.5)";
        });
        cartBtn.addEventListener("mouseleave", function() {
          cartBtn.style.transform = "none";
          cartBtn.style.boxShadow = "0 4px 16px rgba(94,35,148,0.35)";
        });
        cartBtn.addEventListener("click", function() {
          try {
            var editPanel = document.querySelector(".kb-customise-edit-panel");
            var scope = angular.element(editPanel).scope();
            var s = scope;
            while (s && !s.addToCart) {
              s = s.$parent;
            }
            if (s && s.addToCart) {
              s.$apply(function() {
                s.addToCart();
              });
            }
          } catch (err) {
            var nativeBtn = document.querySelector(".kb-button-single-item-checkout-add-to-cart");
            if (nativeBtn) nativeBtn.click();
          }
        });
        widget.appendChild(cartBtn);
        var tiersToggle = document.createElement("div");
        tiersToggle.style.cssText = "text-align: center; margin-top: 16px;";
        var tiersLink = document.createElement("button");
        tiersLink.type = "button";
        tiersLink.textContent = "View volume pricing tiers ▼";
        tiersLink.style.cssText = "background: #5E2394; border: none; color: #fff; font-size: 13px; font-weight: 600; cursor: pointer; padding: 8px 14px; border-radius: 999px;";
        var tiersPanel = document.createElement("div");
        tiersPanel.style.cssText = "display: none; margin-top: 12px; background: #FAFAFA; border-radius: 10px; padding: 16px; border: 1px solid #eee;";
        var sortedTiers = data.tiers.slice().sort(function(a, b) {
          return a.minimumQuantity - b.minimumQuantity;
        });
        sortedTiers.forEach(function(t) {
          var tRow = document.createElement("div");
          tRow.style.cssText = "display: flex; justify-content: space-between; padding: 6px 0; font-size: 14px;";
          var isActive = t.minimumQuantity === tier.minimumQuantity;
          var tLeft = document.createElement("span");
          tLeft.textContent = getTierLabel(data.tiers, t) + " units";
          tLeft.style.cssText = "color: " + (isActive ? "#6B3FA0" : "#666") + "; font-weight: " + (isActive ? "700" : "400") + ";";
          var tRight = document.createElement("span");
          tRight.textContent = formatCurrency(t.unitPrice) + "/each";
          tRight.style.cssText = "font-weight: 600; color: " + (isActive ? "#6B3FA0" : "#333") + ";";
          if (isActive) {
            tLeft.textContent += " ← you";
          }
          tRow.appendChild(tLeft);
          tRow.appendChild(tRight);
          tiersPanel.appendChild(tRow);
        });
        var tiersVisible = false;
        tiersLink.addEventListener("click", function() {
          tiersVisible = !tiersVisible;
          tiersPanel.style.display = tiersVisible ? "block" : "none";
          tiersLink.textContent = tiersVisible ? "Hide volume pricing tiers ▲" : "View volume pricing tiers ▼";
        });
        tiersToggle.appendChild(tiersLink);
        widget.appendChild(tiersToggle);
        widget.appendChild(tiersPanel);
      }
      var orderGroup = document.querySelector(".kb-group-order");
      if (orderGroup) {
        orderGroup.appendChild(widget);
      }
    }
    var watchId = setInterval(function() {
      attempts++;
      if (attempts > POLL_LIMIT * 1e3 / CHECK_INTERVAL) {
        clearInterval(watchId);
        watchId = setInterval(updateWidget, 2e3);
        return;
      }
      updateWidget();
    }, CHECK_INTERVAL);
    function updateWidget() {
      var data = getKBData();
      if (!data) {
        var existing = document.getElementById(WIDGET_ID);
        if (existing) {
          existing.remove();
          lastRenderedHash = "";
        }
        return;
      }
      if (data.productSlug === "orbit-backpack" || data.productSlug === "black-dual-strap-backpack" || data.productSlug === "elemental-jacket-grey1" || data.productSlug === "elemental-joggers-grey" || data.productSlug === "elemental-jacket" || data.productSlug === "elemental-joggers-black" || /114890045|114891065|210147750|211485079|117611677|117991635/.test(window.location.hash || "")) {
        var orbitExisting = document.getElementById(WIDGET_ID);
        if (orbitExisting) {
          orbitExisting.remove();
          lastRenderedHash = "";
        }
        var orbitHideStyle = document.getElementById("xeist-cpp-style");
        if (orbitHideStyle) orbitHideStyle.remove();
        return;
      }
      if (!data.isOrderStep) {
        var existing = document.getElementById(WIDGET_ID);
        if (existing) {
          existing.remove();
          lastRenderedHash = "";
        }
        var hideStyle = document.getElementById("xeist-cpp-style");
        if (hideStyle) hideStyle.remove();
        return;
      }
      renderWidget(data);
    }
    var digestWatch = setInterval(function() {
      var data = getKBData();
      if (data && data.isOrderStep && data.productSlug !== "orbit-backpack" && data.productSlug !== "black-dual-strap-backpack" && data.productSlug !== "elemental-jacket-grey1" && data.productSlug !== "elemental-joggers-grey" && data.productSlug !== "elemental-jacket" && data.productSlug !== "elemental-joggers-black" && !/114890045|114891065|210147750|211485079|117611677|117991635/.test(window.location.hash || "")) {
        renderWidget(data);
      }
    }, 1500);
  })();

  // src/health/27-beacon.js
  (function() {
    var CFG = window.XeistConfig || {};
    var API = String(CFG.sessionApi || "").replace(/\/+$/, "");
    var HOOK = API ? API + "/beacon" : null;
    if (!HOOK) return;
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    var qs = String(window.location.search || "");
    if (qs.indexOf("xeistbeacon=0") > -1) return;
    var FORCE = qs.indexOf("xeistbeacon=test") > -1;
    var core = window.XeistCore;
    if (!core) return;
    function checks() {
      var canvas = document.querySelector(".kb-preview-panel canvas");
      var c = {
        angular: !!window.angular,
        injector: !!core.getInjector(),
        editorService: !!core.getES(),
        canvas: !!(canvas && canvas.width > 0)
      };
      if (window.__xeistCoachOn && window.__xeistCoachOn()) {
        c.bridge = !!(window.XeistKBBridge && typeof window.XeistKBBridge.hasLogo === "function");
        c.coachConfig = !!window.XeistOrbitCoachConfig;
        c.orderPanel = !!document.querySelector("[data-xeist-coach-order-panel]");
        c.logoOverlay = !!document.getElementById("xeist-add-logo-overlay");
      }
      return c;
    }
    function failing(c) {
      var f = [];
      for (var k in c) {
        if (!c[k]) f.push(k);
      }
      return f;
    }
    function ctx() {
      var design = (String(window.location.hash).match(/customise\/(\d+)/) || [])[1] || "?";
      var theme = window.Shopify && window.Shopify.theme ? window.Shopify.theme.id + " " + (window.Shopify.theme.role || "") : "?";
      return "design " + design + " | theme " + theme + " | " + String(navigator.userAgent || "").slice(0, 70);
    }
    var COOLDOWN_KEY = "xeist_beacon_last";
    var COOLDOWN_MS = 10 * 60 * 1e3;
    function send(text) {
      var last = parseInt(core.store.get(COOLDOWN_KEY) || "0", 10) || 0;
      if (!FORCE && Date.now() - last < COOLDOWN_MS) return;
      core.store.set(COOLDOWN_KEY, String(Date.now()));
      var body = JSON.stringify({ text });
      try {
        if (navigator.sendBeacon) {
          navigator.sendBeacon(HOOK, body);
          return;
        }
      } catch (e) {
      }
      try {
        fetch(HOOK, { method: "POST", mode: "no-cors", headers: { "Content-Type": "text/plain" }, body });
      } catch (e) {
      }
    }
    var TICK_MS = 2e3;
    var LIMIT = 30;
    var ticks = 0;
    var task = core.every("health-beacon", TICK_MS, function() {
      ticks++;
      var f = failing(checks());
      if (!f.length) {
        task.stop();
        if (FORCE) send(":white_check_mark: customizer beacon test — all checks green | " + ctx());
        return;
      }
      if (ticks >= LIMIT) {
        task.stop();
        send(":rotating_light: customizer health FAILED [" + f.join(", ") + "] | " + ctx());
      }
    });
  })();

  // src/session/28-session-state.js
  (function() {
    var CFG = window.XeistConfig || {};
    var API = CFG.sessionApi;
    if (!API) return;
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    var core = window.XeistCore;
    if (!core) return;
    API = String(API).replace(/\/+$/, "");
    var EXACT_KEYS = [
      "xeist_carry_sizes",
      "xeist_carry_logo",
      "xeist_deposit_pref",
      "xeist_apply_deposit_at_cart",
      "xeist_set_added"
    ];
    var PREFIX_KEYS = ["xeist_ts_", "xeist_match_sizes_"];
    function makeToken() {
      try {
        var buf = new Uint8Array(16);
        crypto.getRandomValues(buf);
        var s = "";
        for (var i = 0; i < buf.length; i++) s += (buf[i] + 256).toString(16).slice(1);
        return s;
      } catch (e) {
        return null;
      }
    }
    var token = core.store.get("xeist_session_token");
    if (!token || !/^[a-f0-9]{32,64}$/.test(token)) {
      token = makeToken();
      if (!token) return;
      core.store.set("xeist_session_token", token);
    }
    function allKeys() {
      var keys = EXACT_KEYS.slice();
      try {
        for (var i = 0; i < window.localStorage.length; i++) {
          var k = window.localStorage.key(i);
          for (var p = 0; p < PREFIX_KEYS.length; p++) {
            if (k && k.indexOf(PREFIX_KEYS[p]) === 0 && keys.indexOf(k) === -1) keys.push(k);
          }
        }
      } catch (e) {
      }
      return keys;
    }
    function snapshot() {
      var out = {};
      var keys = allKeys();
      for (var i = 0; i < keys.length; i++) {
        var v = core.store.get(keys[i]);
        if (v != null) out[keys[i]] = v;
      }
      return out;
    }
    function put(blob) {
      try {
        fetch(API + "/session/" + token, {
          method: "PUT",
          mode: "cors",
          headers: { "Content-Type": "text/plain" },
          body: JSON.stringify(blob)
        }).then(function(r) {
          return r.json();
        }).then(function(d) {
          if (d && d.updated) core.store.set("xeist_session_synced", String(d.updated));
          else lastSent = "";
        }).catch(function() {
          lastSent = "";
        });
      } catch (e) {
        lastSent = "";
      }
    }
    var ROLE = "?";
    try {
      ROLE = String(window.Shopify && window.Shopify.theme && window.Shopify.theme.role || "?");
    } catch (e) {
    }
    function track(type, payload) {
      try {
        var body = JSON.stringify({ session: token, type: String(type), role: ROLE, payload: payload || {} });
        if (navigator.sendBeacon) {
          navigator.sendBeacon(API + "/events", body);
          return;
        }
        fetch(API + "/events", { method: "POST", mode: "cors", headers: { "Content-Type": "text/plain" }, body }).catch(function() {
        });
      } catch (e) {
      }
    }
    window.XeistTrack = track;
    try {
      fetch(API + "/session/" + token, { mode: "cors" }).then(function(r) {
        return r.json();
      }).then(function(server) {
        if (!server || !server.updated) return;
        var seen = parseInt(core.store.get("xeist_session_synced") || "0", 10) || 0;
        if (server.updated <= seen) return;
        for (var k in server) {
          if (k === "updated") continue;
          if (Object.prototype.hasOwnProperty.call(server, k)) core.store.set(k, server[k]);
        }
        core.store.set("xeist_session_synced", String(server.updated));
      }).catch(function() {
      });
    } catch (e) {
    }
    var lastSent = "";
    var debounce = null;
    core.every("session-sync", 2e3, function() {
      var snap = snapshot();
      var enc = JSON.stringify(snap);
      if (enc === lastSent || enc === "{}") return;
      lastSent = enc;
      if (debounce) clearTimeout(debounce);
      debounce = setTimeout(function() {
        put(snap);
      }, 1500);
    });
    var design = (String(window.location.hash).match(/customise\/(\d+)/) || [])[1] || null;
    track("load", { design });
    var customized = false;
    try {
      window.addEventListener("xeist:customization-changed", function() {
        if (customized) return;
        customized = true;
        track("customize", { design });
      });
    } catch (e) {
    }
  })();

  // src/session/29-funnel-events.js
  (function() {
    if (!window.XeistTrack || !window.XeistCore) return;
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    var track = window.XeistTrack;
    var core = window.XeistCore;
    var design = (String(window.location.hash).match(/customise\/(\d+)/) || [])[1] || null;
    var mobile = false;
    try {
      mobile = window.innerWidth <= 768;
    } catch (e) {
    }
    function once(type) {
      var fired = false;
      return function(payload) {
        if (fired) return;
        fired = true;
        payload = payload || {};
        payload.design = payload.design || design;
        track(type, payload);
      };
    }
    var bootFired = once("boot");
    var bootTask = core.every("fx-boot", 500, function() {
      var c = document.querySelector(".kb-preview-panel canvas");
      if (c && c.width > 0) {
        bootTask.stop();
        var ms = 0;
        try {
          ms = Math.round(performance.now());
        } catch (e) {
        }
        bootFired({ ms, mobile });
      }
    });
    var logoPlaced = once("logo_placed");
    var alignFailed = once("align_failed");
    core.every("fx-logo", 1e3, function() {
      try {
        var br = window.XeistKBBridge;
        if (br && typeof br.hasLogo === "function" && (br.hasLogo() || {}).hasLogo) logoPlaced();
      } catch (e) {
      }
      if (String(window.__xeistAlignLast || "") === "gave-up") alignFailed();
    });
    var sizesOpened = once("sizes_opened");
    var sizesEntered = once("sizes_entered");
    var addToCart = once("add_to_cart");
    var setClick = once("set_click");
    function visibleQtySum() {
      try {
        var els = document.querySelectorAll("input[type=number],input[inputmode=numeric]");
        var sum = 0, seen = 0;
        for (var i = 0; i < els.length; i++) {
          if (!els[i].offsetParent) continue;
          seen++;
          sum += parseInt(els[i].value, 10) || 0;
        }
        return seen ? sum : null;
      } catch (e) {
        return null;
      }
    }
    try {
      document.addEventListener("click", function(e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (t.closest("#xeist-continue-sizes")) sizesOpened();
        if (t.closest("#xeist-complete-set")) setClick();
        var btn = t.closest('button,[role="button"],a');
        if (btn && /add to cart/i.test(btn.textContent || "")) {
          addToCart({
            deposit: core.store.get("xeist_deposit_pref") === "1",
            qty: visibleQtySum(),
            mobile
          });
        }
      }, true);
      document.addEventListener("change", function(e) {
        var t = e.target;
        if (t && t.tagName === "INPUT" && (t.type === "number" || t.getAttribute("inputmode") === "numeric")) {
          sizesEntered();
        }
      }, true);
    } catch (e) {
    }
    var setAdded = once("set_added");
    core.every("fx-set", 3e3, function() {
      var m = core.store.getJSON("xeist_set_added", null);
      if (!m) return;
      for (var k in m) {
        if (Object.prototype.hasOwnProperty.call(m, k) && Date.now() - m[k] < 10 * 60 * 1e3) {
          setAdded({ paired: k });
          return;
        }
      }
    });
    window.addEventListener("xeist:flow-event", function(e) {
      try {
        var d = e && e.detail || {};
        if (!d || !d.type) return;
        var payload = {};
        for (var k in d) {
          if (k !== "type" && Object.prototype.hasOwnProperty.call(d, k)) payload[k] = d[k];
        }
        payload.design = payload.design || design;
        payload.mobile = mobile;
        track("flow_" + String(d.type).replace(/[^a-z_]/g, "").slice(0, 32), payload);
      } catch (err) {
      }
    });
  })();

  // src/uniform/30-uniform-skin.js
  (function() {
    "use strict";
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    var LAYER_BINDING_PATCHES = {
      // The X jersey: armhole bands (#Seams) join the collar.
      "102815703": { collarandarmholes: { add: ["#Seams"] } },
      // Vice jersey: KB had the PINK side art (#Pattern_1) on Side Design 1
      // (default blue) and the BLUE side art (#Pattern_2) on Side Design 2
      // (default pink) — each side color painted half blue, half pink. Swap
      // them (matches the Vice shorts: Side Design 1 = blue, 2 = pink), and
      // the armhole bands (#Seams) join the collar like The X.
      "105371583": {
        sidedesign1: { add: ["#Pattern_2"], remove: ["#Pattern_1"] },
        sidedesign2: { add: ["#Pattern_1"], remove: ["#Pattern_2", "#Pink"] },
        collarandarmholes: { add: ["#Seams"] }
      },
      // Tiger jersey: collar (#Collar) and armhole bands (#Seams) had NO
      // field (always black) — they follow Stripe 2, like The X's trim
      // follows its side panel.
      "108636723": { stripecolor2: { add: ["#Collar", "#Seams"] } },
      // Tiger shorts: the hem band (#Accent_1_) had no field (always black)
      // — it follows the waistband.
      "108636724": { waistbandcolors: { add: ["#Accent_1_"] } }
    };
    (function installLayerBindingPatch() {
      var XP = window.XMLHttpRequest && XMLHttpRequest.prototype;
      if (!XP || XP.__xuLayerPatch) return;
      var dText = Object.getOwnPropertyDescriptor(XP, "responseText");
      var dResp = Object.getOwnPropertyDescriptor(XP, "response");
      if (!dText || !dText.get || !dResp || !dResp.get) return;
      XP.__xuLayerPatch = true;
      function patchBody(raw, patch) {
        try {
          var j = JSON.parse(raw);
          if (!j || !j.fields || !j.fields.length) return raw;
          var changed = false;
          j.fields.forEach(function(f) {
            var rule = f && patch[f.key];
            if (!rule) return;
            var before = String(f.svgIdsSelector || "");
            if (!before) return;
            var list = before.split(",").map(function(x) {
              return x.trim();
            }).filter(Boolean);
            (rule.remove || []).forEach(function(id) {
              var at = list.indexOf(id);
              if (at !== -1) list.splice(at, 1);
            });
            (rule.add || []).forEach(function(id) {
              if (list.indexOf(id) === -1) list.push(id);
            });
            var after = list.join(", ");
            if (after !== before.split(",").map(function(x) {
              return x.trim();
            }).filter(Boolean).join(", ")) {
              f.svgIdsSelector = after;
              changed = true;
            }
          });
          return changed ? JSON.stringify(j) : raw;
        } catch (e) {
          return raw;
        }
      }
      var origOpen = XP.open;
      XP.open = function(method, url) {
        try {
          var u = String(url || "");
          var m = /\/Api\/customize\?[^#]*designId=(\d+)/i.exec(u);
          var patch = m && LAYER_BINDING_PATCHES[m[1]];
          if (patch) {
            var xhr = this, cache = null;
            var patched = function(native) {
              if (xhr.readyState !== 4 || typeof native !== "string") return native;
              if (cache === null) cache = patchBody(native, patch);
              return cache;
            };
            Object.defineProperty(xhr, "responseText", { configurable: true, get: function() {
              return patched(dText.get.call(xhr));
            } });
            Object.defineProperty(xhr, "response", { configurable: true, get: function() {
              return patched(dResp.get.call(xhr));
            } });
          }
        } catch (e) {
        }
        return origOpen.apply(this, arguments);
      };
    })();
    var UNIFORM_PRODUCTS = {
      "102815476": {
        // XE-Caliber Jerseys (basketball)
        noun: "Basketball Uniform",
        priceFrom: "$49.99",
        // sheet jersey tier 1 (1-10)
        timeline: "Est. 3–4 weeks",
        minQty: 6,
        // production minimum (unchanged)
        discountAt: 11,
        // first sheet discount tier (11-24)
        styleUrl: "/pages/3d-uniform-customizer",
        zones: [
          { key: "primarycolors", label: "Body" },
          { key: "sidedesign1", label: "Side Panel" },
          { key: "sidedesign2", label: "Side Panel Accent" },
          { key: "collarandarmholes", label: "Collar & Armholes" },
          { key: "collarandarmholespiping", label: "Trim & Piping" }
        ],
        hiddenZones: []
      },
      "104006063": {
        // XE-Caliber Shorts (matching-shorts flow, module 33)
        // Step fields from KB admin (2026-07-21): Primary Colors, Stripe
        // Color 1-5, Design Colors, Side Design 1-2, Pattern Colors,
        // Waistband Colors/Stripes, Shorts Piping, Collar & Armholes —
        // ALL Conditional (designs bind a subset; absent rows just don't
        // mount). Keys derived by KB's name normalization (verified on the
        // jersey: 'Side Design - 1' -> sidedesign1); confirm live in the
        // shorts zone audit — selectors are case-sensitive.
        noun: "Basketball Shorts",
        // NO text items on this product (no add-teamname — proven live,
        // the no-nonce commit path). The post-look soft rebuild exists
        // ONLY to render text; zone colors repaint live. Skipping it cuts
        // a full ~10s KB boot from every look apply and from the add-both
        // journey (Justin 2026-07-31: 'loading is very slow').
        noTextItems: true,
        priceFrom: "$33.00",
        // package shorts = uniform - jersey at tier
        // (Justin 2026-08-26): 33/33/32/31/30/27
        timeline: "Est. 3–4 weeks",
        minQty: 6,
        discountAt: 11,
        // first sheet discount tier (2026-08-26)
        styleUrl: "/pages/3d-uniform-customizer",
        zones: [
          { key: "primarycolors", label: "Body" },
          { key: "sidedesign1", label: "Side Panel" },
          { key: "sidedesign2", label: "Side Panel Accent" },
          { key: "stripecolor1", label: "Stripe 1" },
          { key: "stripecolor2", label: "Stripe 2" },
          { key: "stripecolor3", label: "Stripe 3" },
          { key: "stripecolor4", label: "Stripe 4" },
          { key: "stripecolor5", label: "Stripe 5" },
          { key: "designcolors", label: "Design" },
          { key: "patterncolors", label: "Pattern" },
          { key: "waistbandcolors", label: "Waistband" },
          { key: "waistbandstripes", label: "Waistband Stripes" },
          { key: "shortspiping", label: "Piping" },
          { key: "collarandarmholes", label: "Trim" }
        ],
        hiddenZones: [],
        // 2026-09-24, Justin (Tiger shorts): "waistband is stuck on black.
        // Have the waist band be the same colour as the main body colour" —
        // on every shorts design with its own waistband field, the waistband
        // (and, on Tiger, the hem band patched onto it) follows the body.
        joinZones: { waistbandcolors: "primarycolors" }
      },
      "112548745": {
        // Short Sleeve Hooded Shooting Shirt (2026-07-22, Justin:
        // full uniform experience — welcome card, look gallery, roster).
        // Step fields from KB admin: Primary Colors, Stripe Color 1-5,
        // Design Colors, Pattern Colors, Side Design 1-2, Collar &
        // Armholes (+ Piping) — the exact key family LOOK_KEYS already
        // covers. Text step exists (add-teamname on the back), so the
        // welcome name write and the commit nonce both work. Tiers from
        // admin: 6 -> $34.99.
        noun: "Shooting Shirt",
        // Canvas scaled to 0.8 (~20% zoom-out, Justin 2026-07-22 —
        // approved live). KB's fov settingsOverride is NOT consumed on
        // this build; CSS canvas scale is the proven mechanism (the coach
        // garments' module-13 pattern). Enforced every tick below because
        // KB's digests replace the preview DOM and wipe inline styles.
        previewScale: 0.8,
        priceFrom: "$34.99",
        timeline: "Est. 3–4 weeks",
        minQty: 6,
        styleUrl: "/pages/3d-uniform-customizer",
        zones: [
          { key: "primarycolors", label: "Body" },
          { key: "sidedesign1", label: "Side Panel" },
          { key: "sidedesign2", label: "Side Panel Accent" },
          { key: "stripecolor1", label: "Stripe 1" },
          { key: "stripecolor2", label: "Stripe 2" },
          { key: "stripecolor3", label: "Stripe 3" },
          { key: "stripecolor4", label: "Stripe 4" },
          { key: "stripecolor5", label: "Stripe 5" },
          { key: "designcolors", label: "Design" },
          { key: "patterncolors", label: "Pattern" },
          { key: "collarandarmholes", label: "Collar & Armholes" },
          { key: "collarandarmholespiping", label: "Trim & Piping" }
        ],
        hiddenZones: []
      },
      "116801147": {
        // Blitz Jerseys (FOOTBALL) — 2026-09-15, Justin: "use the
        // same skin that was built for the basketball uniforms on the
        // football jersey collection". Live recon on the twin, all 10 Blitz
        // designs (the store's /collections/custom-football-uniforms):
        //   - product-level color fields: Primary Colors, Stripe Color 1-2,
        //     Side Design 3 — ALL conditional, each design binds a subset
        //     (per-design zones in UNIFORM_DESIGNS below; absent rows just
        //     don't mount, exactly like the shorts keys).
        //   - text placements: add-teamname (front, the welcome-card name
        //     write works), add-number (front) + add-number-back, and
        //     add-names — KB's "Last Names Fees" unitCharge $5 rides that
        //     placement, so module 31's names opt-in (default OFF) covers
        //     it via NAME_KEYS. add-logo image placement on the front.
        //   - same 4-step KB wizard (Color/Text/Logos/Order), same 50-color
        //     palette (White/Black/Red/Navy/Royal/Grey/Gold all present).
        //   - KB Simple Price Tiers 6-24 $49.99 / 25-49 $48.99 / 50-99
        //     $47.99 / 100-199 $45.99 / 200+ $44.99 = the Shopify tier
        //     variants on every Blitz product. First break at 25.
        //   - NO pants/shorts twin in KB -> no SHORTS_PAIRS entry (module
        //     33 stays out, the package modal never fires): jersey-only
        //     flow, the proven Race path.
        noun: "Football Jersey",
        // The Canadian sheet's entry tier (2026-09-15 night: coaches pay the
        // $59.99 ladder too — module 35 SHEET_CAD['blitz'] / XeistCadLadder;
        // KB's own 6-24 tier is $49.99 USD, the US price). Fallback copy
        // only: module 31 prefers the live sheet quote.
        priceFrom: "$59.99",
        timeline: "Est. 3–4 weeks",
        // KB admin has product.minimumQuantity = 10 on Blitz Jerseys (it
        // seeds 10 roster rows), NOT 6 like XE-Caliber. Mirrors KB so the
        // roster gate never says "ready" for a team KB's own checkout would
        // refuse. Item-2 pricing (roster minimum 6) is still open: when the
        // KB minimum is changed to 6 in admin, flip this to 6 with it.
        minQty: 10,
        discountAt: 25,
        // first KB/sheet break (25-49)
        // FRAMING (2026-09-15, Justin's phone: "you can't see the jersey,
        // it's too zoomed"). KB parks the camera at its maxDistance (2.0,
        // fov 45) for every product; the Blitz model is 1.45 wide x 1.25
        // tall, so in a portrait canvas (phone: 311x712, aspect 0.44) the
        // visible width is only 0.72 and both sleeves fall outside the
        // RENDER itself (no CSS can bring them back — the pixels were never
        // drawn). XE-Caliber is narrow enough to fit. fitCamera pulls the
        // camera back until the garment's bounding box fits the live
        // aspect (+8% margin), raising KB's maxDistance to make room — see
        // fitCameraToGarment(). Phone: v8.css scales every KB canvas 2x in
        // a 28vh box; with the camera further out the jersey read small, so
        // this product uses 2.6x on phones, centred in the preview band.
        fitCamera: { margin: 1.08 },
        previewScaleMobile: 2.6,
        // "Style" on the rail returns to the collection the coach came
        // from (2026-09-10 direction: design discovery stays on the
        // collection/product page, not inside the builder).
        styleUrl: "/collections/custom-football-uniforms",
        zones: [
          { key: "primarycolors", label: "Body" },
          { key: "stripecolor1", label: "Stripe 1" },
          { key: "stripecolor2", label: "Stripe 2" },
          { key: "sidedesign3", label: "Side Design" }
        ],
        hiddenZones: []
      }
    };
    var UNIFORM_DESIGNS = {
      "102815703": {
        // The X jersey — 2026-09-24, Justin: "the two colours used
        // on the side panel should match the collar and the armholes" (NOT a
        // fixed black). The collar/armhole trim always takes the side panel's
        // colors: the collar band follows Side Design 2, the collar + armhole
        // piping follows Side Design 1 — pinned here so it holds whatever
        // KB's defaultKit says. NOTE: the armhole BANDS are the #Seams layer,
        // which no KB field binds (always black) — they follow too only once
        // KB admin adds #Seams to "Collar & Armholes" (selector "#Collar, #Seams").
        joinZones: { collarandarmholes: "sidedesign2", collarandarmholespiping: "sidedesign1" }
      },
      "282910950": {
        // Forza jersey (2026-09-24). Its five fields were KB
        // "Colour Picker" dropdowns (looks couldn't click them); Justin switched
        // them to Colour Tile Picker in KB admin. KB gives Forza NO default
        // colors except the body, so the 3-color structure is pinned from the
        // artwork. 2026-09-24 Justin: "make sure the collar matches the same
        // colour as the shoulder print" (Collar Accent 2 was taking the auto
        // third color, white), then "it can still have 3 colours. the 3rd
        // colour can be the colour for the xeist logo and the accents on the
        // shorts" (his reference: white body, navy collar + shoulders, red
        // XEIST mark). So: body · collar (both accents) + shoulder print ·
        // third = the XEIST logo.
        joinZones: { shoulderpattern: "sidedesign1", collaraccent2: "sidedesign1" },
        zones: [
          { key: "primarycolors", label: "Body" },
          { key: "sidedesign1", label: "Collar Accent 1" },
          { key: "collaraccent2", label: "Collar Accent 2" },
          { key: "shoulderpattern", label: "Shoulder Pattern" },
          { key: "logocolor", label: "Logo" }
        ]
      },
      "282910203": {
        // Forza SHORTS (2026-09-24). The only design of KB product
        // 108967997 (Stride-Line Shorts) on the skin — the product's other six
        // designs stay on plain KitBuilder. A full design-level config (no
        // UNIFORM_PRODUCTS base). PRICING stays Stride-Line's own (Justin
        // 2026-09-24: "keep the shorts pricing different from the xe caliber,
        // as they are different style shorts") — KB tiers 6+ 39.99 / 25+ 37.99
        // / 50+ 34.99 / 100+ 32.99 / 200+ 29.99, charged as KB's digits like
        // every KB product; these two lines are display copy only.
        // Colors, from the artwork + Justin's reference photo (white body,
        // navy side panel, red chevron + red waistband piping): body = Base +
        // the white piping · second = the navy side panel (matches the
        // jersey's collar/shoulders) · third = the red chevron + red piping
        // (matches the jersey's XEIST logo).
        name: "Forza",
        noun: "Basketball Shorts",
        noTextItems: true,
        priceFrom: "$39.99",
        timeline: "Est. 3–4 weeks",
        minQty: 6,
        discountAt: 25,
        styleUrl: "/pages/3d-uniform-customizer",
        zones: [
          { key: "primarycolors", label: "Body" },
          { key: "sidepattern2", label: "Side Panel" },
          { key: "sidepattern1", label: "Chevron" },
          { key: "piping1", label: "Piping 1" },
          { key: "piping2", label: "Piping 2" }
        ],
        hiddenZones: [],
        joinZones: { piping1: "primarycolors", piping2: "sidepattern1" },
        slotOrder: ["primarycolors", "sidepattern2", "sidepattern1"]
      },
      "105371583": {
        // Vice jersey — same trim rule as The X (2026-09-24): the
        // collar + armhole bands take one side color, the piping the other.
        joinZones: { collarandarmholes: "sidedesign1", collarandarmholespiping: "sidedesign2" }
      },
      "214014981": {
        // Race — rebound 2026-07-14: sidedesign1 -> #red art
        name: "Race",
        zones: [
          { key: "primarycolors", label: "Body" },
          { key: "sidedesign1", label: "Side Panel" },
          { key: "collarandarmholes", label: "Collar & Armholes" },
          { key: "collarandarmholespiping", label: "Trim & Piping" }
        ],
        hiddenZones: ["sidedesign2"]
      }
    };
    (function() {
      var body = { key: "primarycolors", label: "Body" };
      var twoStripes = [body, { key: "stripecolor1", label: "Stripe 1" }, { key: "stripecolor2", label: "Stripe 2" }];
      var oneStripe = [body, { key: "stripecolor2", label: "Stripe" }];
      var bodyOnly = [body];
      var fb = {
        "118422104": ["Montana", twoStripes],
        // KB "Showtime" (blitz-jersey-showtime)
        "118422102": ["Machine", twoStripes],
        // KB "Falcon"   (blitz-uniform-falcon)
        "116799835": ["ZKY", oneStripe],
        // KB "Rams"     (blitz-uniform-rams)
        "118419375": ["Bolts", twoStripes.concat([{ key: "sidedesign3", label: "Side Design" }])],
        // KB "Bolts"
        "118422811": ["Maple", bodyOnly],
        // KB "Rain"     (blitz-jersey-purple-rain)
        "118422810": ["United", bodyOnly],
        // KB "Phins"    (blitz-jersey-phins)
        "118422809": ["Army", bodyOnly],
        // KB "Bucks"    (blitz-jersey-bucs)
        "118419376": ["State", twoStripes],
        // KB "Giant"    (blitz-jersey-giant)
        "118422812": ["Falcon", bodyOnly],
        // KB "Raider"   (blitz-jersey-raider)
        "118422806": ["Airline", oneStripe]
        // KB "Ducks"    (blitz-uniform-ducks)
      };
      Object.keys(fb).forEach(function(id) {
        UNIFORM_DESIGNS[id] = { name: fb[id][0], zones: fb[id][1], hiddenZones: [] };
      });
    })();
    var QUICK_COLORS = [
      { name: "White", hex: "#FFFFFF" },
      { name: "Black", hex: "#000000" },
      { name: "Red", hex: "#D22630" },
      { name: "Navy", hex: "#041E42" },
      { name: "Royal", hex: "#104A9F" },
      { name: "Grey", hex: "#BBBCBC" },
      { name: "Gold", hex: "#FFC845" }
    ];
    var WHITE = "#FFFFFF", BLACK = "#000000";
    var fullPaletteCache = null;
    function fullPalette() {
      if (fullPaletteCache) return fullPaletteCache;
      var row = zoneRow("primarycolors");
      var out = [], seen = {};
      if (row) {
        $all("input.kb-tile-picker-radio", row).forEach(function(i) {
          var li = i.closest ? i.closest("li") : i.parentNode;
          var t = li && li.querySelector(".kb-tile-picker-tile");
          var hex = String(i.value || "").toUpperCase();
          var name = (t && t.title || "").replace(/\s+/g, " ").trim();
          if (!/^#[0-9A-F]{6}$/.test(hex) || seen[hex]) return;
          seen[hex] = 1;
          out.push({ name: name || hex, hex });
        });
      }
      if (out.length > 10) {
        fullPaletteCache = out;
        return out;
      }
      return QUICK_COLORS;
    }
    function hexRGB(hex) {
      return {
        r: parseInt(hex.slice(1, 3), 16),
        g: parseInt(hex.slice(3, 5), 16),
        b: parseInt(hex.slice(5, 7), 16)
      };
    }
    var PAL_GROUPS = ["Whites & Greys", "Blacks", "Reds & Maroons", "Oranges & Browns", "Yellows & Golds", "Greens", "Blues & Navys", "Purples & Pinks"];
    function hueGroup(hex) {
      var c = hexRGB(hex), r = c.r / 255, g = c.g / 255, b = c.b / 255;
      var max = Math.max(r, g, b), min = Math.min(r, g, b);
      var l = (max + min) / 2;
      var d = max - min;
      var sat = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
      if (sat < 0.15 || l > 0.94) return l < 0.16 ? "Blacks" : "Whites & Greys";
      if (l < 0.09) return "Blacks";
      var h;
      if (max === r) h = (g - b) / d % 6;
      else if (max === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h = (h * 60 + 360) % 360;
      if (h < 15 || h >= 335) return "Reds & Maroons";
      if (h < 42) return "Oranges & Browns";
      if (h < 70) return "Yellows & Golds";
      if (h < 170) return "Greens";
      if (h < 262) return "Blues & Navys";
      return "Purples & Pinks";
    }
    function nearestPaletteHex(rgb) {
      var best = null, bestD = Infinity;
      fullPalette().forEach(function(p) {
        var c = hexRGB(p.hex);
        var d = (c.r - rgb.r) * (c.r - rgb.r) + (c.g - rgb.g) * (c.g - rgb.g) + (c.b - rgb.b) * (c.b - rgb.b);
        if (d < bestD) {
          bestD = d;
          best = p.hex;
        }
      });
      return best;
    }
    function sampleLogoColors(file, done) {
      var url;
      try {
        url = URL.createObjectURL(file);
      } catch (e) {
        done(null);
        return;
      }
      var img = new Image();
      img.onload = function() {
        var picks = null;
        try {
          var cv = document.createElement("canvas");
          cv.width = cv.height = 64;
          var x = cv.getContext("2d");
          x.drawImage(img, 0, 0, 64, 64);
          var d = x.getImageData(0, 0, 64, 64).data;
          var buckets = {};
          for (var i = 0; i < d.length; i += 4) {
            if (d[i + 3] < 200) continue;
            var r = d[i], g = d[i + 1], b = d[i + 2];
            if (r > 238 && g > 238 && b > 238) continue;
            var key = (r >> 5) + "," + (g >> 5) + "," + (b >> 5);
            var k = buckets[key] || (buckets[key] = { n: 0, r: 0, g: 0, b: 0 });
            k.n++;
            k.r += r;
            k.g += g;
            k.b += b;
          }
          var top = [];
          for (var bk in buckets) {
            if (buckets.hasOwnProperty(bk)) top.push(buckets[bk]);
          }
          picks = clusterPicks(top);
        } catch (e) {
          picks = null;
        }
        try {
          URL.revokeObjectURL(url);
        } catch (e2) {
        }
        done(picks);
      };
      img.onerror = function() {
        try {
          URL.revokeObjectURL(url);
        } catch (e) {
        }
        done(null);
      };
      img.src = url;
    }
    function clusterPicks(top) {
      top.sort(function(a, b) {
        return b.n - a.n;
      });
      var centers = top.slice(0, 8).map(function(k) {
        return { r: k.r / k.n, g: k.g / k.n, b: k.b / k.n, n: k.n };
      });
      var picks = [];
      centers.forEach(function(c0) {
        if (picks.length >= 3) return;
        var distinct = true;
        for (var i = 0; i < picks.length; i++) {
          var p = picks[i];
          var dd = Math.sqrt((p.r - c0.r) * (p.r - c0.r) + (p.g - c0.g) * (p.g - c0.g) + (p.b - c0.b) * (p.b - c0.b));
          if (dd < 80) {
            distinct = false;
            break;
          }
        }
        if (distinct) picks.push(c0);
      });
      if (!picks.length) return null;
      var hexes = [];
      picks.forEach(function(p) {
        var h = nearestPaletteHex(p);
        if (h && hexes.indexOf(h) === -1) hexes.push(h);
      });
      return hexes.length ? hexes : null;
    }
    var LOOK_KEYS = [
      "primarycolors",
      "sidedesign1",
      "sidedesign2",
      "collarandarmholes",
      "collarandarmholespiping",
      "stripecolor1",
      "stripecolor2",
      "stripecolor3",
      "stripecolor4",
      "stripecolor5",
      "designcolors",
      "patterncolors",
      "waistbandcolors",
      "waistbandstripes",
      "shortspiping",
      "sidedesign3"
    ];
    var LOOK_KEY_ALIASES = {
      stripecolor1: "sidedesign1",
      stripecolor2: "sidedesign1",
      stripecolor3: "sidedesign1",
      stripecolor4: "sidedesign1",
      stripecolor5: "sidedesign1",
      designcolors: "sidedesign2",
      patterncolors: "sidedesign2",
      waistbandcolors: "primarycolors",
      waistbandstripes: "sidedesign1",
      shortspiping: "collarandarmholespiping",
      sidedesign3: "sidedesign2"
      // football Bolts: the second accent slot
    };
    function visibleZones() {
      var base = configZones();
      var sl = null;
      try {
        sl = designSlots();
      } catch (e) {
        sl = null;
      }
      if (!sl) return base;
      var have = base.map(function(z) {
        return z.key;
      });
      var names = {};
      try {
        var fs = getInjector().get("CustomizeService").fields || [];
        (Array.isArray(fs) ? fs : Object.keys(fs).map(function(k) {
          return fs[k];
        })).forEach(function(f) {
          if (f && f.key) names[f.key] = String(f.name || f.key).replace(/\s*-\s*/g, " ");
        });
      } catch (e2) {
      }
      var extra = [];
      sl.forEach(function(g) {
        g.keys.forEach(function(k) {
          if (have.indexOf(k) === -1) {
            have.push(k);
            extra.push({ key: k, label: names[k] || k });
          }
        });
      });
      return extra.length ? base.concat(extra) : base;
    }
    function configZones() {
      return design && design.zones || [
        { key: "primarycolors", label: "Body" },
        { key: "sidedesign1", label: "Side Panel" },
        { key: "sidedesign2", label: "Side Panel Accent" },
        { key: "collarandarmholes", label: "Collar & Armholes" },
        { key: "collarandarmholespiping", label: "Piping" }
      ];
    }
    var STEPS = [
      { id: "style", label: "Style", kb: null },
      { id: "look", label: "Look", kb: 0 },
      { id: "logo", label: "Logo", kb: 2 },
      { id: "roster", label: "Roster", kb: 3 },
      { id: "review", label: "Review", kb: 3 }
    ];
    var ACCENT = "#6D28D9";
    function designIdFromHash() {
      var m = window.location.hash.match(/\/customise\/(\d+)/i);
      return m ? m[1] : null;
    }
    var designId = designIdFromHash();
    if (!designId) return;
    var design = null;
    function productIdFromDom() {
      var page = document.querySelector(".kb-customise-page");
      var m = page && String(page.className).match(/kb-product-id-(\d+)/);
      return m ? m[1] : null;
    }
    function harvestDesignName() {
      try {
        var lp = document.querySelector(".kb-line-price-cell");
        var row = lp && lp.parentElement ? lp.parentElement.innerText || "" : "";
        var m = row.replace(/\s+/g, " ").match(/-\s*([A-Za-z0-9'&. ]{2,24}?)\s*Quantity/i);
        return m ? m[1].trim() : "";
      } catch (e) {
        return "";
      }
    }
    function resolveDesign() {
      if (design) return design;
      var pid = productIdFromDom();
      var base = pid && UNIFORM_PRODUCTS[pid];
      var override = UNIFORM_DESIGNS[designId];
      if (!base && !override) return null;
      design = {};
      var src = base || {};
      Object.keys(src).forEach(function(k) {
        design[k] = src[k];
      });
      if (override) Object.keys(override).forEach(function(k) {
        design[k] = override[k];
      });
      if (!design.name) design.name = harvestDesignName();
      if (!design.noun) design.noun = "Basketball Uniform";
      return design;
    }
    function $(s, r) {
      return (r || document).querySelector(s);
    }
    function $all(s, r) {
      return Array.prototype.slice.call((r || document).querySelectorAll(s));
    }
    function el(tag, cls, html) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (html != null) e.innerHTML = html;
      return e;
    }
    function esc(s) {
      return String(s == null ? "" : s).replace(/[&<>"']/g, function(c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }
    function store(k, v) {
      try {
        var writing = arguments.length === 2;
        var str = writing ? JSON.stringify(v) : null;
        var raw;
        if (window.XeistCore && XeistCore.store) {
          if (writing) {
            XeistCore.store.set(k, str);
            return v;
          }
          raw = XeistCore.store.get(k);
        } else {
          if (writing) {
            localStorage.setItem(k, str);
            return v;
          }
          raw = localStorage.getItem(k);
        }
        if (!raw || raw === "[object Object]") return null;
        return JSON.parse(raw);
      } catch (e) {
        return arguments.length === 2 ? v : null;
      }
    }
    function kbInjectorOk(inj) {
      try {
        return !!(inj && inj.has && inj.has("KitService"));
      } catch (e) {
        return false;
      }
    }
    function getInjector() {
      try {
        if (window.XeistCore && XeistCore.getInjector) {
          var i = XeistCore.getInjector();
          if (kbInjectorOk(i)) return i;
        }
        if (!window.angular) return null;
        var h = $(".kb-customise-page") || $("#kb-app");
        var hi = h ? angular.element(h).injector() : null;
        if (kbInjectorOk(hi)) return hi;
        var bi = angular.element(document.body).injector();
        if (kbInjectorOk(bi)) return bi;
      } catch (e) {
      }
      return null;
    }
    function apply(fn) {
      var inj = getInjector();
      if (!inj) return false;
      try {
        inj.get("$rootScope").$apply(fn);
        return true;
      } catch (e) {
        return false;
      }
    }
    function withStepService(fn) {
      var inj = getInjector();
      if (!inj) return false;
      try {
        var ss = inj.get("StepService");
        var rs = inj.get("$rootScope");
        rs.$apply(function() {
          fn(ss);
        });
        return true;
      } catch (e) {
        return false;
      }
    }
    function track(type, payload) {
      try {
        if (window.XeistTrack) window.XeistTrack(type, payload || {});
      } catch (e) {
      }
    }
    function trace(ev, extra) {
      try {
        var log = JSON.parse(sessionStorage.getItem("xu_trace") || "[]");
        log.push({ t: Date.now() % 1e6, ev, x: extra || null });
        sessionStorage.setItem("xu_trace", JSON.stringify(log.slice(-40)));
      } catch (e) {
      }
    }
    function zoneRow(key) {
      return $(".kb-field-" + key);
    }
    function applyZone(key, hex) {
      var row = zoneRow(key);
      if (!row || !hex) return false;
      var inputs = $all("input.kb-tile-picker-radio", row);
      for (var i = 0; i < inputs.length; i++) {
        if (String(inputs[i].value).toLowerCase() === String(hex).toLowerCase()) {
          var li = inputs[i].closest ? inputs[i].closest("li") : inputs[i].parentNode;
          var label = li && li.querySelector("label");
          if (label) {
            label.click();
            noteRecent(hex);
            return true;
          }
        }
      }
      return false;
    }
    var recent = [];
    function noteRecent(hex) {
      hex = String(hex).toUpperCase();
      recent = [hex].concat(recent.filter(function(h) {
        return h !== hex;
      })).slice(0, 3);
      renderRecents();
    }
    function writeTeamName(name) {
      if (!name) return false;
      var inj = getInjector();
      if (!inj) {
        trace("name:no-injector");
        return false;
      }
      try {
        var kv = inj.get("KitService").getKitValues() || {};
        var item = (kv.editor || []).filter(function(it) {
          return it && it.type === "text" && it.placementKey === "add-teamname";
        })[0];
        if (!item) {
          trace("name:no-item", { edLen: (kv.editor || []).length });
          return false;
        }
        inj.get("$rootScope").$apply(function() {
          item.text = String(name).toUpperCase();
        });
        trace("name:written", { v: String(name).toUpperCase() });
        return true;
      } catch (e) {
        trace("name:threw", { e: String(e).slice(0, 60) });
        return false;
      }
    }
    var currentVirtual = "look";
    function kbActiveKey() {
      var a = $(".kb-wizard-breadcrumb-active");
      var m = a && a.className.match(/breadcrumb-(color|text|logos|order)/);
      return m ? m[1] : null;
    }
    function gotoVirtual(id) {
      var step = null;
      for (var i = 0; i < STEPS.length; i++) if (STEPS[i].id === id) step = STEPS[i];
      if (!step) return;
      if (step.id === "style") {
        if (window.confirm("Choose a different uniform style? Your current design stays saved in your basket.")) {
          window.location.href = design.styleUrl;
        }
        return;
      }
      currentVirtual = step.id;
      withStepService(function(ss) {
        ss.setStepIndex(step.kb);
      });
      if (step.id === "review") {
        setTimeout(function() {
          if (window.XeistUniformReview && window.XeistUniformReview.open) {
            window.XeistUniformReview.open();
            return;
          }
          var buy = $(".kb-button-single-item-checkout-buy-now") || $(".kb-field-teamdetails");
          if (buy && buy.scrollIntoView) buy.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 400);
      }
      track("uniform_step", { step: step.id, design: designId });
      syncRail();
    }
    var STEP_KEY = "xu_step_" + designId;
    var stepRemembered = "";
    function rememberStep(id) {
      if (!id || id === stepRemembered) return;
      stepRemembered = id;
      try {
        sessionStorage.setItem(STEP_KEY, JSON.stringify({ id, ts: Date.now() }));
      } catch (e) {
      }
    }
    function navType() {
      try {
        var e = performance.getEntriesByType("navigation")[0];
        return e ? String(e.type) : "";
      } catch (e2) {
        return "";
      }
    }
    function restoreStepAfterReboot() {
      var nt = navType();
      if (nt !== "reload" && nt !== "back_forward") return;
      var saved = null;
      try {
        saved = JSON.parse(sessionStorage.getItem(STEP_KEY) || "null");
      } catch (e) {
      }
      if (!saved || !saved.id || Date.now() - (saved.ts || 0) > 10 * 60 * 1e3) return;
      var target = saved.id === "review" ? "roster" : saved.id;
      if (target !== "logo" && target !== "roster") return;
      try {
        var c = JSON.parse(localStorage.getItem("xeist_shorts_carry") || "null");
        if (c && String(c.toDesign) === String(designId)) return;
      } catch (e3) {
      }
      trace("skin:step-restored", { step: target, nav: nt });
      var tries = 0;
      (function go() {
        var btn = $('#xu-steps .xu-step[data-step="' + target + '"]');
        if (btn) {
          gotoVirtual(target);
          return;
        }
        if (++tries < 20) setTimeout(go, 500);
      })();
    }
    function syncRail() {
      var kb = kbActiveKey();
      var kbToVirtual = { color: "look", text: "look", logos: "logo", order: "roster" };
      if (kb && kbToVirtual[kb]) {
        var mapped = kbToVirtual[kb];
        if (!(mapped === "roster" && currentVirtual === "review")) currentVirtual = mapped;
      }
      $all(".xu-step").forEach(function(b) {
        b.classList.toggle("xu-step-active", b.getAttribute("data-step") === currentVirtual);
      });
      rememberStep(currentVirtual);
      var idx = STEPS.map(function(s) {
        return s.id;
      }).indexOf(currentVirtual);
      var btn = $("#xu-continue");
      if (btn) btn.textContent = idx >= 0 && idx < STEPS.length - 1 ? "Continue to " + STEPS[idx + 1].label : "Review & Checkout";
    }
    function buildRail() {
      if ($("#xu-steps")) return;
      var host = $(".kb-wizard-breadcrumbs");
      if (!host || !host.parentNode) return;
      var rail = el("nav", "", "");
      rail.id = "xu-steps";
      rail.setAttribute("aria-label", "Build your uniform");
      STEPS.forEach(function(s, i) {
        var b = el("button", "xu-step", '<span class="xu-step-n">' + (i + 1) + "</span>" + s.label);
        b.type = "button";
        b.setAttribute("data-step", s.id);
        b.addEventListener("click", function() {
          gotoVirtual(s.id);
        });
        rail.appendChild(b);
      });
      host.parentNode.insertBefore(rail, host);
      syncRail();
    }
    var SETUP_KEY = "xeist_uniform_setup_" + designId;
    var LAST_TEAM_KEY = "xeist_uniform_team_last";
    var team = store(SETUP_KEY) || store(LAST_TEAM_KEY) || { name: "", c1: null, c2: null };
    function chipRow(slot, onPick) {
      var row = el("div", "xu-chips", "");
      QUICK_COLORS.forEach(function(c) {
        var chip = el("button", "xu-chip", "");
        chip.type = "button";
        chip.title = c.name;
        chip.setAttribute("aria-label", slot + ": " + c.name);
        chip.setAttribute("data-hex", c.hex);
        chip.style.background = c.hex;
        var lastDown = 0;
        function pick(e) {
          lastDown = Date.now();
          onPick(c.hex);
        }
        if (window.PointerEvent) {
          chip.addEventListener("pointerdown", pick);
          chip.addEventListener("click", function() {
            if (Date.now() - lastDown > 500) onPick(c.hex);
          });
        } else {
          chip.addEventListener("click", pick);
        }
        row.appendChild(chip);
      });
      return row;
    }
    function palettePanel(slot, onPick) {
      var wrap = el("div", "xu-pal", "");
      var search = el("input", "xu-pal-search", "");
      search.type = "search";
      search.placeholder = "Search colors — try “maroon”";
      search.setAttribute("aria-label", "Search " + slot.toLowerCase() + "s by name");
      wrap.appendChild(search);
      var groupsHost = el("div", "xu-pal-groups", "");
      wrap.appendChild(groupsHost);
      var empty = el("p", "xu-pal-empty", "No color by that name — try “red” or “gold”.");
      empty.hidden = true;
      wrap.appendChild(empty);
      function build() {
        groupsHost.innerHTML = "";
        var byGroup = {};
        fullPalette().forEach(function(c) {
          var g = hueGroup(c.hex);
          (byGroup[g] = byGroup[g] || []).push(c);
        });
        PAL_GROUPS.forEach(function(g) {
          var list = byGroup[g];
          if (!list || !list.length) return;
          var gEl = el("div", "xu-pal-group", "");
          var lab = el("span", "xu-slot-label", "");
          lab.textContent = g;
          gEl.appendChild(lab);
          var grid = el("div", "xu-pal-grid", "");
          list.forEach(function(c) {
            var cell = el("span", "xu-pal-cell", "");
            var chip = el("button", "xu-chip xu-pal-chip", "");
            chip.type = "button";
            chip.title = c.name;
            chip.setAttribute("aria-label", slot + ": " + c.name);
            chip.setAttribute("data-hex", c.hex);
            chip.setAttribute("data-name", c.name.toLowerCase());
            chip.style.background = c.hex;
            chip.addEventListener("click", function() {
              onPick(c.hex);
            });
            var nm = el("span", "xu-pal-name", "");
            nm.textContent = c.name;
            cell.appendChild(chip);
            cell.appendChild(nm);
            grid.appendChild(cell);
          });
          gEl.appendChild(grid);
          groupsHost.appendChild(gEl);
        });
      }
      build();
      wrap.__rebuild = build;
      search.addEventListener("input", function() {
        var q = search.value.toLowerCase().replace(/\s+/g, " ").trim();
        var any = false;
        $all(".xu-pal-group", groupsHost).forEach(function(gEl) {
          var vis = 0;
          $all(".xu-pal-cell", gEl).forEach(function(cell) {
            var chip = cell.querySelector(".xu-pal-chip");
            var hit = !q || (chip.getAttribute("data-name") || "").indexOf(q) !== -1;
            cell.hidden = !hit;
            if (hit) vis++;
          });
          gEl.hidden = vis === 0;
          if (vis) any = true;
        });
        empty.hidden = any;
      });
      return wrap;
    }
    function syncWelcomeRings(card) {
      [["#xu-w-c1", team.c1], ["#xu-w-c2", team.c2], ["#xu-w-c3", team.c3]].forEach(function(pair) {
        var box = $(pair[0], card);
        if (!box) return;
        $all(".xu-chip", box).forEach(function(ch) {
          var hx = ch.getAttribute("data-hex") || "";
          var on = pair[1] && hx.toLowerCase() === String(pair[1]).toLowerCase();
          ch.classList.toggle("xu-chip-on", !!on);
          ch.setAttribute("aria-pressed", on ? "true" : "false");
        });
      });
    }
    function bindDialog(card, onDismiss, initialFocus) {
      var prevFocus = document.activeElement;
      function onKey(e) {
        if (e.key === "Escape") {
          e.stopPropagation();
          onDismiss();
          return;
        }
        if (e.key !== "Tab") return;
        var f = card.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
      document.addEventListener("keydown", onKey, true);
      card.setAttribute("aria-modal", "true");
      if (initialFocus) setTimeout(function() {
        try {
          initialFocus.focus();
        } catch (e) {
        }
      }, 60);
      return function unbind() {
        document.removeEventListener("keydown", onKey, true);
        try {
          if (prevFocus && prevFocus.focus) prevFocus.focus();
        } catch (e) {
        }
      };
    }
    var unbindWelcome = null;
    function wExpected() {
      try {
        return parseInt(window.localStorage.getItem("xeist_expected_" + designId) || "0", 10) || 0;
      } catch (e) {
        return 0;
      }
    }
    function wSaveExpected(card) {
      var i = $("#xu-w-count", card);
      var n = i ? parseInt(i.value || "0", 10) : 0;
      if (n >= 1 && n <= 500) {
        try {
          window.localStorage.setItem("xeist_expected_" + designId, String(n));
        } catch (e) {
        }
        return n;
      }
      return 0;
    }
    function openWelcome() {
      closeWelcome();
      var scrim = el("div", "", "");
      scrim.id = "xu-w-scrim";
      var card = el("section", "", "");
      card.id = "xu-welcome";
      card.setAttribute("role", "dialog");
      card.setAttribute("aria-label", "Set up your team");
      card.innerHTML = '<h3 class="xu-h">Let’s set up your team</h3><p class="xu-sub">30 seconds — we’ll build your uniform options from this.</p><label class="xu-slot-label" for="xu-w-name">Team name</label><input id="xu-w-name" class="xu-w-input" type="text" maxlength="20" placeholder="e.g. WOLVES" value="' + esc(team.name || "") + '"><label class="xu-slot-label" for="xu-w-count">How many players? <span class="xu-w-opt">(sets your team pricing — you can adjust later)</span></label><input id="xu-w-count" class="xu-w-input" type="number" inputmode="numeric" min="1" max="500" placeholder="e.g. 12" style="width:130px"' + (wExpected() > 0 ? ' value="' + wExpected() + '"' : "") + '><div class="xu-slot-label">Main color</div><div id="xu-w-c1"></div><div class="xu-slot-label">Second color</div><div id="xu-w-c2"></div>' + // Third color (2026-09-24): only when this design's artwork is built
      // from 3+ colors (designSlots) — two-color designs stay two taps.
      (needsThird() ? '<div class="xu-slot-label">Third color</div><div id="xu-w-c3"></div>' : "") + '<p id="xu-w-picked" class="xu-sub" aria-live="polite"></p><div class="xu-slot-label">Team logo <span class="xu-w-opt">(optional)</span></div><div class="xu-w-logo-row"><label class="xu-w-logo-btn">Upload logo<input type="file" id="xu-w-logo" accept="image/*" hidden></label><span id="xu-w-logo-name" class="xu-sub"></span></div><button type="button" id="xu-w-go" class="xu-cta xu-w-go">Show my uniforms</button><button type="button" id="xu-w-skip" class="xu-more-btn">Skip — I’ll build it myself</button>';
      document.body.appendChild(scrim);
      document.body.appendChild(card);
      function colorName(hex) {
        if (!hex) return "";
        var lower = String(hex).toLowerCase();
        var m = QUICK_COLORS.concat(fullPalette()).filter(function(c) {
          return c.hex.toLowerCase() === lower;
        })[0];
        return m ? m.name : "";
      }
      function pickedLine() {
        var p = $("#xu-w-picked");
        if (!p) return;
        var names = [team.c1, team.c2].concat(needsThird() ? [team.c3] : []).map(function(h) {
          return colorName(h) || "—";
        });
        p.textContent = team.c1 || team.c2 ? "Your colors: " + (names.length === 3 ? names[0] + ", " + names[1] + " & " + names[2] : names.join(" & ")) : "";
      }
      function mountSlot(sel, slotLabel, assign) {
        var box = $(sel, card);
        box.appendChild(chipRow(slotLabel, function(h) {
          assign(h);
          pickedLine();
          syncWelcomeRings(card);
        }));
        var tg = el("button", "xu-more-btn xu-pal-toggle", "All colors & search");
        tg.type = "button";
        tg.setAttribute("aria-expanded", "false");
        box.appendChild(tg);
        var panel = null;
        tg.addEventListener("click", function() {
          $all(".xu-pal", card).forEach(function(p) {
            if (!panel || p !== panel) p.hidden = true;
          });
          $all(".xu-pal-toggle", card).forEach(function(t) {
            if (t !== tg) t.setAttribute("aria-expanded", "false");
          });
          if (!panel) {
            panel = palettePanel(slotLabel, function(h) {
              assign(h);
              pickedLine();
              syncWelcomeRings(card);
            });
            box.appendChild(panel);
          } else {
            panel.hidden = !panel.hidden;
            if (!panel.hidden && fullPaletteCache && panel.__stale) {
              panel.__rebuild();
              panel.__stale = false;
            }
          }
          if (!fullPaletteCache) panel.__stale = true;
          tg.setAttribute("aria-expanded", panel.hidden ? "false" : "true");
          if (!panel.hidden) {
            var si = panel.querySelector(".xu-pal-search");
            if (si) try {
              si.focus({ preventScroll: true });
            } catch (e) {
            }
            try {
              panel.scrollIntoView({ block: "nearest", behavior: "smooth" });
            } catch (e2) {
            }
          }
          syncWelcomeRings(card);
        });
      }
      mountSlot("#xu-w-c1", "Main color", function(h) {
        team.c1 = h;
      });
      mountSlot("#xu-w-c2", "Second color", function(h) {
        team.c2 = h;
      });
      if (needsThird()) mountSlot("#xu-w-c3", "Third color", function(h) {
        team.c3 = h;
      });
      pickedLine();
      syncWelcomeRings(card);
      var logoInput = $("#xu-w-logo", card);
      if (logoInput) {
        logoInput.addEventListener("change", function() {
          var f = logoInput.files && logoInput.files[0];
          window.__xuPendingLogo = f || null;
          var lbl = $("#xu-w-logo-name", card);
          if (lbl) lbl.textContent = f ? f.name + " — we’ll place it for you" : "";
          if (f && /^image\//.test(f.type || "")) {
            sampleLogoColors(f, function(hexes) {
              if (!hexes || !hexes.length || !document.body.contains(card)) return;
              team.c1 = hexes[0];
              if (hexes[1]) team.c2 = hexes[1];
              if (hexes[2] && needsThird()) team.c3 = hexes[2];
              pickedLine();
              syncWelcomeRings(card);
              var p = $("#xu-w-picked");
              if (p && p.textContent) p.textContent += " (matched from your logo)";
              track("uniform_logo_colors", { design: designId, n: hexes.length });
            });
          }
        });
      }
      $("#xu-w-go", card).addEventListener("click", function() {
        var wCnt = wSaveExpected(card);
        team.name = ($("#xu-w-name").value || "").trim();
        if (!team.c1) team.c1 = BLACK;
        if (!team.c2) team.c2 = team.c1 === WHITE ? BLACK : WHITE;
        if (needsThird() && !team.c3) team.c3 = autoThird(team.c1, team.c2);
        team.lastLook = "Home";
        store(SETUP_KEY, team);
        store(LAST_TEAM_KEY, team);
        try {
          sessionStorage.setItem("xu_welcome_dismissed_" + designId, "1");
        } catch (e) {
        }
        closeWelcome();
        track("uniform_setup_done", { design: designId, named: !!team.name, expected: wCnt || 0 });
        var looks = looksFor(team);
        renderLookbook();
        gotoVirtual("look");
        if (!team.name) {
          applyLook(looks[0], { beforePersist: logoPhase });
          return;
        }
        openBuildOverlay("Building your " + String(team.name).toUpperCase() + " uniform…");
        var started = Date.now();
        trace("welcome:submit", { name: team.name });
        (function tryWrite() {
          if (writeTeamName(team.name)) {
            applyLook(looks[0], {
              showOverlay: false,
              // ours is already up
              // Name is re-asserted INSIDE the commit phase, right before
              // the save-nudge — earlier writes get clobbered by the zone
              // digests (2026-07-14: "Edit team" showed TEAM NAME again).
              beforeCommit: function() {
                writeTeamName(team.name);
              },
              beforePersist: logoPhase,
              // uploads+places the card's logo, if any
              onDone: function() {
                setTimeout(function() {
                  var params = window.location.search.replace(/^\?/, "").split("&").filter(function(p) {
                    return p && !/^xeistsetup=/.test(p) && !/^cb=/.test(p);
                  });
                  params.push("cb=" + Math.floor(Math.random() * 1e9));
                  window.location.replace(window.location.pathname + "?" + params.join("&") + window.location.hash);
                }, 500);
              }
            });
            return;
          }
          if (Date.now() - started > 25e3) {
            closeBuildOverlay();
            applyLook(looks[0]);
            return;
          }
          setTimeout(tryWrite, 500);
        })();
      });
      function skip() {
        wSaveExpected(card);
        store(SETUP_KEY, team);
        try {
          sessionStorage.setItem("xu_welcome_dismissed_" + designId, "1");
        } catch (e) {
        }
        closeWelcome();
        track("uniform_setup_skip", { design: designId });
      }
      $("#xu-w-skip", card).addEventListener("click", skip);
      unbindWelcome = bindDialog(card, skip, $("#xu-w-name", card));
    }
    function closeWelcome() {
      if (unbindWelcome) {
        try {
          unbindWelcome();
        } catch (e) {
        }
        unbindWelcome = null;
      }
      ["xu-w-scrim", "xu-welcome"].forEach(function(id) {
        var n = document.getElementById(id);
        if (n && n.parentNode) n.parentNode.removeChild(n);
      });
    }
    function openBuildOverlay(title, sub) {
      closeBuildOverlay();
      var o = el("div", "", '<div class="xu-build-inner"><div class="xu-build-spin" aria-hidden="true"></div><h3>' + esc(title) + "</h3><p>" + esc(sub || "Putting your name and colors on the 3D model.") + "</p></div>");
      o.id = "xu-build-overlay";
      o.setAttribute("role", "status");
      o.setAttribute("aria-live", "polite");
      document.body.appendChild(o);
    }
    function closeBuildOverlay() {
      var n = document.getElementById("xu-build-overlay");
      if (n && n.parentNode) n.parentNode.removeChild(n);
    }
    function setBuildOverlaySub(text) {
      var p = document.querySelector("#xu-build-overlay .xu-build-inner p");
      if (p) p.textContent = text;
    }
    function logoUploadInput() {
      var headers = $all(".kb-wizard-group-header").filter(function(h) {
        return /upload your logo/i.test(h.textContent || "");
      });
      for (var i = 0; i < headers.length; i++) {
        var wrap = headers[i].closest && headers[i].closest(".kb-form-field-wrapper");
        var inp = wrap && wrap.querySelector("input[type=file]");
        if (inp) return inp;
      }
      return $all(".kb-field-editor input[type=file]")[0] || null;
    }
    function logoPhase(done) {
      var file = window.__xuPendingLogo;
      if (!file) {
        done();
        return;
      }
      var inp = logoUploadInput();
      if (!inp || !window.DataTransfer) {
        trace("logo:no-input");
        done();
        return;
      }
      setBuildOverlaySub("Uploading your logo…");
      var before = $all(".kb-editor-add-image-link").length;
      try {
        var dt = new DataTransfer();
        dt.items.add(file);
        inp.files = dt.files;
        inp.dispatchEvent(new Event("change", { bubbles: true }));
        trace("logo:fed", { name: String(file.name).slice(0, 30), size: file.size });
      } catch (e) {
        trace("logo:feed-threw", { e: String(e).slice(0, 60) });
        done();
        return;
      }
      var waited = 0;
      (function waitGallery() {
        var links = $all(".kb-editor-add-image-link");
        if (links.length > before) {
          setBuildOverlaySub("Placing your logo…");
          try {
            links[links.length - 1].click();
            trace("logo:placed");
          } catch (e) {
            trace("logo:place-threw");
          }
          setTimeout(done, 2500);
          return;
        }
        waited += 700;
        if (waited > 25e3) {
          trace("logo:upload-timeout");
          done();
          return;
        }
        setTimeout(waitGallery, 700);
      })();
    }
    function lum(hex) {
      var h = String(hex).replace("#", "");
      var f = function(i) {
        var c = parseInt(h.substr(i, 2), 16) / 255;
        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
      };
      return 0.2126 * f(0) + 0.7152 * f(2) + 0.0722 * f(4);
    }
    function contrast(a, b) {
      var la = lum(a), lb = lum(b);
      var hi = Math.max(la, lb), lo = Math.min(la, lb);
      return (hi + 0.05) / (lo + 0.05);
    }
    function textColorFor(bodyHex, c1, c2) {
      var teamPick = [c2, c1].filter(function(c) {
        return c && c.toLowerCase() !== String(bodyHex).toLowerCase() && contrast(bodyHex, c) >= 2.5;
      })[0];
      if (teamPick) return teamPick;
      return contrast(bodyHex, WHITE) >= contrast(bodyHex, BLACK) ? WHITE : BLACK;
    }
    var SLOT_PRIORITY = [
      "primarycolors",
      "sidedesign1",
      "stripecolor1",
      "designcolors",
      "sidedesign2",
      "stripecolor2",
      "sidedesign3",
      "color3",
      "shoulderpattern",
      "sidepattern1",
      "sidepattern2",
      "stripecolor3",
      "stripecolor4",
      "stripecolor5",
      "patterncolors",
      "collarandarmholes",
      "collaraccent2",
      "collarandarmholespiping",
      "shortspiping",
      "piping1",
      "piping2",
      "waistbandcolors",
      "waistbandstripes",
      "logocolor"
    ];
    var GREY = "#BBBCBC";
    var PATTERN_KEY = /^(sidedesign|stripecolor|designcolors|patterncolors|color\d|sidepattern|shoulderpattern)/;
    var slotsCache = null, slotsCacheId = null;
    function designSlots() {
      if (slotsCache && slotsCacheId === designId) return slotsCache;
      var inj = getInjector();
      if (!inj) return null;
      var dk = null;
      try {
        dk = inj.get("KitService").defaultKit;
      } catch (e) {
        return null;
      }
      if (!dk) return null;
      var dead = design && design.hiddenZones || [];
      var keys = [];
      try {
        var fs = inj.get("CustomizeService").fields || [];
        (Array.isArray(fs) ? fs : Object.keys(fs).map(function(x) {
          return fs[x];
        })).forEach(function(f) {
          if (f && f.fieldValueType === "Color" && f.key && keys.indexOf(f.key) === -1) keys.push(f.key);
        });
      } catch (e1) {
      }
      Object.keys(dk).forEach(function(k) {
        if (typeof dk[k] === "string" && /^#[0-9a-f]{3,8}$/i.test(dk[k]) && keys.indexOf(k) === -1) keys.push(k);
      });
      var join = design && design.joinZones || {};
      var bodyHex = typeof dk.primarycolors === "string" ? dk.primarycolors.toLowerCase() : null;
      var groups = {}, order = [];
      keys.forEach(function(k) {
        if (dead.indexOf(k) !== -1) return;
        if (join[k] && keys.indexOf(join[k]) !== -1 && dead.indexOf(join[k]) === -1) return;
        var v = dk[k];
        var hex = typeof v === "string" && /^#[0-9a-f]{3,8}$/i.test(v) ? v.toLowerCase() : "nodefault:" + k;
        if (PATTERN_KEY.test(k) && k !== "primarycolors" && hex === bodyHex) hex = "pattern:" + hex;
        if (!groups[hex]) {
          groups[hex] = { hex, keys: [] };
          order.push(hex);
        }
        groups[hex].keys.push(k);
      });
      Object.keys(join).forEach(function(k) {
        if (keys.indexOf(k) === -1 || dead.indexOf(k) !== -1) return;
        var tgt = join[k];
        for (var gi = 0; gi < order.length; gi++) {
          if (groups[order[gi]].keys.indexOf(tgt) !== -1) {
            groups[order[gi]].keys.push(k);
            return;
          }
        }
      });
      if (!order.length) return null;
      var so = design && design.slotOrder || [];
      function rank(k) {
        var o = so.indexOf(k);
        if (o !== -1) return -100 + o;
        var i = SLOT_PRIORITY.indexOf(k);
        return i === -1 ? 90 : i;
      }
      var slots = order.map(function(h) {
        var g = groups[h];
        g.keys.sort(function(a, b) {
          return rank(a) - rank(b);
        });
        g.rank = rank(g.keys[0]);
        return g;
      });
      slots.sort(function(a, b) {
        return a.rank - b.rank;
      });
      slotsCache = slots;
      slotsCacheId = designId;
      trace("slots", { n: slots.length, s: slots.map(function(g) {
        return g.keys.join("+");
      }).join(" | ") });
      return slots;
    }
    function needsThird() {
      var sl = designSlots();
      return !sl || sl.length >= 3;
    }
    function autoThird(c1, c2) {
      var used = [String(c1 || "").toLowerCase(), String(c2 || "").toLowerCase()];
      var cands = [WHITE, BLACK, GREY].filter(function(h) {
        return used.indexOf(h.toLowerCase()) === -1;
      });
      cands.sort(function(a, b) {
        return contrast(c1 || BLACK, b) - contrast(c1 || BLACK, a);
      });
      return cands[0] || GREY;
    }
    function looksFor(t) {
      var slots = designSlots();
      if (!slots) return legacyLooksFor(t);
      var c1 = t.c1 || BLACK, c2 = t.c2 || WHITE;
      var c3 = t.c3 && slots.length >= 3 ? t.c3 : autoThird(c1, c2);
      var recipes = [
        { name: "Home", seq: [c1, c2, c3] },
        { name: "Away", seq: [c2, c1, c3] },
        { name: "Whiteout", seq: [WHITE, c1, c2] },
        { name: "Blackout", seq: [BLACK, c1, c2] },
        { name: "Classic", seq: [c1, c3, c2] },
        { name: "Bold", seq: [c2, c3, c1] }
      ];
      var pool = [c1, c2, c3, WHITE, BLACK, GREY];
      var looks = recipes.map(function(r) {
        var used = [], cols = [];
        slots.forEach(function(sl, idx) {
          var want = r.seq[idx];
          var cands = (want ? [want] : []).concat(r.seq, pool);
          var pick = cands.filter(function(h) {
            return used.indexOf(String(h).toLowerCase()) === -1;
          })[0] || want || GREY;
          used.push(String(pick).toLowerCase());
          cols.push(pick);
        });
        var map = {}, keys = [];
        slots.forEach(function(sl, idx) {
          sl.keys.forEach(function(k) {
            map[k] = cols[idx];
            keys.push(k);
          });
        });
        keys.sort(function(a, b) {
          return (a === "primarycolors" ? -1 : 0) - (b === "primarycolors" ? -1 : 0);
        });
        var body = cols[0];
        var accent = cols[1];
        var lk = { name: r.name, map, keys, swatches: cols.slice(0, 3) };
        lk.textColor = accent && contrast(body, accent) >= 2.5 ? accent : textColorFor(body, c1, c2);
        return lk;
      });
      var seen = {}, out = [];
      looks.forEach(function(lk) {
        var sig = lk.swatches.concat(slots.slice(3).map(function(sl) {
          return lk.map[sl.keys[0]];
        })).map(function(h) {
          return String(h).toLowerCase();
        }).join("|");
        if (!seen[sig]) {
          seen[sig] = 1;
          out.push(lk);
        }
      });
      return out;
    }
    function legacyLooksFor(t) {
      var c1 = t.c1 || BLACK, c2 = t.c2 || WHITE;
      var looks = [
        { name: "Home", map: { primarycolors: c1, sidedesign1: c2, sidedesign2: c2, collarandarmholes: WHITE, collarandarmholespiping: c2 } },
        { name: "Away", map: { primarycolors: c2, sidedesign1: c1, sidedesign2: c1, collarandarmholes: WHITE, collarandarmholespiping: c1 } },
        { name: "Whiteout", map: { primarycolors: WHITE, sidedesign1: c1, sidedesign2: c2, collarandarmholes: c1, collarandarmholespiping: c2 } },
        { name: "Blackout", map: { primarycolors: BLACK, sidedesign1: c1, sidedesign2: c1, collarandarmholes: c1, collarandarmholespiping: WHITE } },
        { name: "Classic", map: { primarycolors: c1, sidedesign1: WHITE, sidedesign2: WHITE, collarandarmholes: c2, collarandarmholespiping: c2 } },
        { name: "Bold", map: { primarycolors: c2, sidedesign1: BLACK, sidedesign2: c1, collarandarmholes: c1, collarandarmholespiping: WHITE } }
      ];
      looks.forEach(function(lk) {
        Object.keys(LOOK_KEY_ALIASES).forEach(function(k) {
          lk.map[k] = lk.map[LOOK_KEY_ALIASES[k]];
        });
      });
      looks.forEach(function(lk) {
        var panel = lk.map.sidedesign1;
        lk.textColor = panel && contrast(lk.map.primarycolors, panel) >= 2.5 ? panel : textColorFor(lk.map.primarycolors, c1, c2);
      });
      var seen = {}, out = [];
      looks.forEach(function(lk) {
        var sig = LOOK_KEYS.map(function(k) {
          return String(lk.map[k]).toLowerCase();
        }).join("|");
        if (!seen[sig]) {
          seen[sig] = 1;
          out.push(lk);
        }
      });
      return out;
    }
    function applyTextColor(hex) {
      if (!hex) return false;
      var inj = getInjector();
      if (!inj) {
        trace("fc:no-injector");
        return false;
      }
      try {
        var kv = inj.get("KitService").getKitValues() || {};
        var items = (kv.editor || []).filter(function(it) {
          return it && it.type === "text";
        });
        if (!items.length) {
          trace("fc:no-items");
          return false;
        }
        inj.get("$rootScope").$apply(function() {
          items.forEach(function(it) {
            it.fontColor = hex;
          });
        });
        trace("fc:written", { v: hex, n: items.length });
        try {
          var es = inj.get("EditorService");
          if (es && typeof es.callChanged === "function") es.callChanged();
          else if (es && typeof es.change === "function") es.change();
        } catch (e2) {
        }
        return true;
      } catch (e) {
        return false;
      }
    }
    var activeLook = team && team.lastLook || null;
    function applyLook(look, opts) {
      opts = opts || {};
      var applied = 0, i = 0;
      var lookKeys = look.keys || LOOK_KEYS;
      activeLook = look.name;
      team.lastLook = look.name;
      if (team.c1 || team.c2) store(SETUP_KEY, team);
      if (opts.showOverlay !== false) {
        openBuildOverlay("Switching to your " + look.name + " look…", "Matching colors and lettering.");
      }
      applyTextColor(look.textColor);
      function softRebuild() {
        var params = window.location.search.replace(/^\?/, "").split("&").filter(function(p) {
          return p && !/^xeistsetup=/.test(p) && !/^cb=/.test(p);
        });
        params.push("cb=" + Math.floor(Math.random() * 1e9));
        window.location.replace(window.location.pathname + "?" + params.join("&") + window.location.hash);
      }
      function zones() {
        if (i >= lookKeys.length) {
          track("uniform_look_applied", { look: look.name, design: designId });
          var note = $("#xu-look-note");
          if (note) note.textContent = applied ? look.name + " applied — you can fine-tune below, or just continue." : "Could not apply — try Adjust colors below.";
          renderLookbook();
          trace("commit:settle-start", { look: look.name });
          setTimeout(function() {
            var nonce = "XUC" + Date.now();
            function stampNonce() {
              var inj2 = getInjector();
              if (!inj2) return false;
              try {
                inj2.get("$rootScope").$apply(function() {
                  var kv2 = inj2.get("KitService").getKitValues() || {};
                  var it2 = (kv2.editor || []).filter(function(x) {
                    return x && x.type === "text" && x.placementKey === "add-teamname";
                  })[0];
                  if (it2) it2.customData = nonce;
                });
                return true;
              } catch (e) {
                return false;
              }
            }
            function persistedKey() {
              try {
                for (var j = 0; j < localStorage.length; j++) {
                  var k2 = localStorage.key(j);
                  var v = localStorage.getItem(k2) || "";
                  if (v.length < 200) continue;
                  if (v.indexOf(nonce) !== -1) return k2;
                }
              } catch (e) {
              }
              return null;
            }
            function done(cycles, blobKey) {
              trace("commit:reload", { cycles, persisted: !!blobKey });
              if (blobKey) {
                try {
                  var goodValue = localStorage.getItem(blobKey);
                  var restore = function() {
                    try {
                      localStorage.setItem(blobKey, goodValue);
                    } catch (e) {
                    }
                  };
                  window.addEventListener("pagehide", restore, true);
                  window.addEventListener("beforeunload", restore, true);
                  restore();
                } catch (e) {
                }
              }
              if (opts.onDone) {
                opts.onDone();
                return;
              }
              if (design && design.noTextItems) {
                trace("commit:no-rebuild");
                closeBuildOverlay();
                return;
              }
              softRebuild();
            }
            var cycle = 0;
            function hasNonceCarrier() {
              var inj3 = getInjector();
              if (!inj3) return false;
              try {
                var kv3 = inj3.get("KitService").getKitValues() || {};
                return (kv3.editor || []).filter(function(x) {
                  return x && x.type === "text" && x.placementKey === "add-teamname";
                }).length > 0;
              } catch (e) {
                return false;
              }
            }
            function startConverge() {
              if (!hasNonceCarrier()) {
                trace("commit:no-nonce-carrier");
                applyZone("primarycolors", look.map.primarycolors);
                setTimeout(function() {
                  done(0, null);
                }, 2500);
                return;
              }
              convergeCycle();
            }
            function convergeCycle() {
              cycle++;
              applyTextColor(look.textColor);
              if (opts.beforeCommit) opts.beforeCommit();
              stampNonce();
              applyZone("primarycolors", look.map.primarycolors);
              var polls = 0;
              (function poll() {
                polls++;
                var bk = persistedKey();
                if (bk) {
                  done(cycle, bk);
                  return;
                }
                if (polls >= 8) {
                  trace("commit:cycle-lost", { cycle });
                  if (cycle >= 5) {
                    done(cycle, null);
                    return;
                  }
                  setTimeout(convergeCycle, 1200);
                  return;
                }
                setTimeout(poll, 300);
              })();
            }
            if (opts.beforePersist) opts.beforePersist(startConverge);
            else startConverge();
          }, 3e3);
          return;
        }
        var k = lookKeys[i++];
        if (!zoneRow(k)) {
          zones();
          return;
        }
        if (applyZone(k, look.map[k])) applied++;
        setTimeout(zones, 400);
      }
      zones();
    }
    function renderLookbook() {
      var card = $("#xu-lookbook");
      if (!card) return;
      var body = $(".xu-lb-body", card);
      if (!(team.c1 || team.c2)) {
        body.innerHTML = '<p class="xu-sub">Tell us your team colors and we’ll build complete uniforms for you.</p><button type="button" class="xu-cta" id="xu-lb-setup">Set up my team</button>';
        var b = $("#xu-lb-setup", card);
        if (b) b.addEventListener("click", openWelcome);
        return;
      }
      body.innerHTML = "";
      looksFor(team).forEach(function(look) {
        var b2 = el("button", "xu-look" + (activeLook === look.name ? " xu-look-on" : ""), "");
        b2.type = "button";
        var sw = el("span", "xu-look-swatches", "");
        (look.swatches || [look.map.primarycolors, look.map.sidedesign1, look.map.collarandarmholes]).forEach(function(hex) {
          var sp = el("span", "xu-look-swatch", "");
          sp.style.background = hex;
          sw.appendChild(sp);
        });
        b2.appendChild(sw);
        b2.appendChild(el("span", "xu-look-name", look.name));
        b2.addEventListener("click", function() {
          applyLook(look);
        });
        body.appendChild(b2);
      });
      body.appendChild(el("p", "", "")).id = "xu-look-note";
    }
    function buildLookbook() {
      if ($("#xu-lookbook")) return;
      var firstRow = zoneRow("primarycolors");
      if (!firstRow || !firstRow.parentNode) return;
      var anchor = firstRow.closest && firstRow.closest(".kb-form-field-wrapper") || firstRow;
      if (!anchor.parentNode) return;
      var card = el("section", "xu-card", "");
      card.id = "xu-lookbook";
      card.innerHTML = '<div class="xu-lb-head"><h3 class="xu-h">Pick your look</h3><button type="button" class="xu-more-btn" id="xu-lb-edit">Edit team</button></div><div class="xu-lb-body"></div><div class="xu-lb-links"><button type="button" class="xu-more-btn" id="xu-adjust-colors">Adjust colors</button><button type="button" class="xu-more-btn" id="xu-adjust-text">Adjust text &amp; font</button></div>';
      anchor.parentNode.insertBefore(card, anchor);
      $("#xu-lb-edit", card).addEventListener("click", openWelcome);
      $("#xu-adjust-colors", card).addEventListener("click", function() {
        var form = $(".kb-wizard-form");
        var on = form && form.classList.toggle("xu-adjust");
        this.textContent = on ? "Hide color zones" : "Adjust colors";
        track("uniform_adjust_colors", { design: designId, on: !!on });
      });
      $("#xu-adjust-text", card).addEventListener("click", function() {
        withStepService(function(ss) {
          ss.setStepIndex(1);
        });
        track("uniform_adjust_text", { design: designId });
      });
      renderLookbook();
    }
    function buildZoneQuickPalettes() {
      (design.hiddenZones || []).forEach(function(k) {
        var row = zoneRow(k);
        var wrap = row && row.closest ? row.closest(".kb-form-field-wrapper") : null;
        if (wrap) wrap.classList.add("xu-zone-dead");
      });
      visibleZones().forEach(function(z) {
        var row = zoneRow(z.key);
        if (!row || row.getAttribute("data-xu-done")) return;
        row.setAttribute("data-xu-done", "1");
        row.classList.add("xu-zone");
        var wrap = row.closest ? row.closest(".kb-form-field-wrapper") : null;
        if (wrap) wrap.classList.add("xu-zone-wrap");
        var mount = row.querySelector(".kb-tile-picker-base");
        if (!mount || !mount.parentNode) return;
        var quick = el("div", "xu-quick", "");
        QUICK_COLORS.forEach(function(c) {
          var chip = el("button", "xu-chip", "");
          chip.type = "button";
          chip.title = c.name;
          chip.setAttribute("aria-label", z.label + ": " + c.name);
          chip.style.background = c.hex;
          chip.addEventListener("click", function() {
            applyZone(z.key, c.hex);
          });
          quick.appendChild(chip);
        });
        var more = el("button", "xu-more-btn", "More colors");
        more.type = "button";
        more.addEventListener("click", function() {
          var on = row.classList.toggle("xu-more");
          more.textContent = on ? "Fewer colors" : "More colors";
        });
        quick.appendChild(more);
        var rec = el("div", "xu-recent", "");
        rec.setAttribute("data-zone", z.key);
        mount.parentNode.insertBefore(quick, mount);
        mount.parentNode.insertBefore(rec, mount);
      });
    }
    function renderRecents() {
      $all(".xu-recent").forEach(function(box) {
        var key = box.getAttribute("data-zone");
        box.innerHTML = recent.length ? '<span class="xu-slot-label">Recently used</span>' : "";
        recent.forEach(function(hex) {
          var chip = el("button", "xu-chip xu-chip-sm", "");
          chip.type = "button";
          chip.title = hex;
          chip.style.background = hex;
          chip.addEventListener("click", function() {
            applyZone(key, hex);
          });
          box.appendChild(chip);
        });
      });
    }
    function zoneCurrent(key) {
      var row = zoneRow(key);
      var i = row && row.querySelector("input.kb-tile-picker-radio:checked");
      if (!i) return null;
      var li = i.closest ? i.closest("li") : i.parentNode;
      var t = li && li.querySelector(".kb-tile-picker-tile");
      return { hex: i.value, name: t && t.title || "" };
    }
    function renameHeaders() {
      visibleZones().forEach(function(z) {
        var row = zoneRow(z.key);
        var wrap = row && row.closest ? row.closest(".kb-form-field-wrapper") : null;
        var h = wrap && wrap.querySelector(".kb-wizard-group-header");
        if (!h) return;
        var cur = zoneCurrent(z.key);
        var want = z.label + (cur && cur.name ? " — " + cur.name : "");
        if (h.getAttribute("data-xu-label") !== want) {
          h.setAttribute("data-xu-label", want);
          h.textContent = want;
        }
      });
    }
    function enforcePreviewScale() {
      var canvas = $(".kb-preview-panel canvas");
      if (!canvas) return;
      var psm = design && design.previewScaleMobile;
      if (psm && window.innerWidth <= 767) {
        var panel = canvas.closest ? canvas.closest(".kb-preview-panel") : null;
        var pr = panel ? panel.getBoundingClientRect() : null;
        var cr = canvas.getBoundingClientRect();
        var applied = 0;
        var m = /translateY\((-?\d+(?:\.\d+)?)px\)/.exec(canvas.style.transform || "");
        if (m) applied = parseFloat(m[1]);
        var shift = pr ? Math.round(pr.top + pr.height / 2 - (cr.top + cr.height / 2 - applied)) : 0;
        var needScale = (canvas.style.transform || "").indexOf("scale(" + psm + ")") === -1;
        if (needScale || Math.abs(shift - applied) > 1) {
          canvas.style.setProperty("transform", "translateY(" + shift + "px) scale(" + psm + ")", "important");
          canvas.style.setProperty("transform-origin", "center center", "important");
        }
        return;
      }
      var ps = design && design.previewScale;
      if (!ps || ps === 1) return;
      var want = "scale(" + ps + ")";
      if ((canvas.style.transform || "").indexOf(want) === -1) {
        canvas.style.setProperty("transform", want, "important");
        canvas.style.setProperty("transform-origin", "center center", "important");
      }
    }
    var fitState = { app: null, aspect: 0, gen: -1, kbMax: 0, box: null, meshes: 0 }, fitGen = 0;
    function liveApp() {
      try {
        var P = window.KitBuilderPBR && KitBuilderPBR.PbrApp;
        var insts = P && P.instances;
        if (!insts || typeof insts.forEach !== "function") return null;
        var connected = null, last = null;
        insts.forEach(function(inst) {
          if (!inst || !inst.lib || !inst.lib.renderer || !inst.lib.camera || !inst.controls) return;
          last = inst;
          var el2 = inst.lib.renderer.domElement;
          if (el2 && el2.isConnected) connected = inst;
        });
        return connected || last;
      } catch (e) {
        return null;
      }
    }
    function garmentBox(app) {
      var box = null, meshes = 0;
      try {
        app.lib.scene.updateMatrixWorld(true);
      } catch (e) {
      }
      app.lib.scene.traverse(function(ch) {
        if (!(ch.isMesh && ch.geometry && ch.visible)) return;
        var g = ch.geometry;
        var tris = g.index ? g.index.count / 3 : g.attributes && g.attributes.position ? g.attributes.position.count / 3 : 0;
        if (tris < 100) return;
        if (g.computeBoundingBox && !g.boundingBox) g.computeBoundingBox();
        var bb = g.boundingBox;
        if (!bb) return;
        meshes++;
        var xs = [bb.min.x, bb.max.x], ys = [bb.min.y, bb.max.y], zs = [bb.min.z, bb.max.z];
        for (var i = 0; i < 8; i++) {
          var v = bb.min.clone().set(xs[i & 1], ys[i >> 1 & 1], zs[i >> 2 & 1]).applyMatrix4(ch.matrixWorld);
          if (!box) box = { minX: v.x, maxX: v.x, minY: v.y, maxY: v.y };
          else {
            if (v.x < box.minX) box.minX = v.x;
            if (v.x > box.maxX) box.maxX = v.x;
            if (v.y < box.minY) box.minY = v.y;
            if (v.y > box.maxY) box.maxY = v.y;
          }
        }
      });
      return box ? { box, meshes } : null;
    }
    function fitCameraToGarment() {
      var cfg = design && design.fitCamera;
      if (!cfg) return;
      var app = liveApp();
      if (!app) return;
      var cam = app.lib.camera, ctl = app.controls;
      if (!cam || !ctl || !ctl.target || !cam.position || !cam.aspect) return;
      if (fitState.app !== app) {
        fitState = { app, aspect: 0, gen: -1, kbMax: typeof ctl.maxDistance === "number" ? ctl.maxDistance : 0, box: null, meshes: 0 };
      }
      var aspect = Math.round(cam.aspect * 1e3) / 1e3;
      var t = ctl.target;
      var dx = cam.position.x - t.x, dy = cam.position.y - t.y, dz = cam.position.z - t.z;
      var d = Math.sqrt(dx * dx + dy * dy + dz * dz);
      if (!(d > 0)) return;
      var parkedAtDefault = fitState.kbMax > 0 && Math.abs(d - fitState.kbMax) < 0.03;
      var armed = fitState.aspect === aspect && fitState.gen === fitGen;
      if (armed && !parkedAtDefault) return;
      var gb;
      try {
        gb = garmentBox(app);
      } catch (e) {
        gb = null;
      }
      if (!gb) return;
      var w = gb.box.maxX - gb.box.minX, h = gb.box.maxY - gb.box.minY;
      if (!(w > 0.05 && h > 0.05)) return;
      fitState.aspect = aspect;
      fitState.gen = fitGen;
      var margin = cfg.margin || 1.08;
      var halfV = Math.tan((cam.fov || 45) * Math.PI / 360);
      var dReq = Math.max(w * margin / (2 * halfV * cam.aspect), h * margin / (2 * halfV));
      if (dReq <= d * 1.02) return;
      try {
        if (typeof ctl.maxDistance === "number" && ctl.maxDistance < dReq * 1.2) ctl.maxDistance = dReq * 1.2;
        var k = dReq / d;
        cam.position.set(t.x + dx * k, t.y + dy * k, t.z + dz * k);
        ctl.update();
        try {
          app.trackSceneChange();
        } catch (e2) {
        }
        trace("fit:camera", { from: +d.toFixed(2), to: +dReq.toFixed(2), a: aspect });
      } catch (e) {
        trace("fit:threw", { e: String(e).slice(0, 60) });
      }
    }
    document.addEventListener("click", function(ev) {
      try {
        var t = ev.target;
        if (t && t.closest && t.closest("a.kb-change-view-button")) fitGen++;
      } catch (e) {
      }
    }, true);
    function syncChipStates() {
      visibleZones().forEach(function(z) {
        var row = zoneRow(z.key);
        if (!row) return;
        var cur = zoneCurrent(z.key);
        var quick = row.querySelector(".xu-quick");
        if (!quick || !cur) return;
        $all(".xu-chip", quick).forEach(function(chip) {
          var on = chip.title && QUICK_COLORS.some(function(c) {
            return c.name === chip.title && c.hex.toLowerCase() === String(cur.hex).toLowerCase();
          });
          chip.classList.toggle("xu-chip-on", !!on);
          chip.setAttribute("aria-pressed", on ? "true" : "false");
        });
      });
    }
    function buildReassurance() {
      if (!$("#xu-reassure-logos")) {
        var logosStep = $all(".kb-field-editor").filter(function(r) {
          var w = r.closest ? r.closest(".kb-form-field-wrapper") : null;
          var h = w && w.querySelector(".kb-wizard-group-header");
          return h && /logos/i.test(h.textContent || "");
        })[0];
        if (logosStep && logosStep.parentNode) {
          var c1 = el(
            "aside",
            "xu-card xu-reassure",
            "<strong>Your logo is safe.</strong> XEIST reviews every logo before production. Need help? Our design team can clean up low-resolution logos at no charge."
          );
          c1.id = "xu-reassure-logos";
          logosStep.parentNode.insertBefore(c1, logosStep.nextSibling);
        }
      }
      if (!$("#xu-reassure-order")) {
        var orderStep = $(".kb-field-teamdetails");
        if (orderStep && orderStep.parentNode) {
          var c2 = el(
            "aside",
            "xu-card xu-reassure",
            "<strong>No order goes into production until your design is reviewed and approved by XEIST.</strong> We check every logo, name and number before anything is stitched."
          );
          c2.id = "xu-reassure-order";
          orderStep.parentNode.insertBefore(c2, orderStep);
        }
      }
    }
    function watchTextWarnings() {
      $all(".kb-wizard-form input[type=text]").forEach(function(inp) {
        if (inp.getAttribute("data-xu-warn")) return;
        inp.setAttribute("data-xu-warn", "1");
        inp.addEventListener("input", function() {
          var warn = inp.parentNode.querySelector(".xu-warn");
          var long = (inp.value || "").length > 14;
          if (long && !warn) {
            warn = el("div", "xu-warn", "Long names may print smaller to fit. Our design team will confirm before production.");
            inp.parentNode.appendChild(warn);
          } else if (!long && warn) warn.parentNode.removeChild(warn);
        });
      });
    }
    function isMobile() {
      return window.innerWidth <= 749;
    }
    function viewButtons() {
      return $all("a.kb-change-view-button");
    }
    function buildViewPill() {
      var pill = $("#xu-viewpill");
      if (pill && pill.parentNode) pill.parentNode.removeChild(pill);
    }
    function bindSwipeSteps() {
      if (window.__xuSwipeBound || !isMobile()) return;
      window.__xuSwipeBound = true;
      var x0 = null, y0 = null, t0 = 0;
      document.addEventListener("touchstart", function(e) {
        var t = e.target;
        if (t && t.closest && (t.closest("canvas") || t.closest("input,textarea,select,#xu-welcome,#xv-drawer"))) {
          x0 = null;
          return;
        }
        var p = e.touches && e.touches[0];
        if (!p) return;
        x0 = p.clientX;
        y0 = p.clientY;
        t0 = Date.now();
      }, { passive: true });
      document.addEventListener("touchend", function(e) {
        if (x0 == null) return;
        var p = e.changedTouches && e.changedTouches[0];
        if (!p) {
          x0 = null;
          return;
        }
        var dx = p.clientX - x0, dy = p.clientY - y0, dt = Date.now() - t0;
        x0 = null;
        if (dt > 600 || Math.abs(dx) < 70 || Math.abs(dy) > Math.abs(dx) * 0.6) return;
        var ids = STEPS.map(function(s) {
          return s.id;
        });
        var idx = ids.indexOf(currentVirtual);
        if (dx < 0 && idx < STEPS.length - 1) gotoVirtual(ids[idx + 1]);
        else if (dx > 0 && idx > 1) gotoVirtual(ids[idx - 1]);
      }, { passive: true });
    }
    function playerCount() {
      try {
        var R = window.XeistUniformRoster;
        if (R && R.audit) {
          var a = R.audit();
          if (a && typeof a.count === "number") return a.count;
        }
      } catch (e) {
      }
      var n = null;
      $all(".kb-wizard-group-header").forEach(function(h) {
        var m = (h.textContent || "").match(/\((\d+)\s*players?\)/i);
        if (m) n = parseInt(m[1], 10);
      });
      return n;
    }
    function priceFromLabel(d) {
      var raw = String(d && d.priceFrom || "");
      var n = parseFloat(raw.replace(/[^0-9.]/g, ""));
      try {
        if (n && window.XeistMoney) return window.XeistMoney.kbUnit(n);
      } catch (e) {
      }
      return raw;
    }
    function buildBar() {
      if ($("#xu-bar")) return;
      var bar = el("div", "", "");
      bar.id = "xu-bar";
      bar.innerHTML = '<div class="xu-bar-info"><strong>' + esc((design.name ? design.name + " " : "") + design.noun) + '</strong><span id="xu-bar-players"></span><span class="xu-bar-eta">' + design.timeline + '</span><span id="xu-bar-price">From ' + priceFromLabel(design) + " per player &middot; team pricing at " + (design.discountAt || design.minQty) + '+</span><span class="xu-bar-trust">Every custom order is reviewed by XEIST before production</span></div>';
      var btn = el("button", "xu-cta", "Continue");
      btn.id = "xu-continue";
      btn.type = "button";
      btn.addEventListener("click", function() {
        var idx = STEPS.map(function(s) {
          return s.id;
        }).indexOf(currentVirtual);
        if (idx >= 0 && idx < STEPS.length - 1) gotoVirtual(STEPS[idx + 1].id);
        else gotoVirtual("review");
      });
      bar.appendChild(btn);
      document.body.appendChild(bar);
    }
    function syncBar() {
      var p = $("#xu-bar-players");
      if (p) {
        var n = playerCount();
        p.textContent = n ? n + " players" : "Team order";
      }
    }
    var CSS = [
      /* step rail */
      "#xu-steps{display:flex;gap:6px;flex-wrap:nowrap;overflow-x:auto;padding:14px 4px 10px;margin:0 0 6px;-webkit-overflow-scrolling:touch;scrollbar-width:none}",
      "#xu-steps::-webkit-scrollbar{display:none}",
      ".xu-step{flex:0 0 auto;display:inline-flex;align-items:center;gap:7px;border:0;background:#f2f2f4;color:#1d1d1f;border-radius:999px;padding:9px 14px;font:600 13px/1 inherit;cursor:pointer;min-height:36px}",
      ".xu-step-n{display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;background:#fff;color:#6e6e73;font-size:11px;font-weight:700}",
      ".xu-step-active{background:" + ACCENT + ";color:#fff}",
      ".xu-step-active .xu-step-n{background:rgba(255,255,255,.25);color:#fff}",
      /* cards */
      ".xu-card{background:#fff;border-radius:16px;box-shadow:0 1px 3px rgba(0,0,0,.07),0 6px 18px rgba(0,0,0,.05);padding:18px;margin:10px 0}",
      ".xu-h{margin:0 0 4px;font-size:17px;font-weight:700;color:#1d1d1f}",
      ".xu-sub{margin:0 0 10px;font-size:13px;color:#6e6e73}",
      ".xu-slot-label{font-size:11px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;color:#6e6e73;margin:12px 0 6px;display:block}",
      /* chips */
      ".xu-chips,.xu-quick,.xu-recent{display:flex;gap:8px;flex-wrap:wrap;align-items:center;margin:6px 0}",
      ".xu-chip{width:34px;height:34px;border-radius:50%;border:2px solid rgba(0,0,0,.12);cursor:pointer;padding:0;box-shadow:inset 0 0 0 1px rgba(255,255,255,.4)}",
      ".xu-chip-sm{width:26px;height:26px}",
      /* Selection ring via BOX-SHADOW, not outline (2026-07-31, Justin:
         ring didn't follow clicks — the theme overrides button outlines,
         so the class applied but never rendered; the ring people DID see
         was the browser focus ring riding the last click). White gap +
         accent ring, inset highlight preserved. !important beats theme. */
      ".xu-chip-on{box-shadow:inset 0 0 0 1px rgba(255,255,255,.4),0 0 0 2px #fff,0 0 0 5px " + ACCENT + "!important;outline:none!important}",
      ".xu-more-btn{border:0;background:transparent;color:" + ACCENT + ";font:600 13px/1 inherit;cursor:pointer;padding:8px 10px;min-height:36px}",
      /* welcome card */
      "#xu-w-scrim{position:fixed;inset:0;background:rgba(20,20,22,.30);backdrop-filter:blur(3px);z-index:2147483100}",
      "#xu-welcome{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);width:min(400px,92vw);background:#fff;border-radius:20px;box-shadow:0 24px 70px rgba(0,0,0,.25);padding:24px;z-index:2147483150}",
      ".xu-w-input{width:100%;box-sizing:border-box;border:1px solid rgba(0,0,0,.16);border-radius:12px;padding:12px 14px;font:700 16px/1.2 inherit;letter-spacing:.04em;text-transform:uppercase}",
      /* 2026-08-27 (Justin): the primary CTA flashes — pulse + shine pull
         the coach from setup into the builder reveal. Reduced-motion users
         keep the color without the movement. */
      ".xu-w-go{width:100%;margin:16px 0 2px;position:relative;overflow:hidden;box-shadow:0 6px 22px rgba(109,40,217,.35);animation:xuWGoPulse 2.2s ease-out infinite}",
      "@keyframes xuWGoPulse{0%{box-shadow:0 6px 22px rgba(109,40,217,.35),0 0 0 0 rgba(109,40,217,.45)}70%{box-shadow:0 6px 22px rgba(109,40,217,.35),0 0 0 13px rgba(109,40,217,0)}100%{box-shadow:0 6px 22px rgba(109,40,217,.35),0 0 0 0 rgba(109,40,217,0)}}",
      '.xu-w-go::after{content:"";position:absolute;top:0;left:-60%;width:45%;height:100%;background:linear-gradient(105deg,transparent,rgba(255,255,255,.34),transparent);animation:xuWGoShine 2.8s ease-in-out infinite}',
      "@keyframes xuWGoShine{0%{left:-60%}55%{left:130%}100%{left:130%}}",
      "@media (prefers-reduced-motion:reduce){.xu-w-go{animation:none}.xu-w-go::after{display:none}}",
      ".xu-w-opt{font-weight:400;text-transform:none;letter-spacing:0;color:#a1a1a6}",
      ".xu-w-logo-row{display:flex;align-items:center;gap:10px;flex-wrap:wrap}",
      /* W8/T2.7: full-palette panel in the wizard */
      ".xu-pal{margin:6px 0 4px;border:1px solid #ececea;border-radius:12px;padding:10px 12px;max-height:280px;overflow-y:auto;overscroll-behavior:contain}",
      ".xu-pal[hidden]{display:none}",
      ".xu-pal-search{width:100%;box-sizing:border-box;border:1px solid rgba(0,0,0,.16);border-radius:9px;padding:9px 12px;font:400 14px/1.3 inherit;margin:0 0 10px}",
      ".xu-pal-toggle{padding-left:0}",
      ".xu-pal-group{margin:0 0 10px}",
      ".xu-pal-group[hidden],.xu-pal-cell[hidden]{display:none}",
      ".xu-pal-group .xu-slot-label{margin:4px 0 6px}",
      ".xu-pal-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(56px,1fr));gap:8px 6px}",
      ".xu-pal-cell{display:flex;flex-direction:column;align-items:center;gap:3px;min-width:0}",
      ".xu-pal-chip{width:40px;height:40px;border-radius:50%}",
      ".xu-pal-name{font-size:9.5px;color:#6e6e73;text-align:center;line-height:1.2;max-width:100%;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}",
      ".xu-pal-empty{font-size:12.5px;color:#8a5a00;margin:2px 0 0}",
      "@media (max-width:749px){.xu-pal{max-height:44vh}.xu-pal-chip{width:44px;height:44px}}",
      ".xu-w-logo-btn{display:inline-flex;align-items:center;border:1.5px dashed rgba(0,0,0,.25);border-radius:12px;padding:10px 16px;font:600 13px/1 inherit;color:#3a3a3c;cursor:pointer;min-height:42px}",
      ".xu-w-logo-btn:hover{border-color:" + ACCENT + ";color:" + ACCENT + "}",
      /* build overlay (pre-rebuild moment) */
      "#xu-build-overlay{position:fixed;inset:0;background:rgba(255,255,255,.96);backdrop-filter:blur(4px);z-index:2147483400;display:flex;align-items:center;justify-content:center;text-align:center}",
      ".xu-build-inner h3{margin:14px 0 4px;font-size:20px;font-weight:800;color:#1d1d1f}",
      ".xu-build-inner p{margin:0;font-size:13.5px;color:#6e6e73}",
      ".xu-build-spin{width:42px;height:42px;border-radius:50%;border:4px solid rgba(109,40,217,.15);border-top-color:" + ACCENT + ";margin:0 auto;animation:xuspin .9s linear infinite}",
      "@keyframes xuspin{to{transform:rotate(360deg)}}",
      "@media (prefers-reduced-motion:reduce){.xu-build-spin{animation:none}}",
      /* look gallery */
      ".xu-lb-head{display:flex;align-items:center;justify-content:space-between}",
      ".xu-lb-body{display:flex;flex-wrap:wrap;gap:8px;margin-top:6px}",
      ".xu-lb-links{display:flex;gap:8px;margin-top:8px;border-top:1px solid rgba(0,0,0,.06);padding-top:6px}",
      ".xu-look{display:inline-flex;align-items:center;gap:10px;border:1.5px solid rgba(0,0,0,.1);background:#fff;border-radius:12px;padding:12px 16px;cursor:pointer;min-height:48px}",
      ".xu-look:hover{border-color:" + ACCENT + "}",
      ".xu-look-on{border-color:" + ACCENT + ";box-shadow:0 0 0 2px rgba(109,40,217,.18)}",
      ".xu-look-swatches{display:inline-flex}",
      ".xu-look-swatch{width:20px;height:20px;border-radius:50%;border:2px solid #fff;box-shadow:0 0 0 1px rgba(0,0,0,.15);margin-left:-7px}",
      ".xu-look-swatch:first-child{margin-left:0}",
      ".xu-look-name{font-weight:700;font-size:13.5px;color:#1d1d1f}",
      "#xu-look-note{font-size:12px;color:#6e6e73;margin:4px 0 0;flex-basis:100%}",
      /* zone editing demoted: hidden until "Adjust colors" (wrapper carries
         the header; row alone left orphaned header bars visible) */
      ".kb-wizard-form:not(.xu-adjust) .xu-zone{display:none!important}",
      ".kb-wizard-form:not(.xu-adjust) .xu-zone-wrap{display:none!important}",
      ".xu-zone-dead{display:none!important}",
      /* zones with no visible effect on this design */
      ".xu-zone .kb-tile-picker-base{display:none}",
      ".xu-zone.xu-more .kb-tile-picker-base{display:block}",
      /* KB restyle. ID-weight selectors on purpose: KB ships its own
         !important rules and plain class selectors lose (verified live). */
      "body.template-page #kb-app .kb-customise-page .kb-wizard-group-header,body.template-page #kb-app .kb-customise-page .kb-wizard-group-header-selected{background:#fff!important;color:#1d1d1f!important;border:1px solid rgba(0,0,0,.08)!important;border-radius:12px!important;font-weight:700!important;box-shadow:0 1px 2px rgba(0,0,0,.05)!important}",
      "body.template-page #kb-app .kb-customise-page .kb-wizard-group-header:after,body.template-page #kb-app .kb-customise-page .kb-wizard-group-header i{color:#6e6e73!important;border-color:#6e6e73!important}",
      /* our Continue drives the flow; KB's NEXT/PREV would resurface the Text step */
      "body.template-page #kb-app .kb-customise-page .kb-button-next,body.template-page #kb-app .kb-customise-page .kb-button-prev{display:none!important}",
      ".xu-zone .kb-wizard-form-label{display:none!important}",
      /* reassurance + warnings */
      ".xu-reassure{border-left:4px solid " + ACCENT + ";font-size:13px;color:#3a3a3c}",
      ".xu-warn{font-size:12px;color:#8a5a00;background:#fff6e5;border-radius:8px;padding:8px 10px;margin-top:6px}",
      /* sticky bar */
      "#xu-bar{position:fixed;left:0;right:0;bottom:0;z-index:2147483000;display:flex;align-items:center;gap:14px;background:rgba(255,255,255,.95);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);border-top:1px solid rgba(0,0,0,.08);padding:10px max(16px,env(safe-area-inset-right)) max(10px,env(safe-area-inset-bottom)) max(16px,env(safe-area-inset-left))}",
      ".xu-bar-info{display:flex;align-items:center;gap:14px;flex-wrap:wrap;font-size:12.5px;color:#3a3a3c;min-width:0;flex:1}",
      ".xu-bar-info strong{font-size:13.5px;color:#1d1d1f}",
      ".xu-bar-trust{color:#6e6e73}",
      ".xu-cta{flex:0 0 auto;border:0;border-radius:12px;background:" + ACCENT + ";color:#fff;font:700 14px/1 inherit;padding:14px 22px;cursor:pointer;min-height:48px}",
      ".xu-cta:hover{filter:brightness(1.08)}",
      "body{padding-bottom:74px}",
      /* W1/T0.6: keep the HubSpot chat FAB clear of the sticky bar — it sat
         directly on the primary CTA at 1440x900 (audit V4) */
      "#hubspot-messages-iframe-container{bottom:84px!important}",
      /* mobile (phase 4A): canvas-first, controls styled as a bottom sheet,
         floating view pill, swipeable steps, big tap targets */
      "@media (max-width:749px){",
      /* W7/T2.6: the audited mobile bar hid price, player count and trust —
         the coach's two most important numbers (V1/V3). Restack instead:
         line 1 name · players · price, line 2 trust (tiny), line 3 CTA. The
         ETA is the only thing dropped — it's the least decision-critical. */
      "#xu-bar{flex-wrap:wrap;gap:4px 10px;padding-top:9px}",
      ".xu-bar-info{flex:1 1 100%;gap:8px 10px;font-size:12px;align-items:baseline}",
      ".xu-bar-info strong{font-size:13px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:46vw}",
      "#xu-bar-players,#xu-bar-price{display:inline;white-space:nowrap;font-weight:600;color:#1d1d1f}",
      ".xu-bar-eta{display:none}",
      ".xu-bar-trust{display:block;flex:1 1 100%;font-size:10.5px;line-height:1.3;margin-top:-2px}",
      /* W7/T2.6: kill Kit Builder's own mobile chrome (audit V3: raw sport
         menu + VIEW BASKET + LOCKER ROOM above our UI at 390px). Our step
         rail and basket flow replace all of it. */
      "body.template-page #kb-app .kb-nav-panel,body.template-page #kb-app .kb-nav,body.template-page #kb-app .kb-nav-mobile-menu,body.template-page #kb-app .kb-nav-title{display:none!important}",
      ".xu-chip{width:40px;height:40px}",
      ".xu-step{padding:11px 16px;min-height:42px}",
      "#xu-steps{position:sticky;top:0;background:rgba(255,255,255,.96);backdrop-filter:blur(12px);z-index:100;padding:10px 8px}",
      /* Welcome as its OWN PAGE on mobile (2026-08-27, Justin: the sheet
         sat awkwardly over the builder — the coach should fill this out
         FIRST, then the flashing CTA reveals the uniform). The scrim goes
         opaque so KB loads invisibly behind it; submit/skip tears the page
         away and the builder is simply there. */
      "#xu-w-scrim{background:#fff;backdrop-filter:none}",
      "#xu-welcome{top:0;bottom:0;left:0;right:0;transform:none;width:100%;height:100%;max-height:none;border-radius:0;box-shadow:none;padding:calc(20px + env(safe-area-inset-top)) 20px calc(28px + env(safe-area-inset-bottom));overflow-y:auto}",
      /* floating front/back pill over the canvas */
      "#xu-viewpill{position:fixed;left:50%;transform:translateX(-50%);bottom:84px;z-index:2147483001;display:flex;background:rgba(255,255,255,.95);backdrop-filter:blur(10px);border:1px solid rgba(0,0,0,.1);border-radius:999px;box-shadow:0 4px 16px rgba(0,0,0,.14);overflow:hidden}",
      ".xu-viewpill-btn{border:0;background:transparent;font:600 13px/1 inherit;color:#3a3a3c;padding:11px 20px;min-height:42px;cursor:pointer}",
      ".xu-viewpill-on{background:" + ACCENT + ";color:#fff}",
      ".xu-cta{padding:15px 26px;min-height:52px;flex:1 1 100%;max-width:none}",
      "body{padding-bottom:118px}",
      "#xu-viewpill{bottom:128px}",
      "#hubspot-messages-iframe-container{bottom:132px!important}",
      ".xu-look{flex:1 1 44%;justify-content:flex-start;min-height:52px}",
      ".xu-lb-body{gap:10px}",
      "}"
    ].join("\n");
    function injectCSS() {
      if ($("#xu-style")) return;
      var scope = "body.template-page #kb-app .kb-customise-page.kb-design-id-" + designId;
      var restore = [
        scope + " .kb-customise-edit-panel{display:block!important}",
        scope + " .kb-preview-panel{flex:1 1 auto!important;max-width:none!important;width:auto!important}",
        scope + "{justify-content:flex-start!important}",
        /* phase 4A mobile: the edit column reads as a drawer sheet under
           the canvas — rounded top, lifted shadow, generous padding.
           Preview height CLAMPED (2026-07-15, Justin: raise the sheet so
           "Pick your look" shows above the fold — KB's preview block runs
           much taller than the jersey render; the clamp only trims empty
           canvas below the model). */
        "@media (max-width:749px){",
        scope + " .kb-customise-edit-panel{background:#fff!important;border-radius:22px 22px 0 0!important;box-shadow:0 -8px 30px rgba(0,0,0,.10)!important;padding:14px 12px 90px!important;margin-top:-18px!important;position:relative!important;z-index:5!important}",
        scope + " .kb-preview-panel{min-height:46vh!important;max-height:52vh!important;overflow:hidden!important}",
        "}"
      ].join("\n");
      var s = el("style", "", "");
      s.id = "xu-style";
      s.appendChild(document.createTextNode(CSS + "\n" + restore));
      document.head.appendChild(s);
      window.dispatchEvent(new Event("resize"));
    }
    var welcomeDecided = false;
    function designUntouched() {
      var inj = getInjector();
      if (!inj) return null;
      try {
        var kv = inj.get("KitService").getKitValues() || {};
        var item = (kv.editor || []).filter(function(it) {
          return it && it.type === "text" && it.placementKey === "add-teamname";
        })[0];
        if (!item) return null;
        var t = String(item.text == null ? "" : item.text).trim().toUpperCase();
        return t === "" || t === "TEAM NAME";
      } catch (e) {
        return null;
      }
    }
    function maybeOpenWelcome() {
      if (welcomeDecided || $("#xu-welcome")) return;
      try {
        var carry = JSON.parse(localStorage.getItem("xeist_shorts_carry") || "null");
        if (carry && String(carry.toDesign) === String(designId)) {
          welcomeDecided = true;
          return;
        }
      } catch (e) {
      }
      var force = /[?&]xeistsetup=1/.test(window.location.search);
      if (force) {
        welcomeDecided = true;
        openWelcome();
        return;
      }
      var dismissed = false;
      try {
        dismissed = sessionStorage.getItem("xu_welcome_dismissed_" + designId) === "1";
      } catch (e) {
      }
      if (dismissed) {
        welcomeDecided = true;
        return;
      }
      var untouched = designUntouched();
      if (untouched === null) return;
      welcomeDecided = true;
      if (untouched) openWelcome();
    }
    var booted = false;
    var tickN = 0;
    function adjustOpen() {
      var f = $(".kb-wizard-form");
      return !!(f && f.classList.contains("xu-adjust"));
    }
    function tick() {
      tickN++;
      var id = designIdFromHash();
      if (id !== designId) {
        teardownIfForeign(id);
        return;
      }
      if (!$(".kb-wizard-breadcrumbs") || !zoneRow("primarycolors")) return;
      if (!resolveDesign()) return;
      injectCSS();
      buildRail();
      buildLookbook();
      buildZoneQuickPalettes();
      buildReassurance();
      if (adjustOpen()) {
        renameHeaders();
        syncChipStates();
      }
      enforcePreviewScale();
      fitCameraToGarment();
      if (tickN % 3 === 0) watchTextWarnings();
      buildBar();
      bumpChatLauncher();
      buildViewPill();
      bindSwipeSteps();
      syncRail();
      if (tickN % 2 === 0) syncBar();
      if (!booted) {
        booted = true;
        try {
          var tsKey = "xeist_ts_" + designId;
          var hadTs = localStorage.getItem(tsKey) === "1";
          localStorage.removeItem(tsKey);
          localStorage.removeItem("xeist_cfg3_" + designId);
          if (hadTs) {
            trace("coach-flag-cleared-reload");
            window.location.reload();
            return;
          }
        } catch (e) {
        }
        window.XeistUniform = { designId, design, accent: ACCENT, team, applyLook, looksFor };
        track("uniform_skin_boot", { design: designId });
        setTimeout(restoreStepAfterReboot, 1200);
      }
      maybeOpenWelcome();
    }
    var chatBumpLast = 0;
    function bumpChatLauncher() {
      var now = Date.now();
      if (now - chatBumpLast < 2500) return;
      chatBumpLast = now;
      try {
        var bar = $("#xu-bar");
        var barH = bar ? Math.ceil(bar.getBoundingClientRect().height) : 0;
        var lift = (barH || 74) + 12;
        var modalOpen = !!($("#xu-welcome") || $("#xp-modal") || $("#xv-drawer") || $("#xc-paymodal") || $("#xs-pkg-panel"));
        var cands = document.querySelectorAll("body > *, body > * > *");
        for (var i = 0; i < cands.length; i++) {
          var el2 = cands[i];
          if (!el2 || !el2.getBoundingClientRect || /^(script|style|link)$/i.test(el2.tagName)) continue;
          if (/^(xu-|xv-|xp-|xc-|xs-|xr-|xeist|kb-)/.test(el2.id || "")) continue;
          var cs = getComputedStyle(el2);
          if (cs.position !== "fixed") continue;
          var r = el2.getBoundingClientRect();
          var w = r.width, h = r.height;
          if (el2.__xuBumped) {
            w = el2.__xuBumped.w;
            h = el2.__xuBumped.h;
          }
          if (w < 36 || w > 120 || h < 36 || h > 120) continue;
          if (!el2.__xuBumped) {
            if (window.innerHeight - r.bottom > 48) continue;
            if (window.innerWidth - r.right > 48) continue;
            el2.__xuBumped = { w, h };
          }
          el2.style.setProperty("bottom", lift + "px", "important");
          el2.style.setProperty("visibility", modalOpen ? "hidden" : "visible", "important");
        }
      } catch (e) {
      }
    }
    function teardownIfForeign(id) {
      if (id) {
        trace("skin:foreign-reload", { from: designId, to: id });
        window.location.reload();
        return;
      }
      ["xu-steps", "xu-bar", "xu-lookbook", "xu-style", "xu-welcome", "xu-w-scrim"].forEach(function(x) {
        var n = document.getElementById(x);
        if (n && n.parentNode) n.parentNode.removeChild(n);
      });
    }
    if (window.XeistCore && XeistCore.every) {
      XeistCore.every("xu-uniform-skin", 900, tick, { runHidden: true });
    } else {
      setInterval(tick, 900);
    }
  })();

  // src/uniform/31-uniform-roster.js
  (function() {
    "use strict";
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    function $(s, r) {
      return (r || document).querySelector(s);
    }
    function $all(s, r) {
      return Array.prototype.slice.call((r || document).querySelectorAll(s));
    }
    function el(tag, cls, html) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (html != null) e.innerHTML = html;
      return e;
    }
    function esc(s) {
      return String(s == null ? "" : s).replace(/[&<>"']/g, function(c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }
    function track(type, payload) {
      try {
        if (window.XeistTrack) window.XeistTrack(type, payload || {});
      } catch (e) {
      }
    }
    function kbInjectorOk(inj) {
      try {
        return !!(inj && inj.has && inj.has("KitService"));
      } catch (e) {
        return false;
      }
    }
    function getInjector() {
      try {
        if (window.XeistCore && XeistCore.getInjector) {
          var i = XeistCore.getInjector();
          if (kbInjectorOk(i)) return i;
        }
        if (!window.angular) return null;
        var host = $(".kb-customise-page") || $("#kb-app");
        var hi = host ? angular.element(host).injector() : null;
        if (kbInjectorOk(hi)) return hi;
        var bi = angular.element(document.body).injector();
        if (kbInjectorOk(bi)) return bi;
      } catch (e) {
      }
      return null;
    }
    var rosterScopeCache = null;
    function rosterScope() {
      if (rosterScopeCache && !rosterScopeCache.$$destroyed) return rosterScopeCache;
      rosterScopeCache = null;
      var td = $(".kb-field-teamdetails");
      if (!td || !window.angular) return null;
      var seed = td.querySelector(".kb-table-row") || td;
      var s = angular.element(seed).scope();
      while (s && typeof s.teams !== "function") s = s.$parent;
      if (s) {
        rosterScopeCache = s;
        return s;
      }
      var tab = $all("a[ng-click]", td).filter(function(a) {
        return /setEnterTeams/.test(a.getAttribute("ng-click") || "");
      })[0];
      var ts = tab && angular.element(tab).scope();
      while (ts && typeof ts.teams !== "function") ts = ts.$parent;
      if (ts) rosterScopeCache = ts;
      return ts || null;
    }
    function apply(fn) {
      var inj = getInjector();
      if (!inj) return false;
      try {
        inj.get("$rootScope").$apply(fn);
        return true;
      } catch (e) {
        return false;
      }
    }
    function sizeOptions() {
      var sel = $(".kb-field-teamdetails select");
      if (!sel) return [];
      return $all("option", sel).filter(function(o) {
        return o.value;
      }).map(function(o) {
        return { id: o.value, label: o.text.trim() };
      });
    }
    function normalize(s) {
      return String(s || "").toLowerCase().replace(/[^a-z0-9+]/g, "");
    }
    var ALIASES = {
      ys: "youthsmall",
      ym: "youthmedium",
      yl: "youthlarge",
      yxl: "youthxl",
      s: "menss",
      m: "mensm",
      l: "mensl",
      xl: "mensxl",
      xxl: "mens2xl",
      "2xl": "mens2xl",
      "3xl": "mens3xl",
      xxxl: "mens3xl",
      as: "menss",
      am: "mensm",
      al: "mensl",
      axl: "mensxl",
      ws: "womenss",
      wm: "womensm",
      wl: "womensl",
      wxl: "womensxl",
      w2xl: "womens2xl",
      w3xl: "womens3xl"
    };
    function matchSizeIn(raw, opts) {
      opts = opts || [];
      var n = normalize(raw);
      if (!n) return null;
      n = ALIASES[n] || n;
      for (var i = 0; i < opts.length; i++) if (normalize(opts[i].label) === n) return opts[i];
      for (var j = 0; j < opts.length; j++) if (normalize(opts[j].label).indexOf(n) !== -1) return opts[j];
      return null;
    }
    function matchSize(raw) {
      return matchSizeIn(raw, sizeOptions());
    }
    function units() {
      var s = rosterScope();
      var t = s && s.teams();
      return t && t[0] && t[0].units || [];
    }
    function minQty() {
      var w = window.XeistUniform;
      return w && w.design && w.design.minQty || 6;
    }
    function splitCells(line, delim) {
      var cells = [], cur = "", inQ = false;
      for (var i = 0; i < line.length; i++) {
        var ch = line.charAt(i);
        if (inQ) {
          if (ch === '"') {
            if (line.charAt(i + 1) === '"') {
              cur += '"';
              i++;
            } else inQ = false;
          } else cur += ch;
        } else if (ch === '"') inQ = true;
        else if (ch === delim) {
          cells.push(cur);
          cur = "";
        } else cur += ch;
      }
      cells.push(cur);
      return cells.map(function(c) {
        return c.trim();
      });
    }
    function looksLikeNumber(s) {
      return /^#?\d{1,2}$/.test(String(s || "").trim());
    }
    function parseRoster(text) {
      var lines = String(text || "").split(/\r?\n/).map(function(l) {
        return l.trim();
      }).filter(Boolean);
      var problems = [], out = [];
      if (!lines.length) return { rows: out, problems, headerSkipped: false, numberFirst: false };
      var nT = 0, nS = 0, nC = 0;
      lines.forEach(function(l) {
        if (l.indexOf("	") !== -1) nT++;
        if (l.indexOf(";") !== -1) nS++;
        if (l.indexOf(",") !== -1) nC++;
      });
      var delim = nT ? "	" : nS && nS >= nC ? ";" : ",";
      var split = lines.map(function(l) {
        var cells = splitCells(l, delim);
        if (cells.length === 1 && cells[0]) {
          var m = cells[0].match(/^(.*?)\s+#?(\d{1,2})(?:\s+(\S.*))?$/);
          if (m) cells = [m[1], m[2], m[3] || ""];
        }
        return cells;
      });
      var headerSkipped = false;
      if (split.length > 1 && /name|player|number|size|jersey|#/i.test(split[0].join(" ")) && !split[0].some(looksLikeNumber)) {
        split.shift();
        headerSkipped = true;
      }
      var numFirstVotes = 0, dataLines = 0;
      split.forEach(function(cells) {
        if (!cells.join("")) return;
        dataLines++;
        if (looksLikeNumber(cells[0]) && cells.length > 1 && !looksLikeNumber(cells[1])) numFirstVotes++;
      });
      var numberFirst = dataLines > 0 && numFirstVotes > dataLines / 2;
      split.forEach(function(cells, i) {
        var lineNo = i + 1 + (headerSkipped ? 1 : 0);
        if (!cells.join("")) return;
        var name, number, sizeRaw;
        if (numberFirst) {
          number = cells[0] || "";
          name = cells[1] || "";
          sizeRaw = cells[2] || "";
        } else {
          name = cells[0] || "";
          number = cells[1] || "";
          sizeRaw = cells[2] || "";
        }
        number = String(number).replace(/^#/, "").trim();
        var row = { name, number, sizeRaw };
        if (!row.name && !row.number) {
          problems.push("Line " + lineNo + ": no name or number — skipped");
          return;
        }
        out.push(row);
      });
      return { rows: out, problems, headerSkipped, numberFirst };
    }
    function planImport(existing, incomingCount, mode) {
      var filled = (existing || []).map(function(u) {
        return !!(String(u && u.name || "").trim() || String(u && u.number || "").trim() || u && u.size);
      });
      var filledCount = filled.filter(Boolean).length;
      var writes = [], i;
      if (mode === "replace") {
        for (i = 0; i < incomingCount; i++) writes.push(i);
        return {
          mode: "replace",
          writes,
          grow: Math.max(0, incomingCount - filled.length),
          added: incomingCount,
          replaced: filledCount,
          totalAfter: incomingCount
        };
      }
      var lastFilled = -1;
      for (i = 0; i < filled.length; i++) if (filled[i]) lastFilled = i;
      var start = lastFilled + 1;
      for (i = 0; i < incomingCount; i++) writes.push(start + i);
      return {
        mode: "append",
        writes,
        grow: Math.max(0, start + incomingCount - filled.length),
        added: incomingCount,
        replaced: 0,
        totalAfter: filledCount + incomingCount
      };
    }
    var rowlink = null;
    function rowlinkKey() {
      var w = window.XeistUniform;
      return w ? "xeist_rowlink_" + w.designId : null;
    }
    function loadRowlink() {
      if (rowlink) return rowlink;
      try {
        rowlink = JSON.parse(window.localStorage.getItem(rowlinkKey()) || "null");
      } catch (e) {
      }
      if (!Array.isArray(rowlink)) rowlink = [];
      return rowlink;
    }
    function saveRowlink() {
      try {
        window.localStorage.setItem(rowlinkKey(), JSON.stringify(rowlink || []));
      } catch (e) {
      }
    }
    function rowlinkSyncLength() {
      var n = units().length;
      var rl = loadRowlink();
      while (rl.length < n) rl.push(null);
      if (rl.length > n) rl.length = n;
    }
    function rowlinkSet(idx, id) {
      var rl = loadRowlink();
      rl[idx] = id || null;
      saveRowlink();
    }
    function rowlinkSplice(idx) {
      var rl = loadRowlink();
      if (idx >= 0 && idx < rl.length) {
        rl.splice(idx, 1);
        saveRowlink();
      }
    }
    var lastUndo = null;
    function setRosterLength(s, target, allowShrink) {
      apply(function() {
        var guard = 400;
        while (units().length < target && guard--) {
          var b = units().length;
          s.addUnit(0);
          if (units().length === b) break;
        }
      });
      if (!allowShrink) return;
      var floor = Math.max(target, minQty());
      if (units().length > floor && s.removeUnit) {
        apply(function() {
          var guard = 400;
          while (units().length > floor && guard--) {
            var b = units().length;
            try {
              s.removeUnit(0, units().length - 1);
            } catch (e) {
              break;
            }
            if (units().length === b) break;
          }
        });
      }
    }
    function importRoster(rows, mode, done) {
      var s = rosterScope();
      if (!s) {
        if (done) done(null);
        return;
      }
      apply(function() {
        if (s.setEnterTeams) s.setEnterTeams(true);
      });
      var waited = 0;
      (function waitSizes() {
        if (sizeOptions().length || waited > 8e3) {
          run();
          return;
        }
        waited += 400;
        setTimeout(waitSizes, 400);
      })();
      function run() {
        var snapshot = units().map(function(u) {
          return { name: u.name, number: u.number, size: u.size };
        });
        var plan = planImport(snapshot, rows.length, mode);
        var needLen = rows.length ? plan.writes[rows.length - 1] + 1 : units().length;
        setRosterLength(s, mode === "replace" ? Math.max(rows.length, 1) : needLen, mode === "replace");
        apply(function() {
          var us = units();
          if (mode === "replace") {
            us.forEach(function(u) {
              u.name = "";
              u.number = "";
              u.size = null;
            });
          }
          rows.forEach(function(row, i) {
            var u = us[plan.writes[i]];
            if (!u) return;
            u.name = row.name;
            u.number = row.number;
            var mz = row.size || (row.sizeRaw ? matchSize(row.sizeRaw) : null);
            if (mz) u.size = mz.id || mz;
          });
        });
        var us2 = units(), written = 0;
        rows.forEach(function(row, i) {
          var u = us2[plan.writes[i]];
          if (u && String(u.name || "") === String(row.name || "") && String(u.number || "") === String(row.number || "")) written++;
        });
        if (mode === "replace") {
          rowlink = [];
        }
        rowlinkSyncLength();
        rows.forEach(function(row, i) {
          rowlinkSet(plan.writes[i], row.xuid || null);
        });
        lastUndo = snapshot;
        track("uniform_roster_import", { rows: rows.length, imported: written, mode });
        if (done) done({ written, plan });
      }
    }
    function undoImport(done) {
      var snap = lastUndo;
      lastUndo = null;
      var s = rosterScope();
      if (!snap || !s) {
        if (done) done(false);
        return;
      }
      setRosterLength(s, Math.max(snap.length, 1), true);
      apply(function() {
        var us = units();
        us.forEach(function(u, i) {
          var v = snap[i] || { name: "", number: "", size: null };
          u.name = v.name;
          u.number = v.number;
          u.size = v.size;
        });
      });
      track("uniform_roster_undo", {});
      if (done) done(true);
    }
    window.XeistRosterImport = { parse: parseRoster, plan: planImport };
    var undoToastTimer = null;
    function showUndoToast(label, onUndo) {
      var t = document.getElementById("xr-undo-toast");
      if (t && t.parentNode) t.parentNode.removeChild(t);
      t = el("div", "xr-undo-toast", "");
      t.id = "xr-undo-toast";
      var sp = document.createElement("span");
      sp.textContent = label;
      var b = document.createElement("button");
      b.type = "button";
      b.id = "xr-undo-del";
      b.textContent = "Undo";
      t.appendChild(sp);
      t.appendChild(b);
      document.body.appendChild(t);
      b.addEventListener("click", function() {
        if (t.parentNode) t.parentNode.removeChild(t);
        onUndo();
      });
      if (undoToastTimer) clearTimeout(undoToastTimer);
      undoToastTimer = setTimeout(function() {
        if (t.parentNode) t.parentNode.removeChild(t);
      }, 6e3);
    }
    document.addEventListener("click", function(e) {
      var a = e.target && e.target.closest ? e.target.closest(".kb-unit-remove a, .kb-unit-remove") : null;
      if (!a) return;
      var tr = a.closest ? a.closest("tr") : null;
      var table = a.closest ? a.closest(".kb-units-table") : null;
      if (!tr || !table) return;
      var rows = table.querySelectorAll("tbody tr");
      var idx = Array.prototype.indexOf.call(rows, tr);
      rosterScopeCache = null;
      var us = units();
      var u = us[idx];
      if (!u) return;
      var snap = { name: u.name, number: u.number, size: u.size, xuid: loadRowlink()[idx] || null };
      if (!(String(snap.name || "").trim() || String(snap.number || "").trim() || snap.size)) return;
      rowlinkSplice(idx);
      setTimeout(function() {
        showUndoToast((String(snap.name || "").trim() || "Player") + " removed", function() {
          rosterScopeCache = null;
          var sc = rosterScope();
          if (!sc) return;
          apply(function() {
            sc.addUnit(0);
            var us2 = units();
            var last = us2[us2.length - 1];
            if (last) {
              last.name = snap.name;
              last.number = snap.number;
              last.size = snap.size;
            }
          });
          rowlinkSyncLength();
          rowlinkSet(units().length - 1, snap.xuid);
          track("uniform_row_undo", {});
        });
      }, 150);
    }, true);
    var qaEditIdx = null;
    var qaWantFocus = 0;
    var qaListSig = null;
    function isMobileQA() {
      try {
        return window.matchMedia && matchMedia("(max-width:749px)").matches;
      } catch (e) {
        return false;
      }
    }
    function qaSizeLabelMap() {
      var m = {};
      sizeOptions().forEach(function(o) {
        m[o.id] = o.label;
      });
      return m;
    }
    function qaRowFilled(u) {
      return !!(String(u.name || "").trim() || String(u.number || "").trim() || u.size);
    }
    function mountQuickAdd(card) {
      var host = $("#xm-qa", card);
      if (!host) return;
      if (!isMobileQA()) {
        document.body.classList.remove("xm-on");
        host.hidden = true;
        return;
      }
      document.body.classList.add("xm-on");
      host.hidden = false;
      host.innerHTML = '<div id="xm-list"></div><div class="xm-form"><span class="xm-lab" id="xm-form-title">Add a player</span><input id="xm-name" class="xm-in" type="text" autocomplete="off" autocapitalize="words" placeholder="Player name"><div class="xm-row2"><input id="xm-num" class="xm-in xm-numin" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="2" placeholder="No."><select id="xm-size" class="xm-in"><option value="">Size…</option></select></div><button type="button" id="xm-add" class="xu-cta xm-add">Add player</button><button type="button" id="xm-cancel" class="xu-more-btn xm-cancel" hidden>Cancel editing</button><p id="xm-count" class="xm-count" aria-live="polite"></p></div>';
      qaEditIdx = null;
      qaListSig = null;
      qaFillSizes();
      $("#xm-add", host).addEventListener("click", qaSubmit);
      $("#xm-cancel", host).addEventListener("click", function() {
        qaSetMode(null);
      });
      ["xm-name", "xm-num"].forEach(function(id) {
        $("#" + id, host).addEventListener("keydown", function(e) {
          if (e.key === "Enter") {
            e.preventDefault();
            qaSubmit();
          }
        });
      });
      renderQuickList();
      if (Date.now() - qaWantFocus < 2500) {
        var nm = $("#xm-name", host);
        if (nm) setTimeout(function() {
          try {
            nm.focus();
          } catch (e) {
          }
        }, 60);
      }
    }
    function qaFillSizes() {
      var sel = $("#xm-size");
      if (!sel) return;
      var opts = sizeOptions();
      if (!opts.length || sel.options.length > 1) return;
      opts.forEach(function(o) {
        var op = document.createElement("option");
        op.value = o.id;
        op.textContent = o.label;
        sel.appendChild(op);
      });
    }
    function qaSetMode(idx) {
      qaEditIdx = idx;
      var name = $("#xm-name"), num = $("#xm-num"), size = $("#xm-size");
      var add = $("#xm-add"), cancel = $("#xm-cancel"), title = $("#xm-form-title");
      if (!name || !add) return;
      if (idx == null) {
        name.value = "";
        num.value = "";
        if (size) size.value = "";
        add.textContent = "Add player";
        title.textContent = "Add a player";
        cancel.hidden = true;
      } else {
        var u = units()[idx] || {};
        name.value = String(u.name || "");
        num.value = String(u.number || "");
        if (size) size.value = u.size || "";
        add.textContent = "Save changes";
        title.textContent = "Edit player — " + (String(u.name || "").trim() || "player");
        cancel.hidden = false;
        var form = name.closest ? name.closest(".xm-form") : null;
        if (form) {
          var vh = window.visualViewport && window.visualViewport.height || window.innerHeight;
          var y = form.getBoundingClientRect().top + (window.pageYOffset || 0) - Math.max(80, Math.round(vh * 0.16));
          try {
            window.scrollTo({ top: y, behavior: "smooth" });
          } catch (e) {
            window.scrollTo(0, y);
          }
          form.classList.remove("xm-form-flash");
          void form.offsetWidth;
          form.classList.add("xm-form-flash");
          setTimeout(function() {
            form.classList.remove("xm-form-flash");
          }, 1500);
          setTimeout(function() {
            var vh2 = window.visualViewport && window.visualViewport.height || window.innerHeight;
            var top2 = form.getBoundingClientRect().top;
            if (top2 < 60 || top2 > vh2 * 0.55) {
              var y2 = top2 + (window.pageYOffset || 0) - Math.max(80, Math.round(vh2 * 0.16));
              try {
                window.scrollTo({ top: y2, behavior: "smooth" });
              } catch (e) {
              }
            }
          }, 600);
        }
        try {
          name.focus({ preventScroll: true });
        } catch (e) {
          try {
            name.focus();
          } catch (e2) {
          }
        }
      }
      renderQuickList();
    }
    function qaSubmit() {
      var name = ($("#xm-name") || {}).value || "";
      var num = (($("#xm-num") || {}).value || "").replace(/[^0-9]/g, "").slice(0, 2);
      var sizeId = ($("#xm-size") || {}).value || "";
      name = name.replace(/\s+/g, " ").trim();
      if (!name && !num) {
        var nm = $("#xm-name");
        if (nm) {
          nm.focus();
          nm.classList.add("xm-in-err");
          setTimeout(function() {
            nm.classList.remove("xm-in-err");
          }, 900);
        }
        return;
      }
      rosterScopeCache = null;
      var s = rosterScope();
      if (!s) return;
      var target = qaEditIdx;
      apply(function() {
        if (s.setEnterTeams) s.setEnterTeams(true);
        var us = units();
        if (target == null) {
          var last = -1;
          for (var i = 0; i < us.length; i++) if (qaRowFilled(us[i])) last = i;
          target = last + 1;
          if (target >= us.length) {
            s.addUnit(0);
            us = units();
            target = us.length - 1;
          }
        }
        var u = us[target];
        if (!u) {
          target = null;
          return;
        }
        u.name = name;
        u.number = num;
        if (sizeId) u.size = sizeId;
      });
      if (target == null) return;
      track(qaEditIdx == null ? "uniform_qa_add" : "uniform_qa_edit", { design: (window.XeistUniform || {}).designId });
      var wasEdit = qaEditIdx != null;
      qaWantFocus = Date.now();
      qaSetMode(null);
      var nm2 = $("#xm-name");
      if (!wasEdit && nm2) {
        try {
          nm2.focus();
        } catch (e) {
        }
      }
    }
    function qaDelete(idx) {
      rosterScopeCache = null;
      var s = rosterScope();
      var u = units()[idx];
      if (!s || !u || !qaRowFilled(u)) return;
      var snap = { name: u.name, number: u.number, size: u.size, xuid: loadRowlink()[idx] || null };
      apply(function() {
        try {
          s.removeUnit(0, idx);
        } catch (e) {
        }
      });
      rowlinkSplice(idx);
      if (qaEditIdx === idx) qaSetMode(null);
      renderQuickList();
      showUndoToast((String(snap.name || "").trim() || "Player") + " removed", function() {
        rosterScopeCache = null;
        var s2 = rosterScope();
        if (!s2) return;
        apply(function() {
          s2.addUnit(0);
          var us2 = units();
          var lastU = us2[us2.length - 1];
          if (lastU) {
            lastU.name = snap.name;
            lastU.number = snap.number;
            lastU.size = snap.size;
          }
        });
        rowlinkSyncLength();
        rowlinkSet(units().length - 1, snap.xuid);
        renderQuickList();
        track("uniform_row_undo", {});
      });
    }
    var wasOnRosterStep = false;
    function pkgApprovalPending() {
      try {
        var f = JSON.parse(window.localStorage.getItem("xeist_pkgflow") || "null");
        return !!(f && f.stage === "shorts" && String(f.to) === String((window.XeistUniform || {}).designId) && Date.now() - (f.ts || 0) < 36e5);
      } catch (e) {
        return false;
      }
    }
    function scrollRosterIntoView() {
      if (pkgApprovalPending()) return;
      var tries = 0;
      (function attempt() {
        var card = $("#xr-card");
        if (!card || !card.offsetHeight) {
          if (tries++ < 12) setTimeout(attempt, 150);
          return;
        }
        try {
          card.scrollIntoView({ block: "start", behavior: "smooth" });
        } catch (e) {
          try {
            card.scrollIntoView();
          } catch (e2) {
          }
        }
      })();
    }
    var NAME_KEYS = ["name-text", "add-names"];
    function namesKey() {
      var w = window.XeistUniform;
      return w ? "xeist_names_" + w.designId : null;
    }
    function namesCapKey() {
      var w = window.XeistUniform;
      return w ? "xeist_names_cap_" + w.designId : null;
    }
    function namesOn() {
      try {
        return window.localStorage.getItem(namesKey()) === "1";
      } catch (e) {
        return false;
      }
    }
    function nameItem() {
      try {
        var es = window.XeistCore && XeistCore.getES && XeistCore.getES();
        var m = es && es.getModel && es.getModel();
        return (m || []).filter(function(it) {
          return it && NAME_KEYS.indexOf(it.placementKey) !== -1;
        })[0] || null;
      } catch (e) {
        return null;
      }
    }
    function rememberNamesKey(it) {
      var k = it && NAME_KEYS.indexOf(it.placementKey) !== -1 ? it.placementKey : "name-text";
      try {
        window.localStorage.setItem(namesCapKey(), k);
      } catch (e) {
      }
    }
    function namePlacementKey() {
      try {
        var v = window.localStorage.getItem(namesCapKey());
        return v && NAME_KEYS.indexOf(v) !== -1 ? v : "name-text";
      } catch (e) {
        return "name-text";
      }
    }
    function namesCapable() {
      var it = nameItem();
      if (it) {
        rememberNamesKey(it);
        return true;
      }
      try {
        return !!window.localStorage.getItem(namesCapKey());
      } catch (e) {
        return false;
      }
    }
    function namesSet(on) {
      try {
        window.localStorage.setItem(namesKey(), on ? "1" : "0");
      } catch (e) {
      }
      track("uniform_names_opt", { on: !!on, design: (window.XeistUniform || {}).designId });
      enforceNames();
    }
    function enforceNames() {
      if (!window.XeistUniform) return;
      var es = window.XeistCore && XeistCore.getES && XeistCore.getES();
      if (!es || !es.getModel) return;
      var m;
      try {
        m = es.getModel();
      } catch (e) {
        return;
      }
      if (!m || !m.length) return;
      var it = nameItem();
      var want = namesOn();
      if (it && !want) {
        rememberNamesKey(it);
        apply(function() {
          try {
            es.deleteItem(it);
          } catch (e) {
          }
        });
      } else if (!it && want && namesCapable()) {
        var key = namePlacementKey();
        apply(function() {
          try {
            es.addDefaultText(key);
          } catch (e) {
          }
        });
      }
    }
    function renderNamesRow() {
      var card = $("#xr-card");
      if (!card) return;
      var row = $("#xn-row");
      if (!namesCapable()) {
        if (row && row.parentNode) row.parentNode.removeChild(row);
        return;
      }
      if (!row || row.parentNode !== card) {
        if (row && row.parentNode) row.parentNode.removeChild(row);
        row = el("div", "xn-row", "");
        row.id = "xn-row";
        row.innerHTML = '<label class="xn-opt"><input type="checkbox" id="xn-names"><span>Add player last names to the jerseys <strong>' + money(5) + ' more per player</strong></span></label><span class="xn-sub">Numbers and team name printing are always included.</span>';
        card.appendChild(row);
        $("#xn-names", row).addEventListener("change", function() {
          namesSet(this.checked);
        });
      }
      var cb = $("#xn-names");
      if (cb && cb.checked !== namesOn() && document.activeElement !== cb) cb.checked = namesOn();
    }
    try {
      window.XeistNamesOpt = { capable: namesCapable, on: namesOn, set: namesSet };
    } catch (e) {
    }
    function renderQuickList() {
      var list = $("#xm-list");
      if (!list || !document.body.classList.contains("xm-on")) return;
      qaFillSizes();
      var labels = qaSizeLabelMap();
      var us = units();
      var items = [];
      us.forEach(function(u, i) {
        if (qaRowFilled(u)) items.push({ i, u });
      });
      var a = auditRoster();
      var minN = minQty();
      var sig = JSON.stringify(items.map(function(x) {
        return [x.i, x.u.name, x.u.number, x.u.size];
      })) + ":" + qaEditIdx + ":" + (a ? a.count : 0);
      if (sig === qaListSig) return;
      qaListSig = sig;
      list.innerHTML = items.map(function(x) {
        var meta = [];
        if (String(x.u.number || "").trim()) meta.push("#" + x.u.number);
        meta.push(x.u.size ? labels[x.u.size] || "sized" : "no size");
        return '<div class="xm-rowwrap' + (qaEditIdx === x.i ? " xm-row-editing" : "") + '"><button type="button" class="xm-row" data-i="' + x.i + '"><span class="xm-row-name">' + esc(String(x.u.name || "").trim() || "(no name)") + '</span><span class="xm-row-meta">' + esc(meta.join(" · ")) + '</span></button><button type="button" class="xm-del" data-i="' + x.i + '" aria-label="Remove ' + esc(String(x.u.name || "player")) + '">×</button></div>';
      }).join("");
      $all(".xm-row", list).forEach(function(b) {
        b.addEventListener("click", function() {
          qaSetMode(parseInt(b.getAttribute("data-i"), 10));
        });
      });
      $all(".xm-del", list).forEach(function(b) {
        b.addEventListener("click", function() {
          qaDelete(parseInt(b.getAttribute("data-i"), 10));
        });
      });
      var cnt = $("#xm-count");
      if (cnt) {
        var n = a ? a.count : items.length;
        cnt.textContent = n ? n + " player" + (n === 1 ? "" : "s") + (n < minN ? " · minimum " + minN : "") : "No players yet — minimum " + minN + " to order.";
      }
    }
    function rowsLabel(rows) {
      return (rows.length === 1 ? "row " : "rows ") + rows.map(function(r) {
        return r + 1;
      }).join(", ");
    }
    function designPlaceholderBlockers() {
      var out = [];
      try {
        var es = window.XeistCore && XeistCore.getES && XeistCore.getES();
        var m = es && es.getModel && es.getModel();
        (m || []).forEach(function(it) {
          if (it && it.placementKey === "add-teamname" && /^TEAM\s*NAME$/i.test(String(it.text || "").trim())) {
            out.push({ msg: "The jersey still says “TEAM NAME” — set your team name", design: true, rows: [] });
          }
        });
      } catch (e) {
      }
      return out;
    }
    function auditRoster() {
      var us = units(), seenExact = {}, seenNorm = {}, sized = 0, named = 0, byLabel = {};
      var blockers = [], cautions = [];
      var noName = [], noSize = [], noNum = [], badNum = [], longName = [];
      var youthRows = [], adultRows = 0;
      var opts = {};
      sizeOptions().forEach(function(o) {
        opts[o.id] = o.label;
      });
      us.forEach(function(u, i) {
        var num = String(u.number == null ? "" : u.number).trim();
        var name = String(u.name == null ? "" : u.name).trim();
        var isActive = !!(name || num || u.size);
        if (name) named++;
        if (u.size) {
          sized++;
          var lb = opts[u.size] || u.size;
          byLabel[lb] = (byLabel[lb] || 0) + 1;
          if (/^youth/i.test(String(lb))) youthRows.push(i);
          else adultRows++;
        }
        if (num) {
          if (!/^\d{1,2}$/.test(num)) {
            badNum.push(i);
          } else if (seenExact[num] != null) {
            blockers.push({ msg: "Duplicate number " + num + " (rows " + (seenExact[num] + 1) + " & " + (i + 1) + ")", rows: [seenExact[num], i] });
          } else {
            var norm = String(parseInt(num, 10));
            if (seenNorm[norm] != null && String(us[seenNorm[norm]].number).trim() !== num) {
              blockers.push({ msg: "Numbers " + String(us[seenNorm[norm]].number).trim() + " and " + num + " print as the same number (rows " + (seenNorm[norm] + 1) + " & " + (i + 1) + ")", rows: [seenNorm[norm], i] });
            }
            seenExact[num] = i;
            if (seenNorm[norm] == null) seenNorm[norm] = i;
          }
        }
        if (isActive) {
          if (!name) noName.push(i);
          if (!u.size) noSize.push(i);
          if (!num) noNum.push(i);
          if (name.length > 15) longName.push(i);
        }
      });
      var active = us.filter(function(u) {
        return String(u.name || "").trim() || String(u.number || "").trim() || u.size;
      }).length;
      if (active) {
        if (noName.length) blockers.push({ msg: noName.length + " player" + (noName.length > 1 ? "s" : "") + " missing a name (" + rowsLabel(noName) + ")", rows: noName });
        if (noNum.length) blockers.push({ msg: noNum.length + " player" + (noNum.length > 1 ? "s" : "") + " missing a jersey number (" + rowsLabel(noNum) + ")", rows: noNum });
        if (noSize.length) blockers.push({ msg: noSize.length + " player" + (noSize.length > 1 ? "s" : "") + " missing a size (" + rowsLabel(noSize) + ")", rows: noSize });
        if (badNum.length) blockers.push({ msg: "Jersey numbers must be 0–99 (" + rowsLabel(badNum) + ")", rows: badNum });
      }
      if (active > 0 && active < minQty()) {
        blockers.push({ msg: "Minimum order is " + minQty() + " — add " + (minQty() - active) + " more player" + (minQty() - active > 1 ? "s" : ""), rows: [] });
      }
      blockers = blockers.concat(designPlaceholderBlockers());
      if (longName.length) {
        cautions.push({ msg: "Long name" + (longName.length > 1 ? "s" : "") + " (" + rowsLabel(longName) + ") may print smaller to fit — our design team confirms before production", rows: longName });
      }
      if (youthRows.length === 1 && adultRows >= 4) {
        cautions.push({ msg: "1 Youth size among " + adultRows + " adult sizes (" + rowsLabel(youthRows) + ") — double-check that’s right", rows: youthRows });
      }
      var warnings = blockers.map(function(b) {
        return b.msg;
      }).concat(cautions.map(function(c) {
        return c.msg;
      }));
      return { count: active, total: us.length, warnings, blockers, cautions, sizes: byLabel };
    }
    function hardenNumberInputs() {
      $all(".kb-units-table tr.kb-table-row td:nth-child(2) input").forEach(function(i) {
        if (i.getAttribute("inputmode") !== "numeric") {
          i.setAttribute("inputmode", "numeric");
          i.setAttribute("pattern", "[0-9]*");
          try {
            i.maxLength = 2;
          } catch (e) {
          }
        }
      });
    }
    function readTiers() {
      var rows = $all(".kb-price-tiers-table tr");
      var tiers = [];
      rows.forEach(function(r) {
        var m = (r.textContent || "").replace(/\s+/g, " ").match(/(\d+)\s*[-–]\s*(\d+)\s*\$?([\d.,]+)|(\d+)\s*\+\s*\$?([\d.,]+)/);
        if (!m) return;
        if (m[1]) tiers.push({ min: +m[1], max: +m[2], price: parseFloat(m[3].replace(/,/g, "")) });
        else tiers.push({ min: +m[4], max: Infinity, price: parseFloat(m[5].replace(/,/g, "")) });
      });
      return tiers;
    }
    var apsCache = null;
    function kbAggregate() {
      if (apsCache && !apsCache.$$destroyed) return apsCache;
      try {
        var seed = document.querySelector(".kb-price-tiers-table") || document.querySelector(".kb-customise-page");
        var s = seed && window.angular ? angular.element(seed).scope() : null;
        while (s && !s.AggregatePricingService) s = s.$parent;
        if (s && s.AggregatePricingService) {
          apsCache = s.AggregatePricingService;
          return apsCache;
        }
      } catch (e) {
      }
      return null;
    }
    function apsVal(x) {
      try {
        return typeof x === "function" ? x() : x;
      } catch (e) {
        return null;
      }
    }
    function addOnPerUnit() {
      var svc = kbAggregate();
      if (!svc) return 0;
      var unit = apsVal(svc.unitPrice), base = apsVal(svc.currentUnitPrice);
      if (typeof unit === "number" && typeof base === "number" && unit >= base) {
        return Math.round((unit - base) * 100) / 100;
      }
      var bd = apsVal(svc.priceBreakdown) || [], sum = 0;
      bd.forEach(function(r) {
        if (r && typeof r.unitPrice === "number") sum += r.unitPrice;
      });
      return Math.round(sum * 100) / 100;
    }
    function addOnLabel() {
      var svc = kbAggregate();
      if (!svc) return "";
      var bd = apsVal(svc.priceBreakdown) || [];
      var seen = {};
      var parts = bd.filter(function(r) {
        return r && r.unitPrice;
      }).map(function(r) {
        return String(r.name || "printing").replace(/:.*$/, "").replace(/^add\s+/i, "").toLowerCase().trim();
      }).filter(function(p) {
        if (seen[p]) return false;
        seen[p] = 1;
        return true;
      });
      return parts.join(" + ");
    }
    function priceInfo(qty) {
      var tiers = readTiers();
      if (!tiers.length || !qty) return null;
      var cur = null, next = null;
      for (var i = 0; i < tiers.length; i++) {
        if (qty >= tiers[i].min && qty <= tiers[i].max) cur = tiers[i];
        if (tiers[i].min > qty && (!next || tiers[i].min < next.min)) next = tiers[i];
      }
      if (!cur && qty < tiers[0].min) {
        cur = tiers[0];
        next = tiers[1] || null;
      }
      if (!cur) return null;
      var add = addOnPerUnit();
      var ladNow = cadLadder(qty), ladNext = next ? cadLadder(next.min) : null;
      var base = ladNow ? ladNow.base : cur.price;
      var nextBase = next ? ladNext ? ladNext.base : next.price : null;
      var unit = Math.round((base + add) * 100) / 100;
      return {
        unit,
        // all-in per player (what the cart will charge)
        base,
        // tier base only (sheet CAD on a ladder line)
        addOn: add,
        // per-player print add-ons
        addOnLabel: add ? addOnLabel() : "",
        total: Math.round(unit * qty * 100) / 100,
        ladder: !!ladNow,
        // true when the base came from the Canadian sheet
        next: next ? { min: next.min, max: next.max, price: Math.round((nextBase + add) * 100) / 100, base: nextBase } : null
      };
    }
    function cadLadder(qty) {
      try {
        return typeof window.XeistCadLadder === "function" ? window.XeistCadLadder(qty) : null;
      } catch (e) {
        return null;
      }
    }
    function M() {
      return window.XeistMoney || null;
    }
    function money(n) {
      var m = M();
      return m ? m.kbUnit(n) : "$" + n.toFixed(2);
    }
    function moneyLine(n) {
      var m = M();
      return m ? m.kbLine(n) : "$" + n.toFixed(2);
    }
    function moneyPer(unit, qty) {
      var m = M();
      return m ? m.kbPer(unit, qty) : "$" + unit.toFixed(2);
    }
    function moneyConverts() {
      var m = M();
      return !!(m && m.converts());
    }
    var currentMethod = "";
    try {
      var navE = performance.getEntriesByType("navigation")[0];
      var navT = navE ? String(navE.type) : "";
      if (navT === "reload" || navT === "back_forward") {
        var hid31 = (window.location.hash.match(/\/customise\/(\d+)/i) || [])[1];
        var savedM = hid31 ? JSON.parse(sessionStorage.getItem("xr_method_" + hid31) || "null") : null;
        if (savedM && savedM.m && Date.now() - (savedM.ts || 0) < 10 * 60 * 1e3) currentMethod = String(savedM.m);
      }
    } catch (e) {
    }
    function getMethod() {
      return currentMethod;
    }
    function setMethod(m) {
      currentMethod = m || "";
      track("uniform_roster_method", { method: m || "chooser" });
      try {
        var hidM = (window.location.hash.match(/\/customise\/(\d+)/i) || [])[1];
        if (hidM) sessionStorage.setItem("xr_method_" + hidM, JSON.stringify({ m: m || "", ts: Date.now() }));
      } catch (eM) {
      }
      if (m) {
        try {
          if (window.XeistUniformKit && XeistUniformKit.pkgflowClear) XeistUniformKit.pkgflowClear();
        } catch (e) {
        }
      }
      renderState(true);
    }
    function hasCollectLink() {
      try {
        var w = window.XeistUniform;
        var c = JSON.parse(window.localStorage.getItem("xeist_collect_" + w.designId) || "null");
        return !!(c && c.token);
      } catch (e) {
        return false;
      }
    }
    var PKG_ITEMS = [
      // W1/T0.4 (2026-08-18): def false — add-ons are opt-in (audit V2).
      // 2026-08-20: shorts label was still $24.99 while PKG_PRICES charged
      // $34.99 (W2 sheet) — label aligned to the charged price.
      { key: "shorts", label: "Matching shorts", rowTitle: "Add matching shorts", desc: "Designed to coordinate with your team jersey.", price: "+$34.99 / player", def: false },
      { key: "compression", label: "Performance compression shirt", rowTitle: "Add performance compression shirt", desc: "A clean base layer for training and game day.", price: "+$29.99 / player", def: false }
    ];
    function shadeHex(hex, f) {
      try {
        let c = function(v) {
          return Math.max(0, Math.min(255, Math.round(v + (f < 0 ? v * f : (255 - v) * f))));
        };
        var h = String(hex).replace("#", "");
        if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
        var r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
        return "rgb(" + c(r) + "," + c(g) + "," + c(b) + ")";
      } catch (e) {
        return hex || "#17171a";
      }
    }
    function svgShorts(c1, c2, px) {
      var band = shadeHex(c1, -0.35);
      return '<svg viewBox="0 0 120 112" width="' + px + '" height="' + px + '" role="img" aria-label="Matching shorts preview in your team colors"><path d="M20 22 L100 22 L112 94 Q112 98 108 98 L72 98 Q69 98 68 95 L60 62 L52 95 Q51 98 48 98 L12 98 Q8 98 8 94 Z" fill="' + esc(c1) + '"/><path d="M20 22 L30 22 L18 98 L12 98 Q8 98 8 94 Z" fill="' + esc(c2) + '"/><path d="M90 22 L100 22 L112 94 Q112 98 108 98 L102 98 Z" fill="' + esc(c2) + '"/><rect x="18" y="12" width="84" height="12" rx="3" fill="' + band + '"/><rect x="52" y="15" width="16" height="6" rx="3" fill="' + esc(c2) + '"/><path d="M60 62 L52 95 Q51 98 48 98 L44 98 L56 52 Z" fill="rgba(0,0,0,.08)"/></svg>';
    }
    function svgCompression(px) {
      return '<svg viewBox="0 0 120 120" width="' + px + '" height="' + px + '" role="img" aria-label="Performance compression shirt"><path d="M44 16 Q60 24 76 16 L94 24 Q100 27 101 34 L106 62 Q106 66 102 67 L92 70 Q89 70 88 66 L86 58 L86 104 Q86 108 82 108 L38 108 Q34 108 34 104 L34 58 L32 66 Q31 70 28 70 L18 67 Q14 66 14 62 L19 34 Q20 27 26 24 Z" fill="#1b1b1e"/><path d="M44 16 Q60 24 76 16 L76 20 Q60 28 44 20 Z" fill="#101012"/><path d="M34 58 L34 104 Q34 108 38 108 L44 108 L44 44 Z" fill="rgba(255,255,255,.05)"/><circle cx="72" cy="34" r="1.6" fill="#8a8a8e"/><circle cx="77" cy="34" r="1.6" fill="#8a8a8e"/><circle cx="72" cy="39" r="1.6" fill="#8a8a8e"/><circle cx="77" cy="39" r="1.6" fill="#8a8a8e"/></svg>';
    }
    function pkgKey() {
      var w = window.XeistUniform;
      return w ? "xeist_pkg_" + w.designId : null;
    }
    function pkgAvailable() {
      try {
        var w = window.XeistUniform;
        return !!(w && window.XeistUniformKit && window.XeistUniformKit.shortsFor(w.designId));
      } catch (e) {
        return false;
      }
    }
    function getPkg() {
      try {
        return JSON.parse(window.localStorage.getItem(pkgKey()) || "null");
      } catch (e) {
        return null;
      }
    }
    function savePkg(pkg) {
      try {
        pkg.ts = Date.now();
        window.localStorage.setItem(pkgKey(), JSON.stringify(pkg));
      } catch (e) {
      }
    }
    function shortsInKit() {
      try {
        var pkg = getPkg();
        return !!(pkg && pkg.shorts && pkg.shortsStatus === "approved");
      } catch (e) {
        return false;
      }
    }
    function kitInfo(count, includeShorts) {
      var info = priceInfo(count || 0);
      if (!info || !count) return null;
      var m = M();
      var lt = function(usd) {
        return m ? m.lineTotal(usd) : Math.round(usd * 100) / 100;
      };
      var inc = includeShorts == null ? shortsInKit() : !!includeShorts;
      var out = {
        count,
        code: m ? m.code() : "USD",
        converts: !!(m && m.converts()),
        jersey: { unit: info.unit, total: info.total, line: lt(info.total) },
        shorts: null,
        next: null
      };
      if (inc) {
        var su = pkgPrice("shorts");
        var st = Math.round(su * count * 100) / 100;
        out.shorts = { unit: su, total: st, line: lt(st) };
      }
      out.line = Math.round((out.jersey.line + (out.shorts ? out.shorts.line : 0)) * 100) / 100;
      out.perPlayer = Math.round(out.line / count * 100) / 100;
      if (info.next && isFinite(info.next.min)) {
        var nextUsd = null;
        if (out.shorts && typeof window.XeistSheetQuote === "function") {
          try {
            var nq = window.XeistSheetQuote(info.next.min);
            if (nq && nq.shorts && nq.unit != null) nextUsd = nq.unit + (info.addOn || 0);
          } catch (e) {
          }
        }
        if (nextUsd == null && !out.shorts) nextUsd = info.next.price;
        var curUsd = (info.unit || 0) + (out.shorts ? out.shorts.unit : 0);
        if (nextUsd != null && nextUsd < curUsd - 5e-3) out.next = { min: info.next.min, away: info.next.min - count, unitUsd: nextUsd };
      }
      return out;
    }
    function fmtLine(n) {
      var m = M();
      return m ? m.fmt(n) : "$" + n.toFixed(2);
    }
    var viewRoster = false;
    function tableVisible(m, count) {
      return viewRoster || m === "manual";
    }
    function syncTable(m, count) {
      var on = tableVisible(m, count);
      var b = document.body;
      if (on) b.className = b.className.replace(/\s*xr-hide-td/g, "");
      else if (b.className.indexOf("xr-hide-td") === -1) b.className += " xr-hide-td";
      if (on && !document.querySelector(".kb-field-teamdetails .kb-table-row")) {
        var sc = rosterScope();
        if (sc && sc.setEnterTeams) apply(function() {
          sc.setEnterTeams(true);
          if (sc.tryOpenFirstTeam) sc.tryOpenFirstTeam();
        });
      }
    }
    function buildCard() {
      if ($("#xr-card")) return;
      var td = $(".kb-field-teamdetails");
      if (!td || !td.parentNode) return;
      var card = el("section", "xu-card", "");
      card.id = "xr-card";
      td.parentNode.insertBefore(card, td);
      renderState(true);
    }
    var lastSig = null;
    function renderState(force) {
      var card = $("#xr-card");
      if (!card) return;
      var m = getMethod();
      var a = auditRoster();
      var count = a ? a.count : 0;
      syncTable(m, count);
      managePkgModal(!m && pkgAvailable() && (!pkgHandled || pkgEditRequested) && onRosterStep());
      var sig = m + ":" + (count > 0) + ":" + viewRoster;
      if (!force && sig === lastSig) return;
      lastSig = sig;
      lastSumHTML = lastWarnHTML = null;
      card.innerHTML = m ? methodHTML(m) : chooserHTML();
      bindState(card, m);
    }
    function onRosterStep() {
      var a = document.querySelector("#xu-steps .xu-step-active");
      return !!(a && a.getAttribute("data-step") === "roster");
    }
    var pkgHandled = false;
    var pkgEditRequested = false;
    var pkgSnap = null;
    function openPkgEditor() {
      pkgEditRequested = true;
      renderState(true);
    }
    try {
      window.XeistUniformPkg = { edit: openPkgEditor, get: function() {
        return getPkg();
      } };
    } catch (e) {
    }
    function pkgToast(title, sub) {
      var t = document.getElementById("xr-toast");
      if (!t) {
        t = document.createElement("div");
        t.id = "xr-toast";
        t.className = "xr-toast";
        document.body.appendChild(t);
      }
      t.innerHTML = "<strong>" + esc(title) + "</strong>" + (sub ? "<span>" + esc(sub) + "</span>" : "");
      t.className = "xr-toast xr-toast-on";
      setTimeout(function() {
        t.className = "xr-toast";
      }, 3600);
    }
    function jerseyBasePrice() {
      try {
        var tiers = readTiers();
        if (tiers.length) return tiers[0].price;
      } catch (e) {
      }
      try {
        var pf = (window.XeistUniform.design.priceFrom || "").replace(/[^0-9.]/g, "");
        return pf ? parseFloat(pf) : null;
      } catch (e) {
        return null;
      }
    }
    var PKG_PRICES = { shorts: 34.99, compression: 29.99 };
    function pkgPrice(key) {
      if (key === "shorts" && typeof window.XeistSheetQuote === "function") {
        var sq = window.XeistSheetQuote(0);
        if (sq && sq.shortsDelta != null) return sq.shortsDelta;
      }
      return PKG_PRICES[key];
    }
    function pkgPriceLabel(key) {
      return money(pkgPrice(key)) + " per player";
    }
    function managePkgModal(want) {
      var existing = document.getElementById("xp-modal");
      if (!want) {
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        document.body.classList.remove("xp-lock");
        return;
      }
      if (existing) return;
      var w = window.XeistUniform || {};
      var team = w.team && w.team.name ? w.team.name : "your team";
      var posters = window.XeistPosters || {};
      var jerseyImg = (posters[w.designId] || {}).img || "";
      var c1 = w.team && w.team.c1 || "#17171a";
      var c2 = w.team && w.team.c2 || shadeHex(c1, 0.55);
      var jerseyName = w.design && w.design.name ? w.design.name + " jersey" : "Jersey";
      var savedPkg = getPkg();
      var sel = {};
      PKG_ITEMS.forEach(function(it) {
        sel[it.key] = savedPkg ? !!savedPkg[it.key] : it.def;
      });
      var aud = auditRoster();
      var step = pkgEditRequested && aud && aud.count > 0 ? "warn" : "select";
      var wrap = document.createElement("div");
      wrap.id = "xp-modal";
      document.body.appendChild(wrap);
      document.body.classList.add("xp-lock");
      var restoreScrollTop = 0;
      function media(key, px) {
        if (key === "jersey") {
          if (pkgSnap) return '<span class="xp-thumb-img" style="width:' + px + "px;height:" + px + 'px"><img src="' + pkgSnap + '" alt="' + esc(jerseyName) + ' — your design"></span>';
          if (jerseyImg) return '<span class="xp-thumb-img" style="width:' + px + "px;height:" + px + 'px"><img src="' + esc(jerseyImg) + '" alt="' + esc(jerseyName) + '" loading="lazy"></span>';
          return '<span class="xp-thumb-img" style="width:' + px + "px;height:" + px + 'px" aria-hidden="true"></span>';
        }
        if (key === "shorts") return '<span class="xp-thumb-img" style="width:' + px + "px;height:" + px + 'px">' + svgShorts(c1, c2, Math.round(px * 0.78)) + "</span>";
        return '<span class="xp-thumb-img" style="width:' + px + "px;height:" + px + 'px">' + svgCompression(Math.round(px * 0.8)) + "</span>";
      }
      function close() {
        pkgHandled = true;
        pkgEditRequested = false;
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        document.body.classList.remove("xp-lock");
      }
      function shell(inner, ariaTitle) {
        wrap.innerHTML = '<div class="xp-scrim"></div><div class="xp-dialog" role="dialog" aria-modal="true" aria-label="' + esc(ariaTitle) + '"><button type="button" class="xp-close" id="xp-close" aria-label="Close">&times;</button>' + inner + "</div>";
        var dlg = wrap.querySelector(".xp-dialog");
        if (dlg) dlg.scrollTop = restoreScrollTop;
        restoreScrollTop = 0;
        $("#xp-close", wrap).addEventListener("click", close);
      }
      function liveSwap() {
        if (pkgSnap || !window.XeistUniformSnap) return;
        try {
          window.XeistUniformSnap(function(url) {
            if (!url) return;
            pkgSnap = url;
            if (!wrap.parentNode) return;
            var d = wrap.querySelector(".xp-dialog");
            if (d) restoreScrollTop = d.scrollTop;
            render();
          });
        } catch (e) {
        }
      }
      function renderSelect() {
        function rowHTML(it) {
          var on = sel[it.key];
          return '<div class="xp-row' + (on ? " xp-on" : "") + '" data-pkg="' + it.key + '" role="switch" tabindex="0" aria-checked="' + (on ? "true" : "false") + '" aria-label="' + esc(it.rowTitle) + '">' + media(it.key, 52).replace("xp-thumb-img", "xp-row-img") + '<span class="xp-info"><span class="xp-name">' + esc(it.rowTitle) + '</span><span class="xp-desc">' + esc(it.desc) + '</span></span><span class="xp-price">' + esc(pkgPriceLabel(it.key)) + '</span><span class="xp-toggle" aria-hidden="true"><span class="xp-knob"></span></span></div>';
        }
        var inner = '<div class="xp-head"><span class="xp-rec">Recommended</span><h3 class="xp-title">' + (w.team && w.team.name ? "Complete the " + esc(team.toUpperCase()) + " package" : "Complete your team package") + '</h3><p class="xp-sub">Select what every athlete should receive. Parents will size the full package in one submission.</p></div><p class="xp-eyebrow">Your team package</p><div class="xp-preview"><div class="xp-thumb xp-thumb-hero" data-prev="jersey">' + media("jersey", 126) + '<span class="xp-thumb-name">' + esc(jerseyName) + '</span><span class="xp-thumb-pill">Included</span></div><span class="xp-plus" aria-hidden="true">+</span><div class="xp-thumb' + (sel.shorts ? "" : " xp-thumb-off") + '" data-prev="shorts">' + media("shorts", 110) + '<span class="xp-thumb-name">Matching shorts</span><span class="xp-thumb-price">' + esc(pkgPriceLabel("shorts")) + '</span></div><span class="xp-plus" aria-hidden="true">+</span><div class="xp-thumb' + (sel.compression ? "" : " xp-thumb-off") + '" data-prev="compression">' + media("compression", 110) + '<span class="xp-thumb-name">Performance compression shirt</span><span class="xp-thumb-price">' + esc(pkgPriceLabel("compression")) + '</span></div></div><p class="xp-prevnote">Preview shown — final artwork is matched to your approved jersey before production.</p><div class="xp-value"><strong>One complete uniform. One parent submission.</strong><span>Parents size every selected item at the same time.</span></div>';
        PKG_ITEMS.forEach(function(it) {
          inner += rowHTML(it);
        });
        inner += '<button type="button" class="xp-continue" id="xp-preview-btn">Preview package</button><button type="button" class="xp-later" id="xp-later">No thanks, I’ll decide later</button>';
        shell(inner, "Build the " + team + " package");
        $all("[data-pkg]", wrap).forEach(function(rowEl) {
          function flip() {
            var k = rowEl.getAttribute("data-pkg");
            sel[k] = !sel[k];
            track("uniform_pkg_toggle", { item: k, on: sel[k] });
            var d = wrap.querySelector(".xp-dialog");
            if (d) restoreScrollTop = d.scrollTop;
            render();
          }
          rowEl.addEventListener("click", flip);
          rowEl.addEventListener("keydown", function(e) {
            if (e.keyCode === 13 || e.keyCode === 32) {
              e.preventDefault();
              flip();
            }
          });
        });
        $("#xp-preview-btn", wrap).addEventListener("click", function() {
          step = "preview";
          track("uniform_pkg_preview", { design: w.designId, shorts: sel.shorts, compression: sel.compression });
          render();
        });
        $("#xp-later", wrap).addEventListener("click", close);
        try {
          $("#xp-preview-btn", wrap).focus({ preventScroll: true });
        } catch (e) {
        }
      }
      function renderPreview() {
        var base = jerseyBasePrice(), tierNote = "";
        try {
          var sqp = typeof window.XeistSheetQuote === "function" ? window.XeistSheetQuote(0) : null;
          if (sqp && sqp.unit != null) {
            base = sqp.shorts ? Math.round((sqp.unit - sqp.shortsDelta) * 100) / 100 : sqp.unit;
            if (sqp.known) tierNote = " · " + sqp.tierLabel;
          }
        } catch (e) {
        }
        var total = base;
        PKG_ITEMS.forEach(function(it) {
          if (sel[it.key] && total != null) total += pkgPrice(it.key);
        });
        var priceRows = '<div class="xp-sumrow"><span>' + esc(jerseyName) + "</span><span>Included</span></div>";
        var includes = '<span class="xp-inc">✓ ' + esc(jerseyName) + "</span>";
        PKG_ITEMS.forEach(function(it) {
          if (!sel[it.key]) return;
          priceRows += '<div class="xp-sumrow"><span>' + esc(it.label) + "</span><span>" + esc(pkgPriceLabel(it.key)) + "</span></div>";
          includes += '<span class="xp-inc">✓ ' + esc(it.label) + "</span>";
        });
        if (total != null) {
          priceRows += '<div class="xp-sumrow xp-sumrow-total"><span>Estimated package price per player' + esc(tierNote) + "</span><span>" + money(total) + "</span></div>";
        }
        var previewRow = '<div class="xp-thumb xp-thumb-hero">' + media("jersey", 150) + '<span class="xp-thumb-name">' + esc(jerseyName) + '</span><span class="xp-thumb-pill">Included</span></div>';
        PKG_ITEMS.forEach(function(it) {
          if (!sel[it.key]) return;
          previewRow += '<span class="xp-plus" aria-hidden="true">+</span><div class="xp-thumb">' + media(it.key, 124) + '<span class="xp-thumb-name">' + esc(it.label) + '</span><span class="xp-thumb-price">' + esc(pkgPriceLabel(it.key)) + "</span></div>";
        });
        var inner = '<div class="xp-head"><span class="xp-eyebrow" style="margin:0 0 10px">Your team package</span><h3 class="xp-title">Review the ' + esc(team.toUpperCase()) + ' package</h3><p class="xp-sub">Confirm what every athlete will receive before collecting player sizes.</p></div><div class="xp-preview">' + previewRow + "</div>" + (sel.shorts ? '<p class="xp-prevnote">Design preview — final artwork will be matched to your approved jersey before production.</p>' : "") + '<div class="xp-includes"><span class="xp-inc-title">Package includes</span>' + includes + '</div><div class="xp-pricing">' + priceRows + '</div><button type="button" class="xp-continue" id="xp-approve">' + (sel.shorts ? "Approve and review your matching shorts" : "Approve package and continue to roster") + '</button><button type="button" class="xp-later" id="xp-edit">Edit package</button>';
        shell(inner, "Review the " + team + " package");
        $("#xp-approve", wrap).addEventListener("click", function() {
          var pkg = { approved: true };
          PKG_ITEMS.forEach(function(it) {
            pkg[it.key] = !!sel[it.key];
          });
          track("uniform_pkg_approved", { design: w.designId, shorts: pkg.shorts, compression: pkg.compression });
          if (pkg.shorts && window.XeistUniformKit && window.XeistUniformKit.reviewShorts) {
            delete pkg.shortsStatus;
            savePkg(pkg);
            close();
            pkgToast("Package approved", "Preparing your matching shorts…");
            setTimeout(function() {
              window.XeistUniformKit.reviewShorts();
            }, 350);
            return;
          }
          savePkg(pkg);
          close();
          renderState(true);
          pkgToast("Package approved", "Player sizing will now be collected for the selected items.");
        });
        $("#xp-edit", wrap).addEventListener("click", function() {
          step = "select";
          render();
        });
        try {
          $("#xp-approve", wrap).focus({ preventScroll: true });
        } catch (e) {
        }
      }
      function renderWarn() {
        var inner = '<div class="xp-head" style="margin-bottom:8px"><h3 class="xp-title">Changing the package may require new player information</h3><p class="xp-sub">Some players have already submitted sizes. Adding or removing products may create missing or unnecessary size fields — nothing already submitted is lost.</p></div><div class="xp-warn-actions"><button type="button" class="xp-continue" id="xp-keep" style="background:#fff!important;border:1px solid #dedede;color:#111!important">Keep current package</button><button type="button" class="xp-continue" id="xp-proceed" style="margin-top:10px">Edit package</button></div>';
        shell(inner, "Package change warning");
        $("#xp-keep", wrap).addEventListener("click", close);
        $("#xp-proceed", wrap).addEventListener("click", function() {
          track("uniform_pkg_edit_after_roster", { design: w.designId });
          step = "select";
          render();
        });
        var kb = wrap.querySelector("#xp-keep");
        if (kb) {
          kb.style.color = "#111";
        }
        try {
          $("#xp-keep", wrap).focus({ preventScroll: true });
        } catch (e) {
        }
      }
      function render() {
        if (step === "warn") renderWarn();
        else if (step === "preview") renderPreview();
        else renderSelect();
        liveSwap();
      }
      wrap.addEventListener("keydown", function(e) {
        if (e.keyCode === 27) close();
      });
      render();
    }
    function chooserHTML() {
      return '<h3 class="xu-h">How would you like to add your players?</h3><p class="xu-sub">Choose the option that works best for you. You can always switch or combine methods later.</p><div class="xr-methods">' + methodCard(
        "parents",
        "Let parents submit",
        "Send a secure link so each parent can enter their player’s details.",
        "Share with parents",
        true,
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M10 14a5 5 0 0 0 7 0l2-2a5 5 0 0 0-7-7l-1 1"/><path d="M14 10a5 5 0 0 0-7 0l-2 2a5 5 0 0 0 7 7l1-1"/></svg>'
      ) + methodCard(
        "manual",
        "Add players myself",
        "Enter player names, sizes and numbers manually.",
        "Add players",
        false,
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="9" cy="8" r="3.5"/><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6"/><path d="M18 8v6M15 11h6"/></svg>'
      ) + methodCard(
        "upload",
        "Upload a roster",
        "Import your roster from a spreadsheet (CSV or Excel).",
        "Upload roster",
        false,
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 15V4M7 9l5-5 5 5"/><path d="M4 17v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2"/></svg>'
      ) + "</div>" + pkgLineHTML() + progressHTML();
    }
    function pkgLineHTML() {
      if (!pkgAvailable()) return "";
      var pkg = getPkg();
      var parts = ["Jersey"];
      if (pkg) {
        PKG_ITEMS.forEach(function(it) {
          if (pkg[it.key]) parts.push(it.label);
        });
        return '<p class="xr-pkg-line">Package: <strong>' + esc(parts.join(" + ")) + '</strong> <button type="button" class="xr-quiet-link xr-pkg-edit" id="xr-pkg-edit">Edit package</button></p>';
      }
      return '<p class="xr-pkg-line">Package not decided yet <button type="button" class="xr-quiet-link xr-pkg-edit" id="xr-pkg-edit">Choose package</button></p>';
    }
    function methodCard(id, title, sub, cta, rec, icon) {
      return '<button type="button" class="xr-method' + (rec ? " xr-method-rec" : "") + '" data-method="' + id + '">' + (rec ? '<span class="xr-rec">Recommended</span>' : "") + (icon ? '<span class="xr-m-ico" aria-hidden="true">' + icon + "</span>" : "") + '<span class="xr-m-title">' + title + '</span><span class="xr-m-sub">' + sub + '</span><span class="xr-m-cta">' + cta + " →</span></button>";
    }
    function methodHTML(m) {
      var titles = { parents: "Collect player details from parents", manual: "Add your players", upload: "Upload your roster" };
      var h = '<div class="xr-head"><h3 class="xu-h">' + titles[m] + '</h3><button type="button" class="xu-more-btn xr-change" id="xr-change">Change method</button></div>';
      if (m === "parents") {
        h += '<div id="xr-collect-slot"><div class="xr-slot-wait" aria-live="polite"><span class="xr-slot-loading"><span class="xr-spin" aria-hidden="true"></span> Loading parent submissions…</span><span class="xr-slot-fallback">Parent submissions didn’t load. Refresh the page to try again, or choose another method above.</span></div></div>';
      } else if (m === "manual") {
        h += `<p class="xu-sub xr-desktop-sub">Type straight into the player rows below — name, number and size for each player. <a class="xr-quiet-link" href="/pages/sizing-guides" target="_blank" rel="noopener">View sizing guide</a></p><div id="xm-qa" hidden></div><button type="button" class="xu-more-btn" id="xr-paste-toggle">Paste a list instead</button><div id="xr-paste-wrap" hidden><textarea id="xr-paste" class="xr-paste" rows="4" placeholder="Jordan Smith	23	YM&#10;Alex Lee	7	Men's M"></textarea><div class="xr-actions"><button type="button" id="xr-import" class="xu-cta xr-btn">Import list</button><button type="button" id="xr-coach" class="xu-more-btn">+ Add coach / spare row</button></div><div id="xr-paste-preview"></div></div>`;
      } else if (m === "upload") {
        h += '<p class="xu-sub">Upload a CSV or Excel file — one player per row: Name, Number, Size. We’ll show you what we found before anything is added.</p><div class="xr-actions"><label class="xu-cta xr-btn xr-file-label">Choose file<input type="file" id="xr-file" accept=".csv,.tsv,.txt,.xls,.xlsx,text/csv,text/tab-separated-values,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" hidden></label><button type="button" class="xr-quiet-link" id="xr-template">Download a template (CSV)</button></div><div id="xr-preview"></div>';
      }
      h += '<p id="xr-note" class="xr-note" aria-live="polite"></p>' + progressHTML();
      return h;
    }
    function progressHTML() {
      return '<div id="xr-progress" class="xr-progress" hidden><span class="xr-progress-ico" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="9" cy="8" r="3.2"/><path d="M3.5 19c0-3 2.5-5.4 5.5-5.4s5.5 2.4 5.5 5.4"/><circle cx="16.5" cy="9" r="2.6"/><path d="M15.5 13.8c2.8.3 5 2.6 5 5.2"/></svg></span><span id="xr-progress-text" class="xr-progress-txt"></span><button type="button" class="xr-outline-btn" id="xr-view">' + (viewRoster ? "Hide roster" : "View roster →") + '</button></div><div id="xr-summary" class="xr-summary"></div><div id="xr-warnings" class="xr-warnings" aria-live="polite"></div>';
    }
    function bindState(card, m) {
      var pe = $("#xr-pkg-edit", card);
      if (pe) pe.addEventListener("click", openPkgEditor);
      $all(".xr-method", card).forEach(function(b) {
        b.addEventListener("click", function() {
          setMethod(b.getAttribute("data-method"));
        });
      });
      var chg = $("#xr-change", card);
      if (chg) chg.addEventListener("click", function() {
        viewRoster = false;
        setMethod("");
      });
      var vw = $("#xr-view", card);
      if (vw) vw.addEventListener("click", function() {
        viewRoster = !viewRoster;
        vw.textContent = viewRoster ? "Hide roster" : "View roster →";
        var aa = auditRoster();
        syncTable(getMethod(), aa ? aa.count : 0);
        if (viewRoster) {
          var s = rosterScope();
          if (s) apply(function() {
            if (s.setEnterTeams) s.setEnterTeams(true);
          });
        }
      });
      var pt = $("#xr-paste-toggle", card);
      if (pt) pt.addEventListener("click", function() {
        var w = $("#xr-paste-wrap", card);
        if (w) {
          w.hidden = !w.hidden;
          pt.textContent = w.hidden ? "Paste a list instead" : "Hide paste box";
        }
      });
      if (m === "manual") mountQuickAdd(card);
      var imp = $("#xr-import", card);
      if (imp) imp.addEventListener("click", function() {
        runImport($("#xr-paste").value);
      });
      var file = $("#xr-file", card);
      if (file) file.addEventListener("change", function(e) {
        var f = e.target.files && e.target.files[0];
        if (!f) return;
        readRosterFile(f);
        e.target.value = "";
      });
      var tpl = $("#xr-template", card);
      if (tpl) tpl.addEventListener("click", downloadTemplate);
      var coach = $("#xr-coach", card);
      if (coach) coach.addEventListener("click", function() {
        var s = rosterScope();
        if (!s) return;
        apply(function() {
          if (s.setEnterTeams) s.setEnterTeams(true);
          s.addUnit(0);
          var us = units();
          var last = us[us.length - 1];
          if (last) last.name = "COACH";
        });
        note("Coach/spare row added — set the size in the row below.");
      });
    }
    function renderProgress(a) {
      var wrap = $("#xr-progress"), txt = $("#xr-progress-text");
      if (!wrap || !txt) return;
      var count = a ? a.count : 0;
      if (!count) {
        wrap.hidden = true;
        return;
      }
      wrap.hidden = false;
      var expected = 0;
      try {
        expected = parseInt(window.localStorage.getItem("xeist_expected_" + window.XeistUniform.designId) || "0", 10) || 0;
      } catch (e) {
      }
      var h = "<strong>" + count + (expected ? " of " + expected : "") + " player" + (count === 1 && !expected ? "" : "s") + ' added</strong><span class="xr-progress-sub">Keep adding players or share your link with parents.</span>';
      if (txt.innerHTML !== h) txt.innerHTML = h;
    }
    function note(msg, isProblem) {
      var n = $("#xr-note");
      if (!n) return;
      n.textContent = msg || "";
      n.style.color = isProblem ? "#8a5a00" : "#6e6e73";
    }
    function plural(n, word) {
      return n + " " + word + (n === 1 ? "" : "s");
    }
    function noteWithUndo(msg, isProblem) {
      var n = $("#xr-note");
      if (!n) return;
      n.textContent = "";
      n.appendChild(document.createTextNode(msg + " "));
      var b = document.createElement("button");
      b.type = "button";
      b.id = "xr-undo";
      b.className = "xr-quiet-link";
      b.textContent = "Undo";
      b.addEventListener("click", function() {
        undoImport(function(ok) {
          renderState(true);
          note(ok ? "Roster restored to how it was before the import." : "Nothing to undo.", !ok);
        });
      });
      n.appendChild(b);
      n.style.color = isProblem ? "#8a5a00" : "#6e6e73";
    }
    function reportImport(res, parsed) {
      viewRoster = true;
      renderState(true);
      if (!res) {
        note("Roster form not ready — open the Roster step first.", true);
        return;
      }
      var msg;
      if (res.written < res.plan.added) {
        msg = "Only " + res.written + " of " + res.plan.added + " players could be written — check the roster below.";
      } else if (res.plan.mode === "replace" && res.plan.replaced) {
        msg = plural(res.written, "player") + " added · replaced your previous " + res.plan.replaced + ".";
      } else {
        msg = plural(res.written, "player") + " added to your roster.";
      }
      if (parsed.problems.length) msg += " " + plural(parsed.problems.length, "line") + " need attention: " + parsed.problems.join(" · ");
      noteWithUndo(msg, res.written < res.plan.added || !!parsed.problems.length);
    }
    function showImportPreview(parsed, mount) {
      if (!mount) return;
      if (!parsed.rows.length) {
        mount.innerHTML = '<p class="xr-note" style="color:#8a5a00">No players found — expected one player per line: Name, Number, Size.</p>';
        return;
      }
      var sizeProbs = [];
      if (sizeOptions().length) {
        parsed.rows.forEach(function(r, i) {
          if (r.sizeRaw && !matchSize(r.sizeRaw)) sizeProbs.push("Row " + (i + 1) + ': size "' + r.sizeRaw + '" not recognized — pick it manually after the import');
        });
      }
      var allProbs = parsed.problems.concat(sizeProbs);
      var a = auditRoster();
      var existing = a ? a.count : 0;
      var n = parsed.rows.length;
      var probs = allProbs.length ? '<div class="xr-warnings">' + allProbs.map(function(p) {
        return '<div class="xu-warn">' + esc(p) + "</div>";
      }).join("") + "</div>" : "";
      var head = '<p class="xr-note">We read <strong>' + plural(n, "player") + "</strong>" + (allProbs.length ? " — " + allProbs.length + " need" + (allProbs.length === 1 ? "s" : "") + " attention." : " — all looking good.") + "</p>";
      var btns;
      if (existing > 0) {
        head += '<p class="xr-note">Your roster already has <strong>' + plural(existing, "player") + "</strong>. Add to them, or replace them?</p>";
        btns = '<div class="xr-actions"><button type="button" class="xu-cta xr-btn" id="xr-do-append">Add to my ' + existing + " (" + (existing + n) + ' total)</button><button type="button" class="xu-more-btn" id="xr-do-replace">Replace all ' + existing + '</button><button type="button" class="xu-more-btn" id="xr-cancel-import">Cancel</button></div>';
      } else {
        btns = '<div class="xr-actions"><button type="button" class="xu-cta xr-btn" id="xr-do-append">Add ' + plural(n, "player") + '</button><button type="button" class="xu-more-btn" id="xr-cancel-import">Cancel</button></div>';
      }
      mount.innerHTML = head + probs + btns;
      var go = function(mode) {
        mount.innerHTML = '<p class="xr-note">Importing…</p>';
        importRoster(parsed.rows, mode, function(res) {
          mount.innerHTML = "";
          reportImport(res, parsed);
        });
      };
      $("#xr-do-append", mount).addEventListener("click", function() {
        go("append");
      });
      var rep = $("#xr-do-replace", mount);
      if (rep) rep.addEventListener("click", function() {
        go("replace");
      });
      $("#xr-cancel-import", mount).addEventListener("click", function() {
        mount.innerHTML = "";
      });
    }
    function previewUpload(text) {
      showImportPreview(parseRoster(text), $("#xr-preview"));
    }
    function runImport(text) {
      var parsed = parseRoster(text);
      var mount = $("#xr-paste-preview");
      if (!parsed.rows.length) {
        note("Nothing to import — paste one player per line: Name, Number, Size.", true);
        if (mount) mount.innerHTML = "";
        return;
      }
      showImportPreview(parsed, mount);
    }
    function loadXLSX(ok, fail) {
      if (window.XLSX) {
        ok(window.XLSX);
        return;
      }
      var sc = document.createElement("script");
      sc.src = "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js";
      sc.onload = function() {
        if (window.XLSX) ok(window.XLSX);
        else fail();
      };
      sc.onerror = fail;
      document.head.appendChild(sc);
    }
    function readRosterFile(f) {
      if (/\.(xlsx?|xlsm)$/i.test(f.name || "")) {
        var rd = new FileReader();
        rd.onload = function() {
          loadXLSX(function(X) {
            try {
              var wb = X.read(new Uint8Array(rd.result), { type: "array" });
              var csv = X.utils.sheet_to_csv(wb.Sheets[wb.SheetNames[0]] || {});
              previewUpload(csv);
            } catch (e) {
              note("Couldn’t read that Excel file — save it as CSV and try again.", true);
            }
          }, function() {
            note("Couldn’t load the Excel reader — save the file as CSV and try again.", true);
          });
        };
        rd.readAsArrayBuffer(f);
        return;
      }
      var rt = new FileReader();
      rt.onload = function() {
        previewUpload(String(rt.result));
      };
      rt.readAsText(f);
    }
    var TEMPLATE_CSV = "Name,Number,Size\r\nJordan Smith,23,Youth Medium\r\nAlex Lee,7,Men's M\r\nSam Diaz,11,Men's L\r\n";
    function downloadTemplate() {
      try {
        var blob = new Blob([TEMPLATE_CSV], { type: "text/csv" });
        var a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = "xeist-roster-template.csv";
        document.body.appendChild(a);
        a.click();
        setTimeout(function() {
          URL.revokeObjectURL(a.href);
          a.remove();
        }, 1e3);
        track("uniform_roster_template", {});
      } catch (e) {
      }
    }
    var lastSumHTML = null, lastWarnHTML = null;
    function renderAudit() {
      var sumEl = $("#xr-summary"), warnEl = $("#xr-warnings");
      if (!sumEl || !warnEl) return;
      var a = auditRoster();
      var sumHTML = "";
      if (a.count) {
        var sizes = Object.keys(a.sizes).map(function(k) {
          return esc(k) + " × " + a.sizes[k];
        }).join(" &middot; ");
        sumHTML = "<strong>" + a.count + " player" + (a.count === 1 ? "" : "s") + "</strong>" + (sizes ? " &middot; " + sizes : "");
      }
      var warnHTML = a.warnings.map(function(w) {
        return '<div class="xu-warn">' + esc(w) + "</div>";
      }).join("");
      if (sumHTML !== lastSumHTML) {
        sumEl.innerHTML = sumHTML;
        lastSumHTML = sumHTML;
      }
      if (warnHTML !== lastWarnHTML) {
        warnEl.innerHTML = warnHTML;
        lastWarnHTML = warnHTML;
      }
      return a;
    }
    function renderPricing(count) {
      var elp = $("#xu-bar-price");
      if (!elp) return;
      var w = window.XeistUniform || {};
      var d = w.design || {};
      var info = priceInfo(count || 0);
      var sq = typeof window.XeistSheetQuote === "function" ? window.XeistSheetQuote(count || 0) : null;
      if (!count || !info) {
        if (sq) {
          elp.textContent = sq.known ? money(sq.unit) + " per player (" + sq.label + ") · " + sq.tierLabel : "From " + money(sq.from) + " per player (" + sq.label + ") · team pricing at " + sq.discountAt + "+";
        } else {
          var pf = parseFloat(String(d.priceFrom || "").replace(/[^0-9.]/g, ""));
          elp.textContent = "From " + (pf ? money(pf) : d.priceFrom || "") + " per player · team pricing at " + (d.discountAt || d.minQty || 6) + "+";
        }
        return;
      }
      var kit = kitInfo(count);
      var txt;
      if (kit && kit.shorts) {
        txt = count + " players · " + (kit.converts ? "≈ " : "") + fmtLine(kit.perPlayer) + " each · " + fmtLine(kit.line) + " (jersey + shorts)";
      } else {
        txt = moneyConverts() ? count + " players · " + moneyPer(info.unit, count) + " each · " + moneyLine(info.total) : count + " × " + money(info.unit) + " = " + moneyLine(info.total);
        if (sq && sq.shorts) txt += " · + matching shorts";
      }
      if (info.addOn) txt += " · includes " + (info.addOnLabel || "printing") + " (" + money(info.addOn) + " per player)";
      if (kit && kit.next) {
        var away = kit.next.away;
        if (away > 0 && away <= 25) txt += " · " + away + " more drops it to " + money(kit.next.unitUsd) + " each";
      }
      if (elp.textContent !== txt) elp.textContent = txt;
    }
    var CSS = [
      ".xr-paste{width:100%;box-sizing:border-box;border:1px solid rgba(0,0,0,.14);border-radius:10px;padding:10px;font:13px/1.5 monospace;resize:vertical;background:#fafafa}",
      ".xr-actions{display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin:10px 0 4px}",
      ".xr-btn{padding:11px 18px;min-height:42px}",
      ".xr-file-label{cursor:pointer}",
      ".xr-note{font-size:12.5px;margin:6px 0 0}",
      ".xr-summary{font-size:13.5px;color:#3a3a3c;margin:18px 0 0;padding:0 2px;line-height:1.6}",
      ".xr-summary strong{font-weight:600;color:#111}",
      ".xr-warnings{margin-top:12px;display:flex;flex-direction:column;gap:8px}",
      "#xr-card .xu-warn{padding:12px 16px;border-radius:10px;line-height:1.5;font-size:13px}",
      "#xr-card>.xu-h,#xr-card .xr-head .xu-h{margin:0 0 6px}",
      "#xr-card>.xu-sub{margin:0 0 8px;line-height:1.55}",
      ".xr-methods{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:14px;margin:20px 0 8px;min-width:0}",
      "@media (max-width:760px){.xr-methods{grid-template-columns:1fr;gap:20px}}",
      ".xr-method{position:relative;display:flex;flex-direction:column;align-items:center;text-align:center;gap:9px;padding:28px 14px 18px;border:1px solid rgba(0,0,0,.12);border-radius:16px;background:#fff;cursor:pointer;font-family:inherit;min-height:215px;min-width:0;transition:border-color .15s,box-shadow .15s}",
      ".xr-method:hover{border-color:#111;box-shadow:0 6px 22px rgba(0,0,0,.07)}",
      ".xr-method-rec{border-color:#111;box-shadow:0 0 0 1px #111 inset}",
      ".xr-rec{display:inline-block;background:#fff!important;color:#111!important;border:1.5px solid #111;font-size:10px!important;font-weight:700!important;letter-spacing:.08em!important;text-transform:uppercase;padding:4px 12px;border-radius:999px;white-space:nowrap;margin:-8px 0 2px}",
      ".xr-m-ico{width:58px;height:58px;border-radius:50%;background:#f4f4f5;display:flex;align-items:center;justify-content:center;color:#111;margin:2px 0 4px;flex:0 0 auto}",
      ".xr-m-ico svg{width:24px;height:24px}",
      ".xr-m-title{font-size:15px;font-weight:700!important}",
      ".xr-m-sub{font-size:12.5px;color:#6e6e73;line-height:1.5}",
      ".xr-m-cta{margin-top:auto;padding-top:14px;font-size:13.5px;font-weight:600;color:#111;text-decoration:underline;text-underline-offset:2px;white-space:nowrap}",
      ".xr-m-cta-dark{text-decoration:none;background:#111;color:#fff;padding:12px 20px;border-radius:10px}",
      ".xr-head{display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap}",
      ".xr-progress{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:12px;padding:10px 14px;border:1px solid rgba(0,0,0,.08);border-radius:10px;background:#fafafa;font-size:13px}",
      "body.xr-hide-td .kb-field-teamdetails{display:none!important}",
      // 2026-08-27 (Justin: "we lost the ability for coaches adding
      // players"): KB's updated teamdetails ng-hides each team pane behind
      // nameAndNumberIsValid() — a PER-SESSION editor validation that stays
      // false on every reload until the coach re-edits the design's name +
      // number text items. Our flow never touches those on the roster step,
      // so the player rows never rendered. When WE decide the table is
      // visible, the panes show — KB's session validation does not get a
      // veto (the audit + import machinery already read these rows safely).
      'body.xr-roster-step:not(.xr-hide-td) .kb-field-teamdetails [class*="kb-team-index-"].ng-hide{display:block!important}',
      /* ---- 2026-07-31 premium pass: interface typography, wider panels,
         quiet chrome. All scoped so KB and the other xu-cards are safe. */
      "#xr-card{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif!important;padding:30px 28px 26px!important;border-radius:18px!important;overflow:visible}",
      "#xr-card *{font-family:inherit!important;letter-spacing:normal!important}",
      "#xr-card>.xu-h,#xr-card .xr-head .xu-h{font-size:24px!important;font-weight:600!important;letter-spacing:-.02em!important;line-height:1.25!important;text-transform:none!important;color:#111!important}",
      "#xr-card .xu-sub{font-size:14.5px!important;line-height:1.55!important;text-transform:none!important;font-weight:400!important}",
      ".xr-quiet-link{color:#111;font-weight:600;text-decoration:underline;text-underline-offset:2px}",
      /* W5: quiet-link is now also used on plain <button>s (template download, Undo) */
      "button.xr-quiet-link{background:none;border:0;padding:0;cursor:pointer;font-size:13px}",
      "#xr-undo{margin-left:2px}",
      "#xr-paste-preview,#xr-preview{margin-top:6px}",
      /* W6/T2.3: collect-slot loading skeleton + CSS-only watchdog */
      ".xr-slot-wait{display:block;padding:16px 2px;font-size:14px;color:#6e6e73}",
      ".xr-slot-loading{display:inline-flex;align-items:center;gap:9px}",
      ".xr-spin{width:15px;height:15px;border:2px solid #e0e0e0;border-top-color:#111;border-radius:50%;animation:xrspin .8s linear infinite;flex:0 0 auto}",
      "@keyframes xrspin{to{transform:rotate(360deg)}}",
      ".xr-slot-fallback{display:block;max-height:0;overflow:hidden;opacity:0;animation:xrfb .4s 8s forwards;color:#8a5a00;line-height:1.55}",
      "@keyframes xrfb{to{max-height:90px;opacity:1;margin-top:10px}}",
      "#xr-card{scroll-margin-top:70px}",
      /* clear the sticky step rail */
      /* last-names opt-in row — quiet contained box, not a centerpiece
         (Justin's phone pass #2, 2026-08-18) */
      ".xn-row{margin:16px 0 0;padding:11px 13px;border:1px solid #ececea;border-radius:12px;background:#fafafa}",
      ".xn-opt{display:flex;align-items:center;gap:9px;cursor:pointer;font-size:13px;color:#111;line-height:1.45}",
      ".xn-opt input{width:18px;height:18px;margin:0;accent-color:#111;flex:0 0 auto;cursor:pointer}",
      ".xn-opt strong{font-weight:600;white-space:nowrap}",
      ".xn-sub{display:block;font-size:11.5px;color:#8a8a8e;margin:4px 0 0 27px;line-height:1.4}",
      "@media (max-width:749px){.xn-opt{font-size:13px}.xn-opt input{width:20px;height:20px}}",
      /* KB's native name/number prompt + currency note (leaked copy, audit
         P2-5): "Please Note, Currency: USD" and the red "To enter player
         details add a name and number: ADD NAME" validation box. Verified
         2026-08-18: it is a cosmetic nag — KitValidationService's checkout
         gate only enforces minimum quantity — and our roster UX owns all
         player guidance. Gone on every breakpoint. */
      "body.template-page #kb-app .kb-field-teamdetails .kb-form-desc{display:none!important}",
      "body.template-page #kb-app .kb-field-teamdetails .kb-pane-teams .kb-validation{display:none!important}",
      /* W7.5: mobile quick-add (one player at a time) */
      "#xm-qa[hidden]{display:none}",
      ".xm-form{border:1px solid rgba(0,0,0,.10);border-radius:14px;padding:14px;margin:8px 0 4px;background:#fff;scroll-margin-top:86px}",
      ".xm-form-flash{animation:xmflash 1.2s ease}",
      "@keyframes xmflash{0%{transform:translateY(0);box-shadow:0 0 0 3px rgba(109,40,217,.45);background:#f6f2ff}15%{transform:translateY(-6px)}30%{transform:translateY(2px)}45%{transform:translateY(0)}70%{box-shadow:0 0 0 3px rgba(109,40,217,.22);background:#f6f2ff}100%{box-shadow:0 0 0 0 rgba(109,40,217,0);background:#fff}}",
      "@media (prefers-reduced-motion:reduce){.xm-form-flash{animation:xmflash-quiet 1.2s ease}}",
      "@keyframes xmflash-quiet{0%{box-shadow:0 0 0 3px rgba(109,40,217,.45);background:#f6f2ff}100%{box-shadow:0 0 0 0 rgba(109,40,217,0);background:#fff}}",
      ".xm-lab{display:block;font-size:11px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;color:#6e6e73;margin:0 0 8px}",
      ".xm-in{width:100%;box-sizing:border-box;min-height:48px;font-size:16px;border:1px solid rgba(0,0,0,.16);border-radius:10px;padding:10px 12px;background:#fff;margin:0 0 10px}",
      ".xm-in-err{border-color:#b23b3b!important;background:#fdf3f3!important}",
      ".xm-row2{display:grid;grid-template-columns:88px 1fr;gap:10px}",
      ".xm-numin{text-align:center;font-weight:700;font-size:18px}",
      ".xm-add{width:100%;min-height:50px;margin-top:2px}",
      ".xm-cancel{width:100%;text-align:center}",
      ".xm-count{font-size:12.5px;color:#6e6e73;text-align:center;margin:10px 0 0}",
      ".xm-rowwrap{display:flex;align-items:stretch;border-bottom:1px solid #f0f0ee}",
      ".xm-rowwrap:last-child{border-bottom:0}",
      ".xm-row{flex:1;display:flex;align-items:center;justify-content:space-between;gap:10px;background:none;border:0;padding:13px 4px;font-family:inherit;font-size:14.5px;text-align:left;cursor:pointer;min-height:48px}",
      ".xm-row-name{font-weight:600;color:#111;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}",
      ".xm-row-meta{color:#6e6e73;flex:0 0 auto;font-size:13px}",
      ".xm-row-editing .xm-row-name{color:#6D28D9}",
      ".xm-del{flex:0 0 auto;min-width:44px;min-height:44px;background:none;border:0;color:#b23b3b;font-size:20px;cursor:pointer}",
      "#xm-list{margin:0 0 12px}",
      "@media (max-width:749px){",
      /* W7.5 declutter (Justin, real-phone pass): package line, progress box,
         size summary and the desktop instruction all leave the phone — the
         sticky bar carries count + price. Warnings/blockers STAY. */
      ".xr-pkg-line,#xr-progress,#xr-summary,.xr-desktop-sub{display:none!important}",
      /* the table + its sticky add button yield to quick-add ONLY when it
         actually mounted (body.xm-on) — fallback stays alive otherwise */
      "body.xm-on.template-page #kb-app .kb-units-table{display:none!important}",
      "body.xm-on.template-page #kb-app .kb-add-unit{display:none!important}",
      "}",
      /* Column headers above the player rows on desktop (2026-09-11):
         KB's thead is force-shown and relabelled by syncRosterHeaders(). */
      "@media (min-width:750px){",
      "body.template-page #kb-app table.xr-units-labelled thead{display:table-header-group!important}",
      "body.template-page #kb-app table.xr-units-labelled thead th{display:table-cell!important;visibility:visible!important;height:auto!important;padding:0 6px 6px 4px!important;font:700 11px/1.3 inherit!important;letter-spacing:.05em;text-transform:uppercase;color:#6e6e73!important;text-align:left;background:transparent!important;border:0!important}",
      "}",
      /* W7/T2.5: delete-undo toast (all breakpoints) */
      ".xr-undo-toast{position:fixed;left:50%;transform:translateX(-50%);bottom:88px;z-index:2147483450;display:flex;align-items:center;gap:14px;background:#111;color:#fff;border-radius:12px;padding:12px 16px;font-size:13.5px;box-shadow:0 8px 30px rgba(0,0,0,.25)}",
      ".xr-undo-toast span{color:#fff}",
      ".xr-undo-toast button{background:none;border:0;color:#9db9ff;font-size:13.5px;font-weight:700;cursor:pointer;padding:6px 4px;min-height:32px}",
      /* W7/T2.5: below 760px the KB player table becomes one card per player —
         full-width name, big numeric field, native size picker with a 46px
         target, 44px delete top-right, sticky Add player. ID-weight prefix on
         purpose: KB ships its own !important rules (see module 30). */
      "@media (max-width:749px){",
      ".xr-undo-toast{bottom:132px;max-width:92vw}",
      "body.template-page #kb-app .kb-units-table,body.template-page #kb-app .kb-units-table tbody{display:block!important;width:100%!important}",
      "body.template-page #kb-app .kb-units-table thead{display:none!important}",
      "body.template-page #kb-app .kb-units-table tbody tr{display:grid!important;grid-template-columns:1fr 1.4fr;gap:10px 12px;position:relative;background:#fff;border:1px solid rgba(0,0,0,.10);border-radius:14px;padding:14px 14px 14px;margin:0 0 12px;box-shadow:0 1px 3px rgba(0,0,0,.05)}",
      "body.template-page #kb-app .kb-units-table td{display:block!important;padding:0!important;border:0!important;width:auto!important}",
      "body.template-page #kb-app .kb-units-table td:nth-child(1){grid-column:1/-1;padding-right:52px!important}",
      "body.template-page #kb-app .kb-units-table td:nth-child(1):before{content:'Player name'}",
      "body.template-page #kb-app .kb-units-table td:nth-child(2):before{content:'Number'}",
      "body.template-page #kb-app .kb-units-table td.kb-unit-size:before{content:'Jersey size'}",
      "body.template-page #kb-app .kb-units-table td.xr-shsz-cell:before{content:'Shorts size'}",
      "body.template-page #kb-app .kb-units-table td:before{display:block;font-size:11px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;color:#6e6e73;margin:0 0 5px}",
      "body.template-page #kb-app .kb-units-table td input.kb-text-box,body.template-page #kb-app .kb-units-table td select{width:100%!important;box-sizing:border-box!important;min-height:46px!important;font-size:16px!important;border:1px solid rgba(0,0,0,.16)!important;border-radius:10px!important;padding:10px 12px!important;background:#fff!important;margin:0!important}",
      "body.template-page #kb-app .kb-units-table td:nth-child(2) input{text-align:center;font-weight:700;font-size:18px!important}",
      "body.template-page #kb-app .kb-units-table td.kb-unit-preview{display:none!important}",
      "body.template-page #kb-app .kb-units-table td.kb-unit-remove{position:absolute;top:4px;right:4px}",
      "body.template-page #kb-app .kb-units-table td.kb-unit-remove a{display:flex!important;align-items:center;justify-content:center;min-width:44px;min-height:44px;padding:0 10px;color:#b23b3b!important;font-size:12.5px!important;font-weight:700!important;text-decoration:none!important}",
      "body.template-page #kb-app .kb-add-unit{position:sticky;bottom:124px;z-index:6;display:flex!important;align-items:center;justify-content:center;width:100%!important;box-sizing:border-box;min-height:50px!important;background:#111!important;border-radius:12px!important;font-size:15px!important;font-weight:700!important;text-decoration:none!important;box-shadow:0 6px 20px rgba(0,0,0,.18)}",
      "body.template-page #kb-app .kb-add-unit,body.template-page #kb-app .kb-add-unit *{color:#fff!important}",
      /* team-name row + aggregate qty table get the same 16px/44px treatment */
      "body.template-page #kb-app .kb-team-table input.kb-text-box{min-height:46px!important;font-size:16px!important;border-radius:10px!important;box-sizing:border-box!important}",
      "body.template-page #kb-app .kb-aggregate-size-quantity-input{min-height:44px!important;min-width:64px!important;font-size:16px!important;text-align:center}",
      "}",
      ".xr-pkg-line{font-size:13.5px;color:#6e6e73;margin:26px 0 0;padding-top:20px;border-top:1px solid #f0f0ee;line-height:1.6;display:flex;align-items:baseline;flex-wrap:wrap;gap:4px 0}",
      ".xr-pkg-line strong{color:#111;font-weight:600}",
      ".xr-pkg-edit{background:none;border:0;padding:0 0 0 10px;cursor:pointer;font:600 13.5px/1 inherit;font-family:inherit}",
      "#xp-modal{position:fixed;inset:0;z-index:2147483240}",
      ".xp-scrim{position:absolute;inset:0;background:rgba(17,17,17,.45)}",
      "body.xp-lock{overflow:hidden}",
      /* the Front/Back pill is irrelevant to the package decision — hide it
         while the sheet is open instead of letting it float over the CTA */
      "body.xp-lock #xu-viewpill{display:none!important}",
      ".xp-dialog{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:min(720px,92vw);max-height:90vh;overflow:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;background:#fff;border-radius:22px;padding:36px 36px 26px;box-shadow:0 30px 90px rgba(0,0,0,.28);font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif!important}",
      ".xp-dialog *{font-family:inherit!important;letter-spacing:normal!important;text-transform:none!important;box-sizing:border-box}",
      ".xp-close{position:absolute;top:16px;right:16px;width:34px;height:34px;border:0;border-radius:50%;background:#f4f4f5;color:#6e6e73!important;font-size:20px!important;line-height:1;cursor:pointer}",
      ".xp-head{text-align:center;max-width:520px;margin:0 auto 24px}",
      ".xp-rec{display:inline-block;background:#f7eeda;color:#8a6a1f!important;font-size:11px!important;font-weight:700!important;letter-spacing:.1em!important;text-transform:uppercase!important;padding:5px 14px;border-radius:999px;margin-bottom:12px}",
      ".xp-title{font-size:26px;font-weight:650!important;letter-spacing:-.02em!important;margin:0 0 8px;color:#111;line-height:1.2}",
      ".xp-sub{font-size:14.5px;color:#666;margin:0;line-height:1.55}",
      ".xp-preview{display:flex;align-items:flex-start;justify-content:center;gap:14px;margin:0 0 22px}",
      ".xp-eyebrow{text-align:center;font-size:11px;font-weight:700!important;letter-spacing:.14em!important;text-transform:uppercase!important;color:#b0b0b3;margin:0 0 12px}",
      ".xp-thumb{display:flex;flex-direction:column;align-items:center;gap:6px;width:150px;transition:opacity .2s}",
      ".xp-thumb-hero .xp-thumb-img{width:126px;height:126px}",
      ".xp-thumb-off{opacity:.35}",
      ".xp-thumb-img{width:110px;height:110px;border-radius:16px;background:#f6f6f4;display:flex;align-items:center;justify-content:center;overflow:hidden}",
      ".xp-thumb-img img{max-width:92%;max-height:92%;object-fit:contain;mix-blend-mode:multiply}",
      ".xp-thumb-ph{background:#1b1b1e}",
      ".xp-thumb-name{font-size:13px;font-weight:600;color:#111;text-align:center}",
      ".xp-thumb-price{font-size:12px;color:#666}",
      ".xp-thumb-pill{font-size:10.5px;font-weight:700!important;color:#1a7f37!important;background:#e7f6ec;border-radius:999px;padding:3px 10px}",
      ".xp-plus{font-size:20px;color:#c9c9cc;align-self:center;margin-top:-28px}",
      ".xp-prevnote{text-align:center;font-size:11.5px;color:#b0b0b3;margin:-12px 0 16px}",
      ".xp-value{display:flex;flex-direction:column;gap:2px;background:#faf6ee;border-radius:12px;padding:14px 18px;margin:0 0 18px;text-align:center}",
      ".xp-value strong{font-size:14px;font-weight:650!important;color:#111}",
      ".xp-value span{font-size:12.5px;color:#8a7a55}",
      ".xp-row{display:flex;align-items:center;gap:14px;border:1px solid #e8e8e8;border-radius:16px;padding:16px 18px;background:#fff;cursor:pointer;margin-bottom:12px;transition:border-color .2s,box-shadow .2s}",
      ".xp-row:hover{border-color:#c9c9cc}",
      ".xp-row.xp-on{border-color:#111;box-shadow:0 0 0 1px #111 inset}",
      ".xp-row-img{width:52px;height:52px;border-radius:12px;background:#f6f6f4;display:flex;align-items:center;justify-content:center;overflow:hidden;flex:0 0 auto}",
      ".xp-row-img img{max-width:88%;max-height:88%;object-fit:contain;mix-blend-mode:multiply}",
      ".xp-row-img svg,.xp-thumb-img svg{display:block}",
      ".xp-row-img.xp-thumb-ph,.xp-row-img.xp-thumb-ph{background:#1b1b1e}",
      ".xp-info{display:flex;flex-direction:column;gap:2px;min-width:0;flex:1 1 auto}",
      ".xp-name{font-size:15px;font-weight:600;color:#111}",
      ".xp-desc{font-size:12.5px;color:#666;line-height:1.4}",
      ".xp-price{font-size:13.5px;font-weight:600;color:#111;white-space:nowrap;flex:0 0 auto}",
      ".xp-toggle{width:48px;height:28px;border-radius:999px;background:#e3e3e0;position:relative;flex:0 0 auto;transition:background .2s}",
      ".xp-on .xp-toggle{background:#111}",
      ".xp-knob{position:absolute;top:3px;left:3px;width:22px;height:22px;border-radius:50%;background:#fff;transition:left .2s}",
      ".xp-on .xp-knob{left:23px}",
      ".xp-continue{display:block;width:100%;height:54px;margin-top:6px;border:0;border-radius:12px;background:#111!important;font-size:15.5px!important;font-weight:600!important;cursor:pointer;transition:opacity .15s}",
      ".xp-continue,.xp-continue *{color:#fff!important}",
      ".xp-continue:hover{opacity:.92}",
      ".xp-later{display:block;margin:12px auto 0;background:none;border:0;padding:8px;color:#9a9a9e!important;font-size:13px!important;font-weight:500!important;text-decoration:none;cursor:pointer}",
      ".xp-includes{display:flex;flex-wrap:wrap;align-items:baseline;gap:6px 18px;border:1px solid #ececea;border-radius:14px;padding:14px 18px;margin:0 0 14px}",
      ".xp-inc-title{font-size:11px;font-weight:700!important;letter-spacing:.1em!important;text-transform:uppercase!important;color:#8a8a8e;width:100%}",
      ".xp-inc{font-size:13.5px;font-weight:600;color:#111}",
      ".xp-pricing{border:1px solid #ececea;border-radius:14px;padding:6px 18px;margin:0 0 18px}",
      ".xp-sumrow{display:flex;justify-content:space-between;gap:16px;padding:10px 0;border-bottom:1px solid #f4f4f2;font-size:13.5px;color:#111}",
      ".xp-sumrow span:last-child{color:#666;white-space:nowrap}",
      ".xp-sumrow:last-child{border-bottom:0}",
      ".xp-sumrow-total{font-weight:700}",
      ".xp-sumrow-total span:last-child{color:#111;font-weight:700}",
      ".xp-warn-actions{display:flex;flex-direction:column;margin-top:10px}",
      ".xr-toast{position:fixed;bottom:26px;right:26px;background:#111;border-radius:12px;padding:14px 20px;display:flex;flex-direction:column;gap:2px;box-shadow:0 8px 30px rgba(0,0,0,.18);z-index:99999;opacity:0;transition:opacity .25s;pointer-events:none}",
      ".xr-toast,.xr-toast *{color:#fff!important;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif!important}",
      ".xr-toast strong{font-size:14px!important;font-weight:650!important}",
      ".xr-toast span{font-size:12.5px!important;opacity:.75}",
      ".xr-toast-on{opacity:1}",
      /* Mobile package sheet (Justin's phone pass, 2026-08-18): a compact
         bottom sheet — tighter rhythm, side-by-side thumbs, CTA padded above
         the safe area. The old 640px rules stacked the three thumbs
         vertically (~500px of scroll before the toggles even appeared). */
      "@media (max-width:640px){",
      ".xp-dialog{top:auto;bottom:0;left:0;right:0;transform:none;width:100%;max-height:calc(100vh - 28px);max-height:calc(100dvh - 28px);border-radius:22px 22px 0 0;padding:22px 16px calc(20px + env(safe-area-inset-bottom))}",
      ".xp-head{margin:0 auto 14px}",
      ".xp-rec{margin-bottom:8px;padding:4px 12px}",
      ".xp-title{font-size:21px}",
      ".xp-sub{font-size:13.5px;line-height:1.5}",
      ".xp-eyebrow{margin:0 0 8px}",
      ".xp-preview{flex-direction:row;align-items:flex-start;justify-content:center;gap:8px;margin:0 0 14px}",
      ".xp-thumb{width:auto;flex:1 1 0;min-width:0;gap:4px}",
      ".xp-thumb-img{width:72px!important;height:72px!important;border-radius:12px}",
      ".xp-thumb-hero .xp-thumb-img{width:86px!important;height:86px!important}",
      ".xp-thumb-name{font-size:11.5px;line-height:1.3}",
      ".xp-thumb-price{font-size:11px}",
      ".xp-thumb-pill{font-size:10px;padding:2px 8px}",
      ".xp-plus{margin-top:28px;font-size:16px;flex:0 0 auto}",
      ".xp-prevnote{margin:-4px 0 12px;font-size:11px}",
      ".xp-value{padding:10px 14px;margin:0 0 12px}",
      ".xp-value strong{font-size:13px}",
      ".xp-value span{font-size:12px}",
      ".xp-row{padding:12px 14px;gap:12px;margin-bottom:8px;border-radius:14px}",
      ".xp-row-img{width:44px;height:44px;border-radius:10px}",
      ".xp-name{font-size:14px}",
      ".xp-desc{font-size:12px}",
      ".xp-price{display:none}",
      ".xp-continue{height:50px;font-size:15px!important}",
      ".xp-later{margin:8px auto 0}",
      ".xp-includes{padding:12px 14px;margin:0 0 10px;gap:4px 14px}",
      ".xp-pricing{padding:4px 14px;margin:0 0 14px}",
      "}",
      ".xr-outline-btn{padding:12px 18px;border:1px solid #e0e0e0;border-radius:10px;background:#fff;color:#111;font:600 13.5px/1 inherit;font-family:inherit;cursor:pointer;white-space:nowrap}",
      ".xr-outline-btn:hover{border-color:#111}",
      ".xr-progress{justify-content:flex-start;padding:18px 20px;border-radius:14px;background:#fafafa;border:1px solid #ececea;margin:16px 0 0}",
      ".xr-progress-ico{width:40px;height:40px;border-radius:50%;background:#e9f6ee;color:#1a7f37;display:flex;align-items:center;justify-content:center;flex:0 0 auto}",
      ".xr-progress-txt{display:flex;flex-direction:column;gap:2px;font-size:14px;flex:1 1 auto}",
      ".xr-progress-sub{font-size:12.5px;color:#8a8a8e;font-weight:400}",
      /* method-card CTAs become real buttons pinned to the card bottom */
      ".xr-m-cta{display:block;margin-top:auto;width:100%;box-sizing:border-box;padding:12px 10px;border:1px solid #e0e0e0;border-radius:10px;background:#fff!important;color:#111!important;font-size:13px!important;font-weight:600!important;text-decoration:none;text-align:center;line-height:1.25}",
      ".xr-method:hover .xr-m-cta{border-color:#111}",
      /* step rail: neutral premium treatment (module 30 renders it) */
      "#xu-steps .xu-step-active{background:#111!important;color:#fff!important;border-color:#111!important}",
      "#xu-steps .xu-step-active .xu-step-n{background:#fff!important;color:#111!important}",
      /* W9/T3.1 (2026-08-18): Share un-hidden — the copy-link button in the
         step rail is live (module 32 owns it, incl. the copied toast). */
      /* approval aside: quiet footer note below the card, not a banner */
      "#xu-reassure-order{border-left:0!important;border:1px solid #ececea!important;background:#fafafa!important;border-radius:12px!important;margin-top:14px!important}",
      "#xu-reassure-order,#xu-reassure-order *{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif!important;font-size:12.5px!important;color:#6e6e73!important;line-height:1.5!important;text-transform:none!important}",
      /* preview side: contained product panel + quiet overlay buttons */
      "@media (min-width:1200px){.kb-preview-panel{background:#fff;border:1px solid #e7e7e7;border-radius:18px}}",
      ".kb-overlay-button.kb-change-design-button,.kb-overlay-button.kb-change-view-button{background:#fff!important;color:#111!important;border:1px solid #e0e0e0!important;border-radius:9px!important;font-size:11px!important;letter-spacing:.04em;padding:7px 12px!important;box-shadow:none!important;text-transform:uppercase}",
      /* use the dead canvas space: widen the working column on big screens */
      /* Step-4 shell: the premium dashboard needs ~800px, not KB's narrow
         sidebar. Scoped to body.xr-roster-step so every other step keeps
         KB's stock 3D-first split. */
      "@media (min-width:1200px){body.xr-roster-step .kb-customise-page{max-width:1480px;margin:0 auto}body.xr-roster-step .kb-preview-panel{width:36%!important}body.xr-roster-step .kb-customise-edit-panel{width:62%!important;max-width:none}}",
      "@media (min-width:1200px) and (max-width:1499px){body.xr-roster-step .kb-customise-edit-panel{width:58%!important}body.xr-roster-step .kb-preview-panel{width:40%!important}}",
      "#xr-card [hidden]{display:none!important}",
      "body.xr-roster-step .kb-preview-panel canvas{max-width:100%!important}",
      ".xr-head{flex-wrap:nowrap}",
      "@media (max-width:700px){.xr-head{flex-wrap:wrap}}",
      ".xr-progress[hidden]{display:none!important}",
      "#xr-card a,#xr-card .xu-more-btn{color:#111}",
      /* Shorts-size column, inline in KB's table (2026-08-26 v2) */
      ".xr-shsz-cell{vertical-align:middle!important}",
      ".xr-shsz-cell .xr-shsz-sel{width:100%;min-width:96px;max-width:160px;height:34px;border:1px solid #ddd;border-radius:8px;padding:0 6px;font-size:13px;color:#111;background:#fff}",
      ".xr-shsz-th{white-space:nowrap}",
      /* Pricing & cart belong to the Review step (module 32 drawer clicks
         the hidden KB buy button programmatically — that keeps working). */
      ".kb-single-item-checkout{display:none!important}"
    ].join("\n");
    function injectCSS() {
      if ($("#xr-style")) return;
      var s = el("style", "", "");
      s.id = "xr-style";
      s.appendChild(document.createTextNode(CSS));
      document.head.appendChild(s);
    }
    var sizingRowHidden = false;
    function relocateExtras() {
      var card = $("#xr-card");
      if (!card || !card.parentNode) return;
      var aside = document.getElementById("xu-reassure-order");
      if (aside && aside.previousElementSibling !== card) {
        try {
          card.parentNode.insertBefore(aside, card.nextSibling);
        } catch (e) {
        }
      }
      if (!sizingRowHidden) {
        $all(".kb-wizard-form-row a").some(function(a) {
          if ((a.textContent || "").replace(/\s+/g, " ").trim() === "Sizing Guides") {
            var row = a.closest ? a.closest(".kb-wizard-form-row") : null;
            if (row) {
              row.style.display = "none";
              sizingRowHidden = true;
            }
            return true;
          }
          return false;
        });
      }
    }
    var coachTouchedTabs = false;
    document.addEventListener("click", function(e) {
      if (!e.isTrusted) return;
      var a = e.target && e.target.closest && e.target.closest(".kb-field-teamdetails a[ng-click]");
      if (a && /setEnterTeams/.test(a.getAttribute("ng-click") || "")) coachTouchedTabs = true;
    }, true);
    function ensureDetailsView(a) {
      if (coachTouchedTabs || !a || !a.count) return;
      var td = $(".kb-field-teamdetails");
      if (!td || td.querySelector(".kb-table-row")) return;
      var tab = $all("a[ng-click]", td).filter(function(x) {
        return /setEnterTeams\(true\)/.test(x.getAttribute("ng-click") || "");
      })[0];
      if (tab) {
        try {
          tab.click();
        } catch (e) {
        }
      }
    }
    var booted = false;
    function setRosterStepClass(on) {
      var b = document.body;
      var has = b.className.indexOf("xr-roster-step") !== -1;
      if (on && !has) b.className += " xr-roster-step";
      else if (!on && has) b.className = b.className.replace(/\s*xr-roster-step/g, "");
      applyStepLayout(on);
    }
    function applyStepLayout(on) {
      var panel = $(".kb-customise-edit-panel");
      var prev = $(".kb-preview-panel");
      var page = $(".kb-customise-page");
      var wide = window.innerWidth >= 1200;
      try {
        if (on && wide) {
          if (panel) {
            panel.style.setProperty("width", "62%", "important");
            panel.style.setProperty("max-width", "none", "important");
          }
          if (prev) prev.style.setProperty("width", "36%", "important");
          if (page) {
            page.style.setProperty("max-width", "1480px");
            page.style.setProperty("margin-left", "auto");
            page.style.setProperty("margin-right", "auto");
          }
        } else {
          if (panel) {
            panel.style.removeProperty("width");
            panel.style.removeProperty("max-width");
          }
          if (prev) prev.style.removeProperty("width");
          if (page) {
            page.style.removeProperty("max-width");
            page.style.removeProperty("margin-left");
            page.style.removeProperty("margin-right");
          }
        }
      } catch (e) {
      }
    }
    var pkgflowChecked = false;
    function pkgflowReturnCheck() {
      if (pkgflowChecked || !window.XeistUniform) return;
      if (!window.XeistUniformKit || !window.XeistUniformKit.pkgflowConsumeComplete) return;
      pkgflowChecked = true;
      if (!window.XeistUniformKit.pkgflowConsumeComplete(window.XeistUniform.designId)) return;
      pkgHandled = true;
      track("uniform_pkg_complete", { design: window.XeistUniform.designId });
      pkgToast("Package complete", "Every selected garment is ready for player sizing.");
      var tries = 0;
      (function goRoster() {
        var btn = document.querySelector('#xu-steps .xu-step[data-step="roster"]');
        if (btn) {
          try {
            btn.click();
          } catch (e) {
          }
          return;
        }
        if (++tries < 20) setTimeout(goRoster, 500);
      })();
    }
    var seededFor = 0;
    function expectedCount() {
      try {
        return parseInt(window.localStorage.getItem("xeist_expected_" + window.XeistUniform.designId) || "0", 10) || 0;
      } catch (e) {
        return 0;
      }
    }
    function seedRowsToExpected() {
      if (getMethod() !== "manual") return;
      var target = Math.min(expectedCount(), 30);
      if (!target || seededFor === target) return;
      var s = rosterScope();
      if (!s || !sizeOptions().length) return;
      var before = units().length;
      if (before < target) {
        apply(function() {
          if (s.setEnterTeams) s.setEnterTeams(true);
        });
        setRosterLength(s, target, false);
        rowlinkSyncLength();
        track("uniform_roster_seeded", { expected: expectedCount(), before, after: units().length });
      }
      seededFor = target;
    }
    var HEADER_LABELS = ["Player name", "No.", "Jersey size"];
    function syncRosterHeaders() {
      var td = $(".kb-field-teamdetails");
      if (!td) return;
      $all('[class*="kb-team-index-"] table', td).forEach(function(table) {
        if (!table.querySelector("td.kb-unit-size select")) return;
        var ths = $all("thead th", table).filter(function(th) {
          return !th.classList.contains("xr-shsz-th");
        });
        if (ths.length < 3) return;
        table.classList.add("xr-units-labelled");
        HEADER_LABELS.forEach(function(label, i) {
          if (ths[i] && ths[i].textContent !== label) ths[i].textContent = label;
        });
      });
    }
    function alignRosterHeaders() {
      if (window.innerWidth < 750) return;
      var td = $(".kb-field-teamdetails");
      if (!td) return;
      $all("table.xr-units-labelled", td).forEach(function(table) {
        var head = table.querySelector("thead tr");
        var row = null;
        $all("tbody tr", table).some(function(tr) {
          if (tr.querySelector("td.kb-unit-size select")) {
            row = tr;
            return true;
          }
          return false;
        });
        if (!head || !row) return;
        var ths = $all("th", head);
        var cells = Array.prototype.filter.call(row.children, function(c) {
          return /^TD$/i.test(c.tagName);
        });
        if (!ths.length || ths.length !== cells.length) return;
        var hr = head.getBoundingClientRect();
        var rr = row.getBoundingClientRect();
        if (!rr.width) return;
        var sig = [], prevRight = rr.left;
        var plan = cells.map(function(c, i) {
          var r = c.getBoundingClientRect();
          var ml = Math.max(0, Math.round(r.left - prevRight));
          prevRight = r.right;
          sig.push(ml + ":" + Math.round(r.width));
          return { ml, w: Math.round(r.width) };
        });
        var key = sig.join(",") + "|" + Math.round(rr.left - hr.left);
        if (head.getAttribute("data-xr-align") === key) return;
        head.setAttribute("data-xr-align", key);
        head.style.setProperty("display", "flex", "important");
        head.style.setProperty("align-items", "flex-end", "important");
        head.style.setProperty("margin-left", Math.round(rr.left - table.getBoundingClientRect().left) + "px", "important");
        ths.forEach(function(th, i) {
          th.style.setProperty("display", "block", "important");
          th.style.setProperty("flex", "0 0 auto", "important");
          th.style.setProperty("box-sizing", "border-box", "important");
          th.style.setProperty("width", plan[i].w + "px", "important");
          th.style.setProperty("margin-left", plan[i].ml + "px", "important");
          th.style.setProperty("padding-left", "0", "important");
          th.style.setProperty("white-space", "nowrap", "important");
        });
      });
    }
    function shszKey() {
      var w = window.XeistUniform;
      return w ? "xeist_pkg_sizes_" + w.designId : null;
    }
    function shszRead() {
      try {
        return JSON.parse(window.localStorage.getItem(shszKey()) || "null") || {};
      } catch (e) {
        return {};
      }
    }
    function shszWrite(d) {
      try {
        window.localStorage.setItem(shszKey(), JSON.stringify(d));
      } catch (e) {
      }
    }
    function shortsApprovedPkg() {
      var p = getPkg();
      return !!(p && p.shorts && p.shortsStatus === "approved");
    }
    function syncShortsSizes() {
      var m = getMethod();
      var td = $(".kb-field-teamdetails");
      var show = !!(td && m && m !== "parents" && shortsApprovedPkg());
      if (!show) {
        $all(".xr-shsz-cell, .xr-shsz-th").forEach(function(n) {
          if (n.parentNode) n.parentNode.removeChild(n);
        });
        return;
      }
      var sh = (shszRead() || {}).shorts || {};
      var rl = loadRowlink();
      var us = units();
      var opts = sizeOptions();
      var optSig = opts.map(function(o) {
        return o.label;
      }).join("|");
      var table = null;
      var ui = 0;
      $all('[class*="kb-team-index-"] tr.kb-table-row', td).forEach(function(tr) {
        var sizeCell = tr.querySelector("td.kb-unit-size");
        if (!sizeCell || !sizeCell.querySelector("select")) return;
        var i = ui++;
        table = table || tr.closest("table");
        var u = us[i] || {};
        var nk = String(u.name == null ? "" : u.name).trim() + "|" + String(u.number == null ? "" : u.number).trim();
        var k = rl[i] || "";
        var cur = k && sh[k] || sh[nk] || "";
        var cell = tr.querySelector("td.xr-shsz-cell");
        var sel;
        if (!cell) {
          cell = document.createElement("td");
          cell.className = "kb-table-cell kb-table-cell-text xr-shsz-cell";
          sel = document.createElement("select");
          sel.className = "xr-shsz-sel";
          sel.setAttribute("aria-label", "Shorts size");
          cell.appendChild(sel);
          sizeCell.parentNode.insertBefore(cell, sizeCell.nextSibling);
          sel.addEventListener("change", shszChanged);
        } else {
          sel = cell.querySelector("select");
        }
        if (sel.getAttribute("data-opts") !== optSig) {
          sel.setAttribute("data-opts", optSig);
          sel.innerHTML = '<option value="">Same as jersey</option>' + opts.map(function(o) {
            return '<option value="' + esc(o.label) + '">' + esc(o.label) + "</option>";
          }).join("");
        }
        sel.setAttribute("data-k", k);
        sel.setAttribute("data-nk", nk);
        if (document.activeElement !== sel && sel.value !== cur) sel.value = cur;
      });
      if (table && !table.querySelector(".xr-shsz-th")) {
        var ths = $all("thead th", table);
        if (ths.length >= 3) {
          var th = document.createElement("th");
          th.className = "kb-table-header-cell xr-shsz-th";
          th.textContent = "Shorts size";
          ths[2].parentNode.insertBefore(th, ths[2].nextSibling);
        }
      }
    }
    function shszChanged() {
      var d = shszRead();
      d.shorts = d.shorts || {};
      var v = this.value;
      [this.getAttribute("data-k"), this.getAttribute("data-nk")].forEach(function(kk) {
        if (!kk) return;
        if (v) d.shorts[kk] = v;
        else delete d.shorts[kk];
      });
      if (!Object.keys(d.shorts).length) delete d.shorts;
      shszWrite(d);
      track("pkg_shorts_size_set", { design: (window.XeistUniform || {}).designId, size: v || "same" });
    }
    function tick() {
      pkgflowReturnCheck();
      var onStep = !!(window.XeistUniform && $(".kb-field-teamdetails") && onRosterStep());
      if (onStep && !wasOnRosterStep) scrollRosterIntoView();
      wasOnRosterStep = onStep;
      setRosterStepClass(onStep);
      if (!onStep) managePkgModal(false);
      if (!window.XeistUniform) return;
      if (!$(".kb-field-teamdetails")) return;
      injectCSS();
      buildCard();
      relocateExtras();
      renderState(false);
      var a = renderAudit();
      renderProgress(a);
      renderPricing(a ? a.count : 0);
      hardenNumberInputs();
      var qaHost = $("#xm-qa");
      if (qaHost && qaHost.hidden === isMobileQA()) mountQuickAdd($("#xr-card"));
      renderQuickList();
      enforceNames();
      renderNamesRow();
      rowlinkSyncLength();
      ensureDetailsView(a);
      seedRowsToExpected();
      syncRosterHeaders();
      syncShortsSizes();
      alignRosterHeaders();
      if (!booted) {
        booted = true;
        window.XeistUniformRoster = {
          // 2026-08-27: module 32 needs the CURRENT collect method — a
          // parents-pay flag left on the design must not block a coach who
          // is hand-entering (or uploading) a roster to pay for it himself.
          method: getMethod,
          audit: auditRoster,
          priceInfo,
          // 2026-09-10 (audit P0 #2): jersey + approved shorts, summed the way
          // the cart will charge them. Module 32's money block reads this.
          kitInfo,
          shortsInKit,
          // Session B (parent-pay): module 35's payment popup prices the
          // coach's package. Jersey = tier-1 base; add-ons per PKG_PRICES.
          jerseyBase: jerseyBasePrice,
          pkgPrices: function() {
            return { shorts: pkgPrice("shorts"), compression: pkgPrice("compression") };
          },
          minQty,
          // W3/T1.3: jump-to-fix from the Review drawer. Opens the Roster
          // step, reveals the manual table if a method chooser is showing,
          // then scrolls to the row and focuses its first incomplete field.
          gotoRow: function(rowIndex) {
            var step = $all(".xu-step").filter(function(b) {
              return /Roster/i.test(b.textContent);
            })[0];
            if (step) step.click();
            setTimeout(function() {
              var later = document.getElementById("xp-later");
              if (later) later.click();
              var table = $(".kb-units-table");
              if (!table || !table.offsetHeight) {
                var m = $all(".xr-method").filter(function(x) {
                  return /Add players/i.test(x.textContent);
                })[0];
                if (m) m.click();
              }
              setTimeout(function() {
                if (document.body.classList.contains("xm-on")) {
                  qaSetMode(rowIndex);
                  var f = $("#xm-qa .xm-form") || $("#xm-qa");
                  if (f) f.scrollIntoView({ block: "center", behavior: "smooth" });
                  return;
                }
                var rows = $all(".kb-units-table tr.kb-table-row");
                var r = rows[rowIndex];
                if (!r) return;
                r.scrollIntoView({ block: "center", behavior: "smooth" });
                var ins = r.querySelectorAll("input");
                var sel = r.querySelector("select");
                var target = ins[0] && !String(ins[0].value).trim() ? ins[0] : ins[1] && !String(ins[1].value).trim() ? ins[1] : sel && !sel.value ? sel : ins[0];
                try {
                  target.focus();
                } catch (e) {
                }
                r.style.transition = "background .3s";
                r.style.background = "#fff6e5";
                setTimeout(function() {
                  r.style.background = "";
                }, 1800);
              }, 600);
            }, 500);
          },
          // W2/T1.2: KB bills every roster ROW, including untouched blanks
          // (audit: 2 named players + 12 seeded blanks -> billed 14). Called
          // by module 32 right before triggering KB's buy. Keeps at least
          // one row so KB's table never renders empty.
          stripEmptyRows: function() {
            var s = rosterScope();
            if (!s || typeof s.teams !== "function") return 0;
            var removed = 0;
            apply(function() {
              var t = s.teams() || [];
              for (var ti = 0; ti < t.length; ti++) {
                var us = t[ti] && t[ti].units || [];
                for (var i = us.length - 1; i >= 0; i--) {
                  var u = us[i] || {};
                  var has = String(u.name == null ? "" : u.name).trim() || String(u.number == null ? "" : u.number).trim() || u.size;
                  if (!has && us.length > 1 && typeof s.removeUnit === "function") {
                    try {
                      s.removeUnit(ti, i);
                      removed++;
                      if (ti === 0) rowlinkSplice(i);
                    } catch (e) {
                    }
                  }
                }
              }
            });
            return removed;
          },
          // Size option list + pure matcher (2026-09-11): module 33 caches a
          // design's options and matches the jersey roster against the SHORTS
          // product's options on the jersey page (sync kit add).
          sizeOptions,
          matchSizeIn,
          readRows: function() {
            var opts = {};
            sizeOptions().forEach(function(o) {
              opts[o.id] = o.label;
            });
            var rl = loadRowlink();
            return units().map(function(u, i) {
              return {
                name: String(u.name == null ? "" : u.name).trim(),
                number: String(u.number == null ? "" : u.number).trim(),
                sizeLabel: u.size ? opts[u.size] || "" : "",
                xuid: rl[i] || null
                // W9/T2.4: stable identity rides along
              };
            }).filter(function(r) {
              return r.name || r.number || r.sizeLabel;
            });
          },
          importRows: function(rows, done) {
            var mapped = (rows || []).map(function(r) {
              return { name: r.name || "", number: r.number || "", sizeRaw: r.sizeLabel || "", xuid: r.xuid || null };
            });
            importRoster(mapped, "replace", function(res) {
              if (done) done(res ? res.written : 0);
            });
          }
        };
        track("uniform_roster_boot", { design: window.XeistUniform.designId });
      }
    }
    if (window.XeistCore && XeistCore.every) {
      XeistCore.every("xu-uniform-roster", 1200, tick, { runHidden: true });
    } else {
      setInterval(tick, 1200);
    }
  })();

  // src/uniform/32-uniform-review.js
  (function() {
    "use strict";
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    function $(s, r) {
      return (r || document).querySelector(s);
    }
    function $all(s, r) {
      return Array.prototype.slice.call((r || document).querySelectorAll(s));
    }
    function el(tag, cls, html) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (html != null) e.innerHTML = html;
      return e;
    }
    function esc(s) {
      return String(s == null ? "" : s).replace(/[&<>"']/g, function(c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }
    function track(type, payload) {
      try {
        if (window.XeistTrack) window.XeistTrack(type, payload || {});
      } catch (e) {
      }
    }
    function kbInjectorOk(inj) {
      try {
        return !!(inj && inj.has && inj.has("KitService"));
      } catch (e) {
        return false;
      }
    }
    function getInjector() {
      try {
        if (window.XeistCore && XeistCore.getInjector) {
          var i = XeistCore.getInjector();
          if (kbInjectorOk(i)) return i;
        }
        if (!window.angular) return null;
        var h = $(".kb-customise-page") || $("#kb-app");
        var hi = h ? angular.element(h).injector() : null;
        if (kbInjectorOk(hi)) return hi;
        var bi = angular.element(document.body).injector();
        if (kbInjectorOk(bi)) return bi;
      } catch (e) {
      }
      return null;
    }
    function zoneLabels() {
      var w = window.XeistUniform;
      if (w && w.design && w.design.zones) {
        return w.design.zones.map(function(z) {
          return [z.key, z.label];
        });
      }
      return [
        ["primarycolors", "Body"],
        ["sidedesign1", "Side Panel"],
        ["sidedesign2", "Side Panel Accent"],
        ["collarandarmholes", "Collar & Armholes"],
        ["collarandarmholespiping", "Piping"]
      ];
    }
    function zoneColor(key) {
      var row = $(".kb-field-" + key);
      var i = row && row.querySelector("input.kb-tile-picker-radio:checked");
      if (!i) return null;
      var li = i.closest ? i.closest("li") : i.parentNode;
      var t = li && li.querySelector(".kb-tile-picker-tile");
      return { hex: i.value, name: t && t.title || i.value };
    }
    function kitValues() {
      var inj = getInjector();
      if (!inj) return null;
      try {
        return inj.get("KitService").getKitValues() || null;
      } catch (e) {
        return null;
      }
    }
    function designFacts() {
      var kv = kitValues() || {};
      var ed = kv.editor || [];
      var teamname = null, font = null, logos = 0;
      ed.forEach(function(it) {
        if (it && it.type === "text") {
          if (it.placementKey === "add-teamname") teamname = it.text;
          font = font || it.fontFamily;
        } else if (it) logos++;
      });
      return { teamname, font, logos };
    }
    function viewButtons() {
      return $all("a.kb-change-view-button");
    }
    function changeView(which) {
      var re = which === "front" ? /front/i : /back/i;
      var btn = viewButtons().filter(function(b) {
        return re.test(b.innerText || "");
      })[0];
      if (btn) btn.click();
    }
    var QUOTE_URL = "/pages/get-a-quote-page";
    var QAPI = window.XeistConfig && window.XeistConfig.sessionApi ? String(window.XeistConfig.sessionApi).replace(/\/+$/, "") : null;
    function section(title, bodyHTML) {
      return '<section class="xv-sec"><h4>' + title + "</h4>" + bodyHTML + "</section>";
    }
    function moneyHTML(count, includeShorts) {
      var R = window.XeistUniformRoster;
      var M = window.XeistMoney || null;
      var mUnit = function(n) {
        return M ? M.kbUnit(n) : "$" + n.toFixed(2);
      };
      var mLine = function(n) {
        return M ? M.kbLine(n) : "$" + n.toFixed(2);
      };
      var fmtS = function(n) {
        return M ? M.fmt(n) : "$" + n.toFixed(2);
      };
      var html = "";
      try {
        var p = R.priceInfo(count);
        if (!p) return "";
        var kit = R.kitInfo ? R.kitInfo(count, includeShorts) : null;
        var converts = !!(M && M.converts());
        var inc = p.addOn ? '<span class="xv-dim">' + mUnit(p.base) + " uniform + " + mUnit(p.addOn) + " " + esc(p.addOnLabel || "printing") + " per player</span>" : '<span class="xv-dim">numbers &amp; team name printing included</span>';
        var note = M ? M.note() : "";
        var lineOf = function(unitUsd, totalUsd) {
          return converts ? count + " players · " + M.kbPer(unitUsd, count) + " each · " + mLine(totalUsd) : count + " × " + mUnit(unitUsd) + " = " + mLine(totalUsd);
        };
        if (kit && kit.shorts) {
          html = '<div id="xv-price-line" class="xv-kit"><p class="xv-kit-row"><span>Jersey</span><span>' + lineOf(kit.jersey.unit, kit.jersey.total) + '</span></p><p class="xv-kit-row"><span>Matching shorts <em>approved ✓</em></span><span>' + lineOf(kit.shorts.unit, kit.shorts.total) + '</span></p><p class="xv-kit-row xv-kit-total"><span>Kit total</span><strong>' + fmtS(kit.line) + '</strong></p><p class="xv-kit-per">' + (converts ? "≈ " : "") + fmtS(kit.perPlayer) + " per player (jersey + shorts) " + inc + (note ? '<span class="xv-dim xv-fx">' + esc(note) + "</span>" : "") + "</p></div>";
        } else {
          html = '<p id="xv-price-line"><strong>' + lineOf(p.unit, p.total) + "</strong> " + inc + (note ? '<span class="xv-dim xv-fx">' + esc(note) + "</span>" : "") + "</p>";
        }
        try {
          if (window.XeistNamesOpt && XeistNamesOpt.capable()) {
            html += '<label class="xv-names"><input type="checkbox" id="xv-names-cb"' + (XeistNamesOpt.on() ? " checked" : "") + "><span>Add player last names to the jerseys <strong>" + mUnit(5) + " more per player</strong></span></label>";
          }
        } catch (e3) {
        }
      } catch (e) {
      }
      return html;
    }
    function rerenderMoney(includeShorts) {
      var host = document.getElementById("xv-money");
      if (!host) return;
      var R = window.XeistUniformRoster;
      var count = 0;
      try {
        count = (R && R.audit ? R.audit().count : 0) || 0;
      } catch (e) {
      }
      if (!count) return;
      host.innerHTML = moneyHTML(count, includeShorts);
      bindNamesCb(host);
    }
    function render() {
      var w = window.XeistUniform || {};
      var d = w.design || {};
      var facts = designFacts();
      var zones = zoneLabels().map(function(z) {
        var c = zoneColor(z[0]);
        return c ? '<li><span class="xv-swatch" style="background:' + esc(c.hex) + '"></span>' + esc(z[1]) + " — " + esc(c.name) + "</li>" : "";
      }).join("");
      var rosterHTML = '<p class="xv-dim">No roster yet — add players in the Roster step.</p>';
      var R = window.XeistUniformRoster;
      var audit = null;
      if (R && R.audit) {
        try {
          audit = R.audit();
        } catch (e) {
        }
        if (audit && audit.count) {
          var sizes = Object.keys(audit.sizes).map(function(k) {
            return esc(k) + " × " + audit.sizes[k];
          }).join(" · ");
          var blockers = audit.blockers || [], cautions = audit.cautions || [];
          var issueHTML = "";
          if (blockers.length) {
            issueHTML += '<ul class="xv-blocklist">' + blockers.map(function(b, i) {
              return "<li>" + esc(b.msg) + ' <a href="#" class="xv-fix" data-bi="' + i + '">Fix</a></li>';
            }).join("") + "</ul>";
          }
          if (cautions.length) {
            issueHTML += '<ul class="xv-warnlist">' + cautions.map(function(c) {
              return "<li>" + esc(c.msg) + "</li>";
            }).join("") + '</ul><label class="xv-caution-ok"><input type="checkbox" id="xv-caution-ok"> I&rsquo;ve reviewed the notes above &mdash; continue</label>';
          }
          if (!blockers.length && !cautions.length) issueHTML = '<p class="xv-ok">Roster looks good — no issues found.</p>';
          rosterHTML = "<p><strong>" + audit.count + " player" + (audit.count === 1 ? "" : "s") + "</strong>" + (sizes ? " — " + sizes : "") + "</p>" + issueHTML;
        }
      }
      var priceHTML = "";
      if (R && R.priceInfo && audit && audit.count) {
        priceHTML = '<div id="xv-money">' + moneyHTML(audit.count, null) + "</div>";
      }
      return '<header class="xv-head"><h3>Review your uniform</h3><button type="button" class="xv-close" aria-label="Back to editing">&times;</button></header><p class="xv-trust">No order goes into production until your design is reviewed and approved by XEIST.</p>' + section(
        "Your uniform",
        '<div class="xv-views"><button type="button" class="xv-view" data-view="front">Front</button><button type="button" class="xv-view" data-view="back">Back</button><span class="xv-dim">Drag the model to rotate &middot; scroll to zoom</span></div>'
      ) + section(
        "Design",
        '<ul class="xv-zones">' + zones + "</ul><p>Style: <strong>" + esc(d.name || "") + "</strong>" + (facts.teamname ? " &middot; Team name: <strong>" + esc(facts.teamname) + "</strong>" : "") + (facts.font ? " &middot; Font: <strong>" + esc(facts.font) + "</strong>" : "") + " &middot; Logos: <strong>" + facts.logos + " uploaded</strong></p>"
      ) + section("Roster", rosterHTML + priceHTML) + section(
        "Production",
        '<ul class="xv-plain"><li>' + esc(d.timeline || "Est. 3–4 weeks") + " after design approval</li><li>Design review by XEIST included — we check every logo, name and number</li><li>Nothing is stitched until you approve the final proof</li></ul>"
      ) + section(
        "Ready?",
        // W3/T1.3: the pay CTA is GATED. Blockers disable it and relabel
        // it with the fix count; cautions disable it until acknowledged.
        (function() {
          var nb = (audit && audit.blockers || []).length;
          var nc = (audit && audit.cautions || []).length;
          if (!audit || !audit.count) return '<button type="button" class="xu-cta xv-pay xv-goto-roster" id="xv-goto-roster">Add your players to continue →</button>';
          if (nb) return '<button type="button" class="xu-cta xv-pay xv-pay-blocked" id="xv-pay" disabled>Fix ' + nb + " thing" + (nb > 1 ? "s" : "") + " to continue</button>";
          try {
            var wpp = window.XeistUniform;
            var xrMeth = "";
            try {
              xrMeth = window.XeistUniformRoster && window.XeistUniformRoster.method ? String(window.XeistUniformRoster.method() || "") : "";
            } catch (eM) {
            }
            if (wpp && xrMeth !== "manual" && xrMeth !== "upload" && localStorage.getItem("xeist_paymode_" + wpp.designId) === "parent") {
              return '<button type="button" class="xu-cta xv-pay xv-parentpay" id="xv-parentpay" disabled>Parents pay online — no team checkout needed</button><p class="xv-parentpay-note">Each player is paid through your share link. XEIST reviews the design and sends your production proof once the roster is in.</p>';
            }
          } catch (e0) {
          }
          if (nc) return '<button type="button" class="xu-cta xv-pay" id="xv-pay" disabled data-needs-ack="1">Add to cart — pay in full</button>';
          return '<button type="button" class="xu-cta xv-pay" id="xv-pay">Add to cart — pay in full</button>';
        })() + '<div class="xv-alt"><button type="button" class="xv-alt-link" id="xv-quote">Request a quote / invoice</button><button type="button" class="xv-alt-link" id="xv-designer">Send to a XEIST designer</button></div><p class="xv-dim">Quotes and designer requests are free — we reply within one business day.</p>'
      );
    }
    function bindDialog(card, onDismiss, initialFocus) {
      var prevFocus = document.activeElement;
      function onKey(e) {
        if (e.key === "Escape") {
          e.stopPropagation();
          onDismiss();
          return;
        }
        if (e.key !== "Tab") return;
        var f = card.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
      document.addEventListener("keydown", onKey, true);
      card.setAttribute("aria-modal", "true");
      if (initialFocus) setTimeout(function() {
        try {
          initialFocus.focus();
        } catch (e) {
        }
      }, 60);
      return function unbind() {
        document.removeEventListener("keydown", onKey, true);
        try {
          if (prevFocus && prevFocus.focus) prevFocus.focus();
        } catch (e) {
        }
      };
    }
    var xvPending = window.__xvPendingOrderProps = window.__xvPendingOrderProps || { props: null, until: 0 };
    (function installCartAddPropsHook() {
      var XP = window.XMLHttpRequest && XMLHttpRequest.prototype;
      if (!XP || XP.__xvPropsHook) return;
      XP.__xvPropsHook = true;
      var origOpen = XP.open;
      var origSend = XP.send;
      XP.open = function(method, url) {
        try {
          this.__xvCartAdd = String(method).toUpperCase() === "POST" && /\/cart\/add(\.js)?(\?|$)/.test(String(url));
        } catch (e) {
          this.__xvCartAdd = false;
        }
        return origOpen.apply(this, arguments);
      };
      XP.send = function(body) {
        if (this.__xvCartAdd && xvPending.props && Date.now() < xvPending.until && typeof body === "string") {
          try {
            var payload = JSON.parse(body);
            if (payload && payload.items && payload.items.length) {
              payload.items[0].properties = payload.items[0].properties || {};
              for (var k in xvPending.props) {
                if (xvPending.props.hasOwnProperty(k)) payload.items[0].properties[k] = xvPending.props[k];
              }
              body = JSON.stringify(payload);
              xvPending.props = null;
              return origSend.call(this, body);
            }
          } catch (e) {
          }
        }
        return origSend.apply(this, arguments);
      };
    })();
    function editUrl(did) {
      var hash = String(location.hash || "");
      if (!/customise\/\d+/.test(hash)) hash = "#/customise/" + did;
      var qs = "";
      try {
        var th = window.Shopify && window.Shopify.theme;
        if (th && th.id && th.role !== "main") qs = "?preview_theme_id=" + th.id;
      } catch (e) {
      }
      return location.origin + location.pathname + qs + hash;
    }
    function buildOrderProps() {
      var R = window.XeistUniformRoster;
      var w = window.XeistUniform || {};
      var did = String(w.designId || (String(location.hash).match(/customise\/(\d+)/) || [])[1] || "");
      var rows = R && R.readRows ? R.readRows() : [];
      var rosterText = rows.map(function(r) {
        return (r.name || "—") + " #" + (r.number || "—") + " (" + (r.sizeLabel || "no size") + ")";
      }).join(" · ");
      var teamName = "";
      try {
        var es = window.XeistCore && XeistCore.getES && XeistCore.getES();
        var tn = (es && es.getModel && es.getModel() || []).filter(function(x) {
          return x.placementKey === "add-teamname";
        })[0];
        if (tn && !/^TEAM\s*NAME$/i.test(String(tn.text || "").trim())) teamName = String(tn.text || "").trim();
      } catch (e2) {
      }
      if (!teamName && w.team && w.team.name) teamName = String(w.team.name);
      var raw = {
        "Team": teamName,
        "Players": rows.length ? String(rows.length) : "",
        "Roster": rosterText,
        "_design_id": did,
        // 2026-09-10 (audit P0 #5): the cart's Edit-design link must reopen
        // THIS basket entry, not a blank design — the hash carries
        // ?basketIndex=N (browser-local, but the Shopify cart is browser-
        // local too). On an unpublished theme the link keeps the preview
        // param so it renders from the same twin (module 35's rule).
        "_edit_url": editUrl(did),
        "_roster_json": JSON.stringify(rows)
      };
      var out = null;
      for (var k in raw) {
        if (!raw.hasOwnProperty(k)) continue;
        var v = raw[k];
        if (v == null || v === "" || v === "[]") continue;
        (out = out || {})[String(k).slice(0, 100)] = String(v).slice(0, 4e3);
      }
      return out;
    }
    function armOrderProps() {
      try {
        var props = buildOrderProps();
        if (window.XeistKBBridge && XeistKBBridge.setOrderProperties) XeistKBBridge.setOrderProperties(props);
        xvPending.props = props;
        xvPending.until = Date.now() + 6e4;
        return props;
      } catch (e) {
        return null;
      }
    }
    var unbindDrawer = null;
    function open() {
      close();
      var scrim = el("div", "", "");
      scrim.id = "xv-scrim";
      var drawer = el("aside", "", render());
      drawer.id = "xv-drawer";
      drawer.setAttribute("role", "dialog");
      drawer.setAttribute("aria-label", "Review your uniform");
      document.body.appendChild(scrim);
      document.body.appendChild(drawer);
      scrim.addEventListener("click", close);
      drawer.querySelector(".xv-close").addEventListener("click", close);
      unbindDrawer = bindDialog(drawer, close, drawer.querySelector(".xv-close"));
      $all(".xv-view", drawer).forEach(function(b) {
        b.addEventListener("click", function() {
          changeView(b.getAttribute("data-view"));
        });
      });
      $all(".xv-fix", drawer).forEach(function(a) {
        a.addEventListener("click", function(e) {
          e.preventDefault();
          var R = window.XeistUniformRoster;
          var bi = parseInt(a.getAttribute("data-bi"), 10);
          var b = (R && R.audit ? R.audit().blockers || [] : [])[bi];
          track("uniform_review_fix_click", { msg: b ? b.msg.slice(0, 60) : "?", design: (window.XeistUniform || {}).designId });
          close();
          if (b && b.design) {
            var look = $all(".xu-step").filter(function(s) {
              return /Look/i.test(s.textContent);
            })[0];
            if (look) look.click();
            setTimeout(function() {
              var et = $all("button, a").filter(function(x) {
                return /Edit team/i.test(x.innerText || "");
              })[0];
              if (et) et.click();
            }, 600);
            return;
          }
          if (R && R.gotoRow) {
            var row = b && b.rows && b.rows.length ? b.rows[0] : (R.audit() || {}).count || 0;
            R.gotoRow(row);
          }
        });
      });
      var ack = drawer.querySelector("#xv-caution-ok");
      if (ack) {
        ack.addEventListener("change", function() {
          var pay = drawer.querySelector("#xv-pay");
          if (pay && pay.getAttribute("data-needs-ack")) pay.disabled = !ack.checked;
        });
      }
      function showCartBuildOverlay() {
        if (document.getElementById("xv-building")) return;
        var team = "";
        try {
          team = window.XeistUniform.team && window.XeistUniform.team.name || "";
        } catch (e) {
        }
        var n = 0;
        try {
          n = (window.XeistUniformRoster.readRows() || []).length;
        } catch (e2) {
        }
        var twoStep = false, syncKit = !!window.__xeistKitSync;
        try {
          var cc = JSON.parse(localStorage.getItem("xeist_shorts_carry") || "null");
          twoStep = !!(cc && cc.autoBuy && String(cc.fromDesign) === String((window.XeistUniform || {}).designId));
        } catch (e3) {
        }
        var ov = el("div", "", "");
        ov.id = "xv-building";
        ov.innerHTML = '<style>#xv-building{position:fixed;inset:0;z-index:2147483500;background:rgba(255,255,255,.96);display:flex;align-items:center;justify-content:center;text-align:center;padding:24px}#xv-building .xvb-box{max-width:420px}#xv-building .xvb-spin{width:44px;height:44px;border:3.5px solid #e8e8e6;border-top-color:#111;border-radius:50%;margin:0 auto 22px;animation:xvbspin .9s linear infinite}@keyframes xvbspin{to{transform:rotate(360deg)}}#xv-building h3{font:700 22px/1.3 -apple-system,BlinkMacSystemFont,sans-serif;color:#111;margin:0 0 10px;letter-spacing:-.01em}#xv-building p{font:400 14.5px/1.6 -apple-system,BlinkMacSystemFont,sans-serif;color:#6e6e73;margin:0}#xv-building .xvb-close{display:none;margin:20px auto 0;padding:11px 22px;border:1px solid #ddd;border-radius:10px;background:#fff;font:600 13px -apple-system,sans-serif;color:#111;cursor:pointer}</style><div class="xvb-box"><div class="xvb-spin" aria-hidden="true"></div><h3 id="xvb-h">Creating your ' + esc(team ? team.toUpperCase() : "team") + ' uniforms…</h3><p id="xvb-p">' + (n ? "Adding " + n + " player" + (n === 1 ? "" : "s") + " to your cart. " : "") + (syncKit ? "Jerseys and matching shorts are being created together — about 30 seconds. Your cart opens automatically. Please don’t close this page." : twoStep ? "Jerseys first — your approved matching shorts are added automatically right after (about a minute in total). Please don’t close this page." : "This usually takes about 30 seconds — your cart will open automatically. Please don’t close this page.") + '</p><button type="button" class="xvb-close" id="xvb-close">Close</button></div>';
        document.body.appendChild(ov);
        setTimeout(function() {
          var h = document.getElementById("xvb-h");
          if (h) h.textContent = "Still working…";
          var pp = document.getElementById("xvb-p");
          if (pp) pp.textContent = "Big rosters can take a little longer — hang tight, your cart will open on its own.";
        }, 6e4);
        setTimeout(function() {
          var c = document.getElementById("xvb-close");
          if (c) {
            c.style.display = "inline-block";
            c.addEventListener("click", function() {
              if (ov.parentNode) ov.parentNode.removeChild(ov);
            });
            var pp = document.getElementById("xvb-p");
            if (pp) pp.textContent = "This is taking longer than it should. Check your cart from the site menu — or close this and press Add to cart once more.";
          }
        }, 12e4);
      }
      function doBuy() {
        armOrderProps();
        close();
        showCartBuildOverlay();
        var buy = $(".kb-button-single-item-checkout-buy-now");
        if (buy) {
          buy.scrollIntoView({ block: "center" });
          var ael = window.angular && angular.element;
          if (ael && ael(buy).triggerHandler) ael(buy).triggerHandler("click");
          else buy.click();
        }
      }
      function showDupPrompt(dup) {
        var old = drawer.querySelector("#xv-dup");
        if (old && old.parentNode) old.parentNode.removeChild(old);
        var box = el("div", "", "");
        box.id = "xv-dup";
        box.innerHTML = '<p><strong>This design is already in your cart.</strong> Add it again, or replace the one that&rsquo;s there?</p><div class="xv-dup-btns"><button type="button" class="xu-cta" id="xv-dup-replace">Replace the one in my cart</button><button type="button" class="xv-dup-quiet" id="xv-dup-keep">Add as a second order</button><button type="button" class="xv-dup-quiet" id="xv-dup-cancel">Cancel</button></div>';
        var pay = drawer.querySelector("#xv-pay");
        pay.parentNode.insertBefore(box, pay);
        pay.style.display = "none";
        function stampCarryDup(choice) {
          window.__xeistDupChoice = choice;
          try {
            var k = "xeist_shorts_carry";
            var c = JSON.parse(localStorage.getItem(k) || "null");
            if (c && c.autoBuy) {
              c.dup = choice;
              localStorage.setItem(k, JSON.stringify(c));
            }
          } catch (e) {
          }
        }
        box.querySelector("#xv-dup-replace").addEventListener("click", function() {
          track("uniform_dup_replace", { design: (window.XeistUniform || {}).designId });
          stampCarryDup("replace");
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: dup.key, quantity: 0 })
          }).then(doBuy).catch(doBuy);
        });
        box.querySelector("#xv-dup-keep").addEventListener("click", function() {
          track("uniform_dup_keep", { design: (window.XeistUniform || {}).designId });
          stampCarryDup("keep");
          doBuy();
        });
        box.querySelector("#xv-dup-cancel").addEventListener("click", function() {
          if (box.parentNode) box.parentNode.removeChild(box);
          pay.style.display = "";
          try {
            localStorage.removeItem("xeist_shorts_carry");
          } catch (e) {
          }
          try {
            var evC;
            try {
              evC = new CustomEvent("xeist:review-buy-cancel");
            } catch (eC) {
              evC = document.createEvent("Event");
              evC.initEvent("xeist:review-buy-cancel", false, false);
            }
            document.dispatchEvent(evC);
          } catch (eD) {
          }
        });
      }
      var payBtn = drawer.querySelector("#xv-pay");
      if (payBtn) payBtn.addEventListener("click", function() {
        if (this.disabled) return;
        track("uniform_review_pay", { design: (window.XeistUniform || {}).designId });
        try {
          if (window.XeistUniformKit && XeistUniformKit.pkgflowClear) XeistUniformKit.pkgflowClear();
        } catch (eP) {
        }
        try {
          var R = window.XeistUniformRoster;
          if (R && R.stripEmptyRows) {
            var n = R.stripEmptyRows();
            if (n) track("uniform_rows_stripped", { removed: n, design: (window.XeistUniform || {}).designId });
          }
        } catch (e) {
        }
        var did = String((window.XeistUniform || {}).designId || "");
        fetch("/cart.js").then(function(r) {
          return r.json();
        }).then(function(c) {
          var dup = did && (c.items || []).filter(function(i) {
            return i.properties && String(i.properties._design_id || "") === did;
          })[0];
          if (dup) showDupPrompt(dup);
          else doBuy();
        }).catch(doBuy);
      });
      drawer.querySelector("#xv-quote").addEventListener("click", function() {
        track("uniform_review_quote", { design: (window.XeistUniform || {}).designId });
        openQuoteModal("quote");
      });
      drawer.querySelector("#xv-designer").addEventListener("click", function() {
        track("uniform_review_designer", { design: (window.XeistUniform || {}).designId });
        openQuoteModal("designer");
      });
      function openQuoteModal(kind) {
        if (!QAPI) {
          try {
            window.open(QUOTE_URL, "_blank", "noopener");
          } catch (e) {
          }
          return;
        }
        var old = document.getElementById("xq-modal");
        if (old && old.parentNode) old.parentNode.removeChild(old);
        var w = window.XeistUniform || {};
        var d = w.design || {};
        var props = {};
        try {
          props = buildOrderProps() || {};
        } catch (e) {
        }
        var R = window.XeistUniformRoster;
        var count = 0, total = null;
        try {
          var a = R && R.audit ? R.audit() : null;
          count = a ? a.count : 0;
          if (count && R.priceInfo) {
            var p = R.priceInfo(count);
            if (p) total = p.total;
          }
        } catch (e) {
        }
        var designName = String(d.name || "Custom uniform");
        var sumBits = [designName];
        if (props.Team) sumBits.push(props.Team);
        sumBits.push(count ? count + " player" + (count === 1 ? "" : "s") : "roster not started");
        var MQ = window.XeistMoney || null;
        if (total != null) sumBits.push(MQ ? MQ.kbLine(total) : "$" + total.toFixed(2));
        var title = kind === "designer" ? "Send your design to a XEIST designer" : "Request a quote / invoice";
        var sub = kind === "designer" ? "A XEIST designer will review your design, tidy anything that needs it, and get back to you." : "We’ll reply with a formal quote or invoice — free, within one business day.";
        var m = el("div", "", "");
        m.id = "xq-modal";
        m.innerHTML = '<div class="xq-scrim"></div><div class="xq-card" role="dialog" aria-modal="true" aria-label="' + esc(title) + '"><h3 class="xq-h">' + esc(title) + '</h3><p class="xq-sub">' + sub + '</p><p class="xq-summary">' + esc(sumBits.join(" · ")) + '</p><label class="xq-lab" for="xq-name">Your name</label><input id="xq-name" class="xq-in" type="text" autocomplete="name"><label class="xq-lab" for="xq-email">Email <span class="xq-req">(required)</span></label><input id="xq-email" class="xq-in" type="email" autocomplete="email" required><label class="xq-lab" for="xq-phone">Phone <span class="xq-req">(optional)</span></label><input id="xq-phone" class="xq-in" type="tel" autocomplete="tel"><label class="xq-lab" for="xq-notes">Anything we should know?</label><textarea id="xq-notes" class="xq-in xq-ta" rows="3" placeholder="Deadlines, quantities, questions…"></textarea><input id="xq-web" type="text" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute;left:-9999px"><p class="xq-err" id="xq-err" hidden></p><div class="xq-btns"><button type="button" class="xu-cta xq-send" id="xq-send">Send request</button><button type="button" class="xv-alt-link" id="xq-cancel">Cancel</button></div></div>';
        document.body.appendChild(m);
        function closeModal() {
          if (m.parentNode) m.parentNode.removeChild(m);
          unbind();
        }
        var unbind = bindDialog(m.querySelector(".xq-card"), closeModal, m.querySelector("#xq-name")) || function() {
        };
        m.querySelector(".xq-scrim").addEventListener("click", closeModal);
        m.querySelector("#xq-cancel").addEventListener("click", closeModal);
        m.querySelector("#xq-send").addEventListener("click", function() {
          var email = m.querySelector("#xq-email").value.replace(/\s+/g, "");
          var errEl = m.querySelector("#xq-err");
          if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
            errEl.hidden = false;
            errEl.textContent = "Enter the email address we should reply to.";
            m.querySelector("#xq-email").focus();
            return;
          }
          errEl.hidden = true;
          var btn = m.querySelector("#xq-send");
          btn.disabled = true;
          btn.textContent = "Sending…";
          var payload = {
            kind,
            name: m.querySelector("#xq-name").value.trim().slice(0, 80),
            email: email.slice(0, 120),
            phone: m.querySelector("#xq-phone").value.trim().slice(0, 40),
            notes: m.querySelector("#xq-notes").value.trim().slice(0, 1e3),
            website: m.querySelector("#xq-web").value,
            design: props._design_id || String(w.designId || ""),
            designName: designName.slice(0, 80),
            team: props.Team || "",
            players: count,
            // Worker prints "$" + total: send the session-currency line with
            // its code so Slack/HubSpot read "$676.00 CAD", never a bare USD figure.
            total: total != null ? MQ ? MQ.lineTotal(total).toFixed(2) + " " + MQ.code() : total.toFixed(2) : "",
            roster: (props.Roster || "").slice(0, 1500),
            url: props._edit_url || location.origin + location.pathname + "#/customise/" + (w.designId || "")
          };
          fetch(QAPI + "/quote", {
            method: "POST",
            mode: "cors",
            headers: { "Content-Type": "text/plain" },
            body: JSON.stringify(payload)
          }).then(function(r) {
            return r.ok ? r.json() : null;
          }).then(function(res) {
            if (!res || !res.ok) throw new Error("bad");
            track("uniform_quote_sent", { design: payload.design, kind, ref: res.ref });
            m.querySelector(".xq-card").innerHTML = '<h3 class="xq-h">Request received ✓</h3><p class="xq-sub">Your reference is <strong>' + esc(res.ref) + "</strong>. We reply within one business day" + (payload.email ? " — a confirmation is on its way to " + esc(payload.email) : "") + '.</p><div class="xq-btns"><button type="button" class="xu-cta xq-send" id="xq-done">Done</button></div>';
            m.querySelector("#xq-done").addEventListener("click", closeModal);
          }).catch(function() {
            btn.disabled = false;
            btn.textContent = "Send request";
            errEl.hidden = false;
            errEl.innerHTML = 'Couldn’t send right now — try again, or use our <a href="' + QUOTE_URL + '" target="_blank" rel="noopener">quote form</a>.';
            track("uniform_quote_error", { design: payload.design, kind });
          });
        });
      }
      var gotoRoster = drawer.querySelector("#xv-goto-roster");
      if (gotoRoster) gotoRoster.addEventListener("click", function() {
        track("uniform_review_goto_roster", { design: (window.XeistUniform || {}).designId });
        close();
        var step = $all(".xu-step").filter(function(b) {
          return /Roster/i.test(b.textContent);
        })[0];
        if (step) step.click();
      });
      bindNamesCb(drawer);
      mountMobileFooter(drawer);
      drawer.addEventListener("change", function(e) {
        var t = e.target;
        if (t && t.id === "xs-drawer-check") rerenderMoney(!!t.checked);
      });
      track("uniform_review_open", { design: (window.XeistUniform || {}).designId });
      try {
        var evOpen;
        try {
          evOpen = new CustomEvent("xeist:review-open", { detail: { drawer } });
        } catch (eC) {
          evOpen = document.createEvent("Event");
          evOpen.initEvent("xeist:review-open", false, false);
        }
        document.dispatchEvent(evOpen);
      } catch (eD) {
      }
    }
    function mountMobileFooter(drawer) {
      if (!drawer || window.innerWidth > 749) return;
      var pay = drawer.querySelector("#xv-pay");
      if (!pay || drawer.querySelector("#xv-footer")) return;
      var f = el("div", "xv-footer", "");
      f.id = "xv-footer";
      var b = el("button", "xu-cta xv-pay xv-pay-proxy", pay.textContent);
      b.type = "button";
      b.disabled = !!pay.disabled;
      b.addEventListener("click", function() {
        try {
          pay.click();
        } catch (e) {
        }
      });
      f.appendChild(b);
      drawer.appendChild(f);
      try {
        var mo = new MutationObserver(function() {
          b.textContent = pay.textContent;
          b.disabled = !!pay.disabled;
        });
        mo.observe(pay, { attributes: true, childList: true, characterData: true, subtree: true });
      } catch (e) {
      }
    }
    function bindNamesCb(root) {
      var ncb = root && root.querySelector("#xv-names-cb");
      if (ncb) ncb.addEventListener("change", function() {
        var on = this.checked;
        try {
          XeistNamesOpt.set(on);
        } catch (e) {
          return;
        }
        setTimeout(function() {
          if (document.getElementById("xv-drawer")) {
            close();
            open();
          }
        }, 700);
      });
    }
    function close() {
      if (unbindDrawer) {
        try {
          unbindDrawer();
        } catch (e) {
        }
        unbindDrawer = null;
      }
      ["xv-scrim", "xv-drawer"].forEach(function(id) {
        var n = document.getElementById(id);
        if (n && n.parentNode) n.parentNode.removeChild(n);
      });
    }
    function buildShare() {
      if ($("#xv-share") || !$("#xu-steps")) return;
      var b = el("button", "xu-step", "Share");
      b.id = "xv-share";
      b.type = "button";
      b.title = "Copy a link to this design (opens on this device only for now)";
      b.addEventListener("click", function() {
        var url = window.location.href;
        function done() {
          b.textContent = "Link copied ✓ this device only";
          setTimeout(function() {
            b.textContent = "Share";
          }, 3500);
        }
        function legacy() {
          try {
            var ta = document.createElement("textarea");
            ta.value = url;
            ta.style.position = "fixed";
            ta.style.opacity = "0";
            document.body.appendChild(ta);
            ta.select();
            var ok = document.execCommand("copy");
            document.body.removeChild(ta);
            if (ok) {
              done();
              return;
            }
          } catch (e) {
          }
          b.textContent = "Copy failed — long-press the address bar";
          setTimeout(function() {
            b.textContent = "Share";
          }, 3e3);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, legacy);
        } else legacy();
        track("uniform_share", { design: (window.XeistUniform || {}).designId });
      });
      $("#xu-steps").appendChild(b);
    }
    var CSS = [
      "#xv-scrim{position:fixed;inset:0;background:rgba(20,20,22,.28);backdrop-filter:blur(2px);z-index:2147483200}",
      "#xv-drawer{position:fixed;top:0;right:0;bottom:0;width:min(460px,94vw);background:#fff;z-index:2147483300;box-shadow:-12px 0 40px rgba(0,0,0,.18);padding:20px 22px calc(24px + env(safe-area-inset-bottom));overflow-y:auto;font-size:14px;color:#1d1d1f;border-radius:18px 0 0 18px}",
      ".xv-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:4px}",
      ".xv-head h3{margin:0;font-size:20px;font-weight:800}",
      ".xv-close{border:0;background:#f2f2f4;border-radius:50%;width:34px;height:34px;font-size:20px;line-height:1;cursor:pointer;color:#3a3a3c}",
      ".xv-trust{font-size:12.5px;color:#6e6e73;border-left:4px solid #6D28D9;padding-left:10px;margin:10px 0 6px}",
      ".xv-sec{border-top:1px solid rgba(0,0,0,.07);padding:14px 0 4px;margin-top:10px}",
      ".xv-sec h4{margin:0 0 8px;font-size:11px;font-weight:700;letter-spacing:.05em;text-transform:uppercase;color:#6e6e73}",
      ".xv-views{display:flex;align-items:center;gap:8px;flex-wrap:wrap}",
      ".xv-view{border:1px solid rgba(0,0,0,.14);background:#fff;border-radius:999px;padding:8px 18px;font-weight:600;cursor:pointer;min-height:38px}",
      ".xv-view:hover{border-color:#6D28D9;color:#6D28D9}",
      ".xv-zones{list-style:none;margin:0 0 8px;padding:0;display:flex;flex-direction:column;gap:5px}",
      ".xv-swatch{display:inline-block;width:15px;height:15px;border-radius:50%;border:1px solid rgba(0,0,0,.18);vertical-align:-2px;margin-right:8px}",
      ".xv-plain{margin:0;padding-left:18px}",
      ".xv-warnlist{margin:6px 0 0;padding-left:18px;color:#8a5a00}",
      /* W3/T1.3: blockers are unmissable — red list, bold Fix links; the
         gated CTA greys out; the caution ack is a quiet single checkbox */
      ".xv-blocklist{margin:6px 0 0;padding-left:18px;color:#b3261e}",
      ".xv-blocklist li{margin:3px 0}",
      ".xv-fix{color:#b3261e;font-weight:700;text-decoration:underline;margin-left:6px;cursor:pointer}",
      ".xv-pay:disabled{background:#c7c7cc;cursor:not-allowed;filter:none}",
      ".xv-pay-blocked:disabled{background:#fdf2f2;color:#b3261e;border:1.5px solid #b3261e;cursor:not-allowed}",
      ".xv-goto-roster{background:#6D28D9!important;color:#fff!important;border:0!important;cursor:pointer}",
      ".xv-goto-roster:hover{filter:brightness(1.08)}",
      ".xv-caution-ok{display:flex;align-items:center;gap:8px;margin:8px 0 0;font-size:13px;color:#8a5a00;cursor:pointer}",
      ".xv-caution-ok input{width:16px;height:16px}",
      /* W4/T1.7: duplicate-design prompt */
      "#xv-dup{background:#fff6e5;border-radius:12px;padding:14px;margin:0 0 10px;font-size:13px}",
      "#xv-dup p{margin:0 0 10px}",
      ".xv-dup-btns{display:flex;flex-direction:column;gap:8px}",
      ".xv-dup-btns .xu-cta{width:100%}",
      ".xv-dup-quiet{border:1px solid rgba(0,0,0,.15);background:#fff;border-radius:10px;padding:11px;min-height:42px;font:600 13px/1 inherit;color:#3a3a3c;cursor:pointer}",
      ".xv-ok{color:#1a7f37;font-size:13px;margin:4px 0 0}",
      ".xv-dim{color:#6e6e73;font-size:12.5px}",
      ".xv-fx{display:block;margin-top:4px}",
      ".xv-kit{margin:0 0 6px}",
      ".xv-kit-row{display:flex;justify-content:space-between;gap:12px;margin:0 0 4px;font-size:13.5px}",
      ".xv-kit-row em{font-style:normal;color:#6e6e73;font-size:12px}",
      ".xv-kit-total{border-top:1px solid rgba(0,0,0,.12);padding-top:6px;margin-top:6px;font-size:15px}",
      ".xv-kit-per{margin:2px 0 0;font-size:13px}",
      ".xv-pay{width:100%;margin:2px 0 10px}",
      ".xv-alt{display:flex;gap:18px;flex-wrap:wrap}",
      ".xv-parentpay{opacity:.9!important;cursor:default!important}",
      ".xv-parentpay-note{font-size:12.5px;color:#6e6e73!important;line-height:1.55;margin:10px 0 0;text-align:center}",
      ".xv-names{display:flex;align-items:flex-start;gap:9px;margin:8px 0 0;font-size:13px;color:#111;cursor:pointer;line-height:1.45}",
      ".xv-names input{width:18px;height:18px;margin:1px 0 0;accent-color:#111;flex:0 0 auto;cursor:pointer}",
      ".xv-names strong{font-weight:700}",
      ".xv-alt-link{color:#6D28D9;font-weight:600;text-decoration:none;background:none;border:0;padding:0;cursor:pointer;font-size:inherit;font-family:inherit}",
      ".xv-alt-link:hover{text-decoration:underline}",
      /* W6/T2.1 quote modal */
      "#xq-modal{position:fixed;inset:0;z-index:2147483400}",
      ".xq-scrim{position:absolute;inset:0;background:rgba(20,20,22,.4);backdrop-filter:blur(2px)}",
      ".xq-card{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:min(430px,92vw);max-height:88vh;overflow-y:auto;background:#fff;border-radius:16px;padding:26px 26px 22px;box-shadow:0 18px 60px rgba(0,0,0,.25);font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif}",
      ".xq-h{margin:0 0 6px;font-size:19px;font-weight:700;color:#111}",
      ".xq-sub{margin:0 0 10px;font-size:13.5px;color:#6e6e73;line-height:1.55}",
      ".xq-summary{margin:0 0 16px;padding:10px 14px;background:#f7f7f5;border-radius:10px;font-size:13px;font-weight:600;color:#111}",
      ".xq-lab{display:block;font-size:12.5px;font-weight:600;color:#111;margin:10px 0 4px}",
      ".xq-req{font-weight:400;color:#8a8a8e}",
      ".xq-in{width:100%;box-sizing:border-box;border:1px solid #dedede;border-radius:9px;padding:10px 12px;font-size:14px;font-family:inherit}",
      ".xq-in:focus{outline:2px solid #111;outline-offset:-1px}",
      ".xq-ta{resize:vertical}",
      ".xq-err{color:#b23b3b;font-size:13px;margin:10px 0 0}",
      ".xq-err a{color:#b23b3b;font-weight:600}",
      ".xq-btns{display:flex;align-items:center;gap:14px;margin-top:16px}",
      ".xq-send{flex:0 0 auto}",
      "@media (max-width:749px){#xv-drawer{width:100vw;border-radius:18px 18px 0 0;top:auto;max-height:88vh;padding-bottom:calc(12px + env(safe-area-inset-bottom))}",
      "#xv-drawer .xv-sec #xv-pay{display:none}",
      "#xv-footer{position:sticky;bottom:calc(-12px - env(safe-area-inset-bottom));margin:12px -22px calc(-12px - env(safe-area-inset-bottom));padding:10px 16px calc(12px + env(safe-area-inset-bottom));background:rgba(255,255,255,.96);backdrop-filter:blur(10px);border-top:1px solid rgba(0,0,0,.08);z-index:3}",
      "#xv-footer .xu-cta{width:100%;min-height:52px}}"
    ].join("\n");
    function injectCSS() {
      if ($("#xv-style")) return;
      var s = el("style", "", "");
      s.id = "xv-style";
      s.appendChild(document.createTextNode(CSS));
      document.head.appendChild(s);
    }
    var booted = false;
    function tick() {
      if (!window.XeistUniform) return;
      injectCSS();
      buildShare();
      if (!booted) {
        booted = true;
        window.XeistUniformReview = { open, close, armOrderProps };
        track("uniform_review_ready", { design: window.XeistUniform.designId });
      }
    }
    if (window.XeistCore && XeistCore.every) {
      XeistCore.every("xu-uniform-review", 1200, tick, { runHidden: true });
    } else {
      setInterval(tick, 1200);
    }
  })();

  // src/uniform/33-uniform-shorts-offer.js
  (function() {
    "use strict";
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    var SHORTS_PAIRS = {
      "110517958": "110517959",
      // Venom Drip
      "112170817": "112178579",
      // South Beach
      "108252654": "108252655",
      // Valley
      "112332966": "112306816",
      // Summit
      "102815703": "103981625",
      // The X
      "115066282": "115043760",
      // Rose
      "107904446": "107902891",
      // Solar
      "104436435": "105092625",
      // Vocal
      "107829115": "107829116",
      // Horns
      "105371583": "105506843",
      // Vice
      "108640209": "108641459",
      // Hornet
      "106128393": "106191907",
      // Frequency
      "107447105": "107456931",
      // Indy
      "106431590": "106431591",
      // The XX
      "107048689": "107045054",
      // Cross
      "106497430": "106498137",
      // Spurs
      "107045055": "107045057",
      // Jurassic
      "108008592": "107983545",
      // Flight
      "108636723": "108636724",
      // Tiger
      "108636726": "108636727",
      // Rapture
      "108636728": "108640210",
      // Storm
      "110225240": "110221506",
      // Buzz
      "110220900": "110220901",
      // Cameron
      "110220902": "110225241",
      // Supersonic
      "110220903": "110220904",
      // Trench
      "110221507": "110220905",
      // Trident
      "110221508": "110221509",
      // Trio
      // Forza (2026-09-24). Its shorts live in a DIFFERENT KB product
      // (108967997 Stride-Line Shorts) and keep that product's own pricing
      // (KB tiers 39.99…; Justin: "different style shorts") — module 30
      // skins that one design only (UNIFORM_DESIGNS['282910203']).
      "282910950": "282910203"
      // Forza
    };
    var CUSTOMIZER_PATH = "/pages/3d-customizer";
    var CARRY_KEY = "xeist_shorts_carry";
    var CARRY_TTL = 30 * 60 * 1e3;
    var RESUME_MAX_AGE = 6 * 60 * 1e3;
    var ACCENT = "#6D28D9";
    function $(s, r) {
      return (r || document).querySelector(s);
    }
    function $all(s, r) {
      return Array.prototype.slice.call((r || document).querySelectorAll(s));
    }
    function el(tag, cls, html) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (html != null) e.innerHTML = html;
      return e;
    }
    function esc(s) {
      return String(s == null ? "" : s).replace(/[&<>"']/g, function(c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }
    function track(type, payload) {
      try {
        if (window.XeistTrack) window.XeistTrack(type, payload || {});
      } catch (e) {
      }
    }
    function trace(ev, extra) {
      try {
        var log = JSON.parse(sessionStorage.getItem("xu_trace") || "[]");
        log.push({ t: Date.now() % 1e6, ev, x: extra || null });
        sessionStorage.setItem("xu_trace", JSON.stringify(log.slice(-40)));
      } catch (e) {
      }
    }
    function readCarry() {
      try {
        var c = JSON.parse(localStorage.getItem(CARRY_KEY) || "null");
        if (!c || Date.now() - (c.ts || 0) > CARRY_TTL) {
          clearCarry();
          return null;
        }
        return c;
      } catch (e) {
        return null;
      }
    }
    function clearCarry() {
      try {
        localStorage.removeItem(CARRY_KEY);
      } catch (e) {
      }
    }
    function customizerUrl(target) {
      var qs = "set=" + Date.now();
      try {
        var th = window.Shopify && window.Shopify.theme;
        if (th && th.id && th.role !== "main") qs += "&preview_theme_id=" + th.id + "&pb=0";
      } catch (e) {
      }
      var hash = String(target || "");
      if (hash.charAt(0) !== "#") hash = "#/customise/" + hash;
      return CUSTOMIZER_PATH + "?" + qs + hash;
    }
    try {
      if (/[?&]xudebug=1/.test(window.location.search)) sessionStorage.setItem("xu_debug", "1");
    } catch (e) {
    }
    try {
      var cB = JSON.parse(localStorage.getItem(CARRY_KEY) || "null");
      var beatGap = null;
      try {
        var b0 = parseInt(sessionStorage.getItem("xu_beat") || "0", 10);
        if (b0) beatGap = Math.round((Date.now() - b0) / 1e3);
      } catch (eB) {
      }
      trace("shorts:boot", {
        hash: (window.location.hash.match(/\/customise\/(\d+)/i) || [])[1] || null,
        carry: cB ? { to: cB.toDesign, autoBuy: !!cB.autoBuy, applied: !!cB.applied, rp: !!cB.routePending, age: Math.round((Date.now() - (cB.ts || 0)) / 1e3) } : null,
        nav: (function() {
          try {
            var e = performance.getEntriesByType("navigation")[0];
            return e ? e.type : null;
          } catch (e2) {
            return null;
          }
        })(),
        sinceBeat: beatGap
      });
      window.addEventListener("unload", function() {
      });
      window.addEventListener("pagehide", function(e) {
        trace("page:hide", { href: String(window.location.href).slice(-60), bf: !!(e && e.persisted) });
        if (e && e.persisted) {
          freeWebGL();
          try {
            document.body.innerHTML = "";
          } catch (eS) {
          }
        }
      });
      window.addEventListener("pageshow", function(e) {
        trace("page:show", { persisted: !!(e && e.persisted) });
        if (e && e.persisted) {
          trace("page:bfcache-reload");
          window.location.reload();
        }
      });
    } catch (e) {
    }
    function freeWebGL() {
      try {
        var cs = document.querySelectorAll("canvas");
        for (var i = 0; i < cs.length; i++) {
          var gl = null;
          try {
            gl = cs[i].getContext("webgl2") || cs[i].getContext("webgl") || cs[i].getContext("experimental-webgl");
          } catch (e1) {
          }
          if (!gl) continue;
          var ext = gl.getExtension("WEBGL_lose_context");
          if (ext) ext.loseContext();
        }
      } catch (e) {
      }
    }
    function debugStrip() {
      var on = false;
      try {
        on = sessionStorage.getItem("xu_debug") === "1";
      } catch (e) {
      }
      if (!on) return;
      var box = document.getElementById("xu-debug");
      if (!box) {
        box = document.createElement("pre");
        box.id = "xu-debug";
        box.style.cssText = "position:fixed;top:0;left:0;right:0;z-index:2147483600;margin:0;padding:6px 8px;max-height:38vh;overflow:auto;background:rgba(0,0,0,.82);color:#9fe870;font:10px/1.35 ui-monospace,Menlo,monospace;white-space:pre-wrap;pointer-events:none";
        (document.body || document.documentElement).appendChild(box);
      }
      var log = [];
      try {
        log = JSON.parse(sessionStorage.getItem("xu_trace") || "[]");
      } catch (e) {
      }
      var lines = log.slice(-14).map(function(e) {
        return e.t + " " + e.ev + (e.x ? " " + JSON.stringify(e.x) : "");
      });
      var txt = "XEIST DEBUG · " + String(window.location.href).slice(-70) + "\n" + lines.join("\n");
      if (box.textContent !== txt) box.textContent = txt;
    }
    function killPreviewBar() {
      try {
        var th = window.Shopify && window.Shopify.theme;
        if (th && th.role === "main") return;
        var w = document.getElementById("PBarNextFrameWrapper");
        if (w && w.parentNode) {
          w.parentNode.removeChild(w);
          trace("preview-bar:removed");
        }
      } catch (e) {
      }
    }
    setInterval(function() {
      try {
        sessionStorage.setItem("xu_beat", String(Date.now()));
      } catch (e) {
      }
      debugStrip();
      killPreviewBar();
    }, 1e3);
    function uni() {
      return window.XeistUniform || null;
    }
    var PKGFLOW_KEY = "xeist_pkgflow";
    function pkgflowRead() {
      try {
        var f = JSON.parse(localStorage.getItem(PKGFLOW_KEY) || "null");
        if (f && Date.now() - (f.ts || 0) < 36e5) return f;
      } catch (e) {
      }
      return null;
    }
    function pkgflowWrite(f) {
      try {
        f.ts = Date.now();
        localStorage.setItem(PKGFLOW_KEY, JSON.stringify(f));
      } catch (e) {
      }
    }
    function pkgflowClear() {
      try {
        localStorage.removeItem(PKGFLOW_KEY);
      } catch (e) {
      }
    }
    try {
      window.XeistUniformKit = window.XeistUniformKit || {};
      window.XeistUniformKit.shortsFor = function(id) {
        return SHORTS_PAIRS[String(id)] || null;
      };
      window.XeistUniformKit.reviewShorts = function() {
        var to = pairedShortsId();
        if (!to) return false;
        try {
          var carry = buildCarry(to, true);
          carry.routePending = false;
          localStorage.setItem(CARRY_KEY, JSON.stringify(carry));
        } catch (e) {
        }
        pkgflowWrite({ stage: "shorts", from: designId(), to: String(to), returnHash: window.location.hash || "" });
        track("pkgflow_shorts_start", { from: designId(), to });
        window.location.replace(customizerUrl(to));
        return true;
      };
      window.XeistUniformKit.pkgflowConsumeComplete = function(jerseyId) {
        var f = pkgflowRead();
        if (!(f && f.stage === "complete" && f.from === String(jerseyId))) return false;
        if (f.consumedTs && Date.now() - f.consumedTs > 18e4) {
          pkgflowClear();
          return false;
        }
        if (!f.consumedTs) {
          f.consumedTs = Date.now();
          pkgflowWrite(f);
        }
        return true;
      };
      window.XeistUniformKit.pkgflowClear = pkgflowClear;
    } catch (e) {
    }
    var pkgPanelMounted = false;
    function pkgflowPanelTick() {
      var f = pkgflowRead();
      if (!f || f.stage !== "shorts" || !designId() || f.to !== designId()) return;
      if (pkgPanelMounted || document.getElementById("xs-pkg-panel")) return;
      if (!uni()) return;
      pkgPanelMounted = true;
      var panel = document.createElement("div");
      panel.id = "xs-pkg-panel";
      panel.innerHTML = '<div class="xs-pkg-card" role="region" aria-label="Approve your matching shorts"><span class="xs-pkg-step">Package review</span><h4 class="xs-pkg-h">Your matching shorts are ready</h4><p class="xs-pkg-sub">We matched these shorts to your approved jersey — colors, team and roster carried over.</p><button type="button" class="xs-pkg-approve" id="xs-pkg-approve">Approve shorts and continue to roster <span class="xs-pkg-arrow" aria-hidden="true">→</span></button><button type="button" class="xs-pkg-adjust" id="xs-pkg-adjust">Make adjustments</button></div>';
      document.body.appendChild(panel);
      if (!document.getElementById("xs-pkg-style")) {
        var st = document.createElement("style");
        st.id = "xs-pkg-style";
        st.textContent = [
          "#xs-pkg-panel{position:fixed;left:0;right:0;bottom:calc(92px + env(safe-area-inset-bottom));display:flex;justify-content:center;z-index:2147483230;pointer-events:none}",
          "@media (max-width:749px){#xs-pkg-panel{bottom:calc(130px + env(safe-area-inset-bottom))}.xs-pkg-card{padding:18px 18px 14px}.xs-pkg-h{font-size:17px!important}}",
          "#xs-pkg-panel *{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif!important;letter-spacing:normal!important;text-transform:none!important}",
          ".xs-pkg-card{pointer-events:auto;background:#fff;border:1px solid #e7e7e7;border-radius:18px;box-shadow:0 18px 60px rgba(0,0,0,.18);padding:22px 26px 18px;max-width:440px;width:calc(100vw - 32px);text-align:center}",
          ".xs-pkg-step{display:inline-block;font-size:10.5px!important;font-weight:700!important;letter-spacing:.1em!important;text-transform:uppercase!important;color:#8a8a8e!important;margin-bottom:6px}",
          ".xs-pkg-h{font-size:19px!important;font-weight:650!important;color:#111!important;margin:0 0 4px}",
          ".xs-pkg-sub{font-size:13.5px!important;color:#666!important;line-height:1.5!important;margin:0 0 14px}",
          /* 2026-08-27 (Justin): the approve CTA must PULL the coach forward —
             brand accent + soft pulse + a periodic shine sweep. Reduced-motion
             users get the vibrant color without the movement. */
          ".xs-pkg-approve{display:block;width:100%;height:52px;border:0;border-radius:12px;background:#6D28D9!important;color:#fff!important;font-size:15px!important;font-weight:700!important;cursor:pointer;position:relative;overflow:hidden;box-shadow:0 6px 22px rgba(109,40,217,.35);animation:xsPkgPulse 2.2s ease-out infinite}",
          ".xs-pkg-approve:hover{filter:brightness(1.12)}",
          ".xs-pkg-arrow{display:inline-block;margin-left:4px;animation:xsPkgNudge 2.2s ease-in-out infinite}",
          "@keyframes xsPkgPulse{0%{box-shadow:0 6px 22px rgba(109,40,217,.35),0 0 0 0 rgba(109,40,217,.45)}70%{box-shadow:0 6px 22px rgba(109,40,217,.35),0 0 0 13px rgba(109,40,217,0)}100%{box-shadow:0 6px 22px rgba(109,40,217,.35),0 0 0 0 rgba(109,40,217,0)}}",
          '.xs-pkg-approve::after{content:"";position:absolute;top:0;left:-60%;width:45%;height:100%;background:linear-gradient(105deg,transparent,rgba(255,255,255,.34),transparent);animation:xsPkgShine 2.8s ease-in-out infinite}',
          "@keyframes xsPkgShine{0%{left:-60%}55%{left:130%}100%{left:130%}}",
          "@keyframes xsPkgNudge{0%,100%{transform:translateX(0)}50%{transform:translateX(4px)}}",
          "@media (prefers-reduced-motion:reduce){.xs-pkg-approve{animation:none}.xs-pkg-approve::after{display:none}.xs-pkg-arrow{animation:none}}",
          ".xs-pkg-adjust{display:block;margin:10px auto 0;background:none;border:0;padding:6px;color:#8a8a8e!important;font-size:13px!important;font-weight:600!important;text-decoration:underline;cursor:pointer}",
          ".xs-pkg-mini{position:fixed;right:16px;bottom:calc(92px + env(safe-area-inset-bottom));z-index:2147483230;height:48px;padding:0 20px;border:0;border-radius:999px;background:#6D28D9!important;color:#fff!important;box-shadow:0 6px 22px rgba(109,40,217,.35)!important;font:600 14px/48px -apple-system,BlinkMacSystemFont,sans-serif!important;cursor:pointer;box-shadow:0 10px 30px rgba(0,0,0,.22)}",
          "@media (max-width:749px){.xs-pkg-mini{bottom:calc(130px + env(safe-area-inset-bottom))}}"
        ].join("\n");
        document.head.appendChild(st);
      }
      function approve() {
        try {
          var k = "xeist_pkg_" + f.from;
          var pkg = JSON.parse(localStorage.getItem(k) || "null") || {};
          pkg.shortsStatus = "approved";
          pkg.shortsApprovedTs = Date.now();
          localStorage.setItem(k, JSON.stringify(pkg));
        } catch (e) {
        }
        track("pkgflow_shorts_approved", { from: f.from, to: f.to });
        f.stage = "complete";
        pkgflowWrite(f);
        var mini = document.getElementById("xs-pkg-mini");
        if (mini && mini.parentNode) mini.parentNode.removeChild(mini);
        if (panel.parentNode) panel.parentNode.removeChild(panel);
        window.location.replace(customizerUrl(f.returnHash || f.from));
      }
      function collapseToMini() {
        if (panel.parentNode) panel.parentNode.removeChild(panel);
        if (document.getElementById("xs-pkg-mini")) return;
        var mini = document.createElement("button");
        mini.id = "xs-pkg-mini";
        mini.className = "xs-pkg-mini";
        mini.type = "button";
        mini.innerHTML = "✓ Approve shorts";
        mini.addEventListener("click", approve);
        document.body.appendChild(mini);
      }
      panel.__collapse = collapseToMini;
      document.getElementById("xs-pkg-approve").addEventListener("click", approve);
      document.getElementById("xs-pkg-adjust").addEventListener("click", function() {
        track("pkgflow_shorts_adjust", { to: f.to });
        collapseToMini();
      });
    }
    if (window.XeistCore && XeistCore.every) {
      XeistCore.every("xs-pkgflow", 1200, pkgflowPanelTick, { runHidden: true });
    } else {
      setInterval(pkgflowPanelTick, 1200);
    }
    function designId() {
      var w = uni();
      return w ? String(w.designId) : null;
    }
    function pairedShortsId() {
      var id = designId();
      return id && SHORTS_PAIRS[id] || null;
    }
    function shortsApproved() {
      try {
        var pkg = JSON.parse(localStorage.getItem("xeist_pkg_" + designId()) || "null");
        return !!(pkg && pkg.shorts && pkg.shortsStatus === "approved");
      } catch (e) {
        return false;
      }
    }
    function onShortsSide() {
      var c = readCarry();
      var id = designId() || (window.location.hash.match(/\/customise\/(\d+)/i) || [])[1];
      return c && String(c.toDesign) === String(id) ? c : null;
    }
    var offerDecided = false;
    function rosterRows() {
      var R = window.XeistUniformRoster;
      if (R && R.readRows) {
        try {
          return R.readRows();
        } catch (e) {
        }
      }
      return [];
    }
    function pkgShortsSizes() {
      try {
        var raw = window.localStorage.getItem("xeist_pkg_sizes_" + designId());
        var d = JSON.parse(raw || "null");
        return d && d.shorts || null;
      } catch (e) {
        return null;
      }
    }
    function rowsForShorts(rows) {
      var pk = pkgShortsSizes();
      if (!pk) return rows;
      return rows.map(function(r) {
        var size = r.xuid && pk[r.xuid] || pk[(r.name || "") + "|" + (r.number || "")];
        return size ? { name: r.name, number: r.number, sizeLabel: size, xuid: r.xuid || null } : r;
      });
    }
    function buildCarry(shortsId, matchSizes) {
      var w = uni() || {};
      var rows = rowsForShorts(rosterRows());
      var xExp = 0;
      try {
        xExp = parseInt(window.localStorage.getItem("xeist_expected_" + designId()) || "0", 10) || 0;
      } catch (e) {
      }
      return {
        v: 1,
        ts: Date.now(),
        fromDesign: designId(),
        toDesign: String(shortsId),
        team: w.team || null,
        // {name,c1,c2,lastLook}
        expected: xExp,
        // roster size from team setup — keeps the
        // shorts page's pricing tier honest (2026-08-26)
        roster: rows,
        // [{name,number,sizeLabel}]
        // Coach's choice from the offer card (2026-07-21, Justin): fill the
        // shorts sizes from the jersey roster, or leave them for the coach.
        matchSizes: matchSizes !== false,
        wantLogo: true,
        // Consumed by the theme.liquid cart relay: KB redirects to /cart
        // after its add completes (confirmed live 2026-07-21) and usually
        // beats the in-page cart poll — the relay picks the flow back up
        // from the cart page. One-shot: whoever routes first clears it.
        routePending: true
      };
    }
    function bindDialog(card, onDismiss, initialFocus) {
      var prevFocus = document.activeElement;
      function onKey(e) {
        if (e.key === "Escape") {
          e.stopPropagation();
          onDismiss();
          return;
        }
        if (e.key !== "Tab") return;
        var f = card.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
      document.addEventListener("keydown", onKey, true);
      card.setAttribute("aria-modal", "true");
      if (initialFocus) setTimeout(function() {
        try {
          initialFocus.focus();
        } catch (e) {
        }
      }, 60);
      return function unbind() {
        document.removeEventListener("keydown", onKey, true);
        try {
          if (prevFocus && prevFocus.focus) prevFocus.focus();
        } catch (e) {
        }
      };
    }
    var unbindOffer = null;
    function openOffer(onAddBoth, onJustJersey) {
      closeOffer();
      var w = uni() || {}, team = w.team || {};
      var scrim = el("div", "", "");
      scrim.id = "xs-scrim";
      var card = el("section", "", "");
      card.id = "xs-offer";
      card.setAttribute("role", "dialog");
      card.setAttribute("aria-label", "Complete the uniform");
      var sw = ["c1", "c2"].map(function(k) {
        return team[k] ? '<span class="xs-sw" style="background:' + esc(team[k]) + '"></span>' : "";
      }).join("");
      var n = rosterRows().length;
      var posters = window.XeistPosters || {};
      var poster = posters[pairedShortsId()];
      var heroHTML = poster && poster.img ? '<div class="xs-hero"><img src="' + esc(poster.img) + `" alt="Matching shorts design" loading="eager" decoding="async" onerror="this.parentNode.style.display='none'"></div><p class="xs-hero-cap">Shown in stock colors — yours are made to match your jersey ` + sw + "</p>" : "";
      card.innerHTML = '<h3 class="xs-h">Your matching shorts are ready</h3>' + heroHTML + '<p class="xs-sub">Designed to pair with this jersey' + (team.name ? " — made for " + esc(String(team.name).toUpperCase()) : "") + (heroHTML ? "." : ". " + sw) + '</p><ul class="xs-points"><li>Your colors and look carry over automatically</li>' + (n ? "<li>Your roster (" + n + " player" + (n === 1 ? "" : "s") + ") carries over</li>" : "") + "<li>Nothing is charged now — you review the shorts first</li></ul>" + (n ? '<label class="xs-match"><input type="checkbox" id="xs-match-sizes" checked> Use the same sizes for the shorts — we’ll fill them in (you can adjust any player after)</label>' : "") + '<button type="button" id="xs-both" class="xs-cta">Add jersey &amp; make matching shorts</button><button type="button" id="xs-solo" class="xs-more">Just the jersey</button>';
      document.body.appendChild(scrim);
      document.body.appendChild(card);
      $("#xs-both", card).addEventListener("click", function() {
        var ms = $("#xs-match-sizes", card);
        var matchSizes = ms ? !!ms.checked : true;
        closeOffer();
        onAddBoth(matchSizes);
      });
      $("#xs-solo", card).addEventListener("click", function() {
        closeOffer();
        onJustJersey();
      });
      function cancel() {
        closeOffer();
        track("uniform_shorts_offer_dismissed", { design: designId() });
      }
      scrim.addEventListener("click", cancel);
      unbindOffer = bindDialog(card, cancel, $("#xs-both", card));
      track("uniform_shorts_offer", { design: designId(), roster: n });
    }
    function closeOffer() {
      if (unbindOffer) {
        try {
          unbindOffer();
        } catch (e) {
        }
        unbindOffer = null;
      }
      ["xs-scrim", "xs-offer"].forEach(function(id) {
        var x = document.getElementById(id);
        if (x && x.parentNode) x.parentNode.removeChild(x);
      });
    }
    function busyMsg(msg) {
      var o = document.getElementById("xs-busy");
      var pp = o && o.querySelector("p");
      if (pp) pp.textContent = msg;
    }
    function showBusy(msg) {
      if (document.getElementById("xs-busy")) {
        busyMsg(msg);
        return;
      }
      var o = el("div", "", '<div class="xs-busy-inner"><div class="xs-spin" aria-hidden="true"></div><p>' + esc(msg) + "</p></div>");
      o.id = "xs-busy";
      o.setAttribute("role", "status");
      o.setAttribute("aria-live", "polite");
      document.body.appendChild(o);
    }
    function interceptBuy(e) {
      var btn = e.target && e.target.closest && e.target.closest(".kb-button-single-item-checkout-buy-now");
      if (!btn) return;
      if (!uni() || !pairedShortsId()) return;
      if (offerDecided) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      openOffer(
        function addBoth(matchSizes) {
          offerDecided = true;
          try {
            localStorage.setItem(CARRY_KEY, JSON.stringify(buildCarry(pairedShortsId(), matchSizes)));
          } catch (err) {
          }
          trace("shorts:carry-set", { to: pairedShortsId() });
          track("uniform_shorts_add_both", { design: designId() });
          showBusy("Adding your jersey to the cart…");
          watchAddThenRoute();
          btn.click();
        },
        function justJersey() {
          offerDecided = true;
          clearCarry();
          track("uniform_shorts_declined", { design: designId() });
          btn.click();
        }
      );
    }
    function watchAddThenRoute() {
      var started = Date.now();
      var baseline = null;
      function cartCount() {
        return fetch("/cart.js").then(function(r) {
          return r.json();
        }).then(function(c) {
          return (c.items || []).length;
        })["catch"](function() {
          return null;
        });
      }
      cartCount().then(function(n) {
        baseline = n;
        trace("shorts:add-watch", { baseline: n });
        (function poll() {
          if (Date.now() - started > 9e4) {
            trace("shorts:add-timeout");
            return;
          }
          cartCount().then(function(m) {
            if (baseline != null && m != null && m > baseline) {
              routeToShorts();
              return;
            }
            setTimeout(poll, 400);
          });
        })();
      });
    }
    function routeToShorts() {
      var to = pairedShortsId();
      if (!to) return;
      try {
        var c = JSON.parse(localStorage.getItem(CARRY_KEY) || "null");
        if (c) {
          c.routePending = false;
          localStorage.setItem(CARRY_KEY, JSON.stringify(c));
        }
      } catch (e) {
      }
      trace("shorts:routing", { to });
      window.location.replace(customizerUrl(to));
    }
    function injectDrawerRow() {
      var drawer = $("#xv-drawer");
      if (!drawer || $("#xs-drawer-row", drawer) || !pairedShortsId()) return;
      var payBtn = $("#xv-pay", drawer);
      if (!payBtn || !payBtn.parentNode) return;
      var row = el("div", "", "");
      row.id = "xs-drawer-row";
      var approved = shortsApproved();
      row.innerHTML = approved ? '<label class="xs-drawer-label"><input type="checkbox" id="xs-drawer-check" checked> Include your <strong>matching shorts</strong> — design approved ✓. Sizes match each player’s jersey (adjust on the Roster step) and they’re added to your cart automatically.</label>' : '<label class="xs-drawer-label"><input type="checkbox" id="xs-drawer-check"> Also make the <strong>matching shorts</strong> — colors, logo &amp; roster carry over</label>';
      payBtn.parentNode.insertBefore(row, payBtn);
      $("#xs-drawer-check", row).addEventListener("change", function() {
        track("uniform_shorts_drawer_toggle", { on: this.checked, design: designId() });
      });
      payBtn.addEventListener("click", function() {
        var on = $("#xs-drawer-check");
        if (on && on.checked && !offerDecided) {
          if (shortsApproved()) {
            var ready = syncKitReady();
            if (ready && startSyncKit(ready)) return;
          }
          offerDecided = true;
          try {
            var carry = buildCarry(pairedShortsId());
            if (shortsApproved()) carry.autoBuy = true;
            localStorage.setItem(CARRY_KEY, JSON.stringify(carry));
          } catch (err) {
          }
          watchAddThenRoute();
        }
      }, true);
    }
    document.addEventListener("xeist:review-open", function() {
      try {
        if (uni()) {
          injectCSS();
          injectDrawerRow();
        }
      } catch (e) {
      }
    });
    document.addEventListener("xeist:review-buy-cancel", function() {
      offerDecided = false;
      clearCarry();
      if (syncTeardown) {
        try {
          syncTeardown();
        } catch (e) {
        }
      }
    });
    var SIZEMAP_PREFIX = "xeist_sizemap_";
    var sizeMapWritten = "";
    function cacheSizeMap() {
      try {
        var R = window.XeistUniformRoster;
        var id = designId();
        if (!R || !R.sizeOptions || !id) return;
        var opts = R.sizeOptions();
        if (!opts || !opts.length) return;
        var json = JSON.stringify(opts);
        if (json === sizeMapWritten) return;
        localStorage.setItem(SIZEMAP_PREFIX + id, JSON.stringify({ ts: Date.now(), opts }));
        sizeMapWritten = json;
      } catch (e) {
      }
    }
    function sizeMapFor(id) {
      try {
        var d = JSON.parse(localStorage.getItem(SIZEMAP_PREFIX + id) || "null");
        return d && d.opts && d.opts.length ? d.opts : null;
      } catch (e) {
        return null;
      }
    }
    function kbInjector() {
      try {
        var i = window.XeistCore && XeistCore.getInjector && XeistCore.getInjector();
        if (i && i.has && i.has("AddToCartService")) return i;
      } catch (e) {
      }
      try {
        var p = document.querySelector(".kb-customise-page");
        var i2 = p && window.angular && angular.element(p).injector();
        if (i2 && i2.has && i2.has("AddToCartService")) return i2;
      } catch (e2) {
      }
      return null;
    }
    function kbScope() {
      try {
        var p = document.querySelector(".kb-customise-page");
        return p && window.angular ? angular.element(p).scope() : null;
      } catch (e) {
        return null;
      }
    }
    function shortsBasketIndex(basket, shortsId) {
      var idx = -1;
      for (var i = 0; i < basket.length; i++) if (String(basket[i] && basket[i].designId) === String(shortsId)) idx = i;
      return idx;
    }
    function parseVariant(data) {
      if (!data) return null;
      var raw = data.webhookResponse;
      if (typeof raw === "string") {
        try {
          var w = JSON.parse(raw);
          if (w && w.variantId) return w;
        } catch (e) {
        }
      }
      if (raw && raw.variantId) return raw;
      if (data.variantId) return data;
      return null;
    }
    function buildShortsTeamdetails(rows, opts) {
      var R = window.XeistUniformRoster;
      var unmatched = 0;
      var units = rows.map(function(r) {
        var u = { name: r.name || "", number: r.number || "" };
        if (r.sizeLabel) {
          var m = R && R.matchSizeIn ? R.matchSizeIn(r.sizeLabel, opts) : null;
          if (m) u.size = String(m.id);
          else unmatched++;
        }
        return u;
      });
      return { td: JSON.stringify({ enterTeams: true, sizes: {}, teams: [{ units }] }), unmatched, units };
    }
    function syncKitReady() {
      try {
        var to = pairedShortsId();
        if (!to) return null;
        var inj = kbInjector(), sc = kbScope();
        if (!inj || !sc || !sc.basket || !sc.basket.length || !sc.state) return null;
        var idx = shortsBasketIndex(sc.basket, to);
        if (idx < 0) {
          trace("kit:no-shorts-entry");
          return null;
        }
        var opts = sizeMapFor(to);
        if (!opts) {
          trace("kit:no-sizemap");
          return null;
        }
        if (typeof sc.state.basketIndex !== "number" || sc.state.basketIndex === idx) return null;
        return { inj, sc, idx, opts, to };
      } catch (e) {
        trace("kit:ready-threw", { e: String(e).slice(0, 60) });
        return null;
      }
    }
    function shortsProps(jerseyProps, rows, to, idx) {
      var out = {};
      for (var k in jerseyProps || {}) if (jerseyProps.hasOwnProperty(k)) out[k] = jerseyProps[k];
      out["Players"] = rows.length ? String(rows.length) : "";
      out["Roster"] = rows.map(function(r) {
        return (r.name || "—") + " #" + (r.number || "—") + " (" + (r.sizeLabel || "no size") + ")";
      }).join(" · ");
      out["_design_id"] = String(to);
      var qs = "";
      try {
        var th = window.Shopify && window.Shopify.theme;
        if (th && th.id && th.role !== "main") qs = "?preview_theme_id=" + th.id;
      } catch (e) {
      }
      out["_edit_url"] = location.origin + location.pathname + qs + "#/customise/" + to + "?basketIndex=" + idx;
      out["_roster_json"] = JSON.stringify(rows.map(function(r) {
        return { name: r.name || "", number: r.number || "", sizeLabel: r.sizeLabel || "" };
      }));
      var clean = {};
      for (var k2 in out) if (out.hasOwnProperty(k2) && out[k2] != null && out[k2] !== "" && out[k2] !== "[]") clean[String(k2).slice(0, 100)] = String(out[k2]).slice(0, 4e3);
      return clean;
    }
    function overlayNote(msg) {
      var pp = document.getElementById("xvb-p");
      if (pp) pp.textContent = msg;
    }
    var SETTLE_MAX_MS = 12e3, SETTLE_TICK_MS = 1500;
    function pinExpected(v) {
      var p = parseFloat(v && v.price);
      if (!v || !v.variantId || !(p > 0)) return null;
      return { id: String(v.variantId), cents: [Math.round(p * 100), Math.round(p)] };
    }
    function settleCartPrices(expects) {
      var list = (expects || []).filter(Boolean);
      var M = window.XeistMoney;
      if (!list.length || !M || !M.kbFixed || !M.kbFixed()) return Promise.resolve("skip");
      var started = Date.now(), tries = 0, lines = [];
      function getJson(url, opts) {
        return fetch(url, opts).then(function(r) {
          if (!r.ok) throw new Error("http " + r.status);
          return r.json();
        });
      }
      function loadLines() {
        return getJson("/cart.js", { cache: "no-store" }).then(function(c) {
          var byVariant = {};
          (c && c.items || []).forEach(function(it) {
            byVariant[String(it.variant_id || it.id)] = { key: it.key, handle: it.handle, qty: it.quantity || 1 };
          });
          lines = [];
          list.forEach(function(x) {
            var l = byVariant[x.id];
            if (l && l.key && l.handle) lines.push({ id: x.id, cents: x.cents, key: l.key, handle: l.handle, qty: l.qty });
          });
        });
      }
      function productPinned(l) {
        return getJson("/products/" + l.handle + ".js?cb=" + Date.now(), { cache: "no-store" }).then(function(p) {
          var v = (p && p.variants || []).filter(function(x) {
            return String(x.id) === l.id;
          })[0];
          return !!v && l.cents.indexOf(v.price) !== -1;
        })["catch"](function() {
          return false;
        });
      }
      function touch(l) {
        return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ id: l.key, quantity: l.qty }) }).then(function(r) {
          return r.json();
        }).then(function(c) {
          var it = (c && c.items || []).filter(function(x) {
            return x.key === l.key;
          })[0];
          return it ? it.price : null;
        })["catch"](function() {
          return null;
        });
      }
      function touchAll() {
        return lines.reduce(function(chain, l) {
          return chain.then(function(acc) {
            return touch(l).then(function(price) {
              acc.push(price != null && l.cents.indexOf(price) !== -1);
              return acc;
            });
          });
        }, Promise.resolve([]));
      }
      return new Promise(function(resolve) {
        function finish(result, pending) {
          touchAll().then(function(flags) {
            var unpinned = flags.filter(function(ok) {
              return !ok;
            }).length;
            var x = { tries, ms: Date.now() - started, unpinned };
            if (pending) x.n = pending;
            trace("kit:cad-" + result, x);
            resolve(result);
          }, function() {
            resolve(result);
          });
        }
        function tick2() {
          tries++;
          Promise.all(lines.map(productPinned)).then(function(flags) {
            var pending = flags.filter(function(ok) {
              return !ok;
            }).length;
            if (!pending) {
              finish("settled");
              return;
            }
            if (Date.now() - started >= SETTLE_MAX_MS) {
              finish("unsettled", pending);
              return;
            }
            setTimeout(tick2, SETTLE_TICK_MS);
          });
        }
        loadLines().then(function() {
          if (!lines.length) {
            trace("kit:cad-nolines");
            resolve("ok");
            return;
          }
          tick2();
        }, function() {
          trace("kit:cad-settle-error");
          resolve("error");
        });
      });
    }
    var syncTeardown = null;
    function startSyncKit(ready) {
      var inj = ready.inj, sc = ready.sc, basket = sc.basket, to = ready.to, idx = ready.idx;
      try {
        var R0 = window.XeistUniformRoster;
        if (R0 && R0.stripEmptyRows) R0.stripEmptyRows();
      } catch (e0) {
      }
      var rows = rowsForShorts(rosterRows());
      if (!rows.length) return false;
      var built = buildShortsTeamdetails(rows, ready.opts);
      if (built.unmatched) {
        trace("kit:unmatched-sizes", { n: built.unmatched });
        return false;
      }
      var State, opts, SIC;
      try {
        State = inj.get("State");
        opts = inj.get("options");
        SIC = inj.get("SingleItemCheckout");
      } catch (e) {
        return false;
      }
      if (!opts || !opts.customCallbacks || typeof opts.customCallbacks.webhookBuyNowCallback !== "function" || !SIC || !SIC.addSingleItemToCart || !State || !State.saveBasket) return false;
      try {
        basket[idx].values = basket[idx].values || {};
        basket[idx].values.teamdetails = built.td;
        State.setBasket(basket);
      } catch (e1) {
        trace("kit:basket-write-failed");
        return false;
      }
      offerDecided = true;
      window.__xeistKitSync = true;
      var cbName = "webhookBuyNowCallback";
      var origCb = opts.customCallbacks[cbName];
      var origSave = State.saveBasket;
      var jerseyVariant = null, shortsVariant = null, shortsErr = null, finished = false, restored = false;
      var started = Date.now();
      var jerseyProps = null;
      try {
        jerseyProps = window.XeistUniformReview && XeistUniformReview.armOrderProps ? XeistUniformReview.armOrderProps() || {} : {};
      } catch (eP) {
        jerseyProps = {};
      }
      var sProps = shortsProps(jerseyProps, rows, to, idx);
      var custom = null;
      try {
        custom = typeof opts.singleItemCheckoutCustomData === "function" ? opts.singleItemCheckoutCustomData() : opts.singleItemCheckoutCustomData;
      } catch (eC) {
        custom = null;
      }
      function restore() {
        if (restored) return;
        restored = true;
        try {
          opts.customCallbacks[cbName] = origCb;
        } catch (e) {
        }
        try {
          State.saveBasket = origSave;
        } catch (e2) {
        }
        window.__xeistKitSync = false;
        syncTeardown = null;
      }
      syncTeardown = function() {
        restore();
        finished = true;
      };
      trace("kit:sync-start", { idx, rows: rows.length });
      track("kit_sync_start", { design: designId(), shorts: to, rows: rows.length });
      State.saveBasket = function(b, ok, err) {
        return origSave.call(State, b, function(res) {
          try {
            if (ok) ok(res);
          } catch (e) {
          }
          if (res && res.editKey && res.token && !finished) fireShorts(res.editKey, res.token);
        }, err);
      };
      function fireShorts(editKey, token) {
        trace("kit:shorts-fired");
        var pr;
        try {
          pr = SIC.addSingleItemToCart(editKey, token, idx, custom);
        } catch (e) {
          shortsErr = "threw";
          trace("kit:shorts-threw");
          maybeFinish();
          return;
        }
        pr.then(function(resp) {
          var d = resp && resp.data;
          var v = parseVariant(d);
          if (v) {
            shortsVariant = v;
            trace("kit:shorts-variant");
          } else {
            shortsErr = d && (d.errors && d.errors.join("; ") || d.quietError) || "no-variant";
            trace("kit:shorts-error", { e: String(shortsErr).slice(0, 80) });
          }
          maybeFinish();
        }, function(e) {
          shortsErr = "http";
          trace("kit:shorts-http-error");
          maybeFinish();
        });
      }
      opts.customCallbacks[cbName] = function(payload) {
        var v = parseVariant({ webhookResponse: payload && payload.content });
        if (!v) {
          trace("kit:jersey-unparsed");
          restore();
          try {
            return origCb.apply(this, arguments);
          } catch (e) {
            return;
          }
        }
        jerseyVariant = v;
        trace("kit:jersey-variant");
        overlayNote("Jerseys created ✓ — finishing your matching shorts…");
        maybeFinish();
      };
      function maybeFinish() {
        if (finished) return;
        if (jerseyVariant && shortsVariant) {
          finished = true;
          restore();
          addBoth();
          return;
        }
        if (jerseyVariant && shortsErr) {
          finished = true;
          restore();
          fallbackHop();
          return;
        }
      }
      (function tickWatch() {
        if (finished) return;
        if (jerseyVariant && Date.now() - started > 12e4) {
          shortsErr = "timeout";
          maybeFinish();
          return;
        }
        setTimeout(tickWatch, 2e3);
      })();
      function cartAdd(items) {
        return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ items }) }).then(function(r) {
          if (!r.ok) throw new Error("cart/add " + r.status);
          return r.json();
        });
      }
      function sweepStaleShorts() {
        var keep = window.__xeistDupChoice === "keep";
        var team = String(jerseyProps && jerseyProps.Team || "").trim().toUpperCase();
        return fetch("/cart.js", { cache: "no-store" }).then(function(r) {
          return r.json();
        }).then(function(c) {
          var stale = keep ? [] : (c.items || []).filter(function(it) {
            var p = it.properties || {};
            if (String(p._design_id || "") !== String(to)) return false;
            var t = String(p.Team || "").trim().toUpperCase();
            return !t || !team || t === team;
          });
          return stale.reduce(function(chain, it) {
            return chain.then(function() {
              return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: it.key, quantity: 0 }) })["catch"](function() {
              });
            });
          }, Promise.resolve()).then(function() {
            if (stale.length) trace("kit:stale-swept", { n: stale.length });
          });
        })["catch"](function() {
        });
      }
      function addBoth() {
        overlayNote("Jerseys ✓ · shorts ✓ — opening your cart…");
        var items = [
          { id: jerseyVariant.variantId, quantity: 1, properties: jerseyProps || {} },
          { id: shortsVariant.variantId, quantity: 1, properties: sProps }
        ];
        var expects = [pinExpected(jerseyVariant), pinExpected(shortsVariant)];
        function openCart() {
          overlayNote("Jerseys ✓ · shorts ✓ — confirming your prices…");
          return settleCartPrices(expects).then(function() {
            window.location.assign("/cart");
          });
        }
        sweepStaleShorts().then(function() {
          return cartAdd(items);
        }).then(function() {
          trace("kit:sync-added");
          track("kit_sync_added", { design: designId(), shorts: to, secs: Math.round((Date.now() - started) / 1e3) });
          try {
            if (window.XeistUniformKit && XeistUniformKit.pkgflowClear) XeistUniformKit.pkgflowClear();
          } catch (e) {
          }
          return openCart();
        })["catch"](function() {
          cartAdd(items).then(function() {
            trace("kit:sync-added-retry");
            return openCart();
          })["catch"](function() {
            fallbackHop();
          });
        });
      }
      function fallbackHop() {
        trace("kit:fallback-hop", { err: String(shortsErr || "").slice(0, 60) });
        track("kit_sync_fallback", { design: designId(), err: String(shortsErr || "").slice(0, 60) });
        overlayNote("Jerseys created ✓ — one more moment for your matching shorts…");
        var jerseyItem = { id: jerseyVariant.variantId, quantity: 1, properties: jerseyProps || {} };
        cartAdd([jerseyItem])["catch"](function() {
          return cartAdd([jerseyItem]);
        }).then(function() {
          try {
            var carry = buildCarry(to);
            carry.autoBuy = true;
            carry.routePending = false;
            if (window.__xeistDupChoice) carry.dup = window.__xeistDupChoice;
            localStorage.setItem(CARRY_KEY, JSON.stringify(carry));
          } catch (e) {
          }
          window.location.replace(customizerUrl(to));
        })["catch"](function() {
          window.location.assign("/cart");
        });
      }
      return true;
    }
    var carryApplied = false;
    var autoBuyStarted = false;
    try {
      (function() {
        var c0 = JSON.parse(localStorage.getItem(CARRY_KEY) || "null");
        var hid = (window.location.hash.match(/\/customise\/(\d+)/i) || [])[1];
        var stale0 = !!(c0 && c0.applied && Date.now() - (c0.appliedTs || 0) > RESUME_MAX_AGE);
        if (stale0) {
          trace("shorts:resume-stale");
          clearCarry();
        }
        if (c0 && c0.autoBuy && !stale0 && String(c0.toDesign) === String(hid)) {
          var boot = function() {
            injectCSS();
            showBusy("Step 2 of 2 — setting up your approved matching shorts. Nothing to do here — your cart opens automatically.");
            setTimeout(function() {
              if (!autoBuyStarted && document.getElementById("xs-busy")) handBack("setup-stall");
            }, 1e5);
          };
          if (document.body) boot();
          else document.addEventListener("DOMContentLoaded", boot);
        }
      })();
    } catch (e) {
    }
    function markCarryApplied() {
      try {
        var c = JSON.parse(localStorage.getItem(CARRY_KEY) || "null");
        if (c) {
          c.applied = true;
          c.appliedTs = Date.now();
          localStorage.setItem(CARRY_KEY, JSON.stringify(c));
        }
      } catch (e) {
      }
    }
    function resumeTick() {
      if (autoBuyStarted || carryApplied) return;
      var c = null;
      try {
        c = JSON.parse(localStorage.getItem(CARRY_KEY) || "null");
      } catch (e) {
      }
      if (!c || !c.autoBuy || !c.applied) return;
      var hid = (window.location.hash.match(/\/customise\/(\d+)/i) || [])[1];
      if (String(c.toDesign) !== String(hid)) return;
      if (Date.now() - (c.appliedTs || 0) > RESUME_MAX_AGE) {
        trace("shorts:resume-stale");
        clearCarry();
        return;
      }
      if (!uni() || !window.XeistUniformRoster || !$(".kb-button-single-item-checkout-buy-now")) return;
      carryApplied = true;
      var rows = 0;
      try {
        rows = XeistUniformRoster.readRows().length;
      } catch (e) {
      }
      trace("shorts:resume", { rows, age: Math.round((Date.now() - (c.appliedTs || 0)) / 1e3) });
      track("pkg_shorts_resume", { design: designId(), rows });
      if (rows || !(c.roster || []).length) {
        autoBuyShorts(c);
        return;
      }
      XeistUniformRoster.importRows(c.roster, function() {
        autoBuyShorts(c);
      });
    }
    function handBack(code) {
      var o = document.getElementById("xs-busy");
      if (!o) return;
      if (o.parentNode) o.parentNode.removeChild(o);
      clearCarry();
      trace("shorts:autobuy-handback", { code });
      track("pkg_shorts_autobuy_handback", { design: designId(), code });
      var opened = false;
      try {
        if (window.XeistUniformReview && XeistUniformReview.open) {
          XeistUniformReview.open();
          opened = true;
        }
      } catch (e) {
      }
      var note = el("div", "xs-handback", "");
      note.id = "xs-handback";
      note.setAttribute("role", "alert");
      note.innerHTML = "<strong>Your matching shorts were not added automatically.</strong> " + (opened ? "Check the roster below and press <strong>Add to cart</strong> to finish." : "Open Review and press <strong>Add to cart</strong> to finish.") + ' <span class="xs-handback-ref">ref ' + esc(code) + "</span>";
      var drawer = document.getElementById("xv-drawer");
      var anchor = drawer && (drawer.querySelector("#xs-drawer-row") || drawer.querySelector("#xv-pay") || drawer.querySelector("#xv-goto-roster"));
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(note, anchor);
      else document.body.appendChild(note);
    }
    var carryAbsent = false;
    function applyCarry() {
      if (carryApplied || carryAbsent) return;
      try {
        if (localStorage.getItem(CARRY_KEY) == null) {
          carryAbsent = true;
          return;
        }
      } catch (e) {
      }
      var c = onShortsSide();
      if (!c) return;
      if (c.applied) return;
      var w = uni();
      if (!w || !w.applyLook || !w.looksFor) return;
      carryApplied = true;
      trace("shorts:carry-apply", { from: c.fromDesign });
      try {
        var key = "xeist_uniform_setup_" + c.toDesign;
        localStorage.setItem(key, JSON.stringify(c.team || {}));
      } catch (e) {
      }
      try {
        if ((c.expected | 0) > 0) localStorage.setItem("xeist_expected_" + c.toDesign, String(c.expected | 0));
      } catch (e) {
      }
      try {
        if (w.team && c.team) {
          w.team.name = c.team.name || "";
          w.team.c1 = c.team.c1 || null;
          w.team.c2 = c.team.c2 || null;
          w.team.lastLook = c.team.lastLook || "Home";
        }
      } catch (e) {
      }
      var looks = [];
      try {
        looks = w.looksFor(c.team || {}) || [];
      } catch (eL) {
        looks = [];
      }
      var name = c.team && c.team.lastLook || "Home";
      var look = looks.filter(function(l) {
        return l.name === name;
      })[0] || looks[0];
      var carryRows = c.roster || [];
      if (c.matchSizes === false) {
        carryRows = carryRows.map(function(r) {
          return { name: r.name, number: r.number, sizeLabel: "" };
        });
      }
      function importRoster(done) {
        if (!carryRows.length) {
          done();
          return;
        }
        var waited = 0, tries = 0;
        (function attempt() {
          var R = window.XeistUniformRoster;
          if (!($(".kb-field-teamdetails") && R && R.importRows)) {
            waited += 500;
            if (waited > 25e3) {
              trace("shorts:roster-timeout");
              done();
              return;
            }
            setTimeout(attempt, 500);
            return;
          }
          R.importRows(carryRows, function(n) {
            if (n > 0 || tries >= 8) {
              trace("shorts:roster-imported", { n, tries });
              done();
              return;
            }
            tries++;
            setTimeout(attempt, 1500);
          });
        })();
      }
      function settleCarry() {
        if (c.autoBuy) markCarryApplied();
        else clearCarry();
      }
      if (!look) {
        trace("shorts:carry-no-look");
        importRoster(function() {
          settleCarry();
          if (c.autoBuy) autoBuyShorts(c);
        });
        return;
      }
      w.applyLook(look, {
        beforePersist: function(next) {
          importRoster(next);
        },
        onDone: function() {
          settleCarry();
          try {
            sessionStorage.setItem("xs_carried_note", JSON.stringify({
              n: (c.roster || []).length,
              matched: c.matchSizes !== false
            }));
            noteAbsent = false;
          } catch (e) {
          }
          track("uniform_shorts_carried", { from: c.fromDesign, to: c.toDesign, players: (c.roster || []).length, matchedSizes: c.matchSizes !== false });
          var d = (uni() || {}).design;
          if (d && d.noTextItems) {
            var o = document.getElementById("xu-build-overlay");
            if (o && o.parentNode) o.parentNode.removeChild(o);
            trace("shorts:carry-no-rebuild");
            if (c.autoBuy) autoBuyShorts(c);
            return;
          }
          var params = window.location.search.replace(/^\?/, "").split("&").filter(function(p) {
            return p && !/^set=/.test(p) && !/^cb=/.test(p);
          });
          params.push("cb=" + Math.floor(Math.random() * 1e9));
          window.location.replace(window.location.pathname + "?" + params.join("&") + window.location.hash);
        }
      });
    }
    function autoBuyShorts(carry) {
      if (autoBuyStarted) return;
      autoBuyStarted = true;
      injectCSS();
      showBusy("Step 2 of 2 — adding your approved matching shorts to your cart. Nothing to do here — your cart opens automatically in about 30 seconds.");
      trace("shorts:autobuy-start");
      var started = Date.now();
      var attempts = 0, lastFire = 0, baseline = null, landed = false, tookOnce = false;
      var lastGate = null, lastBusy = null, sawBtn = false;
      function cartCount() {
        return fetch("/cart.js", { cache: "no-store" }).then(function(r) {
          return r.json();
        }).then(function(c) {
          return (c.items || []).length;
        })["catch"](function() {
          return null;
        });
      }
      var swept = false;
      (function sweep() {
        var keep = carry && carry.dup === "keep";
        var team = String(carry && carry.team && carry.team.name || "").trim().toUpperCase();
        var me = designId();
        fetch("/cart.js", { cache: "no-store" }).then(function(r) {
          return r.json();
        }).then(function(c) {
          var stale = keep ? [] : (c.items || []).filter(function(it) {
            var p = it.properties || {};
            if (String(p._design_id || "") !== String(me)) return false;
            var t = String(p.Team || "").trim().toUpperCase();
            return !t || !team || t === team;
          });
          var q = stale.slice();
          (function next() {
            if (!q.length) {
              if (stale.length) {
                trace("shorts:stale-swept", { n: stale.length });
                track("pkg_shorts_stale_swept", { design: me, n: stale.length });
              }
              return cartCount().then(function(n) {
                baseline = n;
                swept = true;
              });
            }
            var it = q.shift();
            return fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: it.key, quantity: 0 })
            })["catch"](function() {
            }).then(next);
          })();
        })["catch"](function() {
          cartCount().then(function(n) {
            baseline = n;
            swept = true;
          });
        });
      })();
      function kbGate(btn) {
        try {
          var is = window.angular && angular.element(btn).isolateScope();
          if (is && is.canAddToCart) return !!is.canAddToCart();
        } catch (e) {
        }
        return null;
      }
      function kbBusy(btn) {
        try {
          var sc = window.angular && angular.element(btn).scope();
          var svc = sc && sc.AddToCartService;
          if (svc && typeof svc.waiting === "function") return !!svc.waiting();
        } catch (e) {
        }
        return null;
      }
      function code(why) {
        return why + "·a" + attempts + "·g" + String(lastGate) + "·b" + String(lastBusy) + "·btn" + (sawBtn ? 1 : 0) + "·" + Math.round((Date.now() - started) / 1e3) + "s";
      }
      (function step() {
        if (landed) return;
        var elapsed = Date.now() - started;
        if (!attempts && elapsed > 45e3) return handBack(code("no-fire"));
        if (elapsed > 15e4) return handBack(code("timeout"));
        var btn = $(".kb-button-single-item-checkout-buy-now");
        if (btn) {
          sawBtn = true;
          lastBusy = kbBusy(btn);
          if (lastBusy === true) tookOnce = true;
          var mayFire = attempts === 0 || // refire ONLY when the last click provably no-oped: KB idle,
          // gate open again, nothing landed. Anything murkier risks
          // KB's "already adding to cart" alert (m32 recon 2026-08-18).
          !tookOnce && attempts < 3 && Date.now() - lastFire > 9e3 && lastBusy === false && kbGate(btn) === true;
          if (swept && mayFire && (!lastFire || Date.now() - lastFire > 9e3)) {
            var gate = kbGate(btn);
            lastGate = gate;
            if (gate === true || gate === null && elapsed > 1e4) {
              try {
                var R = window.XeistUniformRoster;
                if (R && R.stripEmptyRows) R.stripEmptyRows();
              } catch (eS) {
              }
              try {
                if (window.XeistUniformReview && XeistUniformReview.armOrderProps) XeistUniformReview.armOrderProps();
              } catch (eA) {
              }
              try {
                angular.element(btn).triggerHandler("click");
              } catch (e) {
                try {
                  btn.click();
                } catch (e2) {
                }
              }
              attempts++;
              lastFire = Date.now();
              track("pkg_shorts_autobuy", { design: designId(), attempt: attempts });
              trace("shorts:autobuy-fired", { attempt: attempts });
            }
          }
        }
        if (lastFire && baseline != null) {
          cartCount().then(function(n) {
            if (landed) return;
            if (n != null && n > baseline) {
              landed = true;
              clearCarry();
              trace("shorts:autobuy-landed");
              track("pkg_shorts_autobuy_landed", { design: designId(), attempts, secs: Math.round((Date.now() - started) / 1e3) });
              busyMsg("Shorts added — opening your cart…");
              setTimeout(function() {
                window.location.href = "/cart";
              }, 4e3);
              return;
            }
            setTimeout(step, 1200);
          });
        } else {
          setTimeout(step, 1200);
        }
      })();
    }
    var CSS = [
      "#xs-scrim{position:fixed;inset:0;background:rgba(20,20,22,.30);backdrop-filter:blur(3px);z-index:2147483100}",
      "#xs-offer{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);width:min(540px,92vw);max-height:92vh;overflow-y:auto;background:#fff;border-radius:20px;box-shadow:0 24px 70px rgba(0,0,0,.25);padding:30px;z-index:2147483150;font-size:16px;color:#1d1d1f}",
      ".xs-h{margin:0 0 8px;font-size:24px;font-weight:800}",
      ".xs-sub{margin:0 0 14px;font-size:16px;line-height:1.5;color:#57575b}",
      ".xs-sw{display:inline-block;width:14px;height:14px;border-radius:50%;border:1px solid rgba(0,0,0,.18);vertical-align:-2px;margin-left:4px}",
      ".xs-points{margin:0 0 18px;padding-left:20px;font-size:16px;line-height:1.55;color:#3a3a3c}",
      ".xs-points li{margin:7px 0}",
      ".xs-cta{display:block;width:100%;border:0;border-radius:12px;background:" + ACCENT + ";color:#fff;font:700 17px/1 inherit;padding:17px 22px;cursor:pointer;min-height:54px}",
      ".xs-cta:hover{filter:brightness(1.08)}",
      ".xs-more{display:block;width:100%;border:0;background:transparent;color:" + ACCENT + ";font:600 16px/1 inherit;cursor:pointer;padding:13px 10px;min-height:44px}",
      ".xs-hero{border-radius:14px;overflow:hidden;background:#f5f5f7;margin:2px 0 8px;display:flex;align-items:center;justify-content:center;max-height:220px}",
      ".xs-hero img{width:100%;height:100%;max-height:220px;object-fit:contain;display:block}",
      ".xs-hero-cap{margin:0 0 14px;font-size:14px;color:#8e8e93}",
      "#xs-drawer-row{margin:0 0 10px;font-size:13px}",
      "#xs-handback{margin:0 0 12px;padding:12px 14px;border-radius:12px;background:#fff6e5;border:1px solid #f3d9a4;font-size:14px;line-height:1.5;color:#1d1d1f;text-transform:none!important;letter-spacing:normal!important}",
      "#xs-handback .xs-handback-ref{display:block;margin-top:4px;font-size:11.5px;color:#8a8a8e;font-family:ui-monospace,SFMono-Regular,Menlo,monospace}",
      "body > #xs-handback{position:fixed;left:16px;right:16px;bottom:calc(110px + env(safe-area-inset-bottom));z-index:2147483300;box-shadow:0 12px 40px rgba(0,0,0,.18)}",
      /* text-transform/letter-spacing normalized — the theme styles <label>
         as spaced uppercase, which shrank readability (Justin 2026-07-31) */
      ".xs-match{display:flex;gap:10px;align-items:flex-start;font-size:15.5px;line-height:1.5;color:#3a3a3c;margin:0 0 18px;cursor:pointer;text-transform:none!important;letter-spacing:normal!important;font-weight:400}",
      ".xs-match input{width:18px;height:18px;flex:0 0 auto;margin-top:2px}",
      ".xs-carried{border-left:4px solid " + ACCENT + ";font-size:13px;color:#3a3a3c;display:flex;gap:10px;align-items:flex-start;justify-content:space-between}",
      ".xs-carried-x{border:0;background:#f2f2f4;border-radius:50%;width:26px;height:26px;font-size:15px;line-height:1;cursor:pointer;color:#3a3a3c;flex:0 0 auto}",
      /* 2026-09-11: the theme styles <label> as spaced uppercase — the phone
         review sheet showed "INCLUDE YOUR MATCHING SHORTS — DESIGN APPROVED". */
      ".xs-drawer-label{display:flex;gap:8px;align-items:flex-start;cursor:pointer;text-transform:none!important;letter-spacing:normal!important;font-weight:400;line-height:1.45}",
      "#xs-busy{position:fixed;inset:0;background:rgba(255,255,255,.94);backdrop-filter:blur(3px);z-index:2147483400;display:flex;align-items:center;justify-content:center;text-align:center}",
      ".xs-busy-inner p{margin:12px 0 0;font-size:15px;font-weight:600;color:#1d1d1f}",
      ".xs-spin{width:38px;height:38px;border-radius:50%;border:4px solid rgba(109,40,217,.15);border-top-color:" + ACCENT + ";margin:0 auto;animation:xsspin .9s linear infinite}",
      "@keyframes xsspin{to{transform:rotate(360deg)}}",
      "@media (prefers-reduced-motion:reduce){.xs-spin{animation:none}}",
      "@media (max-width:749px){#xs-offer{top:auto;bottom:0;left:0;transform:none;width:100%;border-radius:22px 22px 0 0;padding:22px 20px calc(22px + env(safe-area-inset-bottom))}}"
    ].join("\n");
    function injectCSS() {
      if ($("#xs-style")) return;
      var s = el("style", "", "");
      s.id = "xs-style";
      s.appendChild(document.createTextNode(CSS));
      document.head.appendChild(s);
    }
    var listenerBound = false;
    function tick() {
      if (!uni()) return;
      injectCSS();
      if (!listenerBound) {
        listenerBound = true;
        document.addEventListener("click", interceptBuy, true);
        track("uniform_shorts_boot", { design: designId(), paired: !!pairedShortsId() });
      }
      injectDrawerRow();
      cacheSizeMap();
      applyCarry();
      resumeTick();
      showCarriedNote();
    }
    var noteAbsent = false;
    function showCarriedNote() {
      if (noteAbsent || document.getElementById("xs-carried")) return;
      var raw = null;
      try {
        raw = sessionStorage.getItem("xs_carried_note");
      } catch (e) {
      }
      if (!raw) {
        noteAbsent = true;
        return;
      }
      var anchor = $("#xr-card") || $("#xu-lookbook");
      if (!anchor || !anchor.parentNode) return;
      var note = null;
      try {
        note = JSON.parse(raw);
      } catch (e) {
      }
      try {
        sessionStorage.removeItem("xs_carried_note");
      } catch (e) {
      }
      if (!note) return;
      var card = el("aside", "xu-card xs-carried", "");
      card.id = "xs-carried";
      card.innerHTML = "<strong>Carried over from your jersey:</strong> " + (note.n ? note.n + " player" + (note.n === 1 ? "" : "s") + (note.matched ? " with sizes matched to the jersey roster — adjust any player below." : " — pick shorts sizes for each player below.") : "your colors and look.") + ' <button type="button" class="xs-carried-x" aria-label="Dismiss">&times;</button>';
      anchor.parentNode.insertBefore(card, anchor);
      card.querySelector(".xs-carried-x").addEventListener("click", function() {
        card.remove();
      });
      var td = $(".kb-field-teamdetails");
      var tab = td && $all("a[ng-click]", td).filter(function(a) {
        return /setEnterTeams\(true\)/.test(a.getAttribute("ng-click") || "");
      })[0];
      if (tab) {
        try {
          tab.click();
        } catch (e) {
        }
      }
    }
    if (window.XeistCore && XeistCore.every) {
      XeistCore.every("xu-shorts-offer", 900, tick, { runHidden: true });
    } else {
      setInterval(tick, 900);
    }
  })();

  // src/enforcers/34-topspace-fix.js
  (function() {
    "use strict";
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    var ID = "xeist-topspace-fix";
    function inject() {
      if (document.getElementById(ID)) return;
      if (!document.head) return;
      var s = document.createElement("style");
      s.id = ID;
      s.appendChild(document.createTextNode(
        "@media (min-width:990px){body .main-content .page-width.page-content{padding-top:12px!important}body .page-content .custom-class{padding-top:0!important}}"
      ));
      document.head.appendChild(s);
    }
    inject();
    document.addEventListener("DOMContentLoaded", inject);
  })();

  // src/uniform/35-roster-collect.js
  (function() {
    "use strict";
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    var CFG = window.XeistConfig || {};
    var API = CFG.sessionApi ? String(CFG.sessionApi).replace(/\/+$/, "") : null;
    function tidyWord(w) {
      if (!w) return w;
      if (/^[a-z]/.test(w)) return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
      if (w.length > 2 && w === w.toUpperCase() && /[A-Z]/.test(w)) {
        return w.charAt(0) + w.slice(1).toLowerCase();
      }
      if (w.length > 3 && /^[A-Z]/.test(w) && /[A-Z]/.test(w.slice(1))) {
        if (!/^(Mc|Mac|O['\u2019]|D['\u2019]|L['\u2019]|De|Di|Du|La|Le|Van|Von|St\.?)?[A-Z]?[a-z'\u2019.-]*$/.test(w)) {
          return w.charAt(0) + w.slice(1).toLowerCase();
        }
      }
      return w;
    }
    function tidyName(raw) {
      var t = String(raw == null ? "" : raw).replace(/\s+/g, " ").trim();
      return t.split(" ").map(function(word) {
        return word.split("-").map(tidyWord).join("-");
      }).join(" ");
    }
    try {
      window.XeistNameTidy = { tidy: tidyName };
    } catch (e0) {
    }
    if (!API) return;
    function $(s, r) {
      return (r || document).querySelector(s);
    }
    function $all(s, r) {
      return Array.prototype.slice.call((r || document).querySelectorAll(s));
    }
    function esc(s) {
      return String(s == null ? "" : s).replace(/[&<>"']/g, function(c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }
    function track(type, payload) {
      try {
        if (window.XeistTrack) window.XeistTrack(type, payload);
      } catch (e) {
      }
    }
    function store() {
      return window.XeistCore && XeistCore.store || {
        get: function(k) {
          try {
            return window.localStorage.getItem(k);
          } catch (e) {
            return null;
          }
        },
        set: function(k, v) {
          try {
            window.localStorage.setItem(k, v);
          } catch (e) {
          }
        },
        remove: function(k) {
          try {
            window.localStorage.removeItem(k);
          } catch (e) {
          }
        }
      };
    }
    function uni() {
      return window.XeistUniform || null;
    }
    function roster() {
      return window.XeistUniformRoster || null;
    }
    function payModeKey() {
      var w = uni();
      return w ? "xeist_paymode_" + w.designId : null;
    }
    function getPayMode() {
      var k = payModeKey();
      var v = k ? store().get(k) : null;
      if (v === "parent" || v === "coach") return v;
      var mv = lastMeta && lastMeta.payMode;
      if (mv === "parent" || mv === "coach") {
        setPayMode(mv);
        return mv;
      }
      return null;
    }
    function setPayMode(m) {
      var k = payModeKey();
      if (k) store().set(k, m);
    }
    function isParentPay() {
      return getPayMode() === "parent";
    }
    var lastMeta = null;
    function paidEntries() {
      return lastEntries.filter(function(e) {
        return e && e.paid;
      });
    }
    function cadFmt(n) {
      try {
        if (window.XeistMoney) return window.XeistMoney.cad(n);
      } catch (e) {
      }
      return "$" + (+n || 0).toFixed(2) + " CAD";
    }
    function fmtMoney(cents) {
      return cadFmt((cents | 0) / 100);
    }
    function fmtDate(ts) {
      try {
        return new Date(ts).toLocaleDateString(void 0, { month: "short", day: "numeric" });
      } catch (e) {
        return "";
      }
    }
    var SHEET_TIERS = [[1, 10], [11, 24], [25, 49], [50, 99], [100, 199], [200, Infinity]];
    var SHEET_CAD = {
      "xe-caliber": { uniform: [82.99, 72.99, 69.99, 67.99, 64.99, 59.99], jersey: [49.99, 39.99, 37.99, 36.99, 34.99, 32.99] },
      // FOOTBALL (2026-09-15): Blitz Jerseys, jersey-only — the fixed CAD tier
      // prices on the Blitz store products (what the parent page charges);
      // mirrors worker PRICE_CAD['blitz'], change both. No uniform row.
      "blitz": { jersey: [59.99, 59.99, 57.99, 54.99, 51.99, 49.99] }
      // add lines as designs are mapped (worker PRICE_CAD is the full table)
    };
    var DESIGN_LINES = {
      "102815703": "xe-caliber",
      // Blitz Jerseys (football) — all 10 store designs
      "118422104": "blitz",
      "118422102": "blitz",
      "116799835": "blitz",
      "118419375": "blitz",
      "118422811": "blitz",
      "118422810": "blitz",
      "118422809": "blitz",
      "118419376": "blitz",
      "118422812": "blitz",
      "118422806": "blitz"
    };
    var PRODUCT_LINES = { "116801147": "blitz" };
    function kbProductId() {
      try {
        var page = document.querySelector(".kb-customise-page");
        var m = page && String(page.className).match(/kb-product-id-(\d+)/);
        return m ? m[1] : "";
      } catch (e) {
        return "";
      }
    }
    function lineFor() {
      var w = uni() || {};
      return DESIGN_LINES[String(w.designId)] || PRODUCT_LINES[kbProductId()] || "";
    }
    window.XeistSheetQuote = function(count) {
      try {
        var line = SHEET_CAD[lineFor()];
        if (!line) return null;
        var pkg = pkgFor();
        var row = pkg.shorts ? line.uniform : line.jersey;
        var n = count > 0 ? count : getExpected() || 0;
        var i = sheetTierIdx(n || 1);
        if (row[i] == null) return null;
        return {
          unit: row[i],
          from: row[0],
          known: n > 0,
          count: n,
          // Package shorts price = uniform minus jersey at the SAME tier
          // (Justin 2026-08-26): $33/$33/$32/$31/$30/$27 down the ladder.
          // Jersey-only lines (football) have no uniform row: no delta.
          shortsDelta: line.uniform && line.uniform[i] != null ? Math.round((line.uniform[i] - line.jersey[i]) * 100) / 100 : null,
          shorts: !!pkg.shorts,
          label: pkg.shorts ? "jersey + shorts" : "jersey",
          tierLabel: SHEET_TIERS[i][1] === Infinity ? SHEET_TIERS[i][0] + "+ players" : SHEET_TIERS[i][0] + "-" + SHEET_TIERS[i][1] + " players",
          // The first tier that is actually CHEAPER than the entry price
          // (2026-09-15 night): football's 1-10 and 11-24 rows are both
          // $59.99, so "team pricing at 11+" was a lie there — it breaks at
          // 25. Basketball still reads 11+ (its 11-24 row is cheaper).
          discountAt: firstBreak(row)
        };
      } catch (e) {
        return null;
      }
    };
    function firstBreak(row) {
      for (var j = 1; j < SHEET_TIERS.length; j++) {
        if (row[j] != null && row[j] < row[0] - 5e-3) return SHEET_TIERS[j][0];
      }
      return SHEET_TIERS[1][0];
    }
    var CAD_LADDER_LINES = { blitz: true };
    window.XeistCadLadder = function(qty) {
      try {
        var key = lineFor();
        if (!CAD_LADDER_LINES[key]) return null;
        var m = window.XeistMoney;
        if (!m || !m.kbFixed || !m.kbFixed()) return null;
        var row = SHEET_CAD[key] && SHEET_CAD[key].jersey;
        if (!row) return null;
        var i = sheetTierIdx(qty || 1);
        if (row[i] == null) return null;
        return { base: row[i], line: key, tierIdx: i };
      } catch (e) {
        return null;
      }
    };
    function sheetTierIdx(n) {
      var q = n > 0 ? n : 1;
      for (var i = 0; i < SHEET_TIERS.length; i++) {
        if (q >= SHEET_TIERS[i][0] && q <= SHEET_TIERS[i][1]) return i;
      }
      return 0;
    }
    function namesOptOn() {
      try {
        return !!(window.XeistNamesOpt && XeistNamesOpt.on());
      } catch (e) {
        return false;
      }
    }
    function pkgQuote(nOverride) {
      var pkg = pkgFor();
      var labels = ["Jersey"];
      if (pkg.shorts) labels.push("Shorts");
      if (pkg.compression) labels.push("Compression shirt");
      var line = SHEET_CAD[lineFor()];
      var total = null, tierNote = "";
      if (line) {
        var i = sheetTierIdx(nOverride || getExpected() || minOrder());
        var row = pkg.shorts ? line.uniform : line.jersey;
        if (row && row[i] != null) {
          total = row[i] + (namesOptOn() ? 5 : 0);
          tierNote = SHEET_TIERS[i][1] === Infinity ? SHEET_TIERS[i][0] + "+ players" : SHEET_TIERS[i][0] + "-" + SHEET_TIERS[i][1] + " players";
        }
      } else {
        var r = roster(), base = null, prices = { shorts: 34.99, compression: 29.99 };
        try {
          if (r && r.jerseyBase) base = r.jerseyBase();
        } catch (e) {
        }
        try {
          if (r && r.pkgPrices) prices = r.pkgPrices();
        } catch (e) {
        }
        total = base;
        if (pkg.shorts && total != null) total += prices.shorts;
        if (pkg.compression && total != null) total += prices.compression;
      }
      return { labels: labels.join(" + "), total, tierNote };
    }
    var LINK_TTL = 30 * 24 * 3600 * 1e3;
    function linkKey() {
      var w = uni();
      return w ? "xeist_collect_" + w.designId : null;
    }
    function loadLink() {
      var k = linkKey();
      if (!k) return null;
      try {
        var c = JSON.parse(store().get(k) || "null");
        if (c && c.token && /^[a-f0-9]{32,64}$/.test(c.token) && Date.now() - (c.ts || 0) < LINK_TTL) return c;
      } catch (e) {
      }
      return null;
    }
    function saveLink(c) {
      var k = linkKey();
      if (k) store().set(k, JSON.stringify(c));
    }
    function clearLink() {
      var k = linkKey();
      if (k) store().remove(k);
    }
    function makeToken() {
      try {
        var buf = new Uint8Array(16);
        crypto.getRandomValues(buf);
        var s = "";
        for (var i = 0; i < buf.length; i++) s += (buf[i] + 256).toString(16).slice(1);
        return s;
      } catch (e) {
        return null;
      }
    }
    function linkUrl(token) {
      var url = "https://www.xeist.com/pages/team-roster?r=" + token;
      try {
        var th = window.Shopify && window.Shopify.theme;
        if (th && th.id && th.role !== "main") url += "&preview_theme_id=" + th.id;
      } catch (e) {
      }
      return url;
    }
    function sizeLabels() {
      var sel = $(".kb-field-teamdetails select");
      if (!sel) return [];
      return $all("option", sel).filter(function(o) {
        return o.value;
      }).map(function(o) {
        return o.text.replace(/^\s+|\s+$/g, "");
      });
    }
    function nudgeDetailsTab() {
      var td = $(".kb-field-teamdetails");
      if (!td) return;
      var tab = $all("a[ng-click]", td).filter(function(x) {
        return /setEnterTeams\(true\)/.test(x.getAttribute("ng-click") || "");
      })[0];
      if (tab) {
        try {
          tab.click();
        } catch (e) {
        }
      }
    }
    function posterFor(designId) {
      try {
        var p = window.XeistPosters && window.XeistPosters[designId];
        return p || null;
      } catch (e) {
        return null;
      }
    }
    function pkgFor() {
      try {
        var w = uni();
        return JSON.parse(store().get("xeist_pkg_" + w.designId) || "null") || {};
      } catch (e) {
        return {};
      }
    }
    var PAY_HANDLES = {
      "102815703:package": "xe-caliber-uniform-the-x",
      // The X (sandbox E2E)
      // FOOTBALL (2026-09-15): EVERY Blitz design — the 10 with their own
      // store product (Montana blitz-jersey-showtime, Machine
      // blitz-uniform-falcon, ZKY blitz-uniform-rams, Bolts, Maple, United,
      // Army, State, Falcon, Airline) and the ones without (OSU, Stars, The
      // U, Pack, Mile High, Juke, B&G, Bengal, Steel, every future one) —
      // charges ONE unlisted store product, `blitz-jersey-team-order`
      // (admin product 8898194178247, status Unlisted: reachable by handle,
      // absent from collections + search). Same 10-24 .. 200+ tier variants,
      // same fixed CAD ladder as SHEET_CAD['blitz'] (59.99/57.99/54.99/
      // 51.99/49.99); the order line names the design ("Design: Montana ·
      // WOLVES"). WHY not the public product per design (Justin, 2026-09-15
      // night): parents must NEVER see free shipping. The public Blitz
      // products sit in the "Team Shipping - Football Jerseys (Parent Pay)"
      // profile ($4.99 under $100, FREE $100+ so bulk direct orders stay
      // free); a parent who bumped the quantity to 2 would cross $100 and
      // ship free. The team-order product sits ALONE in "Team Shipping -
      // Football Parent Pay (no free tier)" ($4.99 flat CA/US, nothing
      // else), so the parent checkout has exactly one rate whatever the
      // quantity. Shopify cannot hide a rate per buyer without a Function
      // app, so the split is done by product. DO NOT add per-design
      // '<designId>:package' entries for Blitz again — that reopens the hole.
      "kb:116801147:package": "blitz-jersey-team-order"
      // '<designId>:package': '<store product handle>',
      // '*:names': '<handle of a $5.00 "player last name printing" product>',
    };
    function payHandleFor(key) {
      var w = uni();
      var id = w ? String(w.designId) : "";
      return PAY_HANDLES[id + ":" + key] || PAY_HANDLES["kb:" + kbProductId() + ":" + key] || PAY_HANDLES["*:" + key] || "";
    }
    function jerseyHandle() {
      try {
        var wrap = document.querySelector(".kb-partial-wrap");
        var sc = window.angular && wrap && angular.element(wrap).scope();
        return sc && sc.design && sc.design.productUrlSlug || "";
      } catch (e) {
        return "";
      }
    }
    function pkgItems() {
      var labels = sizeLabels();
      var items = [{ key: "jersey", label: "Jersey", sizes: labels, handle: jerseyHandle() }];
      var pkg = pkgFor();
      if (pkg.shorts) items.push({ key: "shorts", label: "Shorts", sizes: labels, handle: payHandleFor("shorts") });
      if (pkg.compression) items.push({ key: "compression", label: "Compression shirt", sizes: labels, handle: payHandleFor("compression") });
      return items;
    }
    function putMeta(token, done) {
      var w = uni();
      var poster = w ? posterFor(w.designId) : null;
      var body = {
        team: w && w.team && w.team.name || "",
        design: w && w.designId || "",
        designName: w && w.design && w.design.name || "",
        noun: poster && poster.noun || w && w.design && w.design.noun || "jersey",
        image: poster && poster.img || "",
        expected: getExpected(),
        coachPhone: getPhone(),
        closed: !!(loadLink() && loadLink().paused),
        sizes: sizeLabels(),
        items: pkgItems()
      };
      var pmv = getPayMode();
      if (pmv) body.payMode = pmv;
      var pkh = payHandleFor("package");
      if (pkh) body.packageHandle = pkh;
      var kbp = kbProductId();
      if (kbp) body.kbProduct = kbp;
      body.namesOn = namesOptOn();
      var nh = payHandleFor("names");
      if (nh) body.namesHandle = nh;
      var st = getShipTo();
      if (st) body.shipTo = st;
      var dlv = parseInt(store().get("xeist_deadline_" + ((uni() || {}).designId || "")) || "0", 10);
      if (dlv > Date.now()) body.deadline = dlv;
      fetch(API + "/roster/" + token, {
        method: "PUT",
        mode: "cors",
        headers: { "Content-Type": "text/plain" },
        body: JSON.stringify(body)
      }).then(function(r) {
        if (done) done(r.ok, body);
      }).catch(function() {
        if (done) done(false, body);
      });
    }
    function readCanvasNow() {
      try {
        var best = null, bestArea = 0;
        $all("canvas").forEach(function(cv) {
          var a = (cv.width || 0) * (cv.height || 0);
          if (a > bestArea && cv.width > 200 && cv.height > 200) {
            best = cv;
            bestArea = a;
          }
        });
        if (!best) return null;
        var scale = Math.min(1, 1100 / Math.max(best.width, best.height));
        var w = Math.max(1, Math.round(best.width * scale));
        var h = Math.max(1, Math.round(best.height * scale));
        var oc = document.createElement("canvas");
        oc.width = w;
        oc.height = h;
        var ctx = oc.getContext("2d");
        ctx.fillStyle = "#f6f6f4";
        ctx.fillRect(0, 0, w, h);
        ctx.drawImage(best, 0, 0, w, h);
        var dd = ctx.getImageData(0, 0, w, h).data;
        var r0 = dd[0], g0 = dd[1], b0 = dd[2];
        var minX = w, minY = h, maxX = -1, maxY = -1;
        var step = 2;
        for (var y = 0; y < h; y += step) {
          for (var x = 0; x < w; x += step) {
            var i = (y * w + x) * 4;
            if (Math.abs(dd[i] - r0) + Math.abs(dd[i + 1] - g0) + Math.abs(dd[i + 2] - b0) > 28) {
              if (x < minX) minX = x;
              if (x > maxX) maxX = x;
              if (y < minY) minY = y;
              if (y > maxY) maxY = y;
            }
          }
        }
        if (maxX < 0 || maxX - minX < 40 || maxY - minY < 40) return null;
        var padX = Math.round((maxX - minX) * 0.1), padY = Math.round((maxY - minY) * 0.08);
        var cx = Math.max(0, minX - padX), cy = Math.max(0, minY - padY);
        var cw = Math.min(w - cx, maxX - minX + padX * 2);
        var ch = Math.min(h - cy, maxY - minY + padY * 2);
        var out = document.createElement("canvas");
        var outScale = Math.min(1, 900 / Math.max(cw, ch));
        out.width = Math.max(1, Math.round(cw * outScale));
        out.height = Math.max(1, Math.round(ch * outScale));
        var octx = out.getContext("2d");
        octx.fillStyle = "#f6f6f4";
        octx.fillRect(0, 0, out.width, out.height);
        octx.drawImage(oc, cx, cy, cw, ch, 0, 0, out.width, out.height);
        var url = out.toDataURL("image/jpeg", 0.85);
        return url.length < 600 * 1024 ? url : null;
      } catch (e) {
        trace("collect:capture-err");
        return null;
      }
    }
    function captureDesign(done) {
      var now = readCanvasNow();
      if (now) {
        done(now);
        return;
      }
      var raf = window.requestAnimationFrame;
      if (!raf) {
        trace("collect:capture-blank");
        done(null);
        return;
      }
      var finished = false;
      function finish(url) {
        if (finished) return;
        finished = true;
        window.requestAnimationFrame = raf;
        if (!url) trace("collect:capture-blank");
        done(url);
      }
      window.requestAnimationFrame = function(cb) {
        return raf.call(window, function(ts) {
          try {
            cb(ts);
          } catch (e) {
          }
          if (!finished) {
            var u = readCanvasNow();
            if (u) finish(u);
          }
        });
      };
      try {
        window.dispatchEvent(new Event("resize"));
        var sync = readCanvasNow();
        if (sync) {
          finish(sync);
          return;
        }
      } catch (e) {
      }
      setTimeout(function() {
        finish(null);
      }, 2500);
    }
    function trace(t) {
      try {
        if (window.XeistTrack) window.XeistTrack("roster_collect_trace", { t });
      } catch (e) {
      }
    }
    try {
      window.XeistUniformSnap = captureDesign;
    } catch (e) {
    }
    var previewBusy = false, lastPreviewTs = 0, lastPreviewTry = 0, pendingCapture = false;
    function uploadPreview(token, force) {
      if (previewBusy) return;
      if (!force && Date.now() - lastPreviewTry < 6e4) return;
      lastPreviewTry = Date.now();
      previewBusy = true;
      captureDesign(function(dataUrl) {
        if (!dataUrl) {
          previewBusy = false;
          pendingCapture = true;
          return;
        }
        pendingCapture = false;
        fetch(API + "/roster/" + token + "/preview", {
          method: "PUT",
          mode: "cors",
          headers: { "Content-Type": "text/plain" },
          body: dataUrl
        }).then(function(r) {
          previewBusy = false;
          if (r.ok) lastPreviewTs = Date.now();
        }).catch(function() {
          previewBusy = false;
        });
      });
    }
    function interactionRetry() {
      if (!pendingCapture) return;
      var c = loadLink();
      if (!c) {
        pendingCapture = false;
        return;
      }
      uploadPreview(c.token, true);
    }
    ["pointerdown", "mousedown", "touchstart"].forEach(function(ev) {
      document.addEventListener(ev, function() {
        setTimeout(interactionRetry, 350);
      }, true);
    });
    ["pointerup", "mouseup", "touchend"].forEach(function(ev) {
      document.addEventListener(ev, function() {
        setTimeout(interactionRetry, 80);
      }, true);
    });
    function getRoster(token, done) {
      fetch(API + "/roster/" + token, { mode: "cors" }).then(function(r) {
        if (r.ok) return r.json().then(function(d) {
          done(d, r.status);
        }, function() {
          done(null, r.status);
        });
        done(null, r.status);
      }).catch(function() {
        done(null, 0);
      });
    }
    var CSS = [
      "#xr-collect-slot .xc-block,#xr-collect-slot .xc-block *{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif!important;letter-spacing:normal!important;text-transform:none!important}",
      "#xr-collect-slot .xc-block{margin-top:2px!important}",
      /* the one "Bank Gothic moment" the brand system asks for */
      "#xr-collect-slot .xc-display{text-transform:uppercase!important;letter-spacing:.12em!important;font-weight:700!important}",
      /* 1 - header */
      "#xr-collect-slot .xc-head{display:grid!important;grid-template-columns:minmax(0,1fr) auto!important;gap:22px!important;align-items:start!important;margin:0 0 22px!important}",
      "#xr-collect-slot .xc-h1{font-size:32px!important;line-height:1.08!important;letter-spacing:-.025em!important;font-weight:700!important;margin:0 0 9px!important;color:var(--xt-ink-1)!important}",
      "#xr-collect-slot .xc-lede{font-size:14.5px!important;line-height:1.6!important;color:var(--xt-ink-2)!important;margin:0!important;max-width:46ch!important}",
      "#xr-collect-slot .xc-method{display:inline-flex!important;align-items:center!important;gap:8px!important;white-space:nowrap!important;border:1px solid var(--xt-line)!important;background:var(--xt-btn2-bg)!important;border-radius:12px!important;padding:10px 15px!important;font-size:13px!important;font-weight:500!important;color:var(--xt-ink-2)!important;cursor:pointer!important}",
      "#xr-collect-slot .xc-method:hover{border-color:var(--xt-ink-1)!important;color:var(--xt-ink-1)!important}",
      /* shared card */
      "#xr-collect-slot .xc-card{border:1px solid var(--xt-line)!important;border-radius:16px!important;background:var(--xt-surface-1)!important;padding:26px 28px!important;margin:0 0 18px!important}",
      /* 2 - progress */
      "#xr-collect-slot .xc-prog2{display:grid!important;grid-template-columns:auto minmax(0,1fr)!important;gap:44px!important;align-items:center!important}",
      "@media (max-width:900px){#xr-collect-slot .xc-prog2{grid-template-columns:1fr!important;gap:22px!important}}",
      "#xr-collect-slot .xc-count{display:flex!important;align-items:baseline!important;gap:11px!important}",
      "#xr-collect-slot .xc-num{font-size:52px!important;line-height:.9!important;font-weight:700!important;letter-spacing:-.045em!important;color:var(--xt-ink-1)!important}",
      "#xr-collect-slot .xc-of{font-size:16px!important;font-weight:500!important;color:var(--xt-ink-3)!important}",
      "#xr-collect-slot .xc-prog-t{font-size:11.5px!important;font-weight:700!important;letter-spacing:.09em!important;text-transform:uppercase!important;color:var(--xt-ink-3)!important;margin:0 0 12px!important}",
      "#xr-collect-slot .xc-r-tag-ok{color:var(--xt-good)!important;border-color:var(--xt-good-track)!important}",
      "#xr-collect-slot .xc-count-lbl{font-size:13.5px!important;color:var(--xt-ink-2)!important;margin:9px 0 0!important;white-space:nowrap!important}",
      "#xr-collect-slot .xc-meter{display:flex!important;gap:5px!important}",
      "#xr-collect-slot .xc-seg{height:7px!important;border-radius:4px!important;background:var(--xt-good-track)!important;flex:1 1 0!important;min-width:4px!important}",
      "#xr-collect-slot .xc-seg.on{background:var(--xt-good)!important}",
      "#xr-collect-slot .xc-seg.pend{background:var(--xt-good-track)!important}",
      "#xr-collect-slot .xc-paystat{display:flex!important;flex-wrap:wrap!important;gap:4px 8px!important;margin:12px 0 0!important;font-size:13px!important;color:var(--xt-ink-2)!important}",
      "#xr-collect-slot .xc-paystat b{color:var(--xt-ink-1)!important;font-weight:600!important}",
      "#xr-collect-slot .xc-sep2{color:var(--xt-ink-3)!important}",
      "#xr-collect-slot .xc-r-hollow{width:16px!important;height:16px!important;border-radius:50%!important;border:1.5px solid var(--xt-line)!important;flex:0 0 auto!important;box-sizing:border-box!important}",
      "#xr-collect-slot .xc-r-tag{font-size:11px!important;font-weight:600!important;color:var(--xt-ink-3)!important;border:1px solid var(--xt-line)!important;border-radius:999px!important;padding:3px 9px!important;flex:0 0 auto!important}",
      "#xr-collect-slot .xc-exp-date{width:150px!important}",
      "#xr-collect-slot .xc-set-note{font-size:12.5px!important;color:var(--xt-ink-2)!important}",
      "#xr-collect-slot .xc-minline{display:flex!important;align-items:center!important;gap:9px!important;margin:15px 0 0!important;font-size:13px!important;color:var(--xt-ink-2)!important;line-height:1.45!important}",
      "#xr-collect-slot .xc-mtick{width:16px!important;height:16px!important;border-radius:50%!important;background:var(--xt-good)!important;color:var(--xt-on-good)!important;display:flex!important;align-items:center!important;justify-content:center!important;flex:0 0 auto!important}",
      "#xr-collect-slot .xc-mdot{width:16px!important;height:16px!important;border-radius:50%!important;border:1.5px solid var(--xt-line)!important;flex:0 0 auto!important;box-sizing:border-box!important}",
      "#xr-collect-slot .xc-setexp{background:none!important;border:0!important;padding:0!important;cursor:pointer!important;font-size:13px!important;font-weight:600!important;color:var(--xt-ink-1)!important;text-decoration:underline!important;text-underline-offset:3px!important}",
      /* 3 - share */
      "#xr-collect-slot .xc-share-h{font-size:15px!important;font-weight:600!important;margin:0 0 16px!important;color:var(--xt-ink-1)!important}",
      "#xr-collect-slot .xc-cta-row{display:grid!important;grid-template-columns:minmax(0,1fr) auto!important;gap:11px!important}",
      "@media (max-width:700px){#xr-collect-slot .xc-cta-row{grid-template-columns:1fr!important}}",
      "#xr-collect-slot .xc-cta2{height:58px!important;border:1px solid var(--xt-btn-bg)!important;background:var(--xt-btn-bg)!important;border-radius:12px!important;font-size:13.5px!important;cursor:pointer!important;display:flex!important;align-items:center!important;justify-content:center!important;gap:11px!important}",
      "#xr-collect-slot .xc-cta2,#xr-collect-slot .xc-cta2 *{color:var(--xt-btn-fg)!important}",
      "#xr-collect-slot .xc-cta2:hover{background:var(--xt-btn-bg-hover)!important}",
      "#xr-collect-slot .xc-ghost2{height:58px!important;padding:0 26px!important;border:1px solid var(--xt-btn2-border)!important;background:var(--xt-btn2-bg)!important;border-radius:12px!important;font-size:14px!important;font-weight:500!important;color:var(--xt-ink-1)!important;cursor:pointer!important;display:flex!important;align-items:center!important;justify-content:center!important;gap:9px!important}",
      "#xr-collect-slot .xc-ghost2:hover{border-color:var(--xt-btn2-border-hover)!important}",
      "#xr-collect-slot .xc-secure{display:flex!important;align-items:center!important;gap:9px!important;margin:15px 0 0!important;font-size:12.5px!important;color:var(--xt-ink-3)!important}",
      "#xr-collect-slot .xc-secure svg{flex:0 0 auto!important}",
      "#xr-collect-slot .xc-payhint{background:none!important;border:0!important;padding:0!important;cursor:pointer!important;font-size:12.5px!important;font-weight:600!important;color:var(--xt-ink-1)!important;text-decoration:underline!important;text-underline-offset:3px!important}",
      "#xr-collect-slot .xc-sdot{width:2.5px!important;height:2.5px!important;border-radius:50%!important;background:var(--xt-ink-3)!important;margin:0 2px!important;flex:0 0 auto!important}",
      /* 4 - recent submissions */
      "#xr-collect-slot .xc-recent-h2{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:14px!important;margin:0 0 4px!important}",
      "#xr-collect-slot .xc-view{background:none!important;border:0!important;padding:0!important;cursor:pointer!important;font-size:13px!important;font-weight:500!important;color:var(--xt-ink-2)!important;display:inline-flex!important;align-items:center!important;gap:7px!important}",
      "#xr-collect-slot .xc-view:hover{color:var(--xt-ink-1)!important}",
      "#xr-collect-slot .xc-r-row{display:flex!important;align-items:center!important;gap:12px!important;padding:14px 0!important;border-bottom:1px solid var(--xt-line-soft)!important;font-size:14.5px!important;color:var(--xt-ink-1)!important}",
      "#xr-collect-slot .xc-r-row:last-child{border-bottom:0!important;padding-bottom:0!important}",
      "#xr-collect-slot .xc-r-tick{width:16px!important;height:16px!important;border-radius:50%!important;background:var(--xt-good)!important;color:var(--xt-on-good)!important;display:flex!important;align-items:center!important;justify-content:center!important;flex:0 0 auto!important}",
      "#xr-collect-slot .xc-r-nm{font-weight:500!important;overflow:hidden!important;text-overflow:ellipsis!important;white-space:nowrap!important}",
      "#xr-collect-slot .xc-r-ago{margin-left:auto!important;font-size:13px!important;color:var(--xt-ink-3)!important;flex:0 0 auto!important;padding-left:14px!important;font-variant-numeric:tabular-nums!important}",
      "#xr-collect-slot .xc-empty2{padding:22px 0 6px!important;font-size:13.5px!important;color:var(--xt-ink-2)!important;line-height:1.6!important}",
      "#xr-collect-slot .xc-empty2 strong{display:block!important;color:var(--xt-ink-1)!important;font-size:15px!important;font-weight:600!important;margin:0 0 3px!important}",
      /* 5 - action bar */
      "#xr-collect-slot .xc-bar{border:1px solid var(--xt-line)!important;border-radius:16px!important;background:var(--xt-surface-1)!important;display:grid!important;grid-template-columns:1.2fr 1px .8fr!important;overflow:hidden!important}",
      "@media (max-width:700px){#xr-collect-slot .xc-bar{grid-template-columns:1fr!important}.xc-bar-split{display:none!important}}",
      "#xr-collect-slot .xc-bar-cell{display:flex!important;align-items:center!important;gap:15px!important;padding:20px 24px!important;background:none!important;border:0!important;text-align:left!important;width:100%!important;cursor:pointer!important;font-family:inherit!important}",
      "#xr-collect-slot .xc-bar-cell:hover{background:var(--xt-surface-2)!important}",
      "#xr-collect-slot .xc-bar-cell[disabled]{cursor:default!important;opacity:.45!important}",
      "#xr-collect-slot .xc-bar-cell[disabled]:hover{background:none!important}",
      "#xr-collect-slot .xc-bar-split{background:var(--xt-line)!important}",
      "#xr-collect-slot .xc-ico2{width:40px!important;height:40px!important;border-radius:50%!important;border:1px solid var(--xt-line)!important;display:flex!important;align-items:center!important;justify-content:center!important;flex:0 0 auto!important;color:var(--xt-ink-1)!important}",
      "#xr-collect-slot .xc-bar-cell.go{justify-content:flex-end!important;text-align:right!important}",
      "#xr-collect-slot .xc-bar-cell.go .xc-ico2{order:2!important}",
      "#xr-collect-slot .xc-bar-cell.go .xc-bar-txt{order:1!important}",
      "#xr-collect-slot .xc-bar-cell.go:not([disabled]) .xc-ico2{background:var(--xt-btn-bg)!important;border-color:var(--xt-btn-bg)!important;color:var(--xt-btn-fg)!important}",
      "#xr-collect-slot .xc-bar-t{font-size:14.5px!important;font-weight:600!important;margin:0 0 2px!important;color:var(--xt-ink-1)!important}",
      "#xr-collect-slot .xc-bar-s{font-size:12.5px!important;color:var(--xt-ink-3)!important;margin:0!important}",
      /* paused notice - quiet, never a warning bar */
      "#xr-collect-slot .xc-paused{display:flex!important;align-items:center!important;gap:12px!important;border:1px solid var(--xt-line)!important;background:var(--xt-surface-2)!important;border-radius:12px!important;padding:14px 16px!important;margin:0 0 18px!important;font-size:13.5px!important;color:var(--xt-ink-2)!important}",
      "#xr-collect-slot .xc-paused b{color:var(--xt-ink-1)!important;font-weight:600!important}",
      /* settings drawer (unchanged behaviour, retokenised) */
      "#xr-collect-slot .xc-set{border:1px solid var(--xt-line)!important;border-radius:12px!important;padding:14px 16px!important;margin:-6px 0 18px!important;display:flex!important;flex-direction:column!important;gap:12px!important}",
      "#xr-collect-slot .xc-exp-tel{width:180px!important}",
      "#xr-collect-slot .xc-ship{display:grid!important;grid-template-columns:1fr 1fr!important;gap:8px!important;align-items:center!important}",
      "#xr-collect-slot .xc-ship-i{width:100%!important;box-sizing:border-box!important}",
      "#xr-collect-slot .xc-ship-w{grid-column:1 / -1!important}",
      "#xr-collect-slot .xc-ship #xc-ship-status{grid-column:1 / -1!important}",
      "#xr-collect-slot .xc-shiphint{display:flex!important;align-items:center!important;gap:12px!important;width:100%!important;text-align:left!important;border:1px dashed var(--xt-line)!important;background:var(--xt-surface-2)!important;border-radius:12px!important;padding:12px 14px!important;margin:-6px 0 18px!important;font-size:13px!important;color:var(--xt-ink-2)!important;cursor:pointer!important}",
      "#xr-collect-slot .xc-shiphint b{color:var(--xt-ink-1)!important;font-weight:600!important}",
      "@media (max-width:749px){#xr-collect-slot .xc-ship{grid-template-columns:1fr!important}}",
      "#xr-collect-slot .xc-set-row{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:12px!important;flex-wrap:wrap!important}",
      "#xr-collect-slot .xc-set-label{font-size:13px!important;font-weight:600!important;color:var(--xt-ink-1)!important}",
      "#xr-collect-slot .xc-exp{width:86px!important;border:1px solid var(--xt-line)!important;border-radius:8px!important;padding:8px 10px!important;font-size:14px!important;background:var(--xt-field-bg)!important;color:var(--xt-ink-1)!important}",
      "#xr-collect-slot .xc-danger-note{font-size:12.5px!important;color:var(--xt-ink-2)!important;line-height:1.5!important;margin:0!important}",
      "#xr-collect-slot .xc-btn{padding:10px 14px!important;border-radius:9px!important;border:1px solid var(--xt-btn2-border)!important;background:var(--xt-btn2-bg)!important;color:var(--xt-ink-1)!important;font-size:13px!important;font-weight:600!important;cursor:pointer!important}",
      "#xr-collect-slot .xc-btn-dark{background:var(--xt-btn-bg)!important;border-color:var(--xt-btn-bg)!important}",
      "#xr-collect-slot .xc-btn-dark,#xr-collect-slot .xc-btn-dark *{color:var(--xt-btn-fg)!important}",
      "#xr-collect-slot .xc-status{font-size:13px!important;margin:12px 0 0!important;color:var(--xt-ink-2)!important}",
      "#xr-collect-slot .xc-import{margin:0 0 18px!important;padding:11px 16px!important;border-radius:10px!important;border:1px solid var(--xt-ink-1)!important;background:var(--xt-btn2-bg)!important;color:var(--xt-ink-1)!important;font-size:13.5px!important;font-weight:700!important;cursor:pointer!important}",
      ".xc-toast{position:fixed!important;bottom:26px!important;right:26px!important;background:var(--xt-toast-bg)!important;border-radius:12px!important;padding:12px 18px!important;font-size:13.5px!important;box-shadow:var(--xt-shadow-modal)!important;z-index:99999!important;opacity:0!important;transition:opacity .25s!important}",
      ".xc-toast,.xc-toast *{color:var(--xt-toast-fg)!important}",
      ".xc-toast-on{opacity:1!important}",
      "@media (prefers-reduced-motion:reduce){.xc-toast{transition:none!important}}",
      /* While this block is mounted it IS the card: module 31's own head,
         progress, summary and warnings would double everything the redesign
         already states. The minimum lives in our progress line; blocking
         validation still runs at review/checkout, so nothing is lost. */
      "#xr-card:has(#xc-block) .xr-head{display:none!important}",
      "#xr-collect-slot ~ #xr-note,#xr-collect-slot ~ #xr-summary,#xr-collect-slot ~ #xr-warnings{display:none!important}",
      "#xr-collect-slot ~ #xr-progress{display:none!important}",
      /* the old card chrome this redesign replaces - hidden if 31 still emits it */
      "#xr-collect-slot ~ .xn-row{display:none!important}",
      /* explicit states */
      "#xr-collect-slot .xc-loadrow{display:flex!important;align-items:center!important;gap:10px!important;font-size:14px!important;color:var(--xt-ink-2)!important;padding:18px 2px!important}",
      "#xr-collect-slot .xc-spin{width:16px!important;height:16px!important;border:2px solid var(--xt-line)!important;border-top-color:var(--xt-ink-1)!important;border-radius:50%!important;animation:xcspin .8s linear infinite!important;flex:0 0 auto!important}",
      "@keyframes xcspin{to{transform:rotate(360deg)}}",
      "@media (prefers-reduced-motion:reduce){#xr-collect-slot .xc-spin{animation:none!important;border-top-color:var(--xt-ink-3)!important}}",
      "#xr-collect-slot .xc-errbox{border:1px solid var(--xt-warn-line)!important;background:var(--xt-warn-bg)!important;border-radius:12px!important;padding:18px 20px!important}",
      "#xr-collect-slot .xc-err-title{font-size:14.5px!important;font-weight:600!important;color:var(--xt-warn-title)!important;margin:0 0 4px!important}",
      "#xr-collect-slot .xc-err-sub{font-size:13px!important;color:var(--xt-ink-2)!important;margin:0 0 12px!important;line-height:1.55!important}",
      "#xr-collect-slot .xc-tidy{display:block!important;margin-top:6px!important;font-size:12.5px!important;color:var(--xt-warn-ink)!important}",
      /* MUST BE LAST. The blanket !important pass beats the UA's
         [hidden]{display:none} — which pinned the settings drawer and the
         pause-confirm row open (seen live 2026-08-21). Same specificity as the
         display rules, later in the sheet, so hidden always wins. */
      "#xr-collect-slot [hidden]{display:none!important}"
    ].join("\n");
    function injectCSS() {
      if ($("#xc-style")) return;
      var s = document.createElement("style");
      s.id = "xc-style";
      s.appendChild(document.createTextNode(CSS));
      document.head.appendChild(s);
    }
    var lastCount = -1, importedThrough = 0, lastTeamName = null;
    function block() {
      return $("#xc-block");
    }
    function expectedKey() {
      var w = uni();
      return w ? "xeist_expected_" + w.designId : null;
    }
    function getExpected() {
      try {
        return parseInt(store().get(expectedKey()) || "0", 10) || 0;
      } catch (e) {
        return 0;
      }
    }
    function saveExpected(n) {
      try {
        if (n > 0) store().set(expectedKey(), String(n));
        else store().remove(expectedKey());
      } catch (e) {
      }
    }
    function phoneKey() {
      var w = uni();
      return w ? "xeist_phone_" + w.designId : null;
    }
    function getPhone() {
      try {
        return store().get(phoneKey()) || "";
      } catch (e) {
        return "";
      }
    }
    function savePhone(v) {
      try {
        if (v) store().set(phoneKey(), v);
        else store().remove(phoneKey());
      } catch (e) {
      }
    }
    function cleanPhone(v) {
      var t = String(v || "").replace(/[^0-9+() .-]/g, "").trim();
      var d = t.replace(/\D/g, "");
      return d.length >= 7 && d.length <= 15 ? t : "";
    }
    var SHIP_FIELDS = ["name", "address1", "address2", "city", "province", "zip", "country"];
    function shipKey() {
      var w = uni();
      return w ? "xeist_shipto_" + w.designId : null;
    }
    function shipToValid(st) {
      return !!(st && st.name && st.address1 && st.city && st.province && st.zip);
    }
    function getShipTo() {
      try {
        var st = JSON.parse(store().get(shipKey()) || "null");
        if (shipToValid(st)) return st;
      } catch (e) {
      }
      return lastMeta && shipToValid(lastMeta.shipTo) ? lastMeta.shipTo : null;
    }
    function saveShipTo(st) {
      try {
        store().set(shipKey(), JSON.stringify(st));
      } catch (e) {
      }
    }
    function shipToLine(st) {
      return [st.name, st.address1, st.address2, st.city, st.province, st.zip, st.country].filter(Boolean).join(", ");
    }
    function shipToRowsHTML() {
      var st = getShipTo() || {};
      function inp(id, ph, ac, val, cls) {
        return '<input id="xc-ship-' + id + '" class="xc-exp xc-ship-i' + (cls ? " " + cls : "") + '" type="text" autocomplete="' + ac + '" placeholder="' + ph + '"' + (val ? ' value="' + esc(val) + '"' : "") + ">";
      }
      return '<div class="xc-set-row xc-ship-head"><span class="xc-set-label">Team shipping address</span><span class="xc-set-note">The whole team order ships here as ONE shipment — parents see this address at checkout and split the shipping.</span></div><div class="xc-ship" id="xc-ship">' + inp("name", "Recipient (you or the school)", "name", st.name, "xc-ship-w") + inp("address1", "Street address", "address-line1", st.address1, "xc-ship-w") + inp("address2", "Apt / unit / room (optional)", "address-line2", st.address2) + inp("city", "City", "address-level2", st.city) + inp("province", "Province / State", "address-level1", st.province) + inp("zip", "Postal / ZIP", "postal-code", st.zip, "xc-ship-zip") + '<select id="xc-ship-country" class="xc-exp xc-ship-i" autocomplete="country"><option value="CA"' + (st.country !== "US" ? " selected" : "") + '>Canada</option><option value="US"' + (st.country === "US" ? " selected" : "") + '>United States</option></select><button type="button" class="xc-btn xc-btn-dark" id="xc-ship-save">Save address</button><span class="xc-set-note" id="xc-ship-status">' + (shipToValid(st) ? "Saved — " + esc(shipToLine(st)) : "Not set yet — parents’ orders would ship to their own addresses.") + "</span></div>";
    }
    function bindShipTo(b, token) {
      var save = $("#xc-ship-save", b);
      if (!save) return;
      save.addEventListener("click", function() {
        var st = {};
        SHIP_FIELDS.forEach(function(f) {
          var el = $("#xc-ship-" + f, b);
          st[f] = el ? String(el.value || "").replace(/\s+/g, " ").trim() : "";
        });
        st.zip = st.zip.toUpperCase();
        if (st.country !== "US") st.country = "CA";
        if (!shipToValid(st)) {
          var missing = ["name", "address1", "city", "province", "zip"].filter(function(f) {
            return !st[f];
          })[0];
          var m = $("#xc-ship-" + missing, b);
          if (m) {
            m.focus();
            m.style.borderColor = "var(--xt-warn-title)";
          }
          toast("Fill in the address first");
          return;
        }
        saveShipTo(st);
        var status = $("#xc-ship-status", b);
        if (status) status.textContent = "Saved — " + shipToLine(st);
        putMeta(token, function(ok) {
          toast(ok ? "Team shipping address saved" : "Saved here — will sync when online");
        });
        track("roster_shipto_set", { design: (uni() || {}).designId, country: st.country });
        var hint = $("#xc-shiphint", b);
        if (hint && hint.parentNode) hint.parentNode.removeChild(hint);
      });
    }
    var MIN_ORDER_FALLBACK = 6;
    function minOrder() {
      try {
        var r = roster();
        if (r && typeof r.minQty === "function") {
          var n = r.minQty();
          if (n > 0) return n;
        }
      } catch (e) {
      }
      return MIN_ORDER_FALLBACK;
    }
    var ICON = {
      share: '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M12 15.5V4"/><path d="M8 7.5l4-4 4 4"/><path d="M4 14.5v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4"/></svg>',
      copy: '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><rect x="9" y="9" width="11" height="11" rx="2.6"/><path d="M5 15V6a2 2 0 0 1 2-2h9"/></svg>',
      tick: '<svg viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 12.5l5 5 10-11"/></svg>',
      arrow: '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12h15"/><path d="M13.5 6.5L20 12l-6.5 5.5"/></svg>',
      arrowBig: '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12h14"/><path d="M12.5 6.5L19 12l-6.5 5.5"/></svg>',
      lock: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><rect x="4.5" y="10.5" width="15" height="9.5" rx="2.4"/><path d="M8 10.5V7.6a4 4 0 0 1 8 0v2.9"/></svg>',
      pencil: '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h4L18 10l-4-4L4 16v4z"/><path d="M13.5 6.5l4 4"/></svg>',
      gear: '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3.1"/><path d="M19.1 14.2a1.6 1.6 0 0 0 .3 1.8l.1.1a1.9 1.9 0 1 1-2.7 2.7l-.1-.1a1.6 1.6 0 0 0-1.8-.3 1.6 1.6 0 0 0-1 1.5v.2a1.9 1.9 0 1 1-3.8 0v-.1a1.6 1.6 0 0 0-1-1.5 1.6 1.6 0 0 0-1.8.3l-.1.1a1.9 1.9 0 1 1-2.7-2.7l.1-.1a1.6 1.6 0 0 0 .3-1.8 1.6 1.6 0 0 0-1.5-1h-.2a1.9 1.9 0 1 1 0-3.8h.1a1.6 1.6 0 0 0 1.5-1 1.6 1.6 0 0 0-.3-1.8l-.1-.1a1.9 1.9 0 1 1 2.7-2.7l.1.1a1.6 1.6 0 0 0 1.8.3h.1a1.6 1.6 0 0 0 1-1.5v-.2a1.9 1.9 0 1 1 3.8 0v.1a1.6 1.6 0 0 0 1 1.5 1.6 1.6 0 0 0 1.8-.3l.1-.1a1.9 1.9 0 1 1 2.7 2.7l-.1.1a1.6 1.6 0 0 0-.3 1.8v.1a1.6 1.6 0 0 0 1.5 1h.2a1.9 1.9 0 1 1 0 3.8h-.1a1.6 1.6 0 0 0-1.5 1z"/></svg>',
      pause: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"><path d="M9.5 6v12M14.5 6v12"/></svg>'
    };
    function clickChangeMethod() {
      var host = document.getElementById("xr-card");
      if (!host) return;
      var b = host.querySelector("#xr-change");
      if (!b) {
        b = $all("button,a", host).filter(function(x) {
          return /change\s+method/i.test((x.textContent || "").trim());
        })[0];
      }
      if (b) {
        try {
          b.click();
        } catch (e) {
        }
      }
    }
    function clickViewRoster() {
      var v = document.getElementById("xr-view");
      if (v) {
        try {
          v.click();
        } catch (e) {
        }
      }
    }
    function goToReview() {
      var s = document.querySelector('.xu-step[data-step="review"]');
      if (s) {
        try {
          s.click();
        } catch (e) {
        }
      }
    }
    function renderStart(note) {
      var b = block();
      if (!b) return;
      b.innerHTML = '<div class="xc-head"><div><h2 class="xc-h1">Share with parents</h2><p class="xc-lede">Send your secure link and let parents enter their player information. You focus on coaching.</p></div><button type="button" class="xc-method" id="xc-change-method">Change method' + ICON.pencil + '</button></div><div class="xc-card"><p class="xc-share-h">Create the link for your parents</p><div class="xc-cta-row"><button type="button" class="xc-cta2" id="xc-start">' + ICON.share + '<span class="xc-display">Get the share link</span></button></div><p class="xc-secure">' + ICON.lock + ' Secure link <span class="xc-sdot"></span> Anyone with the link can submit</p>' + (note ? '<p class="xc-status" id="xc-status" aria-live="polite">' + esc(note) + "</p>" : "") + "</div>";
      $("#xc-start", b).addEventListener("click", startCollect);
      $("#xc-change-method", b).addEventListener("click", clickChangeMethod);
    }
    function renderLoading() {
      var b = block();
      if (!b) return;
      b.innerHTML = '<div class="xc-loadrow"><span class="xc-spin" aria-hidden="true"></span> Checking your parent link…</div>';
    }
    function renderError(retry) {
      var b = block();
      if (!b) return;
      b.innerHTML = '<div class="xc-errbox"><p class="xc-err-title">Couldn’t reach the roster service</p><p class="xc-err-sub">Your link and any submissions are safe — this is a connection hiccup on our side.</p><button type="button" class="xc-btn xc-btn-dark" id="xc-retry">Try again</button></div>';
      $("#xc-retry", b).addEventListener("click", retry);
      track("roster_collect_error", { design: (uni() || {}).designId });
    }
    var EXPIRED_NOTE = "Your previous share link expired — get a fresh one to keep collecting.";
    function validateAndRender(c) {
      renderLoading();
      getRoster(c.token, function(d, status) {
        if (!block()) return;
        if (d && d.meta) {
          lastMeta = d.meta;
          lastEntries = d.entries || [];
          lastCount = lastEntries.length;
          renderActive(c);
          if (!getPayMode() && payModalShownFor !== (uni() || {}).designId) {
            payModalShownFor = (uni() || {}).designId;
            showPayModal(function() {
              putMeta(c.token, null);
              if (block()) validateAndRender(c);
            });
          } else if (getPayMode() && !getPhone() && !(d.meta && d.meta.coachPhone) && !phoneSkipped() && phonePromptFor !== (uni() || {}).designId && !document.getElementById("xc-paymodal")) {
            phonePromptFor = (uni() || {}).designId;
            showPhoneModal(c);
          }
        } else if (status === 404) {
          track("roster_collect_expired", { design: (uni() || {}).designId });
          clearLink();
          lastEntries = [];
          lastCount = -1;
          importedThrough = 0;
          renderStart(EXPIRED_NOTE);
        } else {
          renderError(function() {
            validateAndRender(c);
          });
        }
      });
    }
    function isPaused() {
      var c = loadLink();
      return !!(c && c.paused);
    }
    function syncBadge() {
      var b = document.getElementById("xc-live");
      if (b && b.parentNode) b.parentNode.removeChild(b);
    }
    function fmtAgo(ts) {
      var d = Date.now() - (ts || 0);
      if (!ts || d < 0) return "";
      var mn = Math.round(d / 6e4);
      if (mn < 1) return "just now";
      if (mn < 60) return mn + "m ago";
      var hr = Math.round(mn / 60);
      if (hr < 24) return hr + "h ago";
      return Math.round(hr / 24) + "d ago";
    }
    var lastEntries = [];
    var lastPaidSeen = -1;
    function renderProg() {
      var host = $("#xc-prog");
      if (!host) return;
      var pay = isParentPay();
      var paid = paidEntries().length;
      var pending = lastEntries.length - paid;
      var count = pay ? paid : lastEntries.length;
      var exp = getExpected(), min = minOrder();
      var head = '<p class="xc-prog-t">' + (pay ? "Parent payments" : "Parent responses") + "</p>";
      if (exp > 0) {
        head += '<div class="xc-count"><span class="xc-num">' + count + '</span><span class="xc-of">of</span><span class="xc-num">' + exp + '</span></div><p class="xc-count-lbl">players ' + (pay ? "paid" : "submitted") + "</p>";
      } else {
        head += '<div class="xc-count"><span class="xc-num">' + count + '</span></div><p class="xc-count-lbl">player' + (count === 1 ? "" : "s") + " " + (pay ? "paid" : "submitted") + "</p>";
      }
      var total = exp > 0 ? exp : min;
      var segs = "";
      for (var i = 0; i < total; i++) {
        var cls = i < count ? " on" : pay && i < count + pending ? " pend" : "";
        segs += '<span class="xc-seg' + cls + '"></span>';
      }
      var line;
      if (count >= min) {
        line = '<p class="xc-minline"><span class="xc-mtick">' + ICON.tick + "</span>Minimum reached (" + min + " player" + (min === 1 ? "" : "s") + ")" + (exp > 0 ? "" : ' <button type="button" class="xc-setexp" id="xc-setexp">Set expected roster size</button>') + "</p>";
      } else {
        line = '<p class="xc-minline"><span class="xc-mdot"></span>' + count + " of " + min + " minimum players" + (exp > 0 ? "" : ' <button type="button" class="xc-setexp" id="xc-setexp">Set expected roster size</button>') + "</p>";
      }
      var stat = "";
      var left = exp > 0 ? Math.max(exp - count, 0) : 0;
      if (pay) {
        var mm = lastMeta || {};
        stat = '<p class="xc-paystat"><b>' + fmtMoney(mm.collected) + "</b> collected" + (exp > 0 ? ' <span class="xc-sep2">·</span> ' + left + " payment" + (left === 1 ? "" : "s") + " remaining" : pending > 0 ? ' <span class="xc-sep2">·</span> ' + pending + " payment" + (pending === 1 ? "" : "s") + " pending" : "") + (mm.deadline ? ' <span class="xc-sep2">·</span> closes <b>' + esc(fmtDate(mm.deadline)) + "</b>" : "") + "</p>";
      } else if (exp > 0) {
        stat = '<p class="xc-paystat">' + (left > 0 ? "<b>" + left + "</b> player" + (left === 1 ? "" : "s") + " remaining" : "<b>All " + exp + "</b> players submitted") + "</p>";
      }
      host.innerHTML = "<div>" + head + '</div><div><div class="xc-meter" role="img" aria-label="' + count + " of " + total + " players " + (pay ? "paid" : "submitted") + '">' + segs + "</div>" + line + stat + "</div>";
      var se = $("#xc-setexp");
      if (se) se.addEventListener("click", function() {
        toggleSettings(true);
        var i2 = $("#xc-expected");
        if (i2) {
          i2.focus();
          i2.scrollIntoView({ block: "nearest" });
        }
      });
      syncContinue();
    }
    function renderRecent() {
      var list = $("#xc-recent-list");
      if (!list) return;
      if (!lastEntries.length) {
        list.innerHTML = '<div class="xc-empty2"><strong>No submissions yet</strong>Players appear here as parents reply.</div>';
        return;
      }
      var pay = isParentPay();
      var latest = lastEntries.slice(-3).reverse();
      list.innerHTML = latest.map(function(e) {
        var paid = !pay || e.paid;
        var tag = pay ? e.paid ? '<span class="xc-r-tag xc-r-tag-ok">Paid</span>' : '<span class="xc-r-tag">Payment pending</span>' : '<span class="xc-r-tag xc-r-tag-ok">Submitted</span>';
        return '<div class="xc-r-row">' + (paid ? '<span class="xc-r-tick">' + ICON.tick + "</span>" : '<span class="xc-r-hollow"></span>') + '<span class="xc-r-nm">' + esc(e.name) + "</span>" + tag + '<span class="xc-r-ago">' + fmtAgo(pay && e.paid ? e.paidTs || e.ts : e.ts) + "</span></div>";
      }).join("");
    }
    function syncContinue() {
      var go = $("#xc-continue");
      if (!go) return;
      var pay = isParentPay();
      var n = pay ? paidEntries().length : lastEntries.length;
      var ready = n >= minOrder();
      if (ready) go.removeAttribute("disabled");
      else go.setAttribute("disabled", "disabled");
      var t = go.querySelector(".xc-bar-t");
      if (t) t.textContent = pay ? "Review & approve design" : "Continue to review";
      var s = $("#xc-continue-sub");
      if (s) s.textContent = ready ? pay ? "No team checkout — parents pay" : "When you’re ready" : "Once " + minOrder() + " players have " + (pay ? "paid" : "joined");
    }
    function toggleSettings(open) {
      var p = $("#xc-set");
      if (!p) return;
      p.hidden = open === true ? false : open === false ? true : !p.hidden;
    }
    var toastTimer = null;
    function toast(msg) {
      var t = document.getElementById("xc-toast");
      if (!t) {
        t = document.createElement("div");
        t.id = "xc-toast";
        t.className = "xc-toast";
        document.body.appendChild(t);
      }
      t.textContent = msg;
      t.className = "xc-toast xc-toast-on";
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function() {
        t.className = "xc-toast";
      }, 3200);
    }
    function setPaused(paused, done) {
      var c = loadLink();
      if (!c) return;
      c.paused = !!paused;
      saveLink(c);
      putMeta(c.token, function() {
        if (done) done();
      });
      track(paused ? "roster_collect_paused" : "roster_collect_reopened", { design: (uni() || {}).designId });
    }
    function renderActive(c) {
      var b = block();
      if (!b) return;
      var url = linkUrl(c.token);
      var exp = getExpected();
      var paused = isPaused();
      b.innerHTML = (paused ? '<div class="xc-paused">' + ICON.pause + "<span><b>Submissions are closed.</b> Parents opening the link see “this roster is closed”. Nothing already submitted is lost.</span></div>" : "") + /* 1 — header */
      '<div class="xc-head"><div><h2 class="xc-h1">Share with parents</h2><p class="xc-lede">Send your secure link and let parents enter their player information. You focus on coaching.</p></div><button type="button" class="xc-method" id="xc-change-method">Change method' + ICON.pencil + '</button></div><div class="xc-card"><div class="xc-prog2" id="xc-prog"></div></div>' + /* 2b — one team shipment needs a destination (parent-pay only) */
      (isParentPay() && !getShipTo() ? '<button type="button" class="xc-shiphint" id="xc-shiphint">' + ICON.pencil + "<span><b>Where should the team order ship?</b> Add your address so every parent’s jersey ships together to you.</span></button>" : "") + /* settings drawer — opens under the progress card, closed by default */
      '<div class="xc-set" id="xc-set" hidden><div class="xc-set-row"><label class="xc-set-label" for="xc-expected">Expected players</label><input id="xc-expected" class="xc-exp" type="number" inputmode="numeric" min="0" max="500" placeholder="e.g. 12"' + (exp ? ' value="' + exp + '"' : "") + '></div><div class="xc-set-row"><label class="xc-set-label" for="xc-phone">Phone for your XEIST rep</label><input id="xc-phone" class="xc-exp xc-exp-tel" type="tel" inputmode="tel" autocomplete="tel" placeholder="(555) 123-4567"' + (getPhone() || lastMeta && lastMeta.coachPhone ? ' value="' + esc(getPhone() || lastMeta.coachPhone) + '"' : "") + "></div>" + (isParentPay() ? '<div class="xc-set-row"><label class="xc-set-label" for="xc-deadline">Collection deadline</label><input id="xc-deadline" class="xc-exp xc-exp-date" type="date"' + (lastMeta && lastMeta.deadline ? ' value="' + new Date(lastMeta.deadline).toISOString().slice(0, 10) + '"' : "") + '></div><div class="xc-set-row"><span class="xc-set-label">Who pays</span>' + (lastMeta && (lastMeta.paidCount | 0) > 0 ? '<span class="xc-set-note">Parents pay online — locked (payments received)</span>' : '<button type="button" class="xc-btn" id="xc-flip-pay">Switch to: I’ll pay for the team</button>') + "</div>" + shipToRowsHTML() : getPayMode() === "coach" && !(lastMeta && (lastMeta.paidCount | 0) > 0) ? '<div class="xc-set-row"><span class="xc-set-label">Who pays</span><button type="button" class="xc-btn" id="xc-flip-pay">Switch to: parents pay online</button></div>' : "") + '<div class="xc-set-row"><span class="xc-set-label">Package (what parents size)</span><button type="button" class="xc-btn" id="xc-edit-pkg">Edit package</button></div><div class="xc-set-row"><span class="xc-set-label">' + (paused ? "Submissions are closed" : "Pause parent submissions") + '</span><button type="button" class="xc-btn" id="xc-pause-btn">' + (paused ? "Reopen submissions" : "Pause…") + '</button></div><div class="xc-set-row" id="xc-pause-confirm" hidden><p class="xc-danger-note">Parents won’t be able to submit player details until you reopen the roster. Nothing already submitted is lost.</p><span><button type="button" class="xc-btn" id="xc-pause-keep">Keep collecting</button> <button type="button" class="xc-btn xc-btn-dark" id="xc-pause-yes">Pause submissions</button></span></div></div><div class="xc-card">' + (paused ? '<p class="xc-share-h">Submissions are closed</p><div class="xc-cta-row"><button type="button" class="xc-cta2" id="xc-reopen"><span class="xc-display">Reopen submissions</span></button></div>' : '<p class="xc-share-h">Share this link with your parents</p><div class="xc-cta-row"><button type="button" class="xc-cta2" id="xc-share-main">' + ICON.share + '<span class="xc-display">Share with parents</span></button><button type="button" class="xc-ghost2" id="xc-copy">' + ICON.copy + ' Copy link</button></div><p class="xc-secure">' + ICON.lock + ' Secure link <span class="xc-sdot"></span> Anyone with the link can submit' + (lastMeta && (lastMeta.paidCount | 0) > 0 ? "" : ' <span class="xc-sdot"></span> <button type="button" class="xc-payhint" id="xc-payhint">' + (isParentPay() ? "Parents pay online — change" : "Want parents to pay online? Set it up") + "</button>") + "</p>") + '</div><div class="xc-card"><div class="xc-recent-h2"><p class="xc-share-h" style="margin:0">Recent submissions</p><button type="button" class="xc-view" id="xc-viewall">View roster' + ICON.arrow + '</button></div><div id="xc-recent-list"></div></div><div id="xc-import-slot"></div><p class="xc-status" id="xc-status" aria-live="polite" hidden></p><div class="xc-bar"><button type="button" class="xc-bar-cell" id="xc-settings-btn"><span class="xc-ico2">' + ICON.gear + '</span><span class="xc-bar-txt"><p class="xc-bar-t">Roster settings</p><p class="xc-bar-s">Expected size, jersey names, and more</p></span></button><div class="xc-bar-split"></div><button type="button" class="xc-bar-cell go" id="xc-continue" disabled><span class="xc-ico2">' + ICON.arrowBig + '</span><span class="xc-bar-txt"><p class="xc-bar-t">Continue to review</p><p class="xc-bar-s" id="xc-continue-sub">When you’re ready</p></span></button></div>';
      var cm = $("#xc-change-method", b);
      if (cm) cm.addEventListener("click", clickChangeMethod);
      var ph = $("#xc-payhint", b);
      if (ph) ph.addEventListener("click", function() {
        showPayModal(function() {
          putMeta(c.token, null);
          if (block()) validateAndRender(c);
        });
      });
      var dlIn = $("#xc-deadline", b);
      if (dlIn) dlIn.addEventListener("change", function() {
        var v = this.value;
        if (!v) return;
        var ts = (/* @__PURE__ */ new Date(v + "T23:59:59")).getTime();
        if (!(ts > Date.now())) {
          toast("Pick a future date");
          return;
        }
        store().set("xeist_deadline_" + (uni() || {}).designId, String(ts));
        putMeta(c.token, function() {
          toast("Deadline updated");
        });
      });
      var flip = $("#xc-flip-pay", b);
      if (flip) flip.addEventListener("click", function() {
        var to = isParentPay() ? "coach" : "parent";
        setPayMode(to);
        putMeta(c.token, null);
        track("roster_paymode_flipped", { design: (uni() || {}).designId, mode: to });
        renderActive(c);
      });
      var cont = $("#xc-continue", b);
      if (cont) cont.addEventListener("click", function() {
        if (this.hasAttribute("disabled")) return;
        track("roster_continue_to_review", { design: (uni() || {}).designId, count: lastEntries.length });
        if (isParentPay() && !store().get("xeist_approved_" + (uni() || {}).designId)) {
          try {
            fetch(API + "/roster/" + c.token + "/approved", { method: "POST", headers: { "Content-Type": "text/plain" }, body: "{}" });
            store().set("xeist_approved_" + (uni() || {}).designId, "1");
          } catch (e) {
          }
        }
        goToReview();
      });
      syncBadge();
      renderProg();
      renderRecent();
      var copyBtn = $("#xc-copy", b);
      if (copyBtn) copyBtn.addEventListener("click", function() {
        copyText(url, copyBtn);
      });
      var shareBtn = $("#xc-share-main", b);
      if (shareBtn) shareBtn.addEventListener("click", function() {
        var w = uni();
        var team = w && w.team && w.team.name ? w.team.name : "our team";
        if (navigator.share) {
          try {
            navigator.share({
              title: "Team uniform sizes",
              text: "Add your player’s name, number and size for " + team + "’s uniform order:",
              url
            });
            return;
          } catch (e) {
          }
        }
        copyText(url, shareBtn);
      });
      var reopen = $("#xc-reopen", b);
      if (reopen) reopen.addEventListener("click", function() {
        setPaused(false, function() {
          renderActive(c);
        });
      });
      $("#xc-expected", b).addEventListener("change", function() {
        var n = parseInt(this.value, 10) || 0;
        saveExpected(n);
        putMeta(c.token, null);
        renderProg();
      });
      var phSet = $("#xc-phone", b);
      if (phSet) phSet.addEventListener("change", function() {
        var v = cleanPhone(this.value);
        this.value = v;
        savePhone(v);
        putMeta(c.token, null);
        if (v) toast("Phone saved — your XEIST rep can reach you");
        track("roster_phone_set", { design: (uni() || {}).designId, has: !!v });
      });
      $("#xc-settings-btn", b).addEventListener("click", function() {
        toggleSettings();
      });
      bindShipTo(b, c.token);
      var sh = $("#xc-shiphint", b);
      if (sh) sh.addEventListener("click", function() {
        toggleSettings(true);
        var f = $("#xc-ship-name", b);
        if (f) {
          try {
            f.scrollIntoView({ block: "center", behavior: "smooth" });
          } catch (e) {
          }
          setTimeout(function() {
            try {
              f.focus();
            } catch (e2) {
            }
          }, 300);
        }
      });
      var ep = $("#xc-edit-pkg", b);
      if (ep) ep.addEventListener("click", function() {
        var chg = document.getElementById("xr-change");
        if (chg) chg.click();
        try {
          if (window.XeistUniformPkg) window.XeistUniformPkg.edit();
        } catch (e) {
        }
      });
      $("#xc-pause-btn", b).addEventListener("click", function() {
        if (isPaused()) {
          setPaused(false, function() {
            renderActive(c);
          });
          return;
        }
        var pc = $("#xc-pause-confirm", b);
        if (pc) pc.hidden = false;
      });
      var keep = $("#xc-pause-keep", b);
      if (keep) keep.addEventListener("click", function() {
        var pc = $("#xc-pause-confirm", b);
        if (pc) pc.hidden = true;
      });
      var yes = $("#xc-pause-yes", b);
      if (yes) yes.addEventListener("click", function() {
        setPaused(true, function() {
          renderActive(c);
        });
      });
      var va = $("#xc-viewall", b);
      if (va) va.addEventListener("click", function() {
        var v = document.getElementById("xr-view");
        if (v) v.click();
      });
    }
    function copyText(text, btn) {
      function flash() {
        if (!btn) return;
        var old = btn.textContent;
        btn.textContent = "Copied ✓";
        setTimeout(function() {
          btn.textContent = old;
        }, 1600);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(flash, function() {
          legacyCopy(text);
          flash();
        });
      } else {
        legacyCopy(text);
        flash();
      }
    }
    function legacyCopy(text) {
      try {
        var ta = document.createElement("textarea");
        ta.value = text;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      } catch (e) {
      }
    }
    function startCollect() {
      var btn = $("#xc-start");
      if (btn) {
        btn.disabled = true;
        btn.textContent = "Setting up…";
      }
      var waited = 0;
      (function waitSizes() {
        if (!sizeLabels().length && waited <= 8e3) {
          if (waited === 0) nudgeDetailsTab();
          waited += 400;
          setTimeout(waitSizes, 400);
          return;
        }
        if (!sizeLabels().length) {
          if (btn) {
            btn.disabled = false;
            btn.textContent = "Get the share link";
          }
          var st = $("#xc-status");
          if (st) st.textContent = "Couldn’t read this product’s sizes yet — open the roster step below, then try again.";
          return;
        }
        var token = makeToken();
        if (!token) return;
        putMeta(token, function(ok, body) {
          if (!ok) {
            if (btn) {
              btn.disabled = false;
              btn.textContent = "Get the share link";
            }
            var st2 = $("#xc-status");
            if (st2) st2.textContent = "Couldn’t reach the roster service — check your connection and try again.";
            return;
          }
          var c = { token, ts: Date.now() };
          saveLink(c);
          lastTeamName = body.team;
          track("roster_collect_created", { design: body.design });
          renderActive(c);
          lastPreviewTry = 0;
          uploadPreview(token);
        });
      })();
    }
    var pollBusy = false;
    function poll() {
      var c = loadLink();
      if (!c || pollBusy) return;
      if (document.hidden) return;
      pollBusy = true;
      getRoster(c.token, function(d, status) {
        if (d && d.meta) lastMeta = d.meta;
        pollBusy = false;
        if (!d || !d.meta) {
          if (status === 404) {
            track("roster_collect_expired", { design: (uni() || {}).designId });
            clearLink();
            lastEntries = [];
            lastCount = -1;
            importedThrough = 0;
            if (block()) renderStart(EXPIRED_NOTE);
          }
          return;
        }
        var entries = d.entries || [];
        var slot = $("#xc-import-slot");
        if (typeof d.meta.closed === "boolean") {
          var cc = loadLink();
          if (cc && !!cc.paused !== d.meta.closed) {
            cc.paused = d.meta.closed;
            saveLink(cc);
            if (block()) renderActive(cc);
          }
        }
        lastEntries = entries;
        try {
          var mirror = {}, any = false;
          entries.forEach(function(e) {
            if (!e.sizes) return;
            var eid = e.id || (e.ts ? String(e.ts) : null);
            for (var k in e.sizes) {
              if (k === "jersey" || !e.sizes[k]) continue;
              var m = mirror[k] = mirror[k] || {};
              if (eid) m[eid] = e.sizes[k];
              m[(e.name || "") + "|" + (e.number || "")] = e.sizes[k];
              any = true;
            }
          });
          if (any) store().set("xeist_pkg_sizes_" + (uni() || {}).designId, JSON.stringify(mirror));
        } catch (e) {
        }
        if ((d.meta.items || []).length !== pkgItems().length) putMeta(c.token, null);
        var paidNow = entries.filter(function(e) {
          return e && e.paid;
        }).length;
        if (entries.length !== lastCount) {
          if (lastCount >= 0 && entries.length > lastCount) {
            var newest = entries[entries.length - 1];
            if (newest && newest.name) {
              toast(isParentPay() ? newest.paid ? newest.name + " completed their order and payment" : newest.name + " submitted — payment pending" : newest.name + " submitted their roster information");
            }
          }
          lastCount = entries.length;
          renderProg();
          renderRecent();
        } else if (paidNow !== lastPaidSeen && lastPaidSeen >= 0) {
          if (paidNow > lastPaidSeen && isParentPay()) {
            var justPaid = entries.filter(function(e) {
              return e && e.paid;
            }).sort(function(a, b) {
              return (a.paidTs || 0) - (b.paidTs || 0);
            }).pop();
            toast((justPaid && justPaid.name || "A player") + " completed their order and payment");
          }
          renderProg();
          renderRecent();
        }
        lastPaidSeen = paidNow;
        if (!entries.length) return;
        var r = roster();
        if (!r) return;
        var verbatim = !!c.verbatim;
        var tidyChanges = [];
        var rawRows = entries.map(function(e) {
          return {
            name: String(e.name || "").replace(/\s+/g, " ").trim(),
            number: e.number || "",
            sizeLabel: e.size || "",
            xuid: e.id || (e.ts ? String(e.ts) : null)
          };
        });
        var rows = rawRows.map(function(rr) {
          var name = verbatim ? rr.name : tidyName(rr.name);
          if (name !== rr.name) tidyChanges.push(rr.name + " → " + name);
          return { name, number: rr.number, sizeLabel: rr.sizeLabel, xuid: rr.xuid };
        });
        function appendTidyNote(noteEl) {
          if (verbatim || !tidyChanges.length || !noteEl) return;
          var span = document.createElement("span");
          span.className = "xc-tidy";
          span.textContent = " Tidied " + tidyChanges.length + " name" + (tidyChanges.length === 1 ? "" : "s") + ": " + tidyChanges.join(" · ") + " ";
          var btn = document.createElement("button");
          btn.type = "button";
          btn.className = "xc-quiet";
          btn.id = "xc-verbatim";
          btn.textContent = "Keep as typed";
          btn.addEventListener("click", function() {
            var cc2 = loadLink();
            if (cc2) {
              cc2.verbatim = true;
              saveLink(cc2);
            }
            var r2 = roster();
            if (r2) r2.importRows(rawRows, function() {
            });
            span.textContent = " Names kept exactly as parents typed them.";
            track("roster_collect_verbatim", { design: (uni() || {}).designId });
          });
          span.appendChild(btn);
          noteEl.appendChild(span);
        }
        var audit = r.audit();
        var newSinceImport = entries.length > importedThrough;
        if (!newSinceImport) {
          if (slot) slot.innerHTML = "";
          return;
        }
        if (audit.count === 0 || audit.count === importedThrough) {
          var target = entries.length;
          importedThrough = target;
          r.importRows(rows, function(imported) {
            track("roster_collect_import", { entries: target, imported, auto: true });
            var note = $("#xc-status");
            if (note) {
              note.hidden = false;
              note.innerHTML = "<strong>" + target + " player" + (target === 1 ? "" : "s") + "</strong> in the roster — updates land automatically.";
              appendTidyNote(note);
            }
          });
        } else if (slot && !$("#xc-import", slot)) {
          slot.innerHTML = '<button type="button" class="xc-import" id="xc-import">Replace roster with the ' + entries.length + " parent responses</button>";
          $("#xc-import", slot).addEventListener("click", function() {
            var target2 = entries.length;
            importedThrough = target2;
            slot.innerHTML = "";
            r.importRows(rows, function(imported) {
              track("roster_collect_import", { entries: target2, imported, auto: false });
              var note = $("#xc-status");
              if (note) {
                note.hidden = false;
                note.innerHTML = "<strong>" + imported + " player" + (imported === 1 ? "" : "s") + "</strong> imported from parent submissions.";
                appendTidyNote(note);
              }
            });
          });
        }
        var w = uni();
        var nowName = w && w.team && w.team.name || "";
        var wantImage = w && posterFor(w.designId) && !d.meta.image;
        var metaName = d.meta.team || "";
        var wantHandle = payHandleFor("package") || "";
        var handleStale = !!wantHandle && (d.meta.packageHandle || "") !== wantHandle;
        if (nowName && nowName !== metaName || wantImage || handleStale) {
          lastTeamName = nowName;
          putMeta(c.token, null);
        }
        if (!d.meta.previewUpdated || Date.now() - lastPreviewTs > 12e4) {
          uploadPreview(c.token);
        }
      });
    }
    var PM_CSS = [
      // z-index 2026-08-27 (Justin, mobile): module 30's sticky bar lives at
      // 2147483001 and floated OVER this popup, hiding its Continue button
      // behind the bar's own CTA. The popup now outranks all page chrome
      // (bar, view pill, package panel) while staying under the cart-build
      // overlays (2147483400+), which must always win.
      "#xc-paymodal{position:fixed!important;inset:0!important;z-index:2147483380!important;display:flex!important;align-items:center!important;justify-content:center!important;padding:20px!important;background:var(--xt-scrim)!important}",
      "#xc-paymodal,#xc-paymodal *{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif!important;letter-spacing:normal!important;text-transform:none!important;box-sizing:border-box!important}",
      ".xc-pm{background:var(--xt-surface-1)!important;border-radius:18px!important;max-width:470px!important;width:100%!important;padding:28px 30px!important;box-shadow:var(--xt-shadow-modal)!important;max-height:92vh!important;overflow:auto!important}",
      ".xc-pm-h{font-size:21px!important;font-weight:700!important;letter-spacing:-.02em!important;margin:0 0 6px!important;color:var(--xt-ink-1)!important}",
      ".xc-pm-sub{font-size:13.5px!important;line-height:1.6!important;color:var(--xt-ink-2)!important;margin:0 0 16px!important}",
      ".xc-pm-pkg{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:14px!important;border:1px solid var(--xt-line)!important;border-radius:13px!important;padding:15px 17px!important;margin:0 0 14px!important;background:var(--xt-surface-2)!important}",
      ".xc-pm-pkg-t{font-size:14px!important;font-weight:600!important;margin:0 0 2px!important;color:var(--xt-ink-1)!important}",
      ".xc-pm-pkg-s{font-size:12.5px!important;color:var(--xt-ink-2)!important;margin:0!important}",
      ".xc-pm-price{font-size:21px!important;font-weight:700!important;color:var(--xt-ink-1)!important;white-space:nowrap!important}",
      ".xc-pm-price small{font-size:12px!important;font-weight:500!important;color:var(--xt-ink-2)!important}",
      ".xc-pm-edit{background:none!important;border:0!important;padding:0!important;cursor:pointer!important;font-size:12.5px!important;font-weight:600!important;color:var(--xt-ink-1)!important;text-decoration:underline!important;text-underline-offset:3px!important}",
      ".xc-pm-opt{display:flex!important;gap:13px!important;align-items:flex-start!important;border:1.5px solid var(--xt-line)!important;border-radius:14px!important;padding:15px 17px!important;margin:0 0 10px!important;cursor:pointer!important;background:var(--xt-surface-1)!important}",
      ".xc-pm-opt.sel{border-color:var(--xt-ink-1)!important}",
      ".xc-pm-r{width:19px!important;height:19px!important;border-radius:50%!important;border:1.5px solid var(--xt-btn2-border)!important;flex:0 0 auto!important;margin-top:1px!important;display:flex!important;align-items:center!important;justify-content:center!important}",
      ".xc-pm-opt.sel .xc-pm-r{border-color:var(--xt-ink-1)!important}",
      ".xc-pm-opt.sel .xc-pm-r:after{content:''!important;width:9px!important;height:9px!important;border-radius:50%!important;background:var(--xt-ink-1)!important}",
      ".xc-pm-t{font-size:14.5px!important;font-weight:600!important;margin:0 0 3px!important;color:var(--xt-ink-1)!important;display:flex!important;align-items:center!important;gap:8px!important}",
      ".xc-pm-rec{font-size:9.5px!important;font-weight:700!important;letter-spacing:.07em!important;text-transform:uppercase!important;background:var(--xt-surface-3)!important;border-radius:999px!important;padding:3px 8px!important;color:var(--xt-ink-2)!important}",
      ".xc-pm-s{font-size:13px!important;color:var(--xt-ink-2)!important;margin:0!important;line-height:1.5!important}",
      "#xc-phmodal{position:fixed!important;inset:0!important;z-index:2147483380!important;display:flex!important;align-items:center!important;justify-content:center!important;padding:20px!important;background:var(--xt-scrim)!important}",
      "#xc-phmodal,#xc-phmodal *{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif!important;letter-spacing:normal!important;text-transform:none!important;box-sizing:border-box!important}",
      ".xc-ph-skip{display:block!important;width:100%!important;margin:10px 0 0!important;background:none!important;border:0!important;padding:8px!important;font-size:13px!important;font-weight:600!important;color:var(--xt-ink-3)!important;cursor:pointer!important}",
      ".xc-pm-go{width:100%!important;height:52px!important;border:1px solid var(--xt-btn-bg)!important;background:var(--xt-btn-bg)!important;border-radius:12px!important;font-size:13px!important;font-weight:700!important;letter-spacing:.12em!important;text-transform:uppercase!important;cursor:pointer!important;margin-top:8px!important}",
      ".xc-pm-go,.xc-pm-go *{color:var(--xt-btn-fg)!important}",
      ".xc-pm-cnt{display:flex!important;flex-direction:column!important;gap:6px!important;border:1px solid var(--xt-line)!important;border-radius:13px!important;padding:15px 17px!important;margin:0 0 14px!important;background:var(--xt-surface-1)!important}",
      ".xc-pm-cnt-l{font-size:14px!important;font-weight:600!important;color:var(--xt-ink-1)!important}",
      ".xc-pm-cnt-i{width:110px!important;height:44px!important;border:1.5px solid var(--xt-line)!important;border-radius:10px!important;padding:0 12px!important;font-size:16px!important;font-weight:600!important;color:var(--xt-ink-1)!important;background:var(--xt-surface-1)!important;box-sizing:border-box!important}",
      ".xc-pm-cnt-i:focus{outline:none!important;border-color:var(--xt-ink-1)!important}",
      ".xc-pm-cnt-n{font-size:11.5px!important;color:var(--xt-ink-3)!important;line-height:1.5!important}",
      ".xc-pm-ph-i{width:200px!important}",
      ".xc-pm-opt-tag{font-size:10.5px!important;font-weight:600!important;letter-spacing:.06em!important;text-transform:uppercase!important;color:var(--xt-ink-3)!important;margin-left:6px!important}",
      ".xc-pm-go[disabled]{opacity:.45!important;cursor:not-allowed!important}",
      ".xc-pm-fine{font-size:11.5px!important;color:var(--xt-ink-3)!important;margin:12px 0 0!important;line-height:1.6!important;text-align:center!important}"
    ].join("\n");
    function payModalCSS() {
      if (document.getElementById("xc-pm-style")) return;
      var st = document.createElement("style");
      st.id = "xc-pm-style";
      st.appendChild(document.createTextNode(PM_CSS));
      document.head.appendChild(st);
    }
    var phonePromptFor = null;
    function showPhoneModal(c) {
      if (document.getElementById("xc-phmodal")) return;
      var wrap = document.createElement("div");
      wrap.id = "xc-phmodal";
      wrap.innerHTML = '<div class="xc-pm" role="dialog" aria-modal="true" aria-label="Phone for your XEIST rep"><h3 class="xc-pm-h">One last thing — your XEIST rep</h3><p class="xc-pm-sub">Leave the best number to reach you. Your rep helps round up missing parents and gets your order across the line — we may call or text about your team order.</p><div class="xc-pm-cnt"><label class="xc-pm-cnt-l" for="xc-ph-in">Best phone number</label><input id="xc-ph-in" class="xc-pm-cnt-i xc-pm-ph-i" type="tel" inputmode="tel" autocomplete="tel" placeholder="(555) 123-4567"' + (getPhone() ? ' value="' + esc(getPhone()) + '"' : "") + '></div><button type="button" class="xc-pm-go" id="xc-ph-save">Save my number</button><button type="button" class="xc-ph-skip" id="xc-ph-skip">Not now</button></div>';
      document.body.appendChild(wrap);
      var inp = wrap.querySelector("#xc-ph-in");
      function closeIt() {
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
      }
      wrap.querySelector("#xc-ph-save").addEventListener("click", function() {
        var v = cleanPhone(inp && inp.value);
        if (!v) {
          if (inp) {
            inp.focus();
            inp.style.borderColor = "var(--xt-warn-title)";
          }
          return;
        }
        savePhone(v);
        putMeta(c.token, null);
        toast("Phone saved — your XEIST rep can reach you");
        track("roster_phone_set", { design: (uni() || {}).designId, has: true, via: "catchup" });
        closeIt();
      });
      wrap.querySelector("#xc-ph-skip").addEventListener("click", function() {
        try {
          sessionStorage.setItem("xc_ph_skip_" + (uni() || {}).designId, "1");
        } catch (e) {
        }
        track("roster_phone_skipped", { design: (uni() || {}).designId });
        closeIt();
      });
      setTimeout(function() {
        try {
          inp.focus();
        } catch (e) {
        }
      }, 80);
    }
    function phoneSkipped() {
      try {
        return sessionStorage.getItem("xc_ph_skip_" + (uni() || {}).designId) === "1";
      } catch (e) {
        return false;
      }
    }
    var payModalShownFor = null;
    function showPayModal(onDone) {
      if (document.getElementById("xc-paymodal")) return;
      payModalCSS();
      var q2 = pkgQuote();
      var w = uni();
      var team = w && w.team && w.team.name ? w.team.name : "your team";
      var closeDate = fmtDate(Date.now() + 14 * 24 * 3600 * 1e3);
      var min = minOrder();
      var wrap = document.createElement("div");
      wrap.id = "xc-paymodal";
      wrap.innerHTML = '<div class="xc-pm" role="dialog" aria-modal="true" aria-label="Who pays for the uniforms?"><h3 class="xc-pm-h">Set up your roster collection</h3><p class="xc-pm-sub">Parents will submit their player’s size through your secure link. They can also pay for their package in the same step — you never collect money.</p><div class="xc-pm-cnt"><label class="xc-pm-cnt-l" for="xc-pm-count">How many players on your roster?</label><input id="xc-pm-count" class="xc-pm-cnt-i" type="number" inputmode="numeric" min="1" max="500" placeholder="12"' + (getExpected() > 0 ? ' value="' + getExpected() + '"' : "") + '><span class="xc-pm-cnt-n">Sets your per-player price · you can adjust later in Roster settings</span></div><div class="xc-pm-cnt"><label class="xc-pm-cnt-l" for="xc-pm-phone">Best phone number for your XEIST rep <span class="xc-pm-opt-tag">optional</span></label><input id="xc-pm-phone" class="xc-pm-cnt-i xc-pm-ph-i" type="tel" inputmode="tel" autocomplete="tel" placeholder="(555) 123-4567"' + (getPhone() ? ' value="' + esc(getPhone()) + '"' : "") + '><span class="xc-pm-cnt-n">Your rep helps round up missing parents and gets your order across the line · we may call or text about your team order</span></div><div class="xc-pm-pkg"><span><p class="xc-pm-pkg-t">' + esc(team) + ' team package</p><p class="xc-pm-pkg-s">' + esc(q2.labels) + ' · printing included · <button type="button" class="xc-pm-edit" id="xc-pm-edit">Edit package</button></p></span><span class="xc-pm-price">' + (q2.total != null ? cadFmt(q2.total) + "<small>/player" + (q2.tierNote ? " · " + esc(q2.tierNote) : "") + "</small>" : "from your package") + '</span></div><div class="xc-pm-opt sel" data-mode="parent"><span class="xc-pm-r"></span><span><p class="xc-pm-t">Sizes + payment <span class="xc-pm-rec">Recommended</span></p><p class="xc-pm-s">Each parent pays for their own player at checkout.</p></span></div><div class="xc-pm-opt" data-mode="coach"><span class="xc-pm-r"></span><span><p class="xc-pm-t">Sizes only</p><p class="xc-pm-s">You’ll pay for the whole team at review.</p></span></div><button type="button" class="xc-pm-go" id="xc-pm-go">Continue</button><p class="xc-pm-fine">Parents are charged at checkout · production starts at ' + min + " players · refunded in full if the team doesn’t reach " + min + " by " + esc(closeDate) + "</p></div>";
      document.body.appendChild(wrap);
      var countIn = wrap.querySelector("#xc-pm-count");
      var goBtn = wrap.querySelector("#xc-pm-go");
      function pmCount() {
        var n = parseInt(countIn && countIn.value || "0", 10);
        return n >= 1 && n <= 500 ? n : 0;
      }
      function pmSync() {
        var n = pmCount();
        if (goBtn) {
          if (n) goBtn.removeAttribute("disabled");
          else goBtn.setAttribute("disabled", "disabled");
        }
        var q = pkgQuote(n || void 0);
        var pr = wrap.querySelector(".xc-pm-price");
        if (pr) pr.innerHTML = q.total != null ? cadFmt(q.total) + "<small>/player" + (q.tierNote ? " · " + esc(q.tierNote) : "") + "</small>" : "from your package";
      }
      if (countIn) countIn.addEventListener("input", pmSync);
      pmSync();
      var mode = getPayMode() || "parent";
      if (mode === "coach") {
        $all(".xc-pm-opt", wrap).forEach(function(x) {
          x.classList.toggle("sel", x.getAttribute("data-mode") === "coach");
        });
      }
      $all(".xc-pm-opt", wrap).forEach(function(o) {
        o.addEventListener("click", function() {
          mode = o.getAttribute("data-mode");
          $all(".xc-pm-opt", wrap).forEach(function(x) {
            x.classList.toggle("sel", x === o);
          });
        });
      });
      var ed = wrap.querySelector("#xc-pm-edit");
      if (ed) ed.addEventListener("click", function() {
        try {
          if (window.XeistUniformPkg) window.XeistUniformPkg.edit();
        } catch (e) {
        }
        var iv = setInterval(function() {
          if (document.getElementById("xp-modal")) return;
          clearInterval(iv);
          var q3 = pkgQuote(pmCount() || void 0);
          var pr = wrap.querySelector(".xc-pm-price");
          if (pr) pr.innerHTML = q3.total != null ? cadFmt(q3.total) + "<small>/player" + (q3.tierNote ? " · " + esc(q3.tierNote) : "") + "</small>" : "from your package";
          var lb = wrap.querySelector(".xc-pm-pkg-s");
          if (lb) lb.innerHTML = esc(q3.labels) + ' · printing included · <button type="button" class="xc-pm-edit" id="xc-pm-edit2">Edit package</button>';
        }, 600);
      });
      wrap.querySelector("#xc-pm-go").addEventListener("click", function() {
        var n = pmCount();
        if (!n) {
          if (countIn) countIn.focus();
          return;
        }
        saveExpected(n);
        var phIn = wrap.querySelector("#xc-pm-phone");
        var ph = cleanPhone(phIn && phIn.value);
        if (ph) savePhone(ph);
        setPayMode(mode);
        track("roster_paymode_chosen", { design: (uni() || {}).designId, mode, expected: n, phone: !!ph });
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        if (onDone) onDone(mode);
      });
    }
    var mounted = false;
    function tick() {
      if (!uni()) return;
      var slot = $("#xr-collect-slot");
      if (!slot) {
        mounted = false;
        return;
      }
      injectCSS();
      if (!block() || block().parentNode !== slot) {
        var old = block();
        if (old && old.parentNode) old.parentNode.removeChild(old);
        var div = document.createElement("div");
        div.id = "xc-block";
        div.className = "xc-block";
        slot.appendChild(div);
        var ghost = slot.querySelector(".xr-slot-wait");
        if (ghost && ghost.parentNode) ghost.parentNode.removeChild(ghost);
        mounted = false;
      }
      if (!mounted) {
        mounted = true;
        var c = loadLink();
        if (c) {
          lastTeamName = uni().team && uni().team.name || "";
          validateAndRender(c);
        } else if (!getPayMode() && payModalShownFor !== uni().designId) {
          payModalShownFor = uni().designId;
          renderStart();
          showPayModal(function() {
            startCollect();
          });
          return;
        } else {
          renderStart();
        }
      }
    }
    if (window.XeistCore && XeistCore.every) {
      XeistCore.every("xc-roster-collect", 1500, tick, { runHidden: true });
      XeistCore.every("xc-roster-poll", 1e4, poll, { runHidden: false });
    } else {
      setInterval(tick, 1500);
      setInterval(poll, 1e4);
    }
  })();

  // src/core/36-theme-tokens.js
  (function() {
    "use strict";
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    var TOKENS = [
      "--xt-page:#f7f7f5",
      "--xt-stage:radial-gradient(ellipse at 50% 42%,#ffffff 0%,#f2f2ee 72%)",
      "--xt-surface-1:#ffffff",
      "--xt-surface-2:#fbfbfa",
      "--xt-surface-3:#f4f4f1",
      "--xt-line:#ececea",
      "--xt-line-soft:#f4f4f2",
      "--xt-ink-1:#111111",
      "--xt-ink-2:#6e6e73",
      "--xt-ink-3:#a1a1a6",
      "--xt-good:#1a7f37",
      "--xt-good-soft:#e7f6ec",
      "--xt-good-track:#e4efe8",
      "--xt-good-wash:rgba(26,127,55,.10)",
      "--xt-on-good:#ffffff",
      // glyph colour ON the success disc
      "--xt-warn-ink:#8a5a00",
      "--xt-warn-bg:#fdf8ef",
      "--xt-warn-line:#f0e0c0",
      "--xt-warn-title:#111111",
      "--xt-btn-bg:#111111",
      "--xt-btn-fg:#ffffff",
      "--xt-btn-bg-hover:#000000",
      "--xt-btn2-bg:transparent",
      "--xt-btn2-border:#dedede",
      "--xt-btn2-border-hover:#111111",
      "--xt-field-bg:#ffffff",
      "--xt-toast-bg:#111111",
      "--xt-toast-fg:#ffffff",
      "--xt-focus:#111111",
      "--xt-shadow-card:0 1px 2px rgba(0,0,0,.04)",
      "--xt-shadow-modal:0 24px 70px rgba(0,0,0,.25)",
      "--xt-scrim:rgba(0,0,0,.42)"
    ].join(";");
    var CSS = ":root{color-scheme:light;" + TOKENS + "}";
    function injectCSS() {
      try {
        if (document.getElementById && document.getElementById("xeist-theme-tokens")) return;
        var head = document.head || document.getElementsByTagName && document.getElementsByTagName("head")[0];
        if (!head || !head.appendChild) return;
        var s = document.createElement("style");
        s.id = "xeist-theme-tokens";
        s.textContent = CSS;
        if (head.firstChild && head.insertBefore) head.insertBefore(s, head.firstChild);
        else head.appendChild(s);
      } catch (e) {
      }
    }
    injectCSS();
    if (window.XeistCore && XeistCore.every) {
      XeistCore.every("xt-tokens", 4e3, function() {
        injectCSS();
      }, { runHidden: true });
    }
  })();

  // src/logo-tools/37-number-nudge.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1 || !/114891065|114890045/.test(window.location.hash || "")) return;
    var designId = /114890045/.test(window.location.hash || "") ? "114890045" : "114891065";
    var SHOWN_KEY = "xeist_number_nudge_shown_" + designId;
    var CHECK_INTERVAL = 500;
    var POLL_LIMIT = 240;
    var attempts = 0;
    var store = (function() {
      try {
        window.localStorage.getItem(SHOWN_KEY);
        return window.localStorage;
      } catch (e) {
        try {
          return window.sessionStorage;
        } catch (e2) {
          return { getItem: function() {
            return null;
          }, setItem: function() {
          } };
        }
      }
    })();
    if (store.getItem(SHOWN_KEY)) return;
    function upchargeText() {
      var v = window.XeistConfig && window.XeistConfig.v || {};
      var up = parseFloat(designId === "114890045" ? v.dual_number_upcharge : v.orbit_number_upcharge);
      if (!isFinite(up) || up <= 0) return "";
      var fx = 1;
      try {
        fx = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
      } catch (e) {
      }
      return "+$" + (Math.round(up * fx * 100) / 100).toFixed(2) + " per bag · ";
    }
    var pollId = window.setInterval(function() {
      attempts++;
      if (attempts > POLL_LIMIT) {
        window.clearInterval(pollId);
        return;
      }
      var logoBtn = document.getElementById("xeist-add-logo-overlay");
      var numBtn = document.getElementById("xeist-add-number-overlay");
      if (!logoBtn || !numBtn) return;
      var logoOn = (logoBtn.textContent || "").toLowerCase().indexOf("remove logo") !== -1;
      var numberOn = (numBtn.textContent || "").toLowerCase().indexOf("remove number") !== -1;
      if (numberOn) {
        window.clearInterval(pollId);
        store.setItem(SHOWN_KEY, "1");
        return;
      }
      if (!logoOn) return;
      window.clearInterval(pollId);
      store.setItem(SHOWN_KEY, "1");
      window.setTimeout(showNudge, 1500);
    }, CHECK_INTERVAL);
    function showNudge() {
      if (document.getElementById("xeist-number-nudge-overlay")) return;
      var overlay = document.createElement("div");
      overlay.id = "xeist-number-nudge-overlay";
      overlay.style.cssText = [
        "position: fixed",
        "inset: 0",
        "background: rgba(15, 10, 25, 0.55)",
        "z-index: 100001",
        "display: flex",
        "align-items: center",
        "justify-content: center",
        "padding: 20px",
        "opacity: 0",
        "transition: opacity .25s ease"
      ].join(";");
      var card = document.createElement("div");
      card.style.cssText = [
        "background: #fff",
        "color: #140b21",
        "max-width: 420px",
        "width: 100%",
        "border-radius: 18px",
        "padding: 26px 24px 22px",
        "box-shadow: 0 20px 60px rgba(0,0,0,.3)",
        "font-family: inherit",
        "text-align: center",
        "transform: translateY(8px)",
        "transition: transform .25s ease"
      ].join(";");
      card.innerHTML = '<div style="font-size:12px;letter-spacing:.05em;text-transform:uppercase;color:#8a7fa6;margin-bottom:6px;">Logo’s on the bag</div><div style="font-size:20px;font-weight:600;margin-bottom:8px;">Add player numbers?</div><div style="font-size:14px;color:#5c5470;line-height:1.5;margin-bottom:18px;">Put each player’s number on their own bag. ' + upchargeText() + 'we collect names &amp; numbers from your roster after checkout — start by putting yours on the bag.</div><button type="button" data-nudge-yes style="display:block;width:100%;background:#6c2bd9;color:#fff;border:none;font-size:16px;font-weight:600;padding:13px;border-radius:12px;cursor:pointer;margin-bottom:8px;">Add Numbers</button><button type="button" data-nudge-no style="display:block;width:100%;background:transparent;color:#5c5470;border:none;font-size:14px;padding:9px;cursor:pointer;">No thanks — logo only</button>';
      overlay.appendChild(card);
      document.body.appendChild(overlay);
      window.setTimeout(function() {
        overlay.style.opacity = "1";
        card.style.transform = "translateY(0)";
      }, 30);
      function close() {
        overlay.style.opacity = "0";
        window.setTimeout(function() {
          if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        }, 250);
      }
      overlay.addEventListener("click", function(e) {
        if (e.target === overlay) close();
      });
      card.querySelector("[data-nudge-no]").addEventListener("click", close);
      card.querySelector("[data-nudge-yes]").addEventListener("click", function() {
        close();
        var numBtn = document.getElementById("xeist-add-number-overlay");
        if (numBtn) {
          try {
            numBtn.click();
          } catch (e) {
          }
        }
      });
    }
  })();

  // src/coach/38-bag-parent-pay.js
  (function() {
    "use strict";
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1 || !/114891065|114890045/.test(window.location.hash || "")) return;
    var CFG = window.XeistConfig || {};
    var API = CFG.sessionApi ? String(CFG.sessionApi).replace(/\/+$/, "") : null;
    if (!API) return;
    var designId = /114890045/.test(window.location.hash || "") ? "114890045" : "114891065";
    var BAG_PAY = {
      "114891065": {
        label: "Orbit Backpack",
        name: "Orbit",
        handleNumbered: "orbit-backpack-team-order",
        // logo + number (live)
        numberedCad: [5999, 5799, 5499, 5299],
        handleLogoOnly: "orbit-backpack-team-order-logo-only",
        // logo only (create in Shopify)
        logoOnlyCad: [5499, 5299, 4999, 4799]
        // numbered − $5.00/bag
      },
      "114890045": {
        label: "Dual Strap Backpack",
        name: "Dual Strap",
        handleNumbered: "",
        numberedCad: null,
        handleLogoOnly: "",
        logoOnlyCad: null
      }
    };
    function designHasNumber() {
      try {
        var b = window.XeistKBBridge;
        return !!(b && typeof b.hasNumber === "function" && (b.hasNumber() || {}).hasNumber);
      } catch (e) {
        return false;
      }
    }
    function activeHandle(bp) {
      return bp ? designHasNumber() ? bp.handleNumbered || "" : bp.handleLogoOnly || "" : "";
    }
    function activeLadder(bp) {
      return bp ? designHasNumber() ? bp.numberedCad || null : bp.logoOnlyCad || null : null;
    }
    var PARENT_TIERS = [[1, 24], [25, 49], [50, 99], [100, Infinity]];
    function parentUnitCents(qty) {
      var bp = BAG_PAY[designId];
      var handle = activeHandle(bp), ladder = activeLadder(bp);
      if (!bp || !handle || !ladder) return null;
      var n = qty > 0 ? qty : 1;
      for (var i = 0; i < PARENT_TIERS.length; i++) {
        if (n >= PARENT_TIERS[i][0] && n <= PARENT_TIERS[i][1]) return ladder[i] == null ? null : ladder[i];
      }
      return null;
    }
    var LINK_KEY = "xeist_bagpay_" + designId;
    var DEADLINE_DEFAULT_DAYS = 14;
    if (/[?&]xeist_popups=reset/.test((window.location.search || "") + (window.location.hash || ""))) {
      try {
        window.localStorage.removeItem(LINK_KEY);
      } catch (e) {
      }
    }
    function $(s, r) {
      return (r || document).querySelector(s);
    }
    function esc(s) {
      return String(s == null ? "" : s).replace(/[&<>"']/g, function(c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }
    function store() {
      return {
        get: function(k) {
          try {
            return window.localStorage.getItem(k);
          } catch (e) {
            return null;
          }
        },
        set: function(k, v) {
          try {
            window.localStorage.setItem(k, v);
          } catch (e) {
          }
        },
        remove: function(k) {
          try {
            window.localStorage.removeItem(k);
          } catch (e) {
          }
        }
      };
    }
    function loadLink() {
      try {
        var c = JSON.parse(store().get(LINK_KEY) || "null");
        if (c && c.token && /^[a-f0-9]{32,64}$/.test(c.token)) return c;
      } catch (e) {
      }
      return null;
    }
    function shipToValid(st) {
      return !!(st && st.name && st.address1 && st.city && st.province && st.zip);
    }
    function shipToShort(st) {
      return st.name + ", " + st.city + (st.province ? " " + st.province : "");
    }
    function shipToLines(st) {
      return st.name + " · " + st.address1 + (st.address2 ? " " + st.address2 : "") + ", " + st.city + " " + st.province + " " + st.zip + " " + (st.country || "CA");
    }
    var SHIP_CENTS = { coach: 399, parent: 999 };
    var SHIP_ARMED = true;
    function destFieldsHTML(dest, fallbackName) {
      return '<input id="xbp-st-name" class="xbp__input" type="text" autocomplete="name" placeholder="Your name" value="' + esc(dest ? dest.name : fallbackName || "") + '"><input id="xbp-st-a1" class="xbp__input" type="text" autocomplete="address-line1" placeholder="Street address" value="' + esc(dest ? dest.address1 : "") + '"><input id="xbp-st-a2" class="xbp__input" type="text" autocomplete="address-line2" placeholder="Apt, unit (optional)" value="' + esc(dest && dest.address2 ? dest.address2 : "") + '"><input id="xbp-st-city" class="xbp__input" type="text" autocomplete="address-level2" placeholder="City" value="' + esc(dest ? dest.city : "") + '"><div class="xbp__two"><input id="xbp-st-prov" class="xbp__input" type="text" autocomplete="address-level1" placeholder="Province" value="' + esc(dest ? dest.province : "") + '"><input id="xbp-st-zip" class="xbp__input" type="text" autocomplete="postal-code" placeholder="Postal code" value="' + esc(dest ? dest.zip : "") + '"></div><select id="xbp-st-country" class="xbp__input"><option value="CA"' + (dest && dest.country === "US" ? "" : " selected") + '>Canada</option><option value="US"' + (dest && dest.country === "US" ? " selected" : "") + ">United States</option></select>";
    }
    function readDestForm(card) {
      return {
        name: ($("#xbp-st-name", card).value || "").trim(),
        address1: ($("#xbp-st-a1", card).value || "").trim(),
        address2: ($("#xbp-st-a2", card).value || "").trim(),
        city: ($("#xbp-st-city", card).value || "").trim(),
        province: ($("#xbp-st-prov", card).value || "").trim(),
        zip: ($("#xbp-st-zip", card).value || "").trim().toUpperCase(),
        country: $("#xbp-st-country", card).value === "US" ? "US" : "CA"
      };
    }
    function missingDestField(st) {
      return !st.name ? "xbp-st-name" : !st.address1 ? "xbp-st-a1" : !st.city ? "xbp-st-city" : !st.province ? "xbp-st-prov" : !st.zip ? "xbp-st-zip" : "";
    }
    var pendingDest = null;
    function makeToken() {
      try {
        var buf = new Uint8Array(16);
        crypto.getRandomValues(buf);
        var s = "";
        for (var i = 0; i < buf.length; i++) s += (buf[i] + 256).toString(16).slice(1);
        return s;
      } catch (e) {
        return null;
      }
    }
    function linkUrl(token) {
      var url = "https://www.xeist.com/pages/team-roster?r=" + token;
      try {
        var th = window.Shopify && window.Shopify.theme;
        if (th && th.id && th.role !== "main") url += "&preview_theme_id=" + th.id;
      } catch (e) {
      }
      return url;
    }
    function contactKind(v) {
      v = String(v == null ? "" : v).trim();
      if (/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) return "email";
      var digits = v.replace(/[^0-9]/g, "");
      if (digits.length >= 7 && digits.length <= 15 && /^[0-9()+. -]+$/.test(v)) return "phone";
      return null;
    }
    function getQty() {
      var inp = $("[data-bottom-bar-qty-input]");
      var n = inp ? parseInt(inp.value, 10) : 0;
      if (!n || n < 1) {
        var cfg = window.XeistOrbitCoachConfig || {};
        n = cfg.rules && cfg.rules.minQty || 6;
      }
      return Math.min(500, n);
    }
    function putMeta(token, teamName, deadlineMs, phone, email, shipTo, done) {
      var bp = BAG_PAY[designId] || { handle: "", label: "Team Backpack" };
      var previewTheme = "";
      try {
        var th0 = window.Shopify && window.Shopify.theme;
        if (th0 && th0.id && th0.role !== "main") previewTheme = String(th0.id);
      } catch (e) {
      }
      var body = {
        team: teamName,
        coachPhone: String(phone || "").trim(),
        coachEmail: String(email || "").trim(),
        design: designId,
        designName: bp.name || bp.label,
        noun: "backpack",
        image: "",
        expected: getQty(),
        sizes: ["One Size"],
        items: [{ key: "bag", label: bp.label, handle: activeHandle(bp) || "", sizes: ["One Size"] }],
        payMode: "parent",
        deadline: deadlineMs,
        /* Locks the ladder the worker quotes for THIS link (logo-only vs
           numbered), matched to the product handle above. */
        numbersOn: designHasNumber(),
        previewTheme,
        shipTo: shipToValid(shipTo) ? shipTo : null
      };
      var ah = activeHandle(bp);
      if (ah) body.packageHandle = ah;
      fetch(API + "/roster/" + token, {
        method: "PUT",
        mode: "cors",
        headers: { "Content-Type": "text/plain" },
        body: JSON.stringify(body)
      }).then(function(r) {
        if (!r.ok) {
          done(false, null);
          return;
        }
        r.json().then(function(j) {
          done(true, j || null);
        }, function() {
          done(true, null);
        });
      }).catch(function() {
        done(false, null);
      });
    }
    function coachUrl(c) {
      if (!c || !c.coachKey) return "";
      return linkUrl(c.token).replace("?r=" + c.token, "?r=" + c.token + "&c=" + c.coachKey);
    }
    function liveBagDataUrl() {
      try {
        var best = null, bestArea = 0;
        var list = document.querySelectorAll("canvas");
        for (var i = 0; i < list.length; i++) {
          var a = (list[i].width || 0) * (list[i].height || 0);
          if (a > bestArea && list[i].width > 200 && list[i].height > 200) {
            best = list[i];
            bestArea = a;
          }
        }
        if (!best) return null;
        var scale = Math.min(1, 1100 / Math.max(best.width, best.height));
        var oc = document.createElement("canvas");
        oc.width = Math.max(1, Math.round(best.width * scale));
        oc.height = Math.max(1, Math.round(best.height * scale));
        var ctx = oc.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, oc.width, oc.height);
        ctx.drawImage(best, 0, 0, oc.width, oc.height);
        var probe = ctx.getImageData(0, 0, Math.min(64, oc.width), Math.min(64, oc.height)).data;
        var min = 255, max = 0;
        for (var p = 0; p < probe.length; p += 4) {
          var lum = (probe[p] + probe[p + 1] + probe[p + 2]) / 3;
          if (lum < min) min = lum;
          if (lum > max) max = lum;
        }
        if (max - min < 6) return null;
        return oc.toDataURL("image/jpeg", 0.85);
      } catch (e) {
        return null;
      }
    }
    function uploadPreview(token, rec) {
      function put(dataUrl2, sig) {
        if (!dataUrl2) return;
        if (rec && sig && rec.previewSig === sig) return;
        fetch(API + "/roster/" + token + "/preview", {
          method: "PUT",
          mode: "cors",
          headers: { "Content-Type": "text/plain" },
          body: dataUrl2
        }).then(function(r) {
          if (!r.ok || !rec || !sig) return;
          try {
            rec.previewSig = sig;
            store().set(LINK_KEY, JSON.stringify(rec));
          } catch (e) {
          }
        }).catch(function() {
        });
      }
      var cap = window.__xeistBagCapture;
      if (cap && typeof cap.fresh === "function") {
        cap.fresh(function(st) {
          var url = st && st.dataUrl || liveBagDataUrl() || "";
          put(url, st && st.dataUrl ? st.sig : "");
        });
        return;
      }
      var dataUrl = "";
      try {
        var st0 = window.__xeistBagSnapshot;
        if (st0 && st0.dataUrl) dataUrl = st0.dataUrl;
      } catch (e) {
      }
      if (!dataUrl) dataUrl = liveBagDataUrl() || "";
      put(dataUrl, "");
    }
    function money(cents) {
      try {
        if (window.XeistMoney) return window.XeistMoney.cad(cents / 100);
      } catch (e) {
      }
      return "$" + (cents / 100).toFixed(2) + " CAD";
    }
    function fmtDate(ms) {
      try {
        return new Date(ms).toLocaleDateString(void 0, { month: "short", day: "numeric" });
      } catch (e) {
        return "";
      }
    }
    function fire(kind) {
      try {
        window.dispatchEvent(new CustomEvent("xeist:bagpay", { detail: { kind, hasLink: !!loadLink() } }));
      } catch (e) {
      }
    }
    var CSS = [
      "#xeist-bagpay-overlay{position:fixed;inset:0;z-index:100002;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(15,10,25,.55);font-family:inherit;-webkit-font-smoothing:antialiased;}",
      "#xeist-bagpay-overlay *{box-sizing:border-box;font-family:inherit;}",
      "#xeist-bagpay-overlay .xbp__card{position:relative;display:flex;width:100%;max-width:960px;min-height:min(640px,calc(100vh - 40px));max-height:calc(100vh - 40px);background:#fff;color:#141419;border-radius:20px;overflow:hidden;outline:none;box-shadow:0 30px 80px rgba(0,0,0,.35);}",
      "#xeist-bagpay-overlay .xbp__media{position:relative;flex:0 0 44%;display:flex;align-items:center;justify-content:center;padding:96px 40px;overflow:hidden;background:#f4f4f1 linear-gradient(160deg,#ffffff 0%,#f3f3ef 55%,#e9e9e4 100%);}",
      '#xeist-bagpay-overlay .xbp__media::before{content:"";position:absolute;top:-30%;left:-30%;width:160%;height:160%;background:linear-gradient(112deg,rgba(255,255,255,0) 36%,rgba(255,255,255,.8) 48%,rgba(255,255,255,0) 60%);pointer-events:none;}',
      "#xeist-bagpay-overlay .xbp__tag{position:absolute;top:48px;left:44px;margin:0;font-size:12px;font-weight:600;letter-spacing:.32em;text-transform:uppercase;line-height:1.6;color:#3a3147;}",
      '#xeist-bagpay-overlay .xbp__tag::after{content:"";display:block;width:36px;height:1.5px;margin-top:12px;background:#141419;}',
      "#xeist-bagpay-overlay .xbp__bag{position:absolute;top:184px;right:48px;bottom:136px;left:48px;opacity:1;transition:opacity .28s ease;}",
      "#xeist-bagpay-overlay .xbp__bag[hidden]{display:none;}",
      "#xeist-bagpay-overlay .xbp__bag.is-loading{opacity:0;}",
      '#xeist-bagpay-overlay .xbp__bag::after{content:"";position:absolute;z-index:0;left:50%;bottom:-4px;height:80%;aspect-ratio:1/1;border-radius:50%;background:radial-gradient(closest-side,rgba(18,14,28,.40) 0%,rgba(18,14,28,.22) 38%,rgba(18,14,28,.07) 72%,rgba(18,14,28,0) 100%);transform:translate(-50%,50%) scaleY(.17);pointer-events:none;}',
      "#xeist-bagpay-overlay .xbp__bag img{position:absolute;z-index:1;left:50%;bottom:0;display:block;width:auto;height:auto;max-width:100%;max-height:100%;margin:0;transform:translateX(-50%);filter:brightness(1.06);mix-blend-mode:multiply;}",
      "#xeist-bagpay-overlay .xbp__bag.is-cut img{filter:none;mix-blend-mode:normal;}",
      "#xeist-bagpay-overlay .xbp__brand{position:absolute;left:44px;bottom:40px;}",
      "#xeist-bagpay-overlay .xbp__brand img{display:block;height:36px;width:auto;}",
      "#xeist-bagpay-overlay .xbp__brand span{font-size:16px;font-weight:700;letter-spacing:.34em;color:#141419;}",
      "#xeist-bagpay-overlay .xbp__body{position:relative;flex:1 1 auto;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;text-align:center;padding:56px 48px 36px;overflow:auto;-webkit-overflow-scrolling:touch;}",
      "#xeist-bagpay-overlay .xbp__main{display:flex;flex-direction:column;align-items:center;width:100%;margin:auto 0;}",
      "#xeist-bagpay-overlay .xbp__close{position:absolute;top:24px;right:24px;z-index:2;display:flex;align-items:center;justify-content:center;width:46px;height:46px;margin:0;padding:0;border:0;border-radius:50%;background:#fff;color:#141419;box-shadow:0 2px 12px rgba(0,0,0,.14);cursor:pointer;-webkit-appearance:none;appearance:none;}",
      "#xeist-bagpay-overlay .xbp__close:hover{background:#f6f5fa;}",
      "#xeist-bagpay-overlay .xbp__check{display:flex;align-items:center;justify-content:center;width:104px;height:104px;margin:0 0 30px;border-radius:50%;background:#efe9fd;color:#6c2bd9;}",
      "#xeist-bagpay-overlay .xbp__check--off{background:#f1f0f4;color:#8a7fa6;}",
      "#xeist-bagpay-overlay .xbp__check svg{width:44px;height:44px;}",
      "#xeist-bagpay-overlay .xbp__title{margin:0 0 14px;font-size:44px;font-weight:500;letter-spacing:-.02em;line-height:1.1;color:#141419;text-transform:none;}",
      "#xeist-bagpay-overlay .xbp__title--sm{font-size:28px;margin-bottom:22px;}",
      "#xeist-bagpay-overlay .xbp__sub{margin:0 0 10px;max-width:350px;font-size:18px;line-height:1.5;color:#55506a;}",
      "#xeist-bagpay-overlay .xbp__note{margin:0 0 4px;font-size:14px;line-height:1.5;color:#8a7fa6;}",
      "#xeist-bagpay-overlay .xbp__note b{font-weight:600;color:#141419;}",
      "#xeist-bagpay-overlay .xbp__note--ship{margin-bottom:30px;}",
      "#xeist-bagpay-overlay .xbp__dot{margin:0 2px;color:#c4bfd3;}",
      "#xeist-bagpay-overlay .xbp__change{margin:0;padding:0 2px;border:0;background:none;color:#6c2bd9;font-size:inherit;font-weight:500;line-height:inherit;letter-spacing:0;text-transform:none;cursor:pointer;-webkit-appearance:none;appearance:none;}",
      "#xeist-bagpay-overlay .xbp__change:hover{text-decoration:underline;}",
      "#xeist-bagpay-overlay .xbp__weeks{display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin:6px 0 12px;}",
      "#xeist-bagpay-overlay .xbp__weeks[hidden]{display:none;}",
      "#xeist-bagpay-overlay .xbp__chip{height:36px;margin:0;padding:0 16px;border:1px solid #e6e3ef;border-radius:999px;background:#fff;color:#141419;font-size:14px;font-weight:500;line-height:1;letter-spacing:0;text-transform:none;cursor:pointer;-webkit-appearance:none;appearance:none;transition:border-color .12s ease,color .12s ease,background .12s ease;}",
      "#xeist-bagpay-overlay .xbp__chip:hover{border-color:#6c2bd9;color:#6c2bd9;}",
      "#xeist-bagpay-overlay .xbp__chip.is-on{background:#6c2bd9;border-color:#6c2bd9;color:#fff;}",
      "#xeist-bagpay-overlay .xbp__link{display:flex;align-items:center;width:100%;max-width:500px;height:66px;margin:0 0 18px;padding:8px 8px 8px 18px;border:1px solid #e6e3ef;border-radius:14px;background:#fff;}",
      "#xeist-bagpay-overlay .xbp__link svg{flex:none;width:22px;height:22px;margin-right:12px;color:#6c2bd9;}",
      "#xeist-bagpay-overlay .xbp__url{flex:1 1 auto;min-width:0;height:100%;margin:0;padding:0;border:0;border-radius:0;background:transparent;box-shadow:none;font-size:15px;color:#141419;text-overflow:ellipsis;outline:none;-webkit-appearance:none;appearance:none;}",
      "#xeist-bagpay-overlay .xbp__copy{flex:none;height:48px;margin:0;padding:0 20px;border:0;border-radius:10px;background:#f3f0fa;color:#6c2bd9;font-size:16px;font-weight:600;line-height:1;letter-spacing:0;text-transform:none;cursor:pointer;-webkit-appearance:none;appearance:none;}",
      "#xeist-bagpay-overlay .xbp__copy:hover{background:#ebe5f8;}",
      "#xeist-bagpay-overlay .xbp__share{display:flex;align-items:center;justify-content:center;gap:10px;width:100%;max-width:500px;height:58px;margin:0;padding:0 20px;border:0;border-radius:12px;background:#6c2bd9;color:#fff;font-size:18px;font-weight:600;line-height:1;letter-spacing:0;text-transform:none;cursor:pointer;transition:background .12s ease,transform .12s ease;-webkit-appearance:none;appearance:none;}",
      "#xeist-bagpay-overlay .xbp__share svg{flex:none;width:20px;height:20px;}",
      "#xeist-bagpay-overlay .xbp__share:hover{background:#5f22c9;}",
      "#xeist-bagpay-overlay .xbp__share:active{transform:scale(.99);}",
      "#xeist-bagpay-overlay .xbp__share[disabled]{opacity:.5;cursor:default;}",
      "#xeist-bagpay-overlay .xbp__more{margin:22px 0 0;padding:4px 8px;border:0;background:none;color:#6c2bd9;font-size:16px;font-weight:500;line-height:1.2;letter-spacing:0;text-transform:none;cursor:pointer;-webkit-appearance:none;appearance:none;}",
      "#xeist-bagpay-overlay .xbp__more:hover{text-decoration:underline;}",
      "#xeist-bagpay-overlay .xbp__more--page{display:inline-block;margin-top:10px;text-decoration:none;}",
      "#xeist-bagpay-overlay .xbp__details{width:100%;max-width:500px;margin:16px 0 0;padding:14px 18px;border-radius:14px;background:#faf9fd;text-align:left;font-size:14.5px;line-height:1.7;color:#55506a;}",
      "#xeist-bagpay-overlay .xbp__details[hidden]{display:none;}",
      "#xeist-bagpay-overlay .xbp__row{display:flex;justify-content:space-between;gap:16px;}",
      "#xeist-bagpay-overlay .xbp__row[hidden]{display:none;}",
      "#xeist-bagpay-overlay .xbp__row b{font-weight:600;color:#141419;text-align:right;}",
      "#xeist-bagpay-overlay .xbp__newrow{display:flex;flex-wrap:wrap;align-items:center;gap:6px 14px;margin-top:10px;padding-top:10px;border-top:1px solid #ece8f6;font-size:13px;line-height:1.5;color:#8a7fa6;}",
      "#xeist-bagpay-overlay .xbp__newrow[hidden]{display:none;}",
      "#xeist-bagpay-overlay .xbp__newrow span{flex:1 1 100%;}",
      "#xeist-bagpay-overlay .xbp__textbtn{margin:0;padding:0;border:0;background:none;color:#6c2bd9;font-size:13px;font-weight:600;line-height:inherit;letter-spacing:0;text-transform:none;cursor:pointer;-webkit-appearance:none;appearance:none;}",
      "#xeist-bagpay-overlay .xbp__textbtn:hover{text-decoration:underline;}",
      "#xeist-bagpay-overlay .xbp__textbtn--quiet{color:#8a7fa6;font-weight:500;}",
      "#xeist-bagpay-overlay .xbp__foot{flex:none;padding-top:28px;font-size:11px;font-weight:500;letter-spacing:.3em;text-transform:uppercase;color:#a49fb4;}",
      '#xeist-bagpay-overlay .xbp__foot::before{content:"";display:block;width:32px;height:1px;margin:0 auto 16px;background:#dcd8e6;}',
      "#xeist-bagpay-overlay .xbp__form{width:100%;max-width:420px;text-align:left;}",
      "#xeist-bagpay-overlay .xbp__input{display:block;width:100%;height:54px;margin:0 0 12px;padding:0 16px;border:1px solid #e6e3ef;border-radius:12px;background:#fff;box-shadow:none;font-size:16px;color:#141419;outline:none;-webkit-appearance:none;appearance:none;}",
      "#xeist-bagpay-overlay .xbp__input:focus{border-color:#6c2bd9;box-shadow:0 0 0 3px rgba(108,43,217,.12);}",
      "#xeist-bagpay-overlay .xbp__status{min-height:18px;margin-top:10px;font-size:13px;line-height:1.4;color:#8a7fa6;text-align:center;}",
      /* destination form (2026-09-21): only ever shown after "All to me" */
      /* choice tiles (2026-09-22) */
      "#xeist-bagpay-overlay .xbp__opts{display:flex;flex-direction:column;gap:10px;width:100%;max-width:420px;margin:0 0 14px;}",
      "#xeist-bagpay-overlay .xbp__opt{display:flex;flex-direction:column;align-items:flex-start;gap:4px;width:100%;margin:0;padding:18px 20px;border:1px solid #e6e3ef;border-radius:14px;background:#fff;text-align:left;cursor:pointer;-webkit-appearance:none;appearance:none;transition:border-color .12s ease,box-shadow .12s ease;}",
      "#xeist-bagpay-overlay .xbp__opt:hover{border-color:#6c2bd9;}",
      "#xeist-bagpay-overlay .xbp__opt.is-on{border-color:#6c2bd9;box-shadow:0 0 0 3px rgba(108,43,217,.12);}",
      "#xeist-bagpay-overlay .xbp__opt b{font-size:17px;font-weight:600;line-height:1.25;letter-spacing:0;text-transform:none;color:#141419;}",
      "#xeist-bagpay-overlay .xbp__opt span{font-size:14px;line-height:1.4;color:#8a7fa6;}",
      "#xeist-bagpay-overlay .xbp__form--dest{max-width:500px;margin:2px 0 14px;}",
      "#xeist-bagpay-overlay .xbp__form--dest[hidden]{display:none;}",
      "#xeist-bagpay-overlay .xbp__two{display:flex;gap:10px;}",
      "#xeist-bagpay-overlay .xbp__two .xbp__input{flex:1 1 0;min-width:0;}",
      "#xeist-bagpay-overlay select.xbp__input{-webkit-appearance:menulist;appearance:menulist;}",
      "#xeist-bagpay-overlay .xbp__share--sm{height:50px;margin-top:2px;font-size:16px;}",
      "#xeist-bagpay-overlay button:focus-visible{outline:2px solid #6c2bd9;outline-offset:2px;}",
      "@media (max-width:720px){",
      "#xeist-bagpay-overlay{padding:14px;}",
      "#xeist-bagpay-overlay .xbp__card{flex-direction:column;max-width:480px;min-height:0;max-height:calc(100vh - 28px);border-radius:18px;}",
      "#xeist-bagpay-overlay .xbp__media{flex:0 0 auto;height:176px;padding:14px;}",
      "#xeist-bagpay-overlay .xbp__bag{top:14px;right:14px;bottom:24px;left:14px;}",
      "#xeist-bagpay-overlay .xbp__card--create .xbp__media,#xeist-bagpay-overlay .xbp__card--nobag .xbp__media{display:none;}",
      "#xeist-bagpay-overlay .xbp__tag,#xeist-bagpay-overlay .xbp__brand{display:none;}",
      "#xeist-bagpay-overlay .xbp__body{justify-content:flex-start;padding:26px 20px 22px;}",
      "#xeist-bagpay-overlay .xbp__close{top:12px;right:12px;width:38px;height:38px;}",
      "#xeist-bagpay-overlay .xbp__check{width:64px;height:64px;margin-bottom:16px;}",
      "#xeist-bagpay-overlay .xbp__check svg{width:28px;height:28px;}",
      "#xeist-bagpay-overlay .xbp__title{font-size:30px;margin-bottom:10px;}",
      "#xeist-bagpay-overlay .xbp__title--sm{font-size:24px;margin-bottom:16px;}",
      "#xeist-bagpay-overlay .xbp__sub{font-size:15.5px;margin-bottom:6px;}",
      "#xeist-bagpay-overlay .xbp__note{font-size:13px;margin-bottom:2px;}",
      "#xeist-bagpay-overlay .xbp__note--ship{margin-bottom:20px;}",
      "#xeist-bagpay-overlay .xbp__weeks{gap:6px;}",
      "#xeist-bagpay-overlay .xbp__chip{height:34px;padding:0 12px;font-size:13px;}",
      "#xeist-bagpay-overlay .xbp__opt{padding:15px 16px;}",
      "#xeist-bagpay-overlay .xbp__opt b{font-size:16px;}",
      "#xeist-bagpay-overlay .xbp__opt span{font-size:13px;}",
      "#xeist-bagpay-overlay .xbp__link{height:56px;margin-bottom:12px;padding-left:14px;}",
      "#xeist-bagpay-overlay .xbp__url{font-size:13px;}",
      "#xeist-bagpay-overlay .xbp__copy{height:40px;padding:0 14px;font-size:15px;}",
      "#xeist-bagpay-overlay .xbp__share{height:52px;font-size:16px;}",
      "#xeist-bagpay-overlay .xbp__more{margin-top:14px;font-size:15px;}",
      "#xeist-bagpay-overlay .xbp__foot{padding-top:18px;}",
      /* Link ready on phones: the screen itself (2026-09-18 reference) */
      "#xeist-bagpay-overlay.xbp--active{align-items:stretch;padding:0;background:#fff;}",
      "#xeist-bagpay-overlay.xbp--active .xbp__card{max-width:none;max-height:none;border-radius:0;box-shadow:none;overflow-x:hidden;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;}",
      "#xeist-bagpay-overlay.xbp--active .xbp__media{flex:100 1 0px;height:auto;min-height:230px;max-height:400px;padding:0;overflow:visible;background:#fff;}",
      "#xeist-bagpay-overlay.xbp--active .xbp__media::before{display:none;}",
      "#xeist-bagpay-overlay.xbp--active .xbp__brand{display:flex;align-items:center;justify-content:center;top:22px;right:64px;bottom:auto;left:64px;height:16px;}",
      "#xeist-bagpay-overlay.xbp--active .xbp__brand img{height:15px;max-width:120px;}",
      "#xeist-bagpay-overlay.xbp--active .xbp__brand span{font-size:15px;text-indent:.34em;line-height:1;}",
      "#xeist-bagpay-overlay.xbp--active .xbp__bag{top:64px;right:24px;bottom:32px;left:24px;}",
      "#xeist-bagpay-overlay.xbp--active .xbp__body{flex:1 0 auto;overflow:visible;padding:6px 20px 20px;padding-bottom:calc(20px + env(safe-area-inset-bottom,0px));}",
      "#xeist-bagpay-overlay.xbp--active .xbp__close{position:fixed;top:10px;right:12px;width:40px;height:40px;}",
      "#xeist-bagpay-overlay.xbp--active .xbp__title{font-size:32px;}",
      "}"
    ];
    var ICON = {
      check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
      link: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.07 0l3-3a5 5 0 0 0-7.07-7.07l-1.5 1.5"/><path d="M14 11a5 5 0 0 0-7.07 0l-3 3a5 5 0 0 0 7.07 7.07l1.5-1.5"/></svg>',
      send: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/></svg>',
      x: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>'
    };
    var FOOT = '<div class="xbp__foot">Don’t just exist. Xeist.</div>';
    function ensureCSS() {
      if (document.getElementById("xeist-bagpay-css")) return;
      var s = document.createElement("style");
      s.id = "xeist-bagpay-css";
      s.textContent = CSS.join("\n");
      (document.head || document.documentElement).appendChild(s);
    }
    function headerLogoSrc() {
      try {
        var img = document.querySelector(".site-header__logo-link:not(.logo--inverted) img.small--hide") || document.querySelector(".site-header__logo-link:not(.logo--inverted) img") || document.querySelector(".site-header__logo img");
        if (!img) return "";
        var ss = img.getAttribute("srcset") || "";
        var m = ss.match(/(\S+)\s+2x/);
        return m && m[1] || img.currentSrc || img.getAttribute("src") || "";
      } catch (e) {
        return "";
      }
    }
    function bagImageSrc() {
      try {
        var st = window.__xeistBagSnapshot;
        if (st && st.dataUrl) return st.dataUrl;
      } catch (e) {
      }
      return liveBagDataUrl() || "";
    }
    var cutCache = { src: "", url: "" };
    function cutoutBag(src, cb) {
      if (cutCache.src === src && cutCache.url) {
        cb(cutCache.url, true);
        return;
      }
      var finished = false;
      function done(url, cut) {
        if (finished) return;
        finished = true;
        if (cut) cutCache = { src, url };
        cb(url, cut);
      }
      try {
        var im = new Image();
        if (!/^data:/i.test(src)) im.crossOrigin = "anonymous";
        im.onerror = function() {
          done(src, false);
        };
        im.onload = function() {
          try {
            var W = im.naturalWidth, H = im.naturalHeight;
            if (!W || !H) {
              done(src, false);
              return;
            }
            var scale = Math.min(1, 900 / Math.max(W, H));
            var w = Math.max(1, Math.round(W * scale)), h = Math.max(1, Math.round(H * scale));
            var c = document.createElement("canvas");
            c.width = w;
            c.height = h;
            var ctx = c.getContext("2d");
            ctx.drawImage(im, 0, 0, w, h);
            var id = ctx.getImageData(0, 0, w, h), d = id.data, n = w * h;
            var corners = [0, (w - 1) * 4, (h - 1) * w * 4, ((h - 1) * w + (w - 1)) * 4];
            var gr = 0, gg = 0, gb = 0;
            for (var ci = 0; ci < 4; ci++) {
              gr += d[corners[ci]];
              gg += d[corners[ci] + 1];
              gb += d[corners[ci] + 2];
            }
            gr /= 4;
            gg /= 4;
            gb /= 4;
            if (gr + gg + gb < 600) {
              done(src, false);
              return;
            }
            var T = 48, mark = new Uint8Array(n), stack = [];
            var push = function(i2) {
              if (mark[i2]) return;
              var q = i2 * 4;
              if (Math.abs(d[q] - gr) + Math.abs(d[q + 1] - gg) + Math.abs(d[q + 2] - gb) > T) return;
              mark[i2] = 1;
              stack.push(i2);
            };
            for (var x = 0; x < w; x++) {
              push(x);
              push((h - 1) * w + x);
            }
            for (var y = 0; y < h; y++) {
              push(y * w);
              push(y * w + w - 1);
            }
            while (stack.length) {
              var i = stack.pop(), xx = i % w;
              if (xx > 0) push(i - 1);
              if (xx < w - 1) push(i + 1);
              if (i >= w) push(i - w);
              if (i < n - w) push(i + w);
            }
            var removed = 0, minX = w, minY = h, maxX = -1, maxY = -1;
            for (var k = 0; k < n; k++) {
              if (mark[k]) {
                d[k * 4 + 3] = 0;
                removed++;
                continue;
              }
              var kx = k % w, ky = (k - kx) / w;
              if (kx < minX) minX = kx;
              if (kx > maxX) maxX = kx;
              if (ky < minY) minY = ky;
              if (ky > maxY) maxY = ky;
              if (kx > 0 && mark[k - 1] || kx < w - 1 && mark[k + 1] || k >= w && mark[k - w] || k < n - w && mark[k + w]) d[k * 4 + 3] = 150;
            }
            if (removed < n * 0.05 || removed > n * 0.97) {
              done(src, false);
              return;
            }
            ctx.putImageData(id, 0, 0);
            var pad = 2;
            var cx = Math.max(0, minX - pad), cy = Math.max(0, minY - pad);
            var cw = Math.min(w, maxX + pad + 1) - cx, ch = Math.min(h, maxY + pad + 1) - cy;
            var out = document.createElement("canvas");
            out.width = cw;
            out.height = ch;
            out.getContext("2d").drawImage(c, cx, cy, cw, ch, 0, 0, cw, ch);
            if (out.toBlob && window.URL && URL.createObjectURL) {
              out.toBlob(function(b) {
                if (b) done(URL.createObjectURL(b), true);
                else done(src, false);
              }, "image/png");
            } else {
              done(out.toDataURL("image/png"), true);
            }
          } catch (e) {
            done(src, false);
          }
        };
        im.src = src;
      } catch (e0) {
        done(src, false);
      }
    }
    var keyHandler = null;
    function closePopup() {
      var ov = document.getElementById("xeist-bagpay-overlay");
      if (keyHandler) {
        try {
          document.removeEventListener("keydown", keyHandler, true);
        } catch (e) {
        }
        keyHandler = null;
      }
      if (ov && ov.parentNode) {
        ov.parentNode.removeChild(ov);
        fire("closed");
      }
    }
    function popupShell(kind, label, innerHTML) {
      closePopup();
      ensureCSS();
      var bag = bagImageSrc();
      var logo = headerLogoSrc();
      var overlay = document.createElement("div");
      overlay.id = "xeist-bagpay-overlay";
      overlay.className = "xbp--" + kind;
      overlay.setAttribute("role", "dialog");
      overlay.setAttribute("aria-modal", "true");
      overlay.setAttribute("aria-label", label);
      overlay.innerHTML = '<div id="xbp-card" class="xbp__card xbp__card--' + kind + (bag ? "" : " xbp__card--nobag") + '" tabindex="-1"><button type="button" id="xbp-close" class="xbp__close" aria-label="Close">' + ICON.x + '</button><div class="xbp__media" aria-hidden="true"><div class="xbp__tag">Teams<br>move<br>forward</div><div id="xbp-bagwrap" class="xbp__bag is-loading"' + (bag ? "" : " hidden") + '><img id="xbp-bag" alt=""></div><div class="xbp__brand">' + (logo ? '<img src="' + esc(logo) + '" alt="XEIST">' : "<span>XEIST</span>") + '</div></div><div id="xbp-body" class="xbp__body"><div id="xbp-main" class="xbp__main">' + innerHTML + "</div>" + FOOT + "</div></div>";
      document.body.appendChild(overlay);
      if (bag) setBagImage(bag, true);
      overlay.addEventListener("click", function(e) {
        if (e.target === overlay) closePopup();
      });
      $("#xbp-close", overlay).addEventListener("click", closePopup);
      keyHandler = function(e) {
        if (e.key === "Escape" || e.key === "Esc") {
          e.preventDefault();
          closePopup();
        }
      };
      document.addEventListener("keydown", keyHandler, true);
      try {
        $("#xbp-card", overlay).focus({ preventScroll: true });
      } catch (e) {
      }
      try {
        var cap = window.__xeistBagCapture;
        if (cap && typeof cap.fresh === "function") cap.fresh(function(st) {
          if (st && st.dataUrl) setBagImage(st.dataUrl, true);
        });
      } catch (eC) {
      }
      return $("#xbp-main", overlay);
    }
    function setBagImage(src, force) {
      var wrap = document.getElementById("xbp-bagwrap"), img = document.getElementById("xbp-bag");
      if (!wrap || !img || !src) return;
      var cur = img.getAttribute("data-src") || "";
      if (cur === src || cur && !force) return;
      img.setAttribute("data-src", src);
      cutoutBag(src, function(url, cut) {
        if (document.getElementById("xbp-bag") !== img || img.getAttribute("data-src") !== src) return;
        img.onload = function() {
          wrap.className = "xbp__bag" + (cut ? " is-cut" : "");
          wrap.hidden = false;
          var card = document.getElementById("xbp-card");
          if (card) card.className = card.className.replace(/\s*xbp__card--nobag/g, "");
        };
        img.src = url;
      });
    }
    function knownTeam() {
      try {
        return String(window.__xeistTeamName && window.__xeistTeamName() || "").replace(/\s+/g, " ").trim();
      } catch (e) {
        return "";
      }
    }
    function optSub(kind) {
      if (!SHIP_ARMED) return kind === "coach" ? "One shipment to you" : "Shipped to each parent";
      return money(SHIP_CENTS[kind]) + " shipping each";
    }
    function showDest() {
      var known = knownTeam();
      var card = popupShell(
        "create",
        "Where do bags go?",
        '<div class="xbp__title xbp__title--sm">Where do bags go?</div><div class="xbp__opts"><button type="button" class="xbp__opt" data-dest="parent"><b>Each parent gets theirs</b><span>' + esc(optSub("parent")) + '</span></button><button type="button" class="xbp__opt" data-dest="coach"><b>All to me</b><span>' + esc(optSub("coach")) + '</span></button></div><div id="xbp-destform" class="xbp__form xbp__form--dest" hidden>' + destFieldsHTML(null, known) + '<button type="button" id="xbp-st-go" class="xbp__share xbp__share--sm"><span>Continue</span></button><div id="xbp-st-status" class="xbp__status"></div></div>'
      );
      var opts = card.querySelector(".xbp__opts");
      var form = $("#xbp-destform", card);
      function paint(kind) {
        var all = opts.querySelectorAll(".xbp__opt");
        for (var i = 0; i < all.length; i++) {
          all[i].className = "xbp__opt" + (all[i].getAttribute("data-dest") === kind ? " is-on" : "");
        }
      }
      opts.addEventListener("click", function(e) {
        var b = e.target;
        while (b && b !== opts && !(b.getAttribute && b.getAttribute("data-dest"))) b = b.parentNode;
        if (!b || b === opts) return;
        var kind = b.getAttribute("data-dest");
        paint(kind);
        if (kind === "parent") {
          pendingDest = null;
          showCreate();
          return;
        }
        form.hidden = false;
        try {
          $("#xbp-st-name", card).focus();
        } catch (e2) {
        }
      });
      $("#xbp-st-go", card).addEventListener("click", function() {
        var st = readDestForm(card), miss = missingDestField(st);
        if (miss) {
          $("#xbp-st-status", card).textContent = "Fill this in";
          try {
            $("#" + miss, card).focus();
          } catch (e) {
          }
          return;
        }
        pendingDest = st;
        showCreate();
      });
    }
    function showCreate() {
      var known = knownTeam();
      var card = popupShell(
        "create",
        "Your phone and email",
        '<div class="xbp__title xbp__title--sm">Your phone and email</div><div class="xbp__form">' + (known ? "" : '<input id="xbp-team" class="xbp__input" type="text" name="organization" autocomplete="organization" autocapitalize="words" maxlength="60" placeholder="Team name">') + /* 2026-09-02: autocomplete tags so iOS/Android offer the contact card
           as a one-tap chip instead of typing. */
        '<input id="xbp-contact" class="xbp__input" type="tel" name="tel" autocomplete="tel" inputmode="tel" maxlength="40" placeholder="(555) 123-4567"><input id="xbp-email" class="xbp__input" type="email" name="email" autocomplete="email" inputmode="email" autocapitalize="off" spellcheck="false" maxlength="60" placeholder="you@email.com"><button type="button" id="xbp-create" class="xbp__share"><span>Get parent link</span></button><div id="xbp-status" class="xbp__status"></div></div>'
      );
      var contactIn = $("#xbp-contact", card);
      var emailIn = $("#xbp-email", card);
      var teamIn = $("#xbp-team", card);
      function submit() {
        var btn = $("#xbp-create", card);
        var st = $("#xbp-status", card);
        if (!btn || btn.disabled) return;
        var team = known || (teamIn && teamIn.value || "").replace(/\s+/g, " ").trim();
        if (!team) {
          st.textContent = "Add your team name";
          try {
            teamIn.focus();
          } catch (e) {
          }
          return;
        }
        var phone = (contactIn.value || "").trim();
        if (contactKind(phone) !== "phone") {
          st.textContent = "Enter your phone number";
          try {
            contactIn.focus();
          } catch (e) {
          }
          return;
        }
        var email = (emailIn.value || "").trim();
        if (contactKind(email) !== "email") {
          st.textContent = "Enter your email";
          try {
            emailIn.focus();
          } catch (e) {
          }
          return;
        }
        var dl = Date.now() + DEADLINE_DEFAULT_DAYS * 24 * 3600 * 1e3;
        var token = makeToken();
        if (!token) {
          st.textContent = "Use a non-private window";
          return;
        }
        btn.disabled = true;
        st.textContent = "Creating link…";
        putMeta(token, team, dl, phone, email, pendingDest, function(ok, j) {
          if (!ok) {
            st.textContent = "No connection — try again";
            var b = $("#xbp-create", card);
            if (b) b.disabled = false;
            return;
          }
          var rec = { token, ts: Date.now(), team, coachKey: j && j.coachKey || "", shipTo: pendingDest || null };
          store().set(LINK_KEY, JSON.stringify(rec));
          uploadPreview(token, rec);
          showActive(rec);
        });
      }
      fire("create");
      $("#xbp-create", card).addEventListener("click", submit);
      card.addEventListener("keydown", function(e) {
        if (e.key === "Enter") {
          e.preventDefault();
          submit();
        }
      });
      try {
        (known ? contactIn : teamIn).focus();
      } catch (e) {
      }
    }
    function showExpired(card) {
      card.innerHTML = '<div class="xbp__check xbp__check--off" aria-hidden="true">' + ICON.x + '</div><div class="xbp__title">Link expired.</div><div class="xbp__sub">Make a new link to share.</div><button type="button" id="xbp-again" class="xbp__share"><span>Make a new link</span></button>';
      $("#xbp-again", card).addEventListener("click", function() {
        store().remove(LINK_KEY);
        pendingDest = null;
        showDest();
      });
    }
    function showActive(c) {
      var url = linkUrl(c.token);
      var team = c && c.team ? String(c.team) : knownTeam();
      var unit = null;
      try {
        unit = parentUnitCents(getQty());
      } catch (e) {
        unit = null;
      }
      var WEEK = 7 * 24 * 3600 * 1e3;
      var until = c && c.deadline ? c.deadline : c && c.ts ? c.ts + DEADLINE_DEFAULT_DAYS * 24 * 3600 * 1e3 : 0;
      var untilTouched = false;
      var dest = c && shipToValid(c.shipTo) ? c.shipTo : null;
      var destTouched = false;
      var chipsHTML = "";
      for (var w = 1; w <= 4; w++) chipsHTML += '<button type="button" class="xbp__chip" data-weeks="' + w + '" aria-pressed="false">' + w + (w === 1 ? " week" : " weeks") + "</button>";
      var shareable = false;
      try {
        shareable = !!(navigator.share && (!navigator.canShare || navigator.canShare({ url })));
      } catch (e) {
        shareable = false;
      }
      var card = popupShell(
        "active",
        "Parent link",
        '<div class="xbp__check" aria-hidden="true">' + ICON.check + '</div><div class="xbp__title">Link ready.</div><div class="xbp__sub">Share with your parents so they can order and pay for their bags directly.</div><div class="xbp__note"><span>Parents have until <b id="xbp-until">' + esc(fmtDate(until)) + '</b></span> <span class="xbp__dot" aria-hidden="true">·</span> <button type="button" id="xbp-change" class="xbp__change" aria-expanded="false" aria-controls="xbp-weeks">Change</button></div><div id="xbp-weeks" class="xbp__weeks" hidden>' + chipsHTML + '</div><div class="xbp__note"><span>Bags go to <b id="xbp-dest">' + (dest ? "you" : "each parent") + '</b></span> <span class="xbp__dot" aria-hidden="true">·</span> <button type="button" id="xbp-destchange" class="xbp__change" aria-expanded="false" aria-controls="xbp-dests">Change</button></div><div id="xbp-dests" class="xbp__weeks" hidden><button type="button" class="xbp__chip" data-dest="parent" aria-pressed="' + (dest ? "false" : "true") + '">Each parent</button><button type="button" class="xbp__chip" data-dest="coach" aria-pressed="' + (dest ? "true" : "false") + '">All to me</button></div><div id="xbp-destform" class="xbp__form xbp__form--dest" hidden>' + destFieldsHTML(dest, team) + '<button type="button" id="xbp-st-save" class="xbp__share xbp__share--sm"><span id="xbp-st-save-label">Save address</span></button><div id="xbp-st-status" class="xbp__status"></div></div><div class="xbp__note xbp__note--ship">Ships 7–10 days after that.</div><div class="xbp__link">' + ICON.link + '<input id="xbp-link" class="xbp__url" type="text" readonly value="' + esc(url) + '" aria-label="Parent link"><button type="button" id="xbp-copy" class="xbp__copy">Copy</button></div><button type="button" id="xbp-send" class="xbp__share">' + ICON.send + '<span id="xbp-send-label">Share link</span></button><button type="button" id="xbp-more" class="xbp__more" aria-expanded="false" aria-controls="xbp-details">View link details</button>' + /* His own page (2026-09-18): progress, close date, approve — the
           same link his email carries. Only a record made since the key
           shipped has it; older links reach the page from the email. */
        (coachUrl(c) ? '<a id="xbp-coach" class="xbp__more xbp__more--page" href="' + esc(coachUrl(c)) + '" target="_blank" rel="noopener">Open your team order</a>' : "") + /* Price per parent (2026-09-16, Justin: "the link he shares and the
           price per parent"): the local ladder figure at once, replaced by
           the worker's quote (what the parent page actually charges) when
           the meta fetch below lands. Folded behind "View link details"
           with the paid status (2026-09-17). */
        '<div id="xbp-details" class="xbp__details" hidden><div id="xbp-price" class="xbp__row"' + (unit != null ? "" : " hidden") + "><span>Each parent pays</span><b>" + (unit != null ? money(unit) : "") + '</b></div><div id="xbp-ship" class="xbp__row" hidden><span>Shipping each</span><b></b></div><div id="xbp-destrow" class="xbp__row"' + (dest ? "" : " hidden") + '><span>Bags go to</span><b id="xbp-destfull">' + esc(dest ? shipToLines(dest) : "") + '</b></div><div id="xbp-live">Checking payments…</div><div id="xbp-newrow" class="xbp__newrow"><button type="button" id="xbp-new" class="xbp__textbtn">Start a new link</button></div></div>'
      );
      fire("active");
      var sendBtn = $("#xbp-send", card), sendLabel = $("#xbp-send-label", card), copyBtn = $("#xbp-copy", card);
      var moreBtn = $("#xbp-more", card), details = $("#xbp-details", card);
      function writeClipboard() {
        try {
          $("#xbp-link", card).select();
        } catch (e) {
        }
        var okd = false;
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url);
            okd = true;
          }
        } catch (e) {
        }
        if (!okd) {
          try {
            document.execCommand("copy");
          } catch (e2) {
          }
        }
      }
      function flash(el, text, back) {
        el.textContent = text;
        window.setTimeout(function() {
          el.textContent = back;
        }, 1600);
      }
      copyBtn.addEventListener("click", function() {
        writeClipboard();
        flash(copyBtn, "Copied", "Copy");
      });
      sendBtn.addEventListener("click", function() {
        if (!shareable) {
          writeClipboard();
          flash(sendLabel, "Link copied", "Share link");
          return;
        }
        var p = null;
        try {
          p = navigator.share({
            title: (team ? team + " " : "") + "team backpacks",
            /* The words the coach's emails and his page use too (2026-09-18):
               the line that matters is "pay XEIST directly". */
            text: "Order your player’s " + (team ? team + " " : "") + "backpack" + (until ? " by " + fmtDate(until) : "") + ". Enter their details and pay XEIST directly — no need to send payment to me:",
            url
          });
        } catch (e) {
          p = null;
        }
        if (!p || !p.catch) {
          shareable = false;
          writeClipboard();
          flash(sendLabel, "Link copied", "Share link");
          return;
        }
        p.catch(function(err) {
          if (err && err.name === "AbortError") return;
          shareable = false;
        });
      });
      moreBtn.addEventListener("click", function() {
        var open = !!details.hidden;
        details.hidden = !open;
        moreBtn.setAttribute("aria-expanded", open ? "true" : "false");
        moreBtn.textContent = open ? "Hide link details" : "View link details";
      });
      var untilEl = $("#xbp-until", card), changeBtn = $("#xbp-change", card), weeksRow = $("#xbp-weeks", card);
      function paintWeeks() {
        var chips = weeksRow.querySelectorAll(".xbp__chip");
        for (var i = 0; i < chips.length; i++) {
          var n = parseInt(chips[i].getAttribute("data-weeks"), 10);
          var on = !!until && Math.abs(Date.now() + n * WEEK - until) < 12 * 3600 * 1e3;
          chips[i].className = "xbp__chip" + (on ? " is-on" : "");
          chips[i].setAttribute("aria-pressed", on ? "true" : "false");
        }
      }
      function setUntil(ms) {
        until = ms;
        if (untilEl) untilEl.textContent = fmtDate(ms);
        var cl = $("#xbp-closes", card);
        if (cl) cl.textContent = fmtDate(ms);
        paintWeeks();
      }
      function foldWeeks() {
        weeksRow.hidden = true;
        changeBtn.setAttribute("aria-expanded", "false");
      }
      changeBtn.addEventListener("click", function() {
        if (weeksRow.hidden) {
          paintWeeks();
          weeksRow.hidden = false;
          changeBtn.setAttribute("aria-expanded", "true");
        } else foldWeeks();
      });
      weeksRow.addEventListener("click", function(e) {
        var chip = e.target;
        while (chip && chip !== weeksRow && !(chip.getAttribute && chip.getAttribute("data-weeks"))) chip = chip.parentNode;
        if (!chip || chip === weeksRow) return;
        var n = parseInt(chip.getAttribute("data-weeks"), 10);
        if (!n) return;
        var prev = until, next = Date.now() + n * WEEK;
        untilTouched = true;
        setUntil(next);
        foldWeeks();
        putMeta(c.token, team, next, "", "", dest, function(ok) {
          if (!ok) {
            setUntil(prev);
            flash(changeBtn, "Couldn’t save — try again", "Change");
            return;
          }
          try {
            c.deadline = next;
            store().set(LINK_KEY, JSON.stringify(c));
          } catch (es) {
          }
        });
      });
      var destEl = $("#xbp-dest", card), destChange = $("#xbp-destchange", card);
      var destsRow = $("#xbp-dests", card), destForm = $("#xbp-destform", card);
      var destStatus = $("#xbp-st-status", card);
      function paintDests() {
        var wantCoach = !!dest || !destForm.hidden;
        var chips = destsRow.querySelectorAll(".xbp__chip");
        for (var i = 0; i < chips.length; i++) {
          var on = chips[i].getAttribute("data-dest") === "coach" === wantCoach;
          chips[i].className = "xbp__chip" + (on ? " is-on" : "");
          chips[i].setAttribute("aria-pressed", on ? "true" : "false");
        }
      }
      function setDest(st) {
        dest = shipToValid(st) ? st : null;
        if (destEl) destEl.textContent = dest ? "you" : "each parent";
        var row = $("#xbp-destrow", card), full = $("#xbp-destfull", card);
        if (row) row.hidden = !dest;
        if (full && dest) full.textContent = shipToLines(dest);
        paintDests();
      }
      function foldDests(alsoForm) {
        destsRow.hidden = true;
        if (alsoForm) destForm.hidden = true;
        destChange.setAttribute("aria-expanded", "false");
      }
      function saveDest(st, onDone) {
        var prev = dest;
        putMeta(c.token, team, until || 0, "", "", st, function(ok) {
          if (!ok) {
            setDest(prev);
            onDone(false);
            return;
          }
          setDest(st);
          destTouched = true;
          try {
            c.shipTo = st || null;
            store().set(LINK_KEY, JSON.stringify(c));
          } catch (e) {
          }
          onDone(true);
        });
      }
      destChange.addEventListener("click", function() {
        if (destsRow.hidden) {
          paintDests();
          destsRow.hidden = false;
          destChange.setAttribute("aria-expanded", "true");
        } else foldDests(true);
      });
      destsRow.addEventListener("click", function(e) {
        var chip = e.target;
        while (chip && chip !== destsRow && !(chip.getAttribute && chip.getAttribute("data-dest"))) chip = chip.parentNode;
        if (!chip || chip === destsRow) return;
        var want = chip.getAttribute("data-dest");
        if (want === "coach") {
          destForm.hidden = false;
          paintDests();
          try {
            $("#xbp-st-name", card).focus();
          } catch (e2) {
          }
          return;
        }
        destForm.hidden = true;
        if (!dest) {
          foldDests(true);
          return;
        }
        saveDest(null, function(ok) {
          if (!ok) {
            flash(destChange, "Couldn’t save — try again", "Change");
            return;
          }
          foldDests(true);
        });
      });
      var saveBtn = $("#xbp-st-save", card), saveLabel = $("#xbp-st-save-label", card);
      saveBtn.addEventListener("click", function() {
        var st = readDestForm(card);
        var miss = missingDestField(st);
        if (miss) {
          destStatus.textContent = "Fill this in";
          try {
            $("#" + miss, card).focus();
          } catch (e) {
          }
          return;
        }
        saveBtn.disabled = true;
        destStatus.textContent = "Saving…";
        saveDest(st, function(ok) {
          saveBtn.disabled = false;
          if (!ok) {
            destStatus.textContent = "No connection — try again";
            return;
          }
          destStatus.textContent = "";
          foldDests(true);
          flash(saveLabel, "Saved", "Save address");
        });
      });
      var newRow = $("#xbp-newrow", card);
      if (newRow) newRow.addEventListener("click", function(e) {
        var t = e.target;
        if (!t || !t.id) return;
        if (t.id === "xbp-new") {
          newRow.innerHTML = '<span>The old link keeps working for parents who have it.</span><button type="button" id="xbp-new-yes" class="xbp__textbtn">New link</button><button type="button" id="xbp-new-no" class="xbp__textbtn xbp__textbtn--quiet">Keep this one</button>';
        } else if (t.id === "xbp-new-no") {
          newRow.innerHTML = '<button type="button" id="xbp-new" class="xbp__textbtn">Start a new link</button>';
        } else if (t.id === "xbp-new-yes") {
          store().remove(LINK_KEY);
          pendingDest = null;
          showDest();
        }
      });
      fetch(API + "/roster/" + c.token + "?meta=1", { mode: "cors" }).then(function(r) {
        return r.status === 404 ? { gone: true } : r.ok ? r.json() : null;
      }).then(function(d) {
        var el = $("#xbp-live", card);
        if (!el) return;
        if (d && d.gone) {
          showExpired(card);
          return;
        }
        if (!d || !d.meta) {
          el.textContent = "Couldn’t check payments";
          return;
        }
        var m = d.meta;
        try {
          if (m.deadline && !untilTouched) setUntil(m.deadline);
        } catch (ed) {
        }
        try {
          if (!destTouched) {
            setDest(shipToValid(m.shipTo) ? m.shipTo : null);
            try {
              c.shipTo = dest;
              store().set(LINK_KEY, JSON.stringify(c));
            } catch (e0) {
            }
          }
        } catch (es) {
        }
        try {
          if ((m.paidCount | 0) > 0) {
            foldDests(true);
            destChange.hidden = true;
            var dr = $("#xbp-destrow", card);
            if (dr && !dest) {
              dr.hidden = false;
              $("#xbp-destfull", card).textContent = "Each parent’s own address";
            }
          }
        } catch (el2) {
        }
        try {
          if (m.previewUpdated) setBagImage(API + "/roster/" + c.token + "/preview?v=" + m.previewUpdated);
        } catch (ep) {
        }
        try {
          var pe = $("#xbp-price", card), pv = $("#xbp-price b", card);
          var ship = (m.quote && m.quote.ship) | 0;
          if (pe && pv && m.quote && m.quote.total) {
            pv.textContent = money(m.quote.total - ship);
            pe.hidden = false;
          }
          var se = $("#xbp-ship", card), sv = $("#xbp-ship b", card);
          if (se && sv && ship > 0) {
            sv.textContent = money(ship);
            se.hidden = false;
          }
        } catch (eq) {
        }
        var paid = m.paidCount | 0;
        var got = m.collected | 0;
        var html = '<div class="xbp__row"><span>Paid</span><b>' + paid + " of " + esc(m.expected || "?") + " bags" + (got ? " · " + esc(money(got)) + " collected" : "") + "</b></div>";
        if (until || m.deadline) html += '<div class="xbp__row"><span>Closes</span><b id="xbp-closes">' + esc(fmtDate(until || m.deadline)) + "</b></div>";
        if (!paid && (d.count | 0) > 0) html += "<div>" + (d.count | 0) + " submitted, payment pending</div>";
        el.innerHTML = html;
      }).catch(function() {
        var el = $("#xbp-live", card);
        if (el) el.textContent = "Couldn’t check payments";
      });
    }
    window.__xeistBagPay = {
      open: function() {
        var c = loadLink();
        if (c) {
          showActive(c);
          try {
            if (window.__xeistBagCapture || window.__xeistBagSnapshot) uploadPreview(c.token, c);
          } catch (e) {
          }
        } else {
          showDest();
        }
      },
      hasLink: function() {
        return !!loadLink();
      },
      /* Coach-facing parent price for the stepped flow's "Each parent pays"
         (cents CAD, or null while parent checkout is still collect-only). */
      parentUnitCents,
      armed: function() {
        var bp = BAG_PAY[designId];
        return !!(bp && activeHandle(bp) && activeLadder(bp));
      }
    };
    var attempts = 0;
    var pollId = window.setInterval(function() {
      attempts++;
      if (attempts > 120) {
        window.clearInterval(pollId);
        return;
      }
      var cta = $("[data-bottom-bar-cta]");
      if (!cta || !cta.parentNode) return;
      if (document.getElementById("xeist-bagpay-open")) {
        window.clearInterval(pollId);
        return;
      }
      window.clearInterval(pollId);
      var btn = document.createElement("button");
      btn.id = "xeist-bagpay-open";
      btn.type = "button";
      btn.textContent = "or split the cost with parents →";
      btn.style.cssText = "display:block;width:100%;background:none;border:none;color:#6c2bd9;font-size:12.5px;font-weight:500;padding:6px 0 0;cursor:pointer;text-align:center;";
      cta.parentNode.insertBefore(btn, cta.nextSibling);
      btn.addEventListener("click", function() {
        var c = loadLink();
        if (c) showActive(c);
        else showDest();
      });
    }, 500);
  })();

  // src/coach/39-save-design-modal.js
  (function() {
    "use strict";
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1) return;
    if (window.__xeistSaveDesignModal) return;
    var NAME_MAX = 255;
    var FOLDER_MAX = 255;
    var ROOT_SYSTEM_NAME = "Saved";
    var MOBILE_BP = 768;
    var Z = 2147483350;
    var SLOW_MS = 2e4;
    var FONT = '-apple-system,BlinkMacSystemFont,"SF Pro Text","Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif';
    var PREVIEW_BG = "#f6f6f4";
    function $(sel, root) {
      return (root || document).querySelector(sel);
    }
    function esc(s) {
      return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }
    function clean(s) {
      return String(s == null ? "" : s).replace(/[\r\n\t]+/g, " ").replace(/\s+/g, " ").trim();
    }
    function track(type, payload) {
      try {
        if (window.XeistTrack) window.XeistTrack(type, payload || {});
      } catch (e) {
      }
    }
    function isMobile() {
      return window.innerWidth <= MOBILE_BP;
    }
    function reducedMotion() {
      try {
        return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
      } catch (e) {
        return false;
      }
    }
    function svc(name) {
      try {
        return window.XeistCore && XeistCore.getService ? XeistCore.getService(name) : null;
      } catch (e) {
        return null;
      }
    }
    function kickDigest() {
      var rs = svc("$rootScope");
      if (!rs || typeof rs.$apply !== "function" || rs.$$phase) return;
      try {
        rs.$apply();
      } catch (e) {
      }
    }
    function designIdFromHash() {
      return (String(window.location.hash || "").match(/customise\/(\d+)/) || [])[1] || "";
    }
    function customize() {
      return svc("CustomizeService");
    }
    function productName() {
      try {
        var cs = customize();
        if (cs && cs.product && cs.product.name) return clean(cs.product.name);
      } catch (e) {
      }
      try {
        var c = window.XeistOrbitCoachConfig;
        if (c && c.orderTitle) return clean(c.orderTitle);
      } catch (e) {
      }
      try {
        var cs2 = customize();
        if (cs2 && cs2.design && cs2.design.name) return clean(cs2.design.name);
      } catch (e) {
      }
      return "";
    }
    function kitItems() {
      try {
        var es = window.XeistCore && XeistCore.getES && XeistCore.getES();
        var kit = es && typeof es.getKit === "function" ? es.getKit() : null;
        return kit && kit.editor && kit.editor.length ? Array.prototype.slice.call(kit.editor) : [];
      } catch (e) {
        return [];
      }
    }
    function decorations(items) {
      var d = { logo: false, number: false, teamName: false };
      items = items || kitItems();
      for (var i = 0; i < items.length; i++) {
        var it = items[i] || {};
        var key = String(it.placementKey || it.key || "").toLowerCase();
        var text = clean(it.text != null ? it.text : it.value);
        if (it.type === "image" || it.type === "placed-image") d.logo = true;
        else if (it.type === "text" && text) {
          if (/team-?name/.test(key)) d.teamName = true;
          else if (/number/.test(key) || /^\d{1,3}$/.test(text)) d.number = true;
        }
      }
      try {
        var b = window.XeistKBBridge;
        if (b && !d.logo && typeof b.hasLogo === "function" && (b.hasLogo() || {}).hasLogo) d.logo = true;
        if (b && !d.number && typeof b.hasNumber === "function" && (b.hasNumber() || {}).hasNumber) d.number = true;
      } catch (e) {
      }
      return d;
    }
    function descriptorFor(d) {
      var parts = [];
      if (d.logo) parts.push("Logo");
      if (d.number) parts.push("Number");
      if (d.teamName) parts.push("Team name");
      return parts.length ? parts.join(" + ") + " included" : "";
    }
    function teamName() {
      try {
        var t = window.__xeistTeamName && window.__xeistTeamName();
        if (t) return clean(t);
      } catch (e) {
      }
      try {
        var st = window.XeistCore && XeistCore.store;
        if (st && st.getJSON) {
          var u = st.getJSON("xeist_uniform_setup_" + designIdFromHash(), null) || st.getJSON("xeist_uniform_team_last", null);
          if (u && u.name) return clean(u.name);
        }
      } catch (e) {
      }
      try {
        var items = kitItems();
        for (var i = 0; i < items.length; i++) {
          var it = items[i] || {};
          if (it.type === "text" && /team-?name/.test(String(it.placementKey || it.key || "").toLowerCase())) {
            var v = clean(it.text != null ? it.text : it.value);
            if (v) return v;
          }
        }
      } catch (e) {
      }
      return "";
    }
    function composeName(team, product) {
      var n = team && product ? team + " — " + product : product || team || "Untitled design";
      return n.slice(0, NAME_MAX);
    }
    function defaultName() {
      return composeName(teamName(), productName());
    }
    function folderLabel(f) {
      return f ? clean(f.name) || clean(f.systemName) || "Folder" : "";
    }
    function buildTree(list) {
      var byId = {}, kids = {}, root = null, i, f;
      list = Array.isArray(list) ? list : [];
      for (i = 0; i < list.length; i++) {
        f = list[i];
        if (f && f.id != null) byId[String(f.id)] = f;
      }
      for (i = 0; i < list.length; i++) {
        f = list[i];
        if (!f || f.id == null) continue;
        if (!root && f.systemName === ROOT_SYSTEM_NAME) root = f;
        var p = f.parentId == null ? "" : String(f.parentId);
        (kids[p] = kids[p] || []).push(f);
      }
      for (var k in kids) {
        if (!Object.prototype.hasOwnProperty.call(kids, k)) continue;
        kids[k].sort(function(a, b) {
          return folderLabel(a).localeCompare(folderLabel(b));
        });
      }
      return { byId, kids, root, list };
    }
    function childrenOf(tree, id) {
      return tree && tree.kids[String(id)] || [];
    }
    function parentOf(tree, f) {
      return f && f.parentId != null ? tree.byId[String(f.parentId)] || null : null;
    }
    function inSavedTree(tree, id) {
      if (!tree || !tree.root || id == null) return false;
      var cur = tree.byId[String(id)], hops = 0;
      while (cur && hops < 64) {
        if (cur === tree.root) return true;
        cur = parentOf(tree, cur);
        hops++;
      }
      return false;
    }
    function pathOf(tree, id) {
      var out = [], cur = tree.byId[String(id)], hops = 0;
      while (cur && hops < 64) {
        out.unshift(cur);
        if (cur === tree.root) break;
        cur = parentOf(tree, cur);
        hops++;
      }
      return out;
    }
    function browseParentFor(tree, id) {
      var f = tree.byId[String(id)];
      if (!f || f === tree.root) return tree.root.id;
      var p = parentOf(tree, f);
      return p ? p.id : tree.root.id;
    }
    function loggedIn(vm) {
      try {
        var a = vm && vm.authService;
        return !!(a && typeof a.isLoggedIn === "function" && a.isLoggedIn());
      } catch (e) {
        return false;
      }
    }
    function loadedDesign(vm) {
      try {
        var cd = vm && vm.customDesign, cs = customize();
        var id = cs && typeof cs.getCustomDesignId === "function" ? cs.getCustomDesignId() : null;
        if (cd && cd.id != null && id != null && String(cd.id) === String(id)) return cd;
      } catch (e) {
      }
      return null;
    }
    function borrowKbSaveVm(lockerVm, saveAsNew) {
      var dlg = svc("dialog");
      if (!dlg || typeof dlg.createDialog !== "function") return null;
      if (!lockerVm || typeof lockerVm.showSaveCustomDesignDialog !== "function") return null;
      var orig = dlg.createDialog, captured = null, promise = null;
      dlg.createDialog = function(opts) {
        captured = opts && opts.locals ? opts.locals.vm : null;
        return { close: function() {
        }, locals: opts && opts.locals, scope: null, controllerInstance: null, deferred: null };
      };
      try {
        promise = lockerVm.showSaveCustomDesignDialog(
          { preventDefault: function() {
          }, stopPropagation: function() {
          }, target: document.body },
          !!saveAsNew,
          {}
        );
      } catch (e) {
        captured = null;
      }
      dlg.createDialog = orig;
      if (!captured || typeof captured.create !== "function" || !captured.customDesign) return null;
      if (!promise || typeof promise.then !== "function") return null;
      return { vm: captured, promise };
    }
    function flashCapture() {
      var flash = svc("$flash"), orig = flash && flash.notify, got = [], live = false;
      if (!flash || typeof orig !== "function") return { start: function() {
      }, stop: function() {
        return got;
      } };
      return {
        start: function() {
          if (live) return;
          live = true;
          got = [];
          flash.notify = function(level, message) {
            if (live && (level === "success" || level === "error")) {
              got.push({ level, message: String(message == null ? "" : message) });
              return void 0;
            }
            return orig.apply(flash, arguments);
          };
        },
        stop: function() {
          if (live) {
            live = false;
            if (flash.notify !== orig) flash.notify = orig;
          }
          return got;
        }
      };
    }
    function kbErrorText(err, kbvm, got) {
      var parts = [];
      try {
        if (kbvm && kbvm.errors) parts.push(Array.isArray(kbvm.errors) ? kbvm.errors.join(", ") : String(kbvm.errors));
      } catch (e) {
      }
      try {
        if (err && err.data && Array.isArray(err.data.errors)) parts.push(err.data.errors.join(", "));
      } catch (e) {
      }
      try {
        for (var i = 0; i < (got || []).length; i++) {
          if (got[i].level === "error") parts.push(got[i].message.replace(/^Error (saving|creating folder)\.?\s*/i, ""));
        }
      } catch (e) {
      }
      try {
        if (err && err.status === 401) parts.push("You’ve been signed out — sign in and try again.");
      } catch (e) {
      }
      var seen = {}, uniq = [];
      for (var j = 0; j < parts.length; j++) {
        var p = clean(String(parts[j]).replace(/<[^>]+>/g, ""));
        if (p && !seen[p]) {
          seen[p] = 1;
          uniq.push(p);
        }
      }
      return uniq.join(" ");
    }
    function lockerUrl(folderId) {
      try {
        var uh = svc("UrlHelper");
        if (uh && typeof uh.lockerRoomUrl === "function") return String(uh.lockerRoomUrl(folderId) || "");
      } catch (e) {
      }
      return "";
    }
    function readCanvasNow() {
      try {
        var best = null, bestArea = 0;
        var list = document.querySelectorAll("canvas");
        for (var i = 0; i < list.length; i++) {
          var a = (list[i].width || 0) * (list[i].height || 0);
          if (a > bestArea && list[i].width > 200 && list[i].height > 200) {
            best = list[i];
            bestArea = a;
          }
        }
        if (!best) return null;
        var scale = Math.min(1, 1100 / Math.max(best.width, best.height));
        var w = Math.max(1, Math.round(best.width * scale));
        var h = Math.max(1, Math.round(best.height * scale));
        var oc = document.createElement("canvas");
        oc.width = w;
        oc.height = h;
        var ctx = oc.getContext("2d");
        ctx.fillStyle = PREVIEW_BG;
        ctx.fillRect(0, 0, w, h);
        ctx.drawImage(best, 0, 0, w, h);
        var dd = ctx.getImageData(0, 0, w, h).data;
        var r0 = dd[0], g0 = dd[1], b0 = dd[2];
        var minX = w, minY = h, maxX = -1, maxY = -1, step = 2;
        for (var y = 0; y < h; y += step) {
          for (var x = 0; x < w; x += step) {
            var di = (y * w + x) * 4;
            if (Math.abs(dd[di] - r0) + Math.abs(dd[di + 1] - g0) + Math.abs(dd[di + 2] - b0) > 28) {
              if (x < minX) minX = x;
              if (x > maxX) maxX = x;
              if (y < minY) minY = y;
              if (y > maxY) maxY = y;
            }
          }
        }
        if (maxX < 0 || maxX - minX < 40 || maxY - minY < 40) return null;
        var padX = Math.round((maxX - minX) * 0.1), padY = Math.round((maxY - minY) * 0.08);
        var cx = Math.max(0, minX - padX), cy = Math.max(0, minY - padY);
        var cw = Math.min(w - cx, maxX - minX + padX * 2);
        var ch = Math.min(h - cy, maxY - minY + padY * 2);
        var out = document.createElement("canvas");
        var outScale = Math.min(1, 900 / Math.max(cw, ch));
        out.width = Math.max(1, Math.round(cw * outScale));
        out.height = Math.max(1, Math.round(ch * outScale));
        var octx = out.getContext("2d");
        octx.fillStyle = PREVIEW_BG;
        octx.fillRect(0, 0, out.width, out.height);
        octx.drawImage(oc, cx, cy, cw, ch, 0, 0, out.width, out.height);
        var url = out.toDataURL("image/jpeg", 0.88);
        return url.length < 700 * 1024 ? url : null;
      } catch (e) {
        return null;
      }
    }
    function captureDesign(done) {
      var now = readCanvasNow();
      if (now) {
        done(now);
        return;
      }
      var raf = window.requestAnimationFrame;
      if (!raf) {
        done(null);
        return;
      }
      var finished = false, attempts = 0;
      function finish(url) {
        if (finished) return;
        finished = true;
        window.requestAnimationFrame = raf;
        done(url);
      }
      window.requestAnimationFrame = function(cb) {
        return raf.call(window, function(ts) {
          try {
            cb(ts);
          } catch (e) {
          }
          if (!finished && attempts < 8) {
            attempts++;
            var u = readCanvasNow();
            if (u) finish(u);
            else if (attempts >= 8) finish(null);
          }
        });
      };
      try {
        window.dispatchEvent(new Event("resize"));
        var sync = readCanvasNow();
        if (sync) {
          finish(sync);
          return;
        }
      } catch (e) {
      }
      setTimeout(function() {
        finish(null);
      }, 2500);
    }
    var captureInFlight = false;
    function stashPreview() {
      try {
        var st = window.__xeistBagSnapshot;
        if (st && st.dataUrl) return st.dataUrl;
      } catch (e) {
      }
      return null;
    }
    function previewSource(done) {
      var stash = stashPreview();
      if (stash) done(stash, "stash");
      if (captureInFlight) {
        if (!stash) done(null, "none");
        return;
      }
      captureInFlight = true;
      captureDesign(function(url) {
        captureInFlight = false;
        if (url) done(url, "live");
        else if (!stash) done(null, "none");
      });
    }
    function icon(paths, sw) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + (sw || 2) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + paths + "</svg>";
    }
    var I_FOLDER = icon('<path d="M3 7.5A2.5 2.5 0 0 1 5.5 5h4l2 2.5h7A2.5 2.5 0 0 1 21 10v7.5a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 17.5z"/>', 1.8);
    var I_DOWN = icon('<path d="m6 9 6 6 6-6"/>');
    var I_RIGHT = icon('<path d="m9 6 6 6-6 6"/>');
    var I_LEFT = icon('<path d="m15 6-6 6 6 6"/>');
    var I_ARROW = icon('<path d="M5 12h14M13 6l6 6-6 6"/>', 2.2);
    var I_CHECK = icon('<path d="m5 12 5 5L20 7"/>', 2.4);
    var I_PLUS = icon('<path d="M12 5v14M5 12h14"/>', 2.2);
    var I_CLOSE = icon('<path d="M18 6 6 18M6 6l12 12"/>', 2.2);
    var CSS = [
      "#xsd-root{position:fixed!important;inset:0!important;z-index:" + Z + "!important;display:flex!important;align-items:center!important;justify-content:center!important;padding:24px!important;box-sizing:border-box!important;font-family:" + FONT + "!important;opacity:0!important;transition:opacity .18s ease!important}",
      "#xsd-root.is-open{opacity:1!important}",
      "#xsd-root *{box-sizing:border-box!important;font-family:inherit!important;letter-spacing:normal!important;text-transform:none!important;-webkit-font-smoothing:antialiased!important}",
      "#xsd-root .xsd-backdrop{position:absolute!important;inset:0!important;background:rgba(17,17,20,.62)!important}",
      "#xsd-root .xsd-modal{position:relative!important;display:grid!important;grid-template-columns:48fr 52fr!important;grid-template-rows:minmax(0,1fr)!important;width:100%!important;max-width:952px!important;max-height:calc(100vh - 48px)!important;background:var(--xt-surface-1)!important;border-radius:24px!important;overflow:hidden!important;box-shadow:0 30px 90px rgba(0,0,0,.35)!important;color:var(--xt-ink-1)!important;transform:translateY(8px) scale(.985)!important;transition:transform .2s ease!important;outline:none!important;margin:0!important;text-align:left!important}",
      "#xsd-root.is-open .xsd-modal{transform:none!important}",
      /* left: the product being saved */
      "#xsd-root .xsd-preview{display:flex!important;flex-direction:column!important;min-height:0!important;background:" + PREVIEW_BG + "!important;padding:36px 30px 30px!important;margin:0!important}",
      "#xsd-root .xsd-preview__stage{flex:1 1 auto!important;min-height:260px!important;display:flex!important;align-items:center!important;justify-content:center!important;position:relative!important}",
      "#xsd-root .xsd-preview__img{display:block!important;max-width:82%!important;max-height:100%!important;width:auto!important;height:auto!important;object-fit:contain!important;margin:0!important;border:0!important}",
      "#xsd-root .xsd-preview__skeleton{width:56%!important;aspect-ratio:3/4!important;max-height:88%!important;border-radius:22px!important;background:linear-gradient(100deg,#ecece9 30%,#f3f3f0 50%,#ecece9 70%)!important;background-size:200% 100%!important;animation:xsd-shimmer 1.4s ease-in-out infinite!important}",
      "#xsd-root .xsd-preview__fallback{display:flex!important;flex-direction:column!important;align-items:center!important;justify-content:center!important;gap:8px!important;width:56%!important;aspect-ratio:3/4!important;max-height:88%!important;border-radius:22px!important;border:1px dashed var(--xt-line)!important;color:var(--xt-ink-3)!important;font-size:13px!important;text-align:center!important;padding:16px!important}",
      "#xsd-root .xsd-preview__fallback svg{width:26px!important;height:26px!important}",
      "#xsd-root .xsd-preview__caption{text-align:center!important;padding:18px 0 0!important;flex:0 0 auto!important}",
      "#xsd-root .xsd-preview__name{font-size:15px!important;font-weight:700!important;color:var(--xt-ink-1)!important;line-height:1.3!important;margin:0!important}",
      "#xsd-root .xsd-preview__sub{margin:5px 0 0!important;font-size:11.5px!important;font-weight:600!important;letter-spacing:.12em!important;text-transform:uppercase!important;color:var(--xt-ink-3)!important;line-height:1.3!important}",
      /* right: the form */
      "#xsd-root .xsd-panel{position:relative!important;min-height:0!important;overflow-y:auto!important;overflow-x:hidden!important;padding:52px 40px 44px!important;background:var(--xt-surface-1)!important;-webkit-overflow-scrolling:touch!important;margin:0!important}",
      "#xsd-root .xsd-close{position:absolute!important;top:18px!important;right:18px!important;width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;border:0!important;border-radius:12px!important;background:transparent!important;color:var(--xt-ink-1)!important;display:flex!important;align-items:center!important;justify-content:center!important;cursor:pointer!important;padding:0!important;margin:0!important;transition:background .15s!important;z-index:2!important}",
      "#xsd-root .xsd-close:hover{background:var(--xt-surface-3)!important}",
      "#xsd-root .xsd-close:focus-visible{outline:none!important;box-shadow:0 0 0 2px var(--xt-focus)!important}",
      '#xsd-root .xsd-close[aria-disabled="true"]{opacity:.35!important;cursor:default!important}',
      "#xsd-root .xsd-close svg{width:18px!important;height:18px!important}",
      "#xsd-root .xsd-eyebrow{font-size:12.5px!important;font-weight:600!important;letter-spacing:.16em!important;text-transform:uppercase!important;color:var(--xt-ink-2)!important;margin:0 0 14px!important;line-height:1!important;padding-right:44px!important}",
      "#xsd-root .xsd-title{font-size:38px!important;font-weight:700!important;letter-spacing:-.025em!important;line-height:1.1!important;color:var(--xt-ink-1)!important;margin:0 0 10px!important;padding:0 44px 0 0!important}",
      "#xsd-root .xsd-sub{font-size:18.5px!important;font-weight:400!important;color:var(--xt-ink-2)!important;margin:0 0 40px!important;line-height:1.4!important;padding:0!important}",
      "#xsd-root .xsd-block{margin:0 0 38px!important}",
      "#xsd-root .xsd-label{display:block!important;font-size:16px!important;font-weight:500!important;color:var(--xt-ink-1)!important;margin:0 0 12px!important;line-height:1.2!important}",
      "#xsd-root .xsd-field{position:relative!important}",
      "#xsd-root .xsd-input{display:block!important;width:100%!important;height:58px!important;border:1px solid var(--xt-btn2-border)!important;border-radius:14px!important;background:var(--xt-field-bg)!important;color:var(--xt-ink-1)!important;font-size:17.5px!important;font-weight:500!important;padding:0 92px 0 18px!important;margin:0!important;outline:none!important;box-shadow:none!important;-webkit-appearance:none!important;appearance:none!important;transition:border-color .15s,box-shadow .15s!important;line-height:normal!important}",
      "#xsd-root .xsd-input::placeholder{color:var(--xt-ink-3)!important;opacity:1!important}",
      "#xsd-root .xsd-input:focus{border-color:var(--xt-focus)!important;box-shadow:0 0 0 3px rgba(17,17,17,.08)!important}",
      "#xsd-root .xsd-input[disabled]{opacity:.6!important}",
      "#xsd-root .xsd-input.is-invalid{border-color:#c0392b!important}",
      "#xsd-root .xsd-count{position:absolute!important;right:18px!important;top:50%!important;transform:translateY(-50%)!important;font-size:14px!important;color:var(--xt-ink-3)!important;font-variant-numeric:tabular-nums!important;pointer-events:none!important;line-height:1!important}",
      "#xsd-root .xsd-error{font-size:13.5px!important;color:#b42318!important;margin:8px 0 0!important;line-height:1.4!important}",
      "#xsd-root .xsd-static{display:flex!important;align-items:center!important;gap:14px!important;width:100%!important;min-height:58px!important;border:1px solid var(--xt-line)!important;border-radius:14px!important;background:var(--xt-surface-2)!important;color:var(--xt-ink-1)!important;padding:14px 18px!important;margin:0!important;font-size:17px!important;font-weight:600!important;line-height:1.3!important;word-break:break-word!important}",
      "#xsd-root .xsd-static svg{flex:0 0 auto!important;width:22px!important;height:22px!important}",
      "#xsd-root .xsd-select{display:flex!important;align-items:center!important;gap:14px!important;width:100%!important;height:58px!important;border:1px solid var(--xt-btn2-border)!important;border-radius:14px!important;background:var(--xt-field-bg)!important;color:var(--xt-ink-1)!important;padding:0 18px!important;margin:0!important;cursor:pointer!important;text-align:left!important;font-size:17px!important;font-weight:600!important;transition:border-color .15s,box-shadow .15s!important}",
      "#xsd-root .xsd-select:hover{border-color:var(--xt-btn2-border-hover)!important}",
      "#xsd-root .xsd-select:focus-visible{outline:none!important;border-color:var(--xt-focus)!important;box-shadow:0 0 0 3px rgba(17,17,17,.08)!important}",
      "#xsd-root .xsd-select[disabled]{opacity:.6!important;cursor:default!important}",
      "#xsd-root .xsd-select.is-invalid{border-color:#c0392b!important}",
      "#xsd-root .xsd-select__ic{flex:0 0 auto!important;width:22px!important;height:22px!important}",
      "#xsd-root .xsd-select__name{flex:1 1 auto!important;min-width:0!important;overflow:hidden!important;text-overflow:ellipsis!important;white-space:nowrap!important}",
      "#xsd-root .xsd-select__in{font-weight:400!important;color:var(--xt-ink-2)!important;font-size:14.5px!important;margin-left:8px!important}",
      "#xsd-root .xsd-select__chev{flex:0 0 auto!important;width:18px!important;height:18px!important;transition:transform .15s!important}",
      '#xsd-root .xsd-select[aria-expanded="true"] .xsd-select__chev{transform:rotate(180deg)!important}',
      /* inline folder picker */
      "#xsd-root .xsd-picker{margin:10px 0 0!important;border:1px solid var(--xt-line)!important;border-radius:14px!important;overflow:hidden!important;background:var(--xt-surface-1)!important}",
      "#xsd-root .xsd-picker__head{display:flex!important;align-items:center!important;gap:8px!important;padding:8px 10px 8px 12px!important;background:var(--xt-surface-2)!important;border-bottom:1px solid var(--xt-line)!important;min-height:48px!important}",
      "#xsd-root .xsd-picker__back{width:34px!important;height:34px!important;min-width:34px!important;border:0!important;border-radius:9px!important;background:transparent!important;color:var(--xt-ink-1)!important;cursor:pointer!important;display:flex!important;align-items:center!important;justify-content:center!important;padding:0!important;margin:0 2px 0 -4px!important}",
      "#xsd-root .xsd-picker__back:hover{background:var(--xt-surface-3)!important}",
      "#xsd-root .xsd-picker__back svg{width:18px!important;height:18px!important}",
      "#xsd-root .xsd-picker__crumbs{flex:1 1 auto!important;min-width:0!important;font-size:13.5px!important;color:var(--xt-ink-2)!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}",
      "#xsd-root .xsd-picker__crumbs b{color:var(--xt-ink-1)!important;font-weight:600!important}",
      "#xsd-root .xsd-crumb-sep{margin:0 6px!important;color:var(--xt-ink-3)!important}",
      "#xsd-root .xsd-picker__use{flex:0 0 auto!important;height:32px!important;border:1px solid var(--xt-btn2-border)!important;border-radius:9px!important;background:var(--xt-surface-1)!important;color:var(--xt-ink-1)!important;font-size:13px!important;font-weight:600!important;padding:0 12px!important;cursor:pointer!important;margin:0!important;white-space:nowrap!important}",
      "#xsd-root .xsd-picker__use:hover{border-color:var(--xt-btn2-border-hover)!important}",
      "#xsd-root .xsd-picker__here{flex:0 0 auto!important;font-size:13px!important;font-weight:600!important;color:var(--xt-good)!important;display:inline-flex!important;align-items:center!important;gap:5px!important;white-space:nowrap!important}",
      "#xsd-root .xsd-picker__here svg{width:15px!important;height:15px!important}",
      "#xsd-root .xsd-picker__list{max-height:236px!important;overflow-y:auto!important}",
      "#xsd-root .xsd-row{display:flex!important;align-items:center!important;gap:2px!important;padding:2px 6px!important;border-top:1px solid var(--xt-line-soft)!important}",
      "#xsd-root .xsd-row:first-child{border-top:0!important}",
      "#xsd-root .xsd-row__pick{flex:1 1 auto!important;min-width:0!important;display:flex!important;align-items:center!important;gap:12px!important;height:46px!important;border:0!important;border-radius:10px!important;background:transparent!important;color:var(--xt-ink-1)!important;font-size:15.5px!important;font-weight:500!important;padding:0 10px!important;margin:0!important;cursor:pointer!important;text-align:left!important}",
      "#xsd-root .xsd-row__pick:hover{background:var(--xt-surface-3)!important}",
      "#xsd-root .xsd-row__pick:focus-visible,#xsd-root .xsd-row__open:focus-visible,#xsd-root .xsd-picker__back:focus-visible,#xsd-root .xsd-picker__use:focus-visible{outline:none!important;box-shadow:0 0 0 2px var(--xt-focus)!important}",
      "#xsd-root .xsd-row__pick svg{flex:0 0 auto!important;width:20px!important;height:20px!important}",
      "#xsd-root .xsd-row__name{flex:1 1 auto!important;min-width:0!important;overflow:hidden!important;text-overflow:ellipsis!important;white-space:nowrap!important}",
      "#xsd-root .xsd-row.is-selected .xsd-row__pick{font-weight:600!important}",
      "#xsd-root .xsd-row__check{color:var(--xt-good)!important}",
      "#xsd-root .xsd-row__open{flex:0 0 auto!important;width:44px!important;height:44px!important;min-width:44px!important;border:0!important;border-radius:10px!important;background:transparent!important;color:var(--xt-ink-2)!important;cursor:pointer!important;display:flex!important;align-items:center!important;justify-content:center!important;padding:0!important;margin:0!important}",
      "#xsd-root .xsd-row__open:hover{background:var(--xt-surface-3)!important;color:var(--xt-ink-1)!important}",
      "#xsd-root .xsd-row__open svg{width:18px!important;height:18px!important}",
      "#xsd-root .xsd-picker__empty{padding:16px 14px!important;font-size:14px!important;color:var(--xt-ink-2)!important;line-height:1.4!important}",
      /* create-folder */
      "#xsd-root .xsd-ghost{display:flex!important;align-items:center!important;justify-content:center!important;gap:8px!important;width:100%!important;height:48px!important;margin:14px 0 0!important;border:0!important;border-radius:12px!important;background:var(--xt-surface-3)!important;color:var(--xt-ink-1)!important;font-size:15px!important;font-weight:600!important;cursor:pointer!important;padding:0 16px!important;transition:background .15s!important}",
      "#xsd-root .xsd-ghost:hover{background:var(--xt-line)!important}",
      "#xsd-root .xsd-ghost:focus-visible{outline:none!important;box-shadow:0 0 0 2px var(--xt-focus)!important}",
      "#xsd-root .xsd-ghost[disabled]{opacity:.6!important;cursor:default!important}",
      "#xsd-root .xsd-ghost svg{width:16px!important;height:16px!important}",
      "#xsd-root .xsd-newfolder{margin:14px 0 0!important;padding:18px 18px 16px!important;border:1px solid var(--xt-line)!important;border-radius:14px!important;background:var(--xt-surface-2)!important}",
      "#xsd-root .xsd-label--sm{font-size:14.5px!important;margin-bottom:8px!important}",
      "#xsd-root .xsd-input--sm{height:50px!important;font-size:16px!important;padding:0 16px!important}",
      "#xsd-root .xsd-newfolder__in{margin:10px 0 0!important;font-size:13.5px!important;color:var(--xt-ink-2)!important}",
      "#xsd-root .xsd-newfolder__in b{color:var(--xt-ink-1)!important;font-weight:600!important}",
      "#xsd-root .xsd-newfolder__actions{display:flex!important;justify-content:flex-end!important;gap:10px!important;margin:14px 0 0!important}",
      "#xsd-root .xsd-btn{height:44px!important;min-width:44px!important;border-radius:11px!important;padding:0 16px!important;font-size:14.5px!important;font-weight:600!important;cursor:pointer!important;margin:0!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:8px!important}",
      "#xsd-root .xsd-btn:focus-visible{outline:none!important;box-shadow:0 0 0 2px var(--xt-focus)!important}",
      "#xsd-root .xsd-btn--ghost{border:1px solid var(--xt-btn2-border)!important;background:var(--xt-surface-1)!important;color:var(--xt-ink-1)!important}",
      "#xsd-root .xsd-btn--dark{border:0!important;background:var(--xt-btn-bg)!important;color:var(--xt-btn-fg)!important}",
      "#xsd-root .xsd-btn[disabled]{opacity:.55!important;cursor:default!important}",
      "#xsd-root .xsd-btn .xsd-spin{width:16px!important;height:16px!important;border-width:2px!important}",
      /* inline error + retry */
      "#xsd-root .xsd-alert{display:flex!important;align-items:flex-start!important;gap:12px!important;margin:24px 0 -10px!important;padding:12px 14px!important;border:1px solid #f0c9c4!important;border-radius:12px!important;background:#fdf3f2!important;color:#7a271a!important;font-size:14px!important;line-height:1.45!important}",
      "#xsd-root .xsd-alert__msg{flex:1 1 auto!important;padding-top:6px!important}",
      "#xsd-root .xsd-alert__retry{flex:0 0 auto!important;height:36px!important;border:1px solid #e9b8b1!important;border-radius:9px!important;background:#fff!important;color:#7a271a!important;font-size:13.5px!important;font-weight:600!important;padding:0 12px!important;cursor:pointer!important;margin:0!important;white-space:nowrap!important}",
      /* primary */
      "#xsd-root .xsd-save{display:flex!important;align-items:center!important;justify-content:center!important;gap:12px!important;width:100%!important;height:66px!important;margin:38px 0 0!important;border:0!important;border-radius:16px!important;background:var(--xt-btn-bg)!important;color:var(--xt-btn-fg)!important;font-size:19.5px!important;font-weight:600!important;cursor:pointer!important;padding:0 20px!important;transition:background .15s,transform .12s!important;line-height:1!important}",
      "#xsd-root .xsd-save:hover:not([disabled]){background:var(--xt-btn-bg-hover)!important}",
      "#xsd-root .xsd-save:active:not([disabled]){transform:scale(.99)!important}",
      "#xsd-root .xsd-save:focus-visible{outline:none!important;box-shadow:0 0 0 3px #fff,0 0 0 5px var(--xt-focus)!important}",
      "#xsd-root .xsd-save[disabled]{cursor:default!important;opacity:.85!important}",
      "#xsd-root .xsd-save.is-saved{background:var(--xt-good)!important;opacity:1!important}",
      "#xsd-root .xsd-save svg{width:22px!important;height:22px!important;flex:0 0 auto!important}",
      "#xsd-root .xsd-spin{display:inline-block!important;width:20px!important;height:20px!important;border-radius:50%!important;border:2.5px solid rgba(255,255,255,.35)!important;border-top-color:#fff!important;animation:xsd-spin .8s linear infinite!important;flex:0 0 auto!important}",
      "#xsd-root .xsd-help{margin:22px 0 0!important;text-align:center!important;font-size:14px!important;color:var(--xt-ink-2)!important;line-height:1.4!important;padding:0!important}",
      "#xsd-root .xsd-slow{margin:10px 0 0!important;text-align:center!important;font-size:13px!important;color:var(--xt-ink-2)!important;line-height:1.5!important}",
      "#xsd-root .xsd-slow__bg{border:0!important;background:transparent!important;color:var(--xt-ink-1)!important;font-size:13px!important;font-weight:600!important;text-decoration:underline!important;text-underline-offset:3px!important;cursor:pointer!important;padding:4px 6px!important;min-height:32px!important;margin:0!important}",
      "#xsd-root .xsd-slow__bg:focus-visible{outline:none!important;box-shadow:0 0 0 2px var(--xt-focus)!important;border-radius:6px!important}",
      "#xsd-root .xsd-alt{display:block!important;margin:6px auto 0!important;min-height:44px!important;border:0!important;background:transparent!important;color:var(--xt-ink-1)!important;font-size:14px!important;font-weight:500!important;text-decoration:underline!important;text-underline-offset:3px!important;cursor:pointer!important;padding:6px 10px!important}",
      "#xsd-root .xsd-alt:focus-visible{outline:none!important;box-shadow:0 0 0 2px var(--xt-focus)!important;border-radius:8px!important}",
      "#xsd-root .xsd-live{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;white-space:nowrap!important;margin:-1px!important}",
      /* confirmation toast (lives outside #xsd-root: the modal is gone by then) */
      "#xsd-toast{position:fixed!important;right:26px!important;bottom:26px!important;z-index:" + (Z + 1) + "!important;display:flex!important;align-items:center!important;gap:14px!important;max-width:min(460px,calc(100vw - 32px))!important;padding:14px 18px!important;border-radius:14px!important;background:var(--xt-toast-bg)!important;color:var(--xt-toast-fg)!important;font-family:" + FONT + "!important;font-size:14.5px!important;font-weight:500!important;line-height:1.4!important;box-shadow:var(--xt-shadow-modal)!important;opacity:0!important;transform:translateY(8px)!important;transition:opacity .2s,transform .2s!important;box-sizing:border-box!important;letter-spacing:normal!important;text-transform:none!important}",
      "#xsd-toast.is-on{opacity:1!important;transform:none!important}",
      "#xsd-toast svg{width:20px!important;height:20px!important;flex:0 0 auto!important;color:#8ce0a4!important}",
      "#xsd-toast.is-error svg{color:#ffb4a8!important}",
      "#xsd-toast .xsd-spin--toast{display:inline-block!important;width:18px!important;height:18px!important;border-radius:50%!important;border:2.5px solid rgba(255,255,255,.3)!important;border-top-color:#fff!important;animation:xsd-spin .8s linear infinite!important;flex:0 0 auto!important}",
      "#xsd-toast a{color:#fff!important;text-decoration:underline!important;text-underline-offset:3px!important;font-weight:600!important;white-space:nowrap!important;font-family:inherit!important}",
      "#xsd-toast a:focus-visible{outline:2px solid #fff!important;outline-offset:2px!important}",
      "html.xsd-lock,html.xsd-lock body{overflow:hidden!important}",
      /* phone / narrow: single-column sheet */
      "@media (max-width:" + MOBILE_BP + "px){",
      "#xsd-root{align-items:flex-end!important;padding:0!important}",
      "#xsd-root .xsd-modal{grid-template-columns:1fr!important;grid-template-rows:auto minmax(0,1fr)!important;max-width:none!important;max-height:calc(100vh - 16px)!important;max-height:calc(100dvh - 16px)!important;border-radius:24px 24px 0 0!important;transform:translateY(24px)!important;box-shadow:0 -20px 60px rgba(0,0,0,.3)!important}",
      "#xsd-root.is-open .xsd-modal{transform:none!important}",
      "#xsd-root .xsd-preview{flex-direction:row!important;align-items:center!important;gap:16px!important;padding:22px 20px 0!important;background:var(--xt-surface-1)!important}",
      "#xsd-root .xsd-preview__stage{flex:0 0 auto!important;width:104px!important;height:104px!important;min-height:0!important;border-radius:18px!important;background:" + PREVIEW_BG + "!important;overflow:hidden!important}",
      "#xsd-root .xsd-preview__img{max-width:86%!important;max-height:86%!important}",
      "#xsd-root .xsd-preview__skeleton,#xsd-root .xsd-preview__fallback{width:64%!important;border-radius:12px!important;font-size:0!important;gap:0!important;padding:0!important}",
      "#xsd-root .xsd-preview__fallback svg{width:22px!important;height:22px!important}",
      "#xsd-root .xsd-preview__caption{text-align:left!important;padding:0 48px 0 0!important;min-width:0!important}",
      "#xsd-root .xsd-panel{padding:18px 22px calc(22px + env(safe-area-inset-bottom))!important}",
      "#xsd-root .xsd-close{top:14px!important;right:12px!important}",
      "#xsd-root .xsd-eyebrow{margin-bottom:10px!important}",
      "#xsd-root .xsd-title{font-size:29px!important}",
      "#xsd-root .xsd-sub{font-size:15.5px!important;margin-bottom:24px!important}",
      "#xsd-root .xsd-label{font-size:15px!important;margin-bottom:10px!important}",
      "#xsd-root .xsd-input,#xsd-root .xsd-select{height:54px!important;font-size:16px!important}",
      "#xsd-root .xsd-static{min-height:54px!important;font-size:16px!important}",
      "#xsd-root .xsd-block{margin-bottom:24px!important}",
      "#xsd-root .xsd-save{height:60px!important;font-size:18px!important;margin-top:26px!important}",
      "#xsd-root .xsd-alert{margin:18px 0 -6px!important}",
      "#xsd-toast{left:16px!important;right:16px!important;bottom:calc(16px + env(safe-area-inset-bottom))!important;max-width:none!important}",
      "}",
      /* short desktop viewports: tighten, never clip (the panel scrolls) */
      "@media (min-width:" + (MOBILE_BP + 1) + "px) and (max-height:720px){",
      "#xsd-root .xsd-panel{padding:34px 36px 32px!important}",
      "#xsd-root .xsd-title{font-size:34px!important}",
      "#xsd-root .xsd-sub{margin-bottom:24px!important}",
      "#xsd-root .xsd-block{margin-bottom:24px!important}",
      "#xsd-root .xsd-save{margin-top:24px!important}",
      "#xsd-root .xsd-preview__stage{min-height:180px!important}",
      "}",
      "@media (prefers-reduced-motion:reduce){",
      "#xsd-root,#xsd-root .xsd-modal,#xsd-toast,#xsd-root .xsd-select__chev,#xsd-root .xsd-close,#xsd-root .xsd-save{transition:none!important}",
      "#xsd-root .xsd-preview__skeleton{animation:none!important}",
      "}",
      "#xsd-root [hidden]{display:none!important}",
      "@keyframes xsd-spin{to{transform:rotate(360deg)}}",
      "@keyframes xsd-shimmer{0%{background-position:100% 0}100%{background-position:-100% 0}}"
    ].join("\n");
    function injectCSS() {
      if (document.getElementById("xsd-style")) return;
      var s = document.createElement("style");
      s.id = "xsd-style";
      s.appendChild(document.createTextNode(CSS));
      document.head.appendChild(s);
    }
    var state = null;
    var draft = { designId: "", name: null, folderId: null };
    function announce(text) {
      if (!state) return;
      var live = $("#xsd-live", state.root);
      if (!live) return;
      live.textContent = "";
      setTimeout(function() {
        if (live) live.textContent = text;
      }, 30);
    }
    function lockScroll(on) {
      try {
        document.documentElement.classList[on ? "add" : "remove"]("xsd-lock");
      } catch (e) {
      }
    }
    function tapRouting(restore) {
      try {
        var fn = window.__xeistToolsTapRouting;
        if (typeof fn !== "function") return;
        if (!restore) {
          fn(false);
          return;
        }
        var tools = document.getElementById("xeist-logo-tools");
        if (tools && tools.style.display !== "none" && tools.getClientRects().length > 0) fn(true);
      } catch (e) {
      }
    }
    function shellHTML(m) {
      var pname = esc(m.productName || "Your design");
      return '<div class="xsd-backdrop" data-close="1"></div><div class="xsd-modal" role="dialog" aria-modal="true" aria-labelledby="xsd-title" aria-describedby="xsd-sub" tabindex="-1"><section class="xsd-preview" aria-label="Design preview"><div class="xsd-preview__stage"><div class="xsd-preview__skeleton" id="xsd-skel" aria-hidden="true"></div><img class="xsd-preview__img" id="xsd-img" alt="Your ' + pname + ' design as it looks right now" hidden><div class="xsd-preview__fallback" id="xsd-nopreview" hidden>' + I_FOLDER + '<span>Preview unavailable — your design still saves in full.</span></div></div><div class="xsd-preview__caption"><div class="xsd-preview__name">' + pname + "</div>" + (m.descriptor ? '<div class="xsd-preview__sub">' + esc(m.descriptor) + "</div>" : "") + '</div></section><button type="button" class="xsd-close" id="xsd-close" aria-label="Close" data-close="1">' + I_CLOSE + '</button><section class="xsd-panel"><div class="xsd-eyebrow">Save design</div><h2 class="xsd-title" id="xsd-title">Save your design</h2><p class="xsd-sub" id="xsd-sub">Keep it for later. Make changes anytime.</p><form class="xsd-form" id="xsd-form" novalidate><div class="xsd-block"><label class="xsd-label" for="xsd-name" id="xsd-name-label">Design name</label><div class="xsd-field" id="xsd-name-field"><input id="xsd-name" class="xsd-input" type="text" maxlength="' + NAME_MAX + '" autocomplete="off" autocapitalize="words" spellcheck="false" aria-describedby="xsd-count xsd-name-err"><span class="xsd-count" id="xsd-count" aria-hidden="true"></span></div><div class="xsd-static" id="xsd-name-static" hidden></div><div class="xsd-error" id="xsd-name-err" hidden></div></div><div class="xsd-block"><label class="xsd-label" id="xsd-dest-label" for="xsd-select">Save to</label><button type="button" class="xsd-select" id="xsd-select" aria-expanded="false" aria-controls="xsd-picker" aria-describedby="xsd-dest-err"><span class="xsd-select__ic">' + I_FOLDER + '</span><span class="xsd-select__name" id="xsd-select-name">Loading folders…</span><span class="xsd-select__chev">' + I_DOWN + '</span></button><div class="xsd-static" id="xsd-dest-static" hidden></div><div class="xsd-picker" id="xsd-picker" hidden></div><div class="xsd-error" id="xsd-dest-err" hidden></div><button type="button" class="xsd-ghost" id="xsd-newfolder-btn">' + I_PLUS + '<span>Create new folder</span></button><div class="xsd-newfolder" id="xsd-newfolder" hidden><label class="xsd-label xsd-label--sm" for="xsd-folder-name">New folder name</label><input id="xsd-folder-name" class="xsd-input xsd-input--sm" type="text" maxlength="' + FOLDER_MAX + '" placeholder="Enter folder name" autocomplete="off" autocapitalize="words" aria-describedby="xsd-folder-in xsd-folder-err"><div class="xsd-newfolder__in" id="xsd-folder-in">Create in: <b id="xsd-folder-parent"></b></div><div class="xsd-error" id="xsd-folder-err" hidden></div><div class="xsd-newfolder__actions"><button type="button" class="xsd-btn xsd-btn--ghost" id="xsd-folder-cancel">Cancel</button><button type="button" class="xsd-btn xsd-btn--dark" id="xsd-folder-create"><span>Create folder</span></button></div></div></div><div class="xsd-alert" id="xsd-alert" role="alert" hidden><div class="xsd-alert__msg" id="xsd-alert-msg"></div><button type="button" class="xsd-alert__retry" id="xsd-retry">Try again</button></div><button type="submit" class="xsd-save" id="xsd-save"><span id="xsd-save-label">Save design</span><span id="xsd-save-icon">' + I_ARROW + '</span></button><p class="xsd-slow" id="xsd-slow" hidden><span>Still saving — this can take a moment.</span> <button type="button" class="xsd-slow__bg" id="xsd-bg">Continue editing while it finishes</button></p><p class="xsd-help" id="xsd-help">You can return to this design and keep editing.</p><button type="button" class="xsd-alt" id="xsd-alt" hidden></button></form><div class="xsd-live" id="xsd-live" aria-live="polite" aria-atomic="true"></div></section></div>';
    }
    function el(id) {
      return state ? $("#" + id, state.root) : null;
    }
    function show(id, on) {
      var n = el(id);
      if (n) n.hidden = !on;
    }
    function setText(id, text) {
      var n = el(id);
      if (n) n.textContent = text;
    }
    function setFieldError(which, msg) {
      var errId = which === "name" ? "xsd-name-err" : which === "dest" ? "xsd-dest-err" : "xsd-folder-err";
      var ctlId = which === "name" ? "xsd-name" : which === "dest" ? "xsd-select" : "xsd-folder-name";
      var e = el(errId), c = el(ctlId);
      if (e) {
        e.textContent = msg || "";
        e.hidden = !msg;
      }
      if (c) {
        c.classList[msg ? "add" : "remove"]("is-invalid");
        if (msg) c.setAttribute("aria-invalid", "true");
        else c.removeAttribute("aria-invalid");
      }
    }
    function showAlert(msg) {
      var a = el("xsd-alert");
      if (!a) return;
      setText("xsd-alert-msg", msg || "");
      a.hidden = !msg;
      if (msg) {
        announce(msg);
        var r = el("xsd-retry");
        if (r) setTimeout(function() {
          try {
            r.focus();
          } catch (e) {
          }
        }, 30);
      }
    }
    function friendlyError(detail) {
      return "Couldn’t save your design." + (detail ? " " + detail : " Check your connection and try again.");
    }
    function updateCounter() {
      var inp = el("xsd-name"), c = el("xsd-count");
      if (inp && c) c.textContent = String((inp.value || "").length) + "/" + NAME_MAX;
    }
    function selectedFolder() {
      return state && state.tree && state.folderId != null ? state.tree.byId[String(state.folderId)] : null;
    }
    function applyMode() {
      var upd = state.mode === "update";
      var saved = state.saved;
      show("xsd-name-field", !upd);
      show("xsd-name-static", upd);
      show("xsd-select", !upd);
      show("xsd-dest-static", upd);
      show("xsd-newfolder-btn", !upd && !state.newFolderOpen);
      if (upd) {
        var st = el("xsd-name-static");
        if (st) st.textContent = clean(saved && saved.name) || "Untitled design";
        var ds = el("xsd-dest-static");
        if (ds) {
          var f = state.tree && saved && saved.folderId != null ? state.tree.byId[String(saved.folderId)] : null;
          ds.innerHTML = I_FOLDER + "<span>" + esc(f ? folderLabel(f) : state.folderStatus === "loading" ? "Loading…" : "Locker Room") + "</span>";
        }
        state.pickerOpen = false;
        state.newFolderOpen = false;
        show("xsd-picker", false);
        show("xsd-newfolder", false);
        var lbl = el("xsd-dest-label");
        if (lbl) {
          lbl.textContent = "Saved in";
          lbl.removeAttribute("for");
        }
        setText("xsd-help", "This updates the saved version of “" + (clean(saved && saved.name) || "this design") + "”.");
      } else {
        var lbl2 = el("xsd-dest-label");
        if (lbl2) {
          lbl2.textContent = "Save to";
          lbl2.setAttribute("for", "xsd-select");
        }
        setText("xsd-help", "You can return to this design and keep editing.");
      }
      var alt = el("xsd-alt");
      if (alt) {
        if (state.canUpdate) {
          alt.hidden = false;
          alt.textContent = upd ? "Save as a new design instead" : "Update “" + (clean(saved && saved.name) || "the saved design") + "” instead";
        } else alt.hidden = true;
      }
      if (!state.saving) setText("xsd-save-label", upd ? "Update design" : "Save design");
      setFieldError("name", "");
      setFieldError("dest", "");
      showAlert("");
    }
    function renderDest() {
      if (!state) return;
      var nameEl = el("xsd-select-name"), sel = el("xsd-select");
      if (!nameEl) return;
      if (state.folderStatus === "loading") {
        nameEl.textContent = "Loading folders…";
      } else if (state.folderStatus === "error" || !state.tree) {
        nameEl.textContent = "Folders unavailable — tap to retry";
      } else {
        var f = selectedFolder() || state.tree.root;
        var p = parentOf(state.tree, f);
        nameEl.innerHTML = esc(folderLabel(f)) + (p && f !== state.tree.root ? '<span class="xsd-select__in">in ' + esc(folderLabel(p)) + "</span>" : "");
      }
      if (sel) sel.setAttribute("aria-expanded", state.pickerOpen ? "true" : "false");
      var parent = el("xsd-folder-parent");
      if (parent) parent.textContent = folderLabel(selectedFolder() || state.tree && state.tree.root) || ROOT_SYSTEM_NAME;
      renderPicker();
      if (state.mode === "update") applyMode();
    }
    function renderPicker() {
      var box = el("xsd-picker");
      if (!box) return;
      if (!state.pickerOpen || !state.tree || !state.tree.root) {
        box.hidden = true;
        box.innerHTML = "";
        return;
      }
      var tree = state.tree;
      var cur = tree.byId[String(state.browseId)] || tree.root;
      if (!inSavedTree(tree, cur.id)) cur = tree.root;
      var path = pathOf(tree, cur.id);
      var crumbs = [];
      for (var i = 0; i < path.length; i++) {
        crumbs.push(i === path.length - 1 ? "<b>" + esc(folderLabel(path[i])) + "</b>" : esc(folderLabel(path[i])));
      }
      var here = String(cur.id) === String(state.folderId);
      var up = parentOf(tree, cur);
      var head = '<div class="xsd-picker__head">' + (cur !== tree.root && up ? '<button type="button" class="xsd-picker__back" data-open="' + esc(up.id) + '" aria-label="Back to ' + esc(folderLabel(up)) + '">' + I_LEFT + "</button>" : "") + '<div class="xsd-picker__crumbs" aria-label="Current folder">' + crumbs.join('<span class="xsd-crumb-sep" aria-hidden="true">›</span>') + "</div>" + (here ? '<span class="xsd-picker__here">' + I_CHECK + "Selected</span>" : '<button type="button" class="xsd-picker__use" data-pick="' + esc(cur.id) + '">Save here</button>') + "</div>";
      var kids = childrenOf(tree, cur.id), rows = [];
      for (var k = 0; k < kids.length; k++) {
        var f = kids[k], sel = String(f.id) === String(state.folderId);
        var n = childrenOf(tree, f.id).length;
        rows.push('<div class="xsd-row' + (sel ? " is-selected" : "") + '"><button type="button" class="xsd-row__pick" data-pick="' + esc(f.id) + '" aria-pressed="' + (sel ? "true" : "false") + '">' + I_FOLDER + '<span class="xsd-row__name">' + esc(folderLabel(f)) + "</span>" + (sel ? '<span class="xsd-row__check">' + I_CHECK + "</span>" : "") + '</button><button type="button" class="xsd-row__open" data-open="' + esc(f.id) + '" aria-label="Open ' + esc(folderLabel(f)) + (n ? " (" + n + (n === 1 ? " folder" : " folders") + " inside)" : " (no folders inside)") + '">' + I_RIGHT + "</button></div>");
      }
      var list = '<div class="xsd-picker__list" role="group" aria-label="Folders in ' + esc(folderLabel(cur)) + '">' + (rows.length ? rows.join("") : '<div class="xsd-picker__empty">No folders inside “' + esc(folderLabel(cur)) + "” yet. Use “Create new folder” below to add one.</div>") + "</div>";
      box.innerHTML = head + list;
      box.hidden = false;
    }
    function setPreview(url, how) {
      if (!state) return;
      state.preview = url ? "ready" : "none";
      show("xsd-skel", false);
      var img = el("xsd-img");
      if (url && img) {
        img.onerror = function() {
          img.hidden = true;
          show("xsd-nopreview", true);
        };
        img.src = url;
        img.hidden = false;
        show("xsd-nopreview", false);
      } else {
        show("xsd-nopreview", true);
      }
      track("save_modal_preview", { how: how || (url ? "ok" : "none") });
    }
    function stillSaving() {
      if (!state) return;
      show("xsd-slow", true);
      announce("Still saving. You can keep waiting, or continue editing while it finishes — you’ll get a note either way.");
      var bg = el("xsd-bg");
      if (bg) {
        try {
          bg.focus();
        } catch (e) {
        }
      }
    }
    function detachSave() {
      if (!state || !state.saving) return;
      state.detached = true;
      track("save_modal_detached", { design: designIdFromHash(), mode: state.mode });
      close(false);
      toast("Still saving in the background — you’ll get a note when it’s done.", null, "info");
    }
    function setSaving(on) {
      if (!state) return;
      state.saving = on;
      var btn = el("xsd-save");
      if (btn) {
        btn.disabled = on;
        btn.classList.remove("is-saved");
        setText("xsd-save-label", on ? "Saving…" : state.mode === "update" ? "Update design" : "Save design");
        var ic = el("xsd-save-icon");
        if (ic) ic.innerHTML = on ? '<span class="xsd-spin" aria-hidden="true"></span>' : I_ARROW;
        btn.setAttribute("aria-busy", on ? "true" : "false");
      }
      ["xsd-name", "xsd-select", "xsd-newfolder-btn", "xsd-folder-name", "xsd-folder-create", "xsd-folder-cancel", "xsd-alt", "xsd-retry"].forEach(function(id) {
        var n = el(id);
        if (n) n.disabled = on;
      });
      var close2 = el("xsd-close");
      if (close2) close2.setAttribute("aria-disabled", on ? "true" : "false");
      if (state.slowTimer) {
        clearTimeout(state.slowTimer);
        state.slowTimer = null;
      }
      show("xsd-slow", false);
      if (on) {
        showAlert("");
        announce(state.mode === "update" ? "Updating your design…" : "Saving your design…");
        state.slowTimer = setTimeout(function() {
          if (state && state.saving) show("xsd-slow", true);
        }, SLOW_MS);
      }
    }
    function setSavedState(label) {
      var btn = el("xsd-save");
      if (!btn) return;
      btn.disabled = true;
      btn.classList.add("is-saved");
      setText("xsd-save-label", label);
      var ic = el("xsd-save-icon");
      if (ic) ic.innerHTML = I_CHECK;
      btn.setAttribute("aria-busy", "false");
    }
    function initialFolderId(tree) {
      try {
        if (state.saved && state.saved.folderId != null && inSavedTree(tree, state.saved.folderId)) return state.saved.folderId;
      } catch (e) {
      }
      try {
        if (draft.folderId != null && draft.designId === designIdFromHash() && inSavedTree(tree, draft.folderId)) return draft.folderId;
      } catch (e) {
      }
      try {
        var dfs = svc("defaultFolderService");
        var last = dfs && typeof dfs.getDefaultFolderId === "function" ? dfs.getDefaultFolderId() : null;
        if (last != null && inSavedTree(tree, last)) return last;
      } catch (e) {
      }
      return tree.root.id;
    }
    function loadFolders(onDone) {
      if (!state) return;
      var fo = svc("folders");
      if (!fo || typeof fo.getFolders !== "function") {
        state.folderStatus = "error";
        renderDest();
        return;
      }
      state.folderStatus = "loading";
      renderDest();
      var p = null;
      try {
        p = fo.getFolders();
      } catch (e) {
        p = null;
      }
      kickDigest();
      if (!p || typeof p.then !== "function") {
        state.folderStatus = "error";
        renderDest();
        return;
      }
      p.then(function(res) {
        if (!state) return;
        var tree = buildTree(res && res.data);
        if (!tree.root) {
          state.folderStatus = "error";
          renderDest();
          return;
        }
        state.tree = tree;
        state.folderStatus = "ready";
        if (state.folderId == null || !inSavedTree(tree, state.folderId)) state.folderId = initialFolderId(tree);
        if (state.browseId == null || !inSavedTree(tree, state.browseId)) state.browseId = browseParentFor(tree, state.folderId);
        renderDest();
        if (onDone) onDone(tree);
      }, function() {
        if (!state) return;
        state.folderStatus = "error";
        renderDest();
      });
    }
    function pickFolder(id) {
      if (!state || !state.tree || !inSavedTree(state.tree, id)) return;
      var f = state.tree.byId[String(id)];
      if (!f) return;
      state.folderId = f.id;
      state.pickerOpen = false;
      state.browseId = browseParentFor(state.tree, f.id);
      setFieldError("dest", "");
      renderDest();
      announce("Saving to " + folderLabel(selectedFolder()) + ".");
      var sel = el("xsd-select");
      if (sel) {
        try {
          sel.focus();
        } catch (e) {
        }
      }
    }
    function browseTo(id) {
      if (!state || !state.tree || !inSavedTree(state.tree, id)) return;
      var f = state.tree.byId[String(id)];
      if (!f) return;
      state.browseId = f.id;
      renderPicker();
      var first = state.root && (state.root.querySelector("#xsd-picker .xsd-picker__back") || state.root.querySelector("#xsd-picker .xsd-row__pick") || state.root.querySelector("#xsd-picker .xsd-picker__use"));
      if (first) {
        try {
          first.focus();
        } catch (e) {
        }
      }
    }
    function togglePicker(force) {
      if (!state || state.saving) return;
      if (state.folderStatus !== "ready" || !state.tree) {
        loadFolders();
        return;
      }
      var next = typeof force === "boolean" ? force : !state.pickerOpen;
      state.pickerOpen = next;
      if (next) {
        state.browseId = browseParentFor(state.tree, state.folderId);
      }
      renderDest();
      if (next) {
        var first = state.root.querySelector("#xsd-picker .xsd-row.is-selected .xsd-row__pick") || state.root.querySelector("#xsd-picker .xsd-row__pick") || state.root.querySelector("#xsd-picker .xsd-picker__use");
        if (first) {
          try {
            first.focus();
          } catch (e) {
          }
        }
      }
    }
    function toggleNewFolder(on) {
      if (!state) return;
      state.newFolderOpen = on;
      show("xsd-newfolder", on);
      show("xsd-newfolder-btn", !on && state.mode !== "update");
      setFieldError("folder", "");
      if (on) {
        state.pickerOpen = false;
        renderDest();
        var inp = el("xsd-folder-name");
        if (inp) {
          inp.value = "";
          setTimeout(function() {
            try {
              inp.focus();
            } catch (e) {
            }
          }, 30);
        }
      } else {
        var inp2 = el("xsd-folder-name");
        if (inp2) inp2.value = "";
        var b = el("xsd-newfolder-btn");
        if (b && !b.hidden) {
          try {
            b.focus();
          } catch (e) {
          }
        }
      }
    }
    function setFolderBusy(on) {
      if (!state) return;
      state.folderBusy = on;
      var c = el("xsd-folder-create"), x = el("xsd-folder-cancel"), i = el("xsd-folder-name");
      if (c) {
        c.disabled = on;
        c.innerHTML = on ? '<span class="xsd-spin" aria-hidden="true"></span><span>Creating…</span>' : "<span>Create folder</span>";
      }
      if (x) x.disabled = on;
      if (i) i.disabled = on;
    }
    function createFolder() {
      if (!state || state.folderBusy || state.saving) return;
      var inp = el("xsd-folder-name");
      var name = clean(inp ? inp.value : "");
      if (!name) {
        setFieldError("folder", "Enter a folder name.");
        if (inp) inp.focus();
        return;
      }
      if (name.length > FOLDER_MAX) {
        setFieldError("folder", "Folder names can be up to " + FOLDER_MAX + " characters.");
        if (inp) inp.focus();
        return;
      }
      var fo = svc("folders");
      if (!fo || typeof fo.createFolder !== "function") {
        setFieldError("folder", "Folders aren’t available right now. Try again in a moment.");
        return;
      }
      var parentId = state.folderId != null ? state.folderId : state.tree && state.tree.root ? state.tree.root.id : null;
      if (parentId == null) {
        setFieldError("folder", "Choose where to create the folder first.");
        return;
      }
      setFieldError("folder", "");
      setFolderBusy(true);
      var p = null;
      try {
        p = fo.createFolder({ parentId, name });
      } catch (e) {
        p = null;
      }
      kickDigest();
      if (!p || typeof p.then !== "function") {
        setFolderBusy(false);
        setFieldError("folder", "Couldn’t create the folder. Try again.");
        return;
      }
      p.then(function(res) {
        if (!state) return;
        var created = res && res.data;
        var newId = created && created.id != null ? created.id : null;
        loadFolders(function(tree) {
          if (newId != null && tree.byId[String(newId)] && inSavedTree(tree, newId)) {
            state.folderId = newId;
            state.browseId = browseParentFor(tree, newId);
          }
          setFolderBusy(false);
          toggleNewFolder(false);
          renderDest();
          announce("Folder “" + (folderLabel(created) || name) + "” created and selected.");
          track("save_folder_created", { design: designIdFromHash() });
          var sel = el("xsd-select");
          if (sel) {
            try {
              sel.focus();
            } catch (e) {
            }
          }
        });
      }, function(err) {
        if (!state) return;
        setFolderBusy(false);
        var d = kbErrorText(err, null, null);
        setFieldError("folder", d ? "Couldn’t create the folder: " + d : "Couldn’t create the folder. Check your connection and try again.");
        if (inp) {
          try {
            inp.focus();
          } catch (e) {
          }
        }
      });
    }
    function onSaved(data, folderId, updated) {
      if (!state) return;
      var fid = data && data.folderId != null ? data.folderId : folderId;
      var f = state.tree && fid != null ? state.tree.byId[String(fid)] : null;
      var folderName = folderLabel(f) || ROOT_SYSTEM_NAME;
      var msg = updated ? "Design updated." : "Design saved to " + folderName + ".";
      state.savedOk = true;
      setSavedState(updated ? "Updated" : "Saved");
      announce(msg);
      draft = { designId: "", name: null, folderId: null };
      track(updated ? "save_design_updated" : "save_design_saved", { design: designIdFromHash(), folder: fid == null ? null : String(fid) });
      var url = lockerUrl(fid);
      var trigger = state.trigger;
      setTimeout(function() {
        close(true);
        toast(msg, url ? { href: url, label: "View saved designs" } : null);
        try {
          if (trigger && trigger.focus) trigger.focus();
        } catch (e) {
        }
      }, reducedMotion() ? 350 : 900);
    }
    function settledDetached(ok, data, folderId, updated, detail) {
      if (ok) {
        var fid = data && data.folderId != null ? data.folderId : folderId;
        var url = lockerUrl(fid);
        toast(updated ? "Design updated." : "Design saved.", url ? { href: url, label: "View saved designs" } : null);
        track(updated ? "save_design_updated" : "save_design_saved", { design: designIdFromHash(), detached: true });
      } else {
        toast(friendlyError(detail) + " Open Save to try again.", null, "error");
        track("save_design_failed", { design: designIdFromHash(), detached: true });
      }
    }
    function runCreate(name, folderId) {
      var borrowed = borrowKbSaveVm(state.lockerVm, !!state.saved);
      if (!borrowed) {
        showAlert("Kit Builder isn’t ready to save yet. Give it a moment and try again.");
        return;
      }
      borrowed.vm.customDesign.name = name;
      borrowed.vm.customDesign.folderId = folderId;
      setSaving(true);
      var fc = flashCapture();
      state.flash = fc;
      fc.start();
      var mine = state;
      borrowed.promise.then(function(data) {
        fc.stop();
        if (state !== mine) {
          if (mine.detached) settledDetached(true, data, folderId, false);
          return;
        }
        onSaved(data, folderId, false);
      }, function(err) {
        var got = fc.stop();
        var detail = kbErrorText(err, borrowed.vm, got);
        if (state !== mine) {
          if (mine.detached) settledDetached(false, null, folderId, false, detail);
          return;
        }
        setSaving(false);
        track("save_design_failed", { design: designIdFromHash() });
        showAlert(friendlyError(detail));
      });
      try {
        borrowed.vm.create();
      } catch (e) {
        fc.stop();
        setSaving(false);
        showAlert(friendlyError(clean(e && e.message)));
        return;
      }
      kickDigest();
    }
    function runUpdate() {
      var vm = state.lockerVm;
      if (!vm || typeof vm.updateCustomDesign !== "function" || !state.saved || state.saved.readOnly) {
        state.mode = "create";
        state.canUpdate = false;
        applyMode();
        return;
      }
      setSaving(true);
      var fc = flashCapture();
      state.flash = fc;
      fc.start();
      var p = null;
      try {
        p = vm.updateCustomDesign({});
      } catch (e) {
        fc.stop();
        setSaving(false);
        showAlert(friendlyError(clean(e && e.message)));
        return;
      }
      kickDigest();
      if (!p || typeof p.then !== "function") {
        fc.stop();
        setSaving(false);
        showAlert(friendlyError(""));
        return;
      }
      var savedFolder = state.saved.folderId;
      var mine = state;
      p.then(function(data) {
        fc.stop();
        if (state !== mine) {
          if (mine.detached) settledDetached(true, data, savedFolder, true);
          return;
        }
        onSaved(data, savedFolder, true);
      }, function(err) {
        var got = fc.stop();
        var detail = kbErrorText(err, null, got);
        if (state !== mine) {
          if (mine.detached) settledDetached(false, null, savedFolder, true, detail);
          return;
        }
        setSaving(false);
        track("save_design_failed", { design: designIdFromHash(), update: true });
        showAlert(friendlyError(detail));
      });
    }
    function submit() {
      if (!state || state.saving) return;
      showAlert("");
      if (state.mode === "update") {
        runUpdate();
        return;
      }
      var inp = el("xsd-name");
      var name = clean(inp ? inp.value : state.name);
      var ok = true, firstBad = null;
      if (!name) {
        setFieldError("name", "Enter a design name.");
        ok = false;
        firstBad = inp;
      } else if (name.length > NAME_MAX) {
        setFieldError("name", "Design names can be up to " + NAME_MAX + " characters.");
        ok = false;
        firstBad = inp;
      } else setFieldError("name", "");
      if (state.folderStatus !== "ready" || !state.tree || state.folderId == null || !inSavedTree(state.tree, state.folderId)) {
        setFieldError("dest", state.folderStatus === "error" ? "We couldn’t load your folders. Tap the folder to retry." : "Choose a folder to save to.");
        ok = false;
        firstBad = firstBad || el("xsd-select");
      } else setFieldError("dest", "");
      if (!ok) {
        if (firstBad) {
          try {
            firstBad.focus();
          } catch (e) {
          }
        }
        return;
      }
      state.name = name;
      runCreate(name, state.folderId);
    }
    function toast(msg, link, kind) {
      injectCSS();
      var old = document.getElementById("xsd-toast");
      if (old && old.parentNode) old.parentNode.removeChild(old);
      var t = document.createElement("div");
      t.id = "xsd-toast";
      t.setAttribute("role", kind === "error" ? "alert" : "status");
      if (kind) t.className = "is-" + kind;
      t.innerHTML = (kind === "error" ? I_CLOSE : kind === "info" ? '<span class="xsd-spin xsd-spin--toast" aria-hidden="true"></span>' : I_CHECK) + "<span>" + esc(msg) + "</span>" + (link && link.href ? '<a href="' + esc(link.href) + '">' + esc(link.label) + "</a>" : "");
      document.body.appendChild(t);
      var on = function() {
        t.classList.add("is-on");
      };
      if (reducedMotion()) on();
      else setTimeout(on, 20);
      var hide = function() {
        t.classList.remove("is-on");
        setTimeout(function() {
          if (t.parentNode) t.parentNode.removeChild(t);
        }, reducedMotion() ? 0 : 220);
      };
      var timer = setTimeout(hide, kind === "error" ? 12e3 : 7e3);
      t.addEventListener("mouseenter", function() {
        clearTimeout(timer);
      });
      t.addEventListener("mouseleave", function() {
        timer = setTimeout(hide, 3e3);
      });
      t.addEventListener("click", function(e) {
        if (e.target && e.target.tagName === "A") hide();
      });
    }
    function focusables(root) {
      var list = root.querySelectorAll('button:not([disabled]),[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])');
      var out = [];
      for (var i = 0; i < list.length; i++) {
        var n = list[i], hidden = false, p = n;
        while (p && p !== root) {
          if (p.hidden) {
            hidden = true;
            break;
          }
          p = p.parentNode;
        }
        if (!hidden) out.push(n);
      }
      return out;
    }
    function bindDialog(modal) {
      function onKey(e) {
        if (!state) return;
        if (e.key === "Escape" || e.key === "Esc") {
          e.stopPropagation();
          e.preventDefault();
          if (state.pickerOpen) {
            state.pickerOpen = false;
            renderDest();
            var s = el("xsd-select");
            if (s) {
              try {
                s.focus();
              } catch (x) {
              }
            }
            return;
          }
          if (state.newFolderOpen && !state.folderBusy) {
            toggleNewFolder(false);
            return;
          }
          if (state.saving) {
            stillSaving();
            return;
          }
          close(false);
          return;
        }
        if (e.key !== "Tab") return;
        var f = focusables(modal);
        if (!f.length) {
          e.preventDefault();
          modal.focus();
          return;
        }
        var first = f[0], last = f[f.length - 1], active = document.activeElement;
        var inside = modal.contains(active);
        if (!inside) {
          e.preventDefault();
          (e.shiftKey ? last : first).focus();
          return;
        }
        if (e.shiftKey && active === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && active === last) {
          e.preventDefault();
          first.focus();
        }
      }
      function onFocusIn(e) {
        if (!state || !modal.contains(e.target)) {
          if (state && state.root && !state.root.contains(e.target)) {
            try {
              modal.focus();
            } catch (x) {
            }
          }
        }
      }
      document.addEventListener("keydown", onKey, true);
      document.addEventListener("focusin", onFocusIn, true);
      return function unbind() {
        document.removeEventListener("keydown", onKey, true);
        document.removeEventListener("focusin", onFocusIn, true);
      };
    }
    function wire() {
      var root = state.root;
      root.addEventListener("click", function(e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var closer = t.closest("[data-close]");
        if (closer && root.contains(closer)) {
          if (closer.classList.contains("xsd-backdrop") && t !== closer) return;
          if (state.saving) {
            stillSaving();
            return;
          }
          close(false);
          return;
        }
        var pick = t.closest("[data-pick]");
        if (pick && root.contains(pick)) {
          pickFolder(pick.getAttribute("data-pick"));
          return;
        }
        var open2 = t.closest("[data-open]");
        if (open2 && root.contains(open2)) {
          browseTo(open2.getAttribute("data-open"));
          return;
        }
      });
      var form = el("xsd-form");
      form.addEventListener("submit", function(e) {
        e.preventDefault();
        submit();
      });
      var name = el("xsd-name");
      name.value = state.name;
      updateCounter();
      name.addEventListener("input", function() {
        state.name = name.value;
        state.nameDirty = true;
        updateCounter();
        if (clean(name.value)) setFieldError("name", "");
      });
      el("xsd-select").addEventListener("click", function() {
        togglePicker();
      });
      el("xsd-newfolder-btn").addEventListener("click", function() {
        toggleNewFolder(true);
      });
      el("xsd-folder-cancel").addEventListener("click", function() {
        toggleNewFolder(false);
      });
      el("xsd-folder-create").addEventListener("click", function() {
        createFolder();
      });
      el("xsd-folder-name").addEventListener("keydown", function(e) {
        if (e.key === "Enter") {
          e.preventDefault();
          createFolder();
        }
      });
      el("xsd-folder-name").addEventListener("input", function() {
        setFieldError("folder", "");
      });
      el("xsd-retry").addEventListener("click", function() {
        submit();
      });
      el("xsd-bg").addEventListener("click", function() {
        detachSave();
      });
      el("xsd-alt").addEventListener("click", function() {
        if (state.saving) return;
        if (state.mode === "update") {
          state.mode = "create";
          if (!state.nameDirty) {
            state.name = clean(state.saved && state.saved.name) || defaultName();
            var n = el("xsd-name");
            if (n) {
              n.value = state.name;
              updateCounter();
            }
          }
        } else {
          state.mode = "update";
        }
        applyMode();
        renderDest();
        track("save_modal_mode", { mode: state.mode });
        var target = state.mode === "create" ? el("xsd-name") : el("xsd-save");
        if (target) {
          try {
            target.focus();
          } catch (e) {
          }
        }
      });
    }
    function open(ctx) {
      ctx = ctx || {};
      var lockerVm = ctx.vm || ctx.scope && ctx.scope.vmLr || null;
      if (!lockerVm || typeof lockerVm.showSaveCustomDesignDialog !== "function") return false;
      if (!svc("dialog") || !svc("folders")) return false;
      if (!loggedIn(lockerVm)) return false;
      if (state) close(true);
      injectCSS();
      var saved = loadedDesign(lockerVm);
      var canUpdate = !!(saved && !saved.readOnly && typeof lockerVm.updateCustomDesign === "function");
      var did = designIdFromHash();
      var reuseDraft = draft.designId === did && draft.name != null;
      state = {
        trigger: ctx.trigger || (document.activeElement && document.activeElement !== document.body ? document.activeElement : null),
        lockerVm,
        saved,
        canUpdate,
        mode: canUpdate ? "update" : "create",
        name: saved && saved.name ? clean(saved.name) : reuseDraft ? draft.name : defaultName(),
        nameDirty: !!(reuseDraft && !saved),
        tree: null,
        folderId: null,
        browseId: null,
        folderStatus: "loading",
        saving: false,
        savedOk: false,
        detached: false,
        pickerOpen: false,
        newFolderOpen: false,
        folderBusy: false,
        preview: "loading",
        flash: null,
        slowTimer: null,
        root: null,
        unbind: null
      };
      var root = document.createElement("div");
      root.id = "xsd-root";
      root.innerHTML = shellHTML({ productName: productName(), descriptor: descriptorFor(decorations()) });
      state.root = root;
      document.body.appendChild(root);
      lockScroll(true);
      tapRouting(false);
      wire();
      applyMode();
      var modal = $(".xsd-modal", root);
      state.unbind = bindDialog(modal);
      if (reducedMotion()) root.classList.add("is-open");
      else setTimeout(function() {
        if (state && state.root === root) root.classList.add("is-open");
      }, 20);
      setTimeout(function() {
        if (!state || state.root !== root) return;
        var nameInput = el("xsd-name");
        if (!isMobile() && state.mode === "create" && nameInput) {
          try {
            nameInput.focus();
            nameInput.setSelectionRange(nameInput.value.length, nameInput.value.length);
          } catch (e) {
          }
        } else {
          try {
            modal.focus();
          } catch (e) {
          }
        }
      }, 40);
      loadFolders();
      previewSource(function(url, how) {
        if (state && state.root === root) setPreview(url, how);
      });
      track("save_modal_open", { design: did, mode: state.mode });
      return true;
    }
    function close(silent) {
      if (!state) return;
      var st = state;
      state = null;
      if (!st.savedOk && st.mode === "create" && !st.saved) draft = { designId: designIdFromHash(), name: st.nameDirty ? st.name : null, folderId: st.folderId };
      if (st.unbind) st.unbind();
      if (st.slowTimer) clearTimeout(st.slowTimer);
      try {
        if (st.flash && !st.detached) st.flash.stop();
      } catch (e) {
      }
      lockScroll(false);
      tapRouting(true);
      var root = st.root;
      function remove() {
        if (root && root.parentNode) root.parentNode.removeChild(root);
      }
      if (reducedMotion() || !root) remove();
      else {
        root.classList.remove("is-open");
        setTimeout(remove, 200);
      }
      if (!silent) {
        try {
          if (st.trigger && st.trigger.focus) st.trigger.focus();
        } catch (e) {
        }
        track("save_modal_close", { saved: false });
      }
    }
    window.__xeistSaveDesignModal = {
      open,
      close: function() {
        close(false);
      },
      isOpen: function() {
        return !!state;
      },
      // test hooks (vitest runs the real module in a vm sandbox)
      _test: {
        composeName,
        defaultName,
        descriptorFor,
        decorations,
        buildTree,
        inSavedTree,
        pathOf,
        browseParentFor,
        borrowKbSaveVm,
        flashCapture,
        kbErrorText,
        loadedDesign,
        NAME_MAX,
        FOLDER_MAX,
        CSS
      }
    };
  })();

  // src/core/40-money.js
  (function() {
    "use strict";
    if (window.XeistMoney) return;
    var KB_FIXED_CAD = true;
    function fixedFor(code) {
      var o = window.__xeistKbFixedCad;
      var on = o === true || o === false ? o : KB_FIXED_CAD;
      return on && code === "CAD";
    }
    function session() {
      var sc = window.Shopify && window.Shopify.currency || {};
      var code = String(sc.active || "").toUpperCase();
      if (!/^[A-Z]{3}$/.test(code)) code = "USD";
      var rate = parseFloat(sc.rate);
      if (!(rate > 0)) rate = 1;
      var fixed = fixedFor(code);
      return { code, rate: fixed ? 1 : rate, marketRate: rate, converts: !fixed && Math.abs(rate - 1) > 1e-9, fixed };
    }
    function roundCents(n) {
      return Math.round(n * 100) / 100;
    }
    function roundingMode(s) {
      var o = window.__xeistMoneyRounding;
      if (o === "whole" || o === "cents") return o;
      return s.converts ? "whole" : "cents";
    }
    function convert(usd) {
      var s = session();
      return roundCents((+usd || 0) * s.rate);
    }
    function lineTotal(usd) {
      var s = session();
      var v = (+usd || 0) * s.rate;
      return roundingMode(s) === "whole" ? Math.round(v) : roundCents(v);
    }
    function perPlayer(usdUnit, qty) {
      qty = +qty || 0;
      if (!qty) return convert(usdUnit);
      return roundCents(lineTotal((+usdUnit || 0) * qty) / qty);
    }
    function withCommas(fixed) {
      var parts = String(fixed).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    }
    function fmt(amount, code) {
      var n = +amount || 0;
      return "$" + withCommas(n.toFixed(2)) + " " + (code || session().code);
    }
    function approx(str) {
      return (session().converts ? "≈ " : "") + str;
    }
    window.XeistMoney = {
      session,
      code: function() {
        return session().code;
      },
      converts: function() {
        return session().converts;
      },
      // true in a CAD session while the worker pins fixed CAD prices on KB
      // products: the cart will show the USD digits in CAD (module 33 waits
      // for that pin before opening the cart).
      kbFixed: function() {
        return session().fixed;
      },
      convert,
      lineTotal,
      perPlayer,
      fmt,
      // KitBuilder-priced (USD) figures, shown as the session-currency charge:
      kbUnit: function(usd) {
        return approx(fmt(convert(usd)));
      },
      // "≈ $56.32 CAD"
      kbLine: function(usd) {
        return fmt(lineTotal(usd));
      },
      // "$676.00 CAD"
      kbPer: function(usdUnit, qty) {
        return approx(fmt(perPlayer(usdUnit, qty)));
      },
      // Canadian-sheet figures (fixed CAD prices on the tier products):
      cad: function(n) {
        return fmt(n, "CAD");
      },
      // One line of copy for a converting session, e.g. under a total.
      note: function() {
        var s = session();
        if (s.fixed) return "Charged in CAD at checkout";
        if (!s.converts) return "";
        return "Charged in " + s.code + " at checkout · converted from USD at today’s rate";
      }
    };
  })();

  // src/logo-tools/41-number-prompt.js
  (function() {
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1 || !/114891065|114890045/.test(window.location.hash || "")) return;
    var design = (String(window.location.hash).match(/customise\/(\d+)/) || [])[1] || "";
    var CHOSEN_KEY = "xeist_coach_number_" + design;
    var MAX_DIGITS = 2;
    var SETTLE_MS = 6e3;
    var SETTLE_TICK = 150;
    var store = (function() {
      try {
        window.localStorage.getItem(CHOSEN_KEY);
        return window.localStorage;
      } catch (e) {
        try {
          return window.sessionStorage;
        } catch (e2) {
          return { getItem: function() {
            return null;
          }, setItem: function() {
          }, removeItem: function() {
          } };
        }
      }
    })();
    function track(type, payload) {
      try {
        if (typeof window.XeistTrack !== "function") return;
        payload = payload || {};
        payload.design = design;
        window.XeistTrack(type, payload);
      } catch (e) {
      }
    }
    function getInjector() {
      try {
        var root2 = document.querySelector("[ng-controller]") || document.getElementById("kitBuilder");
        if (!root2 || !window.angular) return null;
        return angular.element(root2).injector() || null;
      } catch (e) {
        return null;
      }
    }
    function numberItems() {
      try {
        var inj = getInjector();
        if (!inj) return [];
        var kit = inj.get("KitService").kit;
        var items = kit && kit.editor || [];
        var out = [];
        for (var i = 0; i < items.length; i++) {
          if (String(items[i].placementKey || "").toLowerCase() === "add-number") out.push(items[i]);
        }
        return out;
      } catch (e) {
        return [];
      }
    }
    function itemText(it) {
      return String(it && it.text == null ? "" : it && it.text).trim();
    }
    function currentText() {
      var items = numberItems();
      for (var i = 0; i < items.length; i++) {
        var t = itemText(items[i]);
        if (t) return t;
      }
      return "";
    }
    function hasItem() {
      return numberItems().length > 0;
    }
    function writeText(text) {
      var items = numberItems();
      if (!items.length) return false;
      var dirty = [];
      for (var i = 0; i < items.length; i++) if (itemText(items[i]) !== text) dirty.push(items[i]);
      if (!dirty.length) return false;
      var apply = function() {
        for (var d = 0; d < dirty.length; d++) {
          dirty[d].text = text;
          if (Object.prototype.hasOwnProperty.call(dirty[d], "value")) dirty[d].value = text;
        }
      };
      var inj = getInjector();
      try {
        inj.get("$rootScope").$apply(apply);
      } catch (e) {
        try {
          apply();
          inj.get("$rootScope").$applyAsync();
        } catch (e2) {
          try {
            apply();
          } catch (e3) {
          }
        }
      }
      return true;
    }
    function setDefaultText(text) {
      try {
        var cfg = window.XeistOrbitCoachConfig;
        if (!cfg) return;
        cfg.numberDefaults = cfg.numberDefaults || {};
        cfg.numberDefaults.text = text || "2";
      } catch (e) {
      }
    }
    function remember(text) {
      try {
        if (text) store.setItem(CHOSEN_KEY, text);
        else store.removeItem(CHOSEN_KEY);
      } catch (e) {
      }
    }
    var CSS = [
      '#xeist-number-prompt{position:fixed;inset:0;z-index:99600;display:none;font-family:-apple-system,"SF Pro Text","Helvetica Neue",Arial,sans-serif;-webkit-font-smoothing:antialiased}',
      "#xeist-number-prompt.is-open{display:block}",
      "#xeist-number-prompt .xnp__catch{position:absolute;inset:0;background:transparent}",
      "#xeist-number-prompt .xnp__card{position:absolute;box-sizing:border-box;width:236px;padding:16px 16px 12px;background:#fff;color:#141419;border-radius:20px;",
      "box-shadow:0 0 0 1px #ececef,0 18px 44px -18px rgba(20,20,25,.35);opacity:0;transform:translateY(-6px) scale(.98);transition:opacity .18s ease,transform .18s ease}",
      "#xeist-number-prompt.is-on .xnp__card{opacity:1;transform:none}",
      "#xeist-number-prompt .xnp__card *{box-sizing:border-box;font-family:inherit}",
      "#xeist-number-prompt .xnp__eyebrow{margin:0 0 2px;font-size:11.5px;font-weight:600;letter-spacing:.09em;text-transform:uppercase;color:#8e8e96;text-align:center}",
      "#xeist-number-prompt .xnp__input{display:block;width:100%;height:72px;margin:0 0 12px;padding:0;border:0;border-bottom:1px solid #ececef;border-radius:0;background:transparent;",
      "color:#141419;font-size:46px;font-weight:700;letter-spacing:-0.02em;line-height:1;text-align:center;font-variant-numeric:tabular-nums;outline:none;-webkit-appearance:none;appearance:none;caret-color:#6d28ed}",
      "#xeist-number-prompt .xnp__input::placeholder{color:#d1d1d6;font-weight:700}",
      "#xeist-number-prompt .xnp__input:focus{border-bottom-color:#6d28ed}",
      "#xeist-number-prompt .xnp__done{display:flex;align-items:center;justify-content:center;width:100%;height:46px;border:0;border-radius:14px;background:#6d28ed;color:#fff;",
      "font-size:15px;font-weight:600;letter-spacing:-0.01em;cursor:pointer;transition:transform .12s ease,background .12s ease}",
      "#xeist-number-prompt .xnp__done:active{transform:scale(.985);background:#5b1fd0}",
      "#xeist-number-prompt .xnp__remove{display:block;width:100%;height:34px;margin:2px 0 0;border:0;background:none;color:#8e8e96;font-size:13px;font-weight:600;cursor:pointer}",
      "#xeist-number-prompt .xnp__remove[hidden]{display:none}",
      "#xeist-number-prompt .xnp__remove:hover{color:#3c3c43}",
      "#xeist-number-prompt .xnp__hint{margin:8px 0 0;font-size:12px;line-height:1.45;color:#8e8e96;text-align:center}",
      "#xeist-number-prompt button:focus-visible{outline:2px solid #6d28ed;outline-offset:2px}",
      "@media (prefers-reduced-motion: reduce){#xeist-number-prompt .xnp__card{transition:none}}"
    ].join("");
    function ensureStyle() {
      if (document.getElementById("xeist-number-prompt-style")) return;
      var st = document.createElement("style");
      st.id = "xeist-number-prompt-style";
      st.textContent = CSS;
      (document.head || document.documentElement).appendChild(st);
    }
    var root = null, card = null, input = null, doneBtn = null, removeBtn = null;
    var isOpen = false;
    var desired = "";
    var addRequested = false;
    var rafId = 0;
    var settleId = 0;
    var hadItemAtOpen = false;
    var hadTextAtOpen = "";
    function build() {
      if (root) return;
      ensureStyle();
      root = document.createElement("div");
      root.id = "xeist-number-prompt";
      root.innerHTML = '<div class="xnp__catch" data-xnp-catch></div><div class="xnp__card" role="dialog" aria-labelledby="xeist-number-prompt-title"><p class="xnp__eyebrow" id="xeist-number-prompt-title">Your number</p><input class="xnp__input" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="' + MAX_DIGITS + '" autocomplete="off" autocorrect="off" spellcheck="false" placeholder="23" aria-label="Your number"><button type="button" class="xnp__done">Done</button><button type="button" class="xnp__remove" hidden>Remove number</button><p class="xnp__hint">Team numbers are collected after checkout.</p></div>';
      document.body.appendChild(root);
      card = root.querySelector(".xnp__card");
      input = root.querySelector(".xnp__input");
      doneBtn = root.querySelector(".xnp__done");
      removeBtn = root.querySelector(".xnp__remove");
      root.querySelector("[data-xnp-catch]").addEventListener("click", function() {
        close("dismiss");
      });
      doneBtn.addEventListener("click", function() {
        commit();
      });
      removeBtn.addEventListener("click", function() {
        removeNumber();
        close("remove");
      });
      input.addEventListener("input", onInput);
      input.addEventListener("keydown", function(e) {
        if (e.key === "Enter") {
          e.preventDefault();
          commit();
        } else if (e.key === "Escape") {
          e.preventDefault();
          close("escape");
        }
      });
      root.addEventListener("keydown", function(e) {
        if (e.key === "Escape") {
          e.preventDefault();
          close("escape");
        }
      });
      window.addEventListener("resize", function() {
        if (isOpen) place();
      });
    }
    function toolButton() {
      return document.getElementById("xeist-add-number-overlay");
    }
    function place() {
      if (!card) return;
      var btn = toolButton();
      var wide = window.innerWidth > 768;
      card.style.left = card.style.right = card.style.top = card.style.bottom = card.style.width = card.style.maxWidth = card.style.margin = "";
      if (wide && btn) {
        var r = btn.getBoundingClientRect();
        if (r.width) {
          var w = 236;
          var h = card.offsetHeight || 220;
          var right = Math.round(window.innerWidth - r.left + 12);
          if (window.innerWidth - right - w < 12) right = Math.max(12, window.innerWidth - w - 12);
          var top = Math.round(r.top + r.height / 2 - h / 2);
          top = Math.max(12, Math.min(top, window.innerHeight - h - 12));
          card.style.right = right + "px";
          card.style.top = top + "px";
          card.style.width = w + "px";
          return;
        }
      }
      card.style.left = "16px";
      card.style.right = "16px";
      card.style.width = "auto";
      card.style.maxWidth = "360px";
      card.style.margin = "0 auto";
      card.style.top = "calc(12px + env(safe-area-inset-top))";
    }
    function sanitize(v) {
      return String(v || "").replace(/\D+/g, "").slice(0, MAX_DIGITS);
    }
    function onInput() {
      var v = sanitize(input.value);
      if (input.value !== v) input.value = v;
      if (!v) return;
      desired = v;
      setDefaultText(desired);
      if (hasItem()) {
        writeText(desired);
        return;
      }
      if (!addRequested) {
        addRequested = true;
        window.__xeistUserNumberIntent = true;
        try {
          var tool = window.__xeistNumberTool;
          if (tool && typeof tool.add === "function") tool.add();
        } catch (e) {
        }
      }
    }
    function syncTick() {
      rafId = 0;
      if (!isOpen) return;
      if (desired) writeText(desired);
      rafId = window.requestAnimationFrame(syncTick);
    }
    function settle() {
      if (settleId) window.clearInterval(settleId);
      var until = Date.now() + SETTLE_MS;
      var text = desired;
      settleId = window.setInterval(function() {
        if (text) {
          writeText(text);
          if (hasItem()) remember(text);
        }
        reflectOnTool();
        if (Date.now() > until) {
          window.clearInterval(settleId);
          settleId = 0;
        }
      }, SETTLE_TICK);
    }
    function reflectOnTool() {
      var b = toolButton();
      if (!b) return;
      var t = currentText();
      if (t) b.setAttribute("data-xf-num", "#" + t);
      else b.removeAttribute("data-xf-num");
    }
    function removeNumber() {
      desired = "";
      setDefaultText("2");
      remember("");
      try {
        var tool = window.__xeistNumberTool;
        if (tool && typeof tool.remove === "function") tool.remove();
      } catch (e) {
      }
      track("number_removed", {});
      window.setTimeout(reflectOnTool, 600);
      window.setTimeout(reflectOnTool, 1600);
    }
    function commit() {
      var v = sanitize(input.value);
      if (!v) {
        if (hasItem()) removeNumber();
        close("done-empty");
        return;
      }
      desired = v;
      setDefaultText(desired);
      if (hasItem()) writeText(desired);
      else if (!addRequested) {
        onInput();
      }
      remember(desired);
      track("number_set", { len: desired.length, changed: desired !== hadTextAtOpen });
      close("done");
    }
    function open() {
      build();
      hadItemAtOpen = hasItem();
      hadTextAtOpen = currentText();
      desired = hadTextAtOpen;
      addRequested = false;
      window.__xeistUserNumberIntent = true;
      input.value = hadTextAtOpen;
      removeBtn.hidden = !hadItemAtOpen;
      root.classList.add("is-open");
      place();
      isOpen = true;
      try {
        input.focus({ preventScroll: true });
        input.select();
      } catch (e) {
        try {
          input.focus();
        } catch (e2) {
        }
      }
      window.requestAnimationFrame(function() {
        root.classList.add("is-on");
        place();
      });
      if (!rafId) rafId = window.requestAnimationFrame(syncTick);
      track("number_prompt_open", { has: hadItemAtOpen ? 1 : 0 });
    }
    function close(reason) {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove("is-on");
      window.setTimeout(function() {
        if (!isOpen) root.classList.remove("is-open");
      }, 200);
      try {
        input.blur();
      } catch (e) {
      }
      if (rafId) {
        window.cancelAnimationFrame(rafId);
        rafId = 0;
      }
      if (desired && hasItem()) remember(desired);
      settle();
      if (reason === "escape") {
        try {
          var b = toolButton();
          if (b) b.focus({ preventScroll: true });
        } catch (e) {
        }
      }
    }
    window.__xeistNumberPrompt = {
      open,
      close,
      isOpen: function() {
        return isOpen;
      },
      current: currentText
    };
    window.setInterval(function() {
      try {
        reflectOnTool();
        var step = document.documentElement.getAttribute("data-xeist-step");
        if (isOpen && step !== null && step !== "0") close("step");
      } catch (e) {
      }
    }, 1e3);
  })();

  // src/logo-tools/42-decoration-lock.js
  (function() {
    "use strict";
    if (window.location.pathname.indexOf("/pages/3d-customizer") === -1 || !/114891065|114890045/.test(window.location.hash || "")) return;
    var LOCK_KEYS = { "add-logo": true, "add-number": true };
    var TICK_MS = 100;
    var UNDO_CAP = 2, UNDO_WINDOW_MS = 1e4;
    var holdUntil = 0;
    window.__xeistSelectHold = function(ms) {
      var n = parseInt(ms, 10);
      holdUntil = Math.max(holdUntil, Date.now() + (n > 0 ? n : 1500));
    };
    var rest = {};
    var undos = {};
    var stats = { cleared: 0, blind: 0, restored: 0, capped: 0 };
    window.__xeistDecorationLock = stats;
    function core() {
      return window.XeistCore || null;
    }
    function service(name) {
      var c = core();
      return c ? c.getService(name) : null;
    }
    function num(v) {
      var n = parseFloat(v);
      return isFinite(n) ? n : null;
    }
    function byId(id) {
      try {
        return id ? document.getElementById(id) : null;
      } catch (e) {
        return null;
      }
    }
    function apply(fn) {
      var rs = service("$rootScope");
      if (rs && !rs.$$phase) {
        rs.$apply(fn);
        return;
      }
      fn();
    }
    function busy() {
      var cta = document.querySelector("[data-bottom-bar-cta]");
      return !!(cta && cta.disabled);
    }
    function selectorShowing() {
      var groups = document.querySelectorAll('g[id^="selectorGroup"]');
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i];
        if (g.getAttribute("display") === "none") continue;
        if (g.style && g.style.display === "none") continue;
        return true;
      }
      return false;
    }
    function elementsOf(it) {
      var out = [];
      var el = byId(it.$id);
      if (el) out.push(el);
      var rep = byId("_kb_Svg_Replacement_" + it.$id);
      if (rep) out.push(rep);
      return out;
    }
    function poseOf(el) {
      return { x: el.getAttribute("x"), y: el.getAttribute("y"), tf: el.getAttribute("transform") || "" };
    }
    function samePose(a, b) {
      var ax = num(a.x), bx = num(b.x), ay = num(a.y), by = num(b.y);
      if (ax == null !== (bx == null) || ay == null !== (by == null)) return false;
      if (ax != null && Math.abs(ax - bx) > 0.5) return false;
      if (ay != null && Math.abs(ay - by) > 0.5) return false;
      return a.tf === b.tf;
    }
    function underCap(id) {
      var now = Date.now();
      var list = (undos[id] || []).filter(function(t) {
        return now - t < UNDO_WINDOW_MS;
      });
      undos[id] = list;
      if (list.length >= UNDO_CAP) return false;
      list.push(now);
      return true;
    }
    function tick() {
      var es = service("EditorService");
      if (!es || typeof es.getSelectedItem !== "function" || typeof es.clearSelection !== "function") return;
      var ks = service("KitService");
      var items = ks && ks.kit && ks.kit.editor || [];
      var sel = null;
      try {
        sel = es.getSelectedItem();
      } catch (e) {
        sel = null;
      }
      var showing = selectorShowing();
      var tracked = [];
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (!it || !LOCK_KEYS[String(it.placementKey || "").toLowerCase()]) continue;
        var els = elementsOf(it);
        for (var j = 0; j < els.length; j++) tracked.push(els[j]);
      }
      if (!sel && !showing) {
        for (var r = 0; r < tracked.length; r++) rest[tracked[r].id] = poseOf(tracked[r]);
        return;
      }
      if (Date.now() < holdUntil) return;
      if (busy()) return;
      var drifted = [];
      for (var d = 0; d < tracked.length; d++) {
        var el = tracked[d], was = rest[el.id];
        if (!was) continue;
        if (!samePose(poseOf(el), was)) drifted.push({ el, was });
      }
      try {
        var changed = false;
        apply(function() {
          for (var k = 0; k < drifted.length; k++) {
            var f = drifted[k];
            if (!underCap(f.el.id)) {
              stats.capped++;
              continue;
            }
            try {
              if (f.was.tf) f.el.setAttribute("transform", f.was.tf);
              else f.el.removeAttribute("transform");
              if (f.was.x != null) f.el.setAttribute("x", f.was.x);
              if (f.was.y != null) f.el.setAttribute("y", f.was.y);
              changed = true;
              stats.restored++;
            } catch (e) {
            }
          }
          es.clearSelection();
          if (changed && typeof es.change === "function") es.change();
        });
        stats.cleared++;
        if (!sel) stats.blind++;
      } catch (e) {
      }
    }
    function start() {
      var c = core();
      if (!c || typeof c.every !== "function") {
        setTimeout(start, 500);
        return;
      }
      c.every("decoration-lock", TICK_MS, tick);
    }
    start();
  })();
})();
